{
  "common": {
    "btn": {
      "create": "បង្កើតថ្មី",
      "create-new": "បង្កើតថ្មី",
      "create-account": "បង្កើតគណនី",
      "later": "ពេលក្រោយ",
      "add": "បន្ថែម",
      "renew": "បន្ត",
      "clone": "ចម្លង",
      "clone-resource": "ចម្លងពីគំរូដើម",
      "update": "កែប្រែ",
      "submit": "បញ្ជូន",
      "sign-in": "ចូល",
      "edit": "កែប្រែ",
      "confirm": "បញ្ជាក់",
      "delete": "លុប",
      "new-record": "កំណត់ត្រាថ្មី",
      "generate": "បង្កើត",
      "close": "បិទ",
      "cancel": "បោះបង់",
      "manage": "គ្រប់គ្រង",
      "print": "បោះពុម្ព",
      "download": "ទាញយក",
      "action": {
        "label": "សកម្មភាព",
        "option": {
          "view": "មើលសេចក្តីលម្អិត",
          "edit": "កែប្រែ",
          "delete": "លុប",
          "manage": "គ្រប់គ្រង"
        }
      }
    },
    "main-header": {
      "edit-profile": "កែប្រែពត៌មានគណនី",
      "change-pwd": "ដូរលេខសម្ងាត់",
      "sign-out": "ចាកចេញ",
      "admin-setting": "ការកំណត់របស់អ្នកគ្រប់គ្រង"
    },
    "footer": {
      "privacy": "ឯកជនភាព",
      "term": "លក្ខខណ្ឌ",
      "support": "ជំនួយ",
      "feedback": "មតិកែលម្អ"
    },
    "aiml-app": {
      "main-header": {
        "my-task": "ភារកិច្ចរបស់ខ្ញុំ",
        "my-applications": "កម្មវិធីរបស់ខ្ញុំ"
      },
      "sub-header1": {
        "title": "កម្មវិធីទាំងអស់"
      }
    },
    "required": "ទាមទារ",
    "confirmation": "ការបញ្ជាក់",
    "a11y": {
      "loading": "កំពុងផ្ទុក…"
    },
    "delete-message-one-item": "លុប មួយ {entity_name}? អី្វដែលត្រូវបានលុបហើយមិនអាចយកមកវិញបានទេ។",
    "delete-message-multiple-items": "លុប {selected_item_count} {entity_name}? អី្វដែលត្រូវបានលុបហើយមិនអាចយកមកវិញបានទេ។"
  },
  "public": {
    "sing-in": {
      "header": "ចូលប្រើប្រាស់កម្មវិធី OptimalHR",
      "email": "អុីម៉េល",
      "password": "លេខសម្ងាត់"
    },
    "register": {
      "header": "បង្កើតគណនីអ្នកប្រើប្រាស់ថ្មី",
      "first-name": {
        "label": "នាមខ្លួន",
        "description": "ឈ្មោះរបស់អ្នក"
      },
      "last-name": {
        "label": "គោត្តនាម",
        "description": "នាមត្រគោលរបស់អ្នក"
      },
      "email": {
        "label": "អុីម៉េល",
        "description": "ប្រអប់សំបុត្រអេឡិកត្រូនិករបស់អ្នក"
      },
      "organization": {
        "label": "ស្ថាប័ន",
        "description": "ឈ្មោះស្ថាប័នរបស់អ្នក (ក្រុមហ៊ុន អង្គការ សាលារៀន ។ល។)"
      },
      "process": {
        "header": "បង្កើតគណនីអ្នកប្រើប្រាស់ថ្មី",
        "title": "AIML SaaS កំពុងបង្កើតគ្រឿងបង្គុំរបស់ប្រព័ន្នដែលចាំបាច់សំរាប់ការកំណត់អត្តសញ្ញាណនិងការដាក់ដោយឡែកនូវទិន្នន័យរបស់គណនីអ្នកប្រើប្រាស់របស់អ្នក។ ដំណើរការនេះមានរយៈពេល ២ ទៅ ៣ នាទី។",
        "create-user-and-identity-directory": "កំពុងបង្កើតបញ្ជីអ្នកប្រើប្រាស់និងបញ្ជីអត្តសញ្ញាណ",
        "create-policy-and-role": "កំពុងបង្កើតគោលការណ៍នៃការកំណត់អត្តសញ្ញាណនិងការដាក់ដោយឡែក ព្រមទាំងតួនាទីគោលសំរាប់អ្នកប្រើប្រាស់",
        "apply-policy-and-role": "កំពុងភ្ជាប់គោលការណ៍ទាំងនោះជាមួយតួនាទី",
        "create-admin-user-and-tenant-records": "កំពុងបង្កើតគណនីគ្រប់គ្រងនិងទិន្នន័យផ្សេងទៀតដែលចាំបាច់សំរាប់ការចាប់ផ្តើមប្រើប្រាស់របស់អ្នក",
        "message": "រួចរាល់! ពត៌មានសំរាប់ចូលប្រើប្រាស់ត្រូវបានបញ្ជូនទៅអុីម៉េល {email_address}",
        "back": "ទៅកាន់",
        "login-screen": "អេក្រង់ចូលប្រើប្រាស់"
      }
    },
    "confirm-tenant": {
      "main-title": "អបអរសាទរសំរាប់ការចូលប្រើប្រាស់បានជោគជ័យ!",
      "description": "សូមប្តូរលេខសម្ងាត់របស់អ្នកមុននឹងបន្ត",
      "current-password": {
        "title": "លេខសម្ងាត់បច្ចុប្បន្ន",
        "description": "លេខសម្ងាត់បណ្តោះអាសន្នដែលត្រូវបានផ្ញើទៅកាន់អុីម៉េលរបស់អ្នក"
      },
      "new-password": {
        "title": "លេខសម្ងាត់ថ្មី",
        "description": "តិចបំផុត៨តួដែលក្នុងនោះតម្រូវឲ្យមានអក្សរធំ អក្សរតូចនិងលេខ"
      },
      "confirm-password": {
        "title": "បញ្ជាក់លេខសម្ងាត់ថ្មី",
        "description": "បញ្ចូលលេខសម្ងាត់ថ្មីម្តងទៀត"
      },
      "error-messaga": {
        "pwd-not-match": "លេខសម្ងាត់ថ្មីមិនដូចគ្នាទេ",
        "pwd-required": "សូមបញ្ចូលលេខសម្ងាត់បច្ចុប្បន្ន លេខសម្ងាត់ថ្មី និងបញ្ជាក់លេខសម្ងាត់ថ្មី",
        "pwd-required-type": "លេខសម្ងាត់ត្រូវមានប្រវែងតិចបំផុត៨តួដែលក្នុងនោះតម្រូវឲ្យមានអក្សរធំ អក្សរតូចនិងលេខ"
      }
    },
    "change-pwd": {
      "main-title": "Change password",
      "description": " ",
      "current-pwd": {
        "title": "Current password",
        "description": "Your current password login"
      },
      "new-pwd": {
        "title": "New password",
        "description": "Minimum password length is 8. Required uppercase letters, lowercase letters and numbers."
      },
      "confirm-pwd": {
        "title": "Confirm new password",
        "description": "Repeat your new password."
      },
      "error-messaga": {
        "pwd-not-match": "Passwords do not match.",
        "pwd-required": "Current, new, and confirm passwords are required. Please enter these values.",
        "pwd-required-type": "Password must contain uppercase letters, lowercase letters, numbers and 8 characters minimum."
      }
    },
    "edit-profile": {
      "main-title": "Edit profile",
      "description": " ",
      "first-name": "First name",
      "last-name": "Last name"
    }
  },
  "aimlApp": {
    "my-tasks": {
      "main-header": "ភារកិច្ចរបស់ខ្ញុំ",
      "placeholder-search": "ស្វែងរកភារកិច្ចតាមឈ្មោះ"
    },
    "my-applications": {
      "main-header": "កម្មវិធីរបស់ខ្ញុំ",
      "placeholder-search": "ស្វែងរកកម្មវិធីតាមឈ្មោះ",
      "all-apps": {
        "title": "កម្មវិធីទាំងអស់",
        "group-human-capital-management": "ការគ្រប់គ្រងធនធានមនុស្ស",
        "group-administration": "ការគ្រប់គ្រងកម្មវិធី"
      }
    },
    "recently-visited": {
      "title": "កម្មវិធីដែលបានចូលប្រើប្រាស់ថ្មីៗ"
    }
  },
  "acm": {
    "messageProvisionedResources": {
      "header": "",
      "message": ""
    },
    "user": {
      "list": {
        "main-title": "Users",
        "filter-box-placeholder": "Filter by user name, first name, last name, ...",
        "description": " ",
        "table-name": "user",
        "table-header": {
          "user-name": "User name",
          "first-name": "First name",
          "last-name": "Last name",
          "role": "Role",
          "create-at": "Created at",
          "create-by": "Created by"
        },
        "filter-key": {
          "user-name": "Filter by User name",
          "first-name": "Filter by First name",
          "last-name": "Filter by Last name",
          "role": "Filter by Role"
        }
      },
      "form": {
        "main-title-create": "Create new user",
        "main-title-edit": "Edit user",
        "description": "",
        "user-identity": {
          "title": "User identity",
          "user-name": {
            "label": "User name",
            "description": "",
            "placeholder": "Must be a valid email address"
          },
          "first-name": {
            "label": "First name",
            "description": " ",
            "placeholder": "For example, Bopha"
          },
          "last-name": {
            "label": "Last name",
            "description": "",
            "placeholder": "For example, CHAN"
          },
          "line-employee": {
            "label": "Linked employee",
            "description": "",
            "placeholder": ""
          }
        },
        "user-permission": {
          "title": "User permission",
          "system-base-role": {
            "label": "System based role",
            "tenant-user": "Tenant user",
            "tenant-admin": "Tenant admin(administers other users)",
            "description": ""
          },
          "job-base-role": {
            "label": "Job based role",
            "description": "",
            "placeholder": "Select an existing role for this user"
          },
          "policy": {
            "label": "Policy",
            "description": "",
            "placeholder": "Select existing policies defining permissions for those users"
          }
        }
      },
      "detail": {
        "main-title": "User details",
        "description": " ",
        "user-identity": {
          "title": "User identity",
          "user-name": "User name",
          "first-name": "First name",
          "last-name": "Last name",
          "created-at": "Created at",
          "created-by": "Created by",
          "updated-at": "Updated at",
          "updated-by": "Updated by"
        },
        "permission": {
          "title": "User permission",
          "system-based-role": "System based role",
          "job-based-role": "Job based role",
          "policies": "Policies"
        }
      }
    },
    "policy": {
      "list": {
        "main-title": "Policies",
        "filter-box-placeholder": "Filter by policy name",
        "description": " ",
        "table-name": "policy",
        "table-header": {
          "name": "Name",
          "statements": "Statements",
          "created-at": "Created at",
          "updated-at": "Updated at"
        },
        "filter-key": {
          "name": "Filter by policy name"
        }
      },
      "form": {
        "main-title-create": "Create policy",
        "main-title-edit": "Edit policy",
        "description": "",
        "general-info": {
          "title": "General information",
          "name": {
            "label": "Name",
            "description": "",
            "placeholder": "For example, HR Assistant"
          }
        },
        "statements": {
          "title": "Statements",
          "discription": "A policy statement defines a set of permissions used to a assign to a either a Role, User or User Group. A policy can have multiple statements, e.g. Statement 1 define permissions to access resources under Directory service while Statement 2 is for Employees service",
          "statement-name": {
            "label": "Statement name",
            "description": "",
            "placeholder": "E.g. Directory Service"
          },
          "serviec-name": {
            "label": "Service name",
            "description": "",
            "placeholder": "Select the service to which you want to have access control"
          },
          "resources": {
            "label": "Resources",
            "description": "",
            "placeholder": "Select those resource(s) to which you want to have access control"
          },
          "action": {
            "label": "Actions",
            "description": "",
            "placeholder": "Select those action(operations) to include in this statement"
          },
          "effect": {
            "label": "Effect",
            "description": "Specify whether to Allow or Deny above Actions/Operations under this statement",
            "allow": "Allow",
            "deny": "Deny"
          }
        }
      },
      "detail": {
        "main-title": "Policy details",
        "description": "",
        "general-info": {
          "title": "Gerneral information",
          "policy-type": "Policy type",
          "policy-name": "Policy name",
          "created-at": "Created at",
          "updated-at": "Updated at"
        },
        "statement": {
          "title": "Statements",
          "name": "Name",
          "service": "Service",
          "details": {
            "view-detail": "View details",
            "title": "Statement details",
            "name": "Name",
            "service": "Service",
            "effect": "Effect",
            "resources": "Resources",
            "actions": "Actions"
          }
        }
      }
    },
    "role": {
      "list": {
        "main-title": "Roles",
        "filter-box-placeholder": "Filter by role name",
        "description": " ",
        "table-name": "role",
        "table-header": {
          "name": "Name",
          "statements": "Policies",
          "created-at": "Created at",
          "updated-at": "Updated at"
        },
        "filter-key": {
          "name": "Filter by role name"
        }
      },
      "form": {
        "main-title-create": "Create role",
        "main-title-edit": "Edit role",
        "description": "",
        "general-info": {
          "title": "General information",
          "name": {
            "label": "Name",
            "description": "",
            "placeholder": "For example, HR Executive"
          }
        },
        "permissions": {
          "title": "Permissions",
          "policies": {
            "label": "Policies",
            "description": "",
            "placeholder": "Select one or more existing policies to define permissions"
          }
        }
      },
      "detail": {
        "main-title": "Role details",
        "description": " ",
        "general-info": {
          "title": "Gerneral information",
          "policy-type": "Role name",
          "policy-name": "Role type",
          "created-at": "Created at",
          "updated-at": "Updated at"
        },
        "permission": {
          "title": "Permission",
          "policies": "Policies"
        }
      }
    },
    "user-group": {
      "list": {
        "main-title": "User groups",
        "filter-box-placeholder": "Filter by group name",
        "description": " ",
        "table-name": "user group",
        "table-header": {
          "group-name": "Group name",
          "user": "User",
          "created-at": "Created at",
          "created-by": "Created by"
        },
        "filter-key": {
          "name": "Filter by group name"
        }
      },
      "form": {
        "main-title-create": "Create user group",
        "main-title-edit": "Edit user group",
        "description": "",
        "group-name": {
          "label": "Group name",
          "description": "",
          "placeholder": "For example, HR Interns"
        },
        "group-members": {
          "label": "Group members",
          "description": "",
          "placeholder": "Select existing users to become members of the group"
        },
        "group-permissions": {
          "label": "Group permissions",
          "description": "",
          "placeholder": "Select existing policies defining permissions for those users"
        }
      },
      "detail": {
        "main-title": "User group details",
        "description": " ",
        "general-info": {
          "title": "Gerneral information",
          "group-name": "Group name",
          "group-members": "Group members",
          "group-permission": "Group permission",
          "created-at": "Created at",
          "created-by": "Created by"
        }
      }
    }
  },
  "directory": {
    "messageProvisionedResources": {
      "header": "Initialize Default tenant resources",
      "message": "Clone default selection process in order to process applications you need to have a selection process. A selection process consists of steps, lined with each other, allowing you to"
    },
    "menu": {
      "dashboard": "",
      "people": "",
      "organizations": "",
      "data-migrations": ""
    },
    "people": {
      "list": {
        "main-title": "",
        "filter-box-placeholder": "",
        "table-header": {
          "full-name": "",
          "sex": "",
          "nationality": "",
          "contact-info": ""
        },
        "filter-key": {
          "full-name": "",
          "middle-name": "",
          "last-name": ""
        }
      },
      "form": {
        "main-title-create": "",
        "main-title-edit": "",
        "personal-data": {
          "sub-title": "",
          "title": {
            "label": "",
            "description": ""
          },
          "full-name": {
            "label": "",
            "description": ""
          },
          "first-name": {
            "label": "First name",
            "description": " "
          },
          "last-name": {
            "label": "",
            "description": ""
          },
          "middle-name": {
            "label": "",
            "description": ""
          },
          "gender": {
            "label": "",
            "description": "",
            "options": {
              "male": "",
              "female": ""
            }
          },
          "date-of-birth": {
            "label": "",
            "description": ""
          },
          "country-of-birth": {
            "label": "",
            "description": " "
          },
          "province-of-birth": {
            "label": "",
            "description": ""
          },
          "nationality": {
            "label": "",
            "description": ""
          },
          "national-id": {
            "label": "National id",
            "description": " "
          },
          "marital-status": {
            "label": "",
            "description": ""
          },
          "profile-photo": {
            "label": "",
            "description": ""
          },
          "profile-summary": {
            "label": "",
            "description": ""
          },
          "achievement": {
            "label": "",
            "description": ""
          }
        },
        "contact-info": {
          "sub-title": "",
          "contact-type": {
            "label": "",
            "description": ""
          },
          "contact-value": {
            "label": "",
            "description": ""
          }
        }
      },
      "details": {
        "main-title": "",
        "personal-data": {
          "sub-title": "",
          "first-name": "",
          "middle-name": "",
          "last-name": "",
          "gender": "",
          "date-of-birth": "",
          "place-of-birth": "",
          "nationality": "",
          "marital-status": ""
        },
        "contact-info": {
          "sub-title": ""
        }
      }
    },
    "organizations": {
      "basic-form": {
        "main-header-create": "Create organization profile",
        "main-header-edit": "Edit organization profile",
        "basic-data": {
          "title": "Basic data",
          "offical-name": "Official name",
          "short-name": "Short name",
          "nature": "Nature",
          "industry": "Industry"
        }
      }
    }
  },
  "employment": {
    "messageProvisionedResources": {
      "header": "Initialize default tenant resources",
      "message": "Clone default selection process in order to process applications you need to have a selection process. A selection process consists of steps, lined with each other, allowing you to"
    },
    "menu": {
      "dashboard": "Dashboard",
      "employer": "និយោជក"
    },
    "employer": {
      "executiveOversight": {
        "search": "ស្វែងរកតាមគម្រោង ឬអ្នកត្រួតពិនិត្យ...",
        "executiveOversightForm": {
          "title": "កំណត់អ្នកត្រួតពិនិត្យប្រតិបត្តិ",
          "editForm": {
            "title": "កែប្រែការចាត់តាំងត្រួតពិនិត្យ"
          },
          "outsourcingProject": {
            "title": "គម្រោង / ក្រុមហ៊ុន Outsourcing",
            "description": "ជ្រើសរើសក្រុមហ៊ុនដែលត្រូវគ្រប់គ្រងសម្រាប់ការចាត់តាំងត្រួតពិនិត្យ",
            "search": "-- ជ្រើសរើសគម្រោង --"
          },
          "SLTMembers": {
            "title": "សមាជិក SLT",
            "description": "ជ្រើសរើសសមាជិក SLT ម្នាក់ ឬច្រើននាក់ដើម្បីចាត់តាំង",
            "search": "ស្វែងរកបុគ្គលិក..."
          }
        },
        "assignOverseer": "អ្នកត្រួតពិនិត្យដែលបានចាត់តាំង",
        "noAssignOverseer": "មិនទាន់មានអ្នកត្រួតពិនិត្យ",
        "alreadyAssigned": "បានកំណត់រួចហើយ"
      },
      "list": {
        "main-title": "និយោជក",
        "filter-box-placeholder": " ",
        "description": "ប្រសិនបើអ្នកកំពុងគ្រប់គ្រងអាជីវកម្ម សាខា ឬគម្រោងច្រើន អ្នកអាចបង្កើតនិយោជកផ្សេងៗគ្នាសំរាប់ការគ្រប់គ្រងបុគ្គលិក បញ្ជីប្រាក់ខែ និងទិន្នន័យដទៃទៀតរបស់ពួកគេទាំងអស់នៅក្នុងគណនីអ្នកប្រើប្រាស់ (Tenant account) របស់អ្នកតែមួយ។ ចំណាំ៖ និយោជកឈ្មោះ  {organization_name} គឺត្រូវបានបង្កើតឡើងដោយស្វ័យប្រវត្តិសម្រាប់អ្នក។",
        "table-name": "និយោជក",
        "table-header": {
          "full-name": "ឈ្មោះពេញ",
          "abbreviated-name": "ឈ្មោះកាត់",
          "employee-id-format": "ទំរង់លេខកូដបុគ្គលិក",
          "type": "ប្រភេទនិយោជក",
          "active-employee": "ចំនួនបុគ្គលិកកំពុងបម្រើការងារ"
        },
        "filter-key": {
          "full-name": "ច្រោះតាមរយៈឈ្មោះពេញ",
          "abbreviated-name": "ច្រោះតាមរយៈឈ្មោះកាត់",
          "type": "ច្រោះតាមរយះប្រភេទនិយោជក"
        }
      },
      "delete-message": "លុបនិយោជកនេះនឹងលុបទិន្នន័យដទៃទៀតទាំងអស់របស់គាត់ ឧទាហរណ៍បុគ្គលិកទាំងអស់នៅក្រោមនិយោជកនេះនឹងបានត្រូវលុបផងដែរ។ តើអ្នកពិតជាចង់លុបមែនឬ?",
      "detail": {
        "main-title": "ពត៌មាននិយោជក",
        "sub-title1": {
          "title": "ពត៌មានទូទៅ",
          "full-name": "ឈ្មោះពេញ",
          "abbreviated-name": "ឈ្មោះខ្លី",
          "employee-id-format": "ទំរង់លេខកូដបុគ្គលិក",
          "created-at": "បង្កើតឡើងនៅ",
          "created-by": "បង្កើតឡើងដោយ",
          "updated-at": "ធ្វើបច្ចុប្បន្នភាពនៅ",
          "updated-by": "ធ្វើបច្ចុប្បន្នភាពដោយ"
        },
        "sub-title2": {
          "title": "ពត៌មានដទៃទៀត",
          "phone-number": "លេខទូរស័ព្ទ",
          "email-address": "អុីម៉េល",
          "street-address": "អសយដ្ឋាន",
          "website": "គេហទំព័រ",
          "logo": " "
        }
      },
      "form": {
        "main-title-create": "បង្កើតនិយោជកថ្មី",
        "main-title-edit": "កែប្រែពត័មាននិយោជក",
        "description": "For a quick creation, you enter just the basic data first while other datails could be entered any time later.",
        "general-info": {
          "title": "ពត៌មានទូទៅ",
          "full-name": {
            "label": "ឈ្មោះពេញ",
            "description": "What is the full name of the employer entity? E.g. Angkor Brilliant Consulting."
          },
          "abbreviated-name": {
            "label": "ឈ្មោះខ្លី",
            "description": "What is its short name? E.g. ABC"
          },
          "employee-id-format": {
            "label": "ទំរង់លេខកូដបុគ្គលិក",
            "description": "The placeholder of employee ID. E.g. ABC-00000"
          }
        },
        "details": {
          "title": "Other info",
          "phone-number": {
            "label": "Phone number(s)",
            "description": "One or more phone numbers"
          },
          "email-address": {
            "label": "Email address(es)",
            "description": "One or more email addresses."
          },
          "street-address": {
            "label": "Address",
            "description": "Street address."
          },
          "website": {
            "label": "Website",
            "description": "Website URL e.g www.abc-consulting.com"
          },
          "logo": {
            "label": "Logo",
            "description": "Image(.jpeg or .png)."
          }
        }
      },
      "manage": {
        "main-title": "ការគ្រប់គ្រងរបស់និយោជក",
        "description": "ខាងក្រោមគឺជាផ្នែកផ្សេងៗនៃការគ្រប់គ្រងនិយោជករបស់អ្នក។ ជ្រើសរើសផ្នែកណាមួយដើម្បីចូលមើលសេចក្តីលម្អិតរបស់វា។",
        "app-sections": {
          "employee": {
            "title": "Employees",
            "description": "គ្រប់គ្រងសំណុំឯកសារបុគ្គលិក",
            "active": "Active"
          },
          "department": {
            "title": "Departments",
            "description": "គ្រប់គ្រងនាយកដ្ឋានរឺផែ្នក",
            "active": "Active"
          },
          "job-profile": {
            "title": "Job Profiles",
            "description": "គ្រប់គ្រងសំណុំឯកសារមុខងារ",
            "active": "Active"
          }
        }
      }
    },
    "employee": {
      "list": {
        "main-title": "Employees",
        "filter-box-placeholder": "Filter by full name, job title, ...",
        "description": " ",
        "table-name": "employee",
        "table-header": {
          "employee-id": "Employee ID",
          "employee-name": "Full name",
          "employee-status": "Status",
          "job-title": "Job title",
          "department": "Department",
          "work-contacts": "Work contacts"
        },
        "filter-key": {
          "employee-id": "Filter by Employee ID",
          "employee-name": "Filter by Full name",
          "employee-status": "Filter by Status",
          "job-title": "Filter by Job title",
          "department": "Filter by Department",
          "work-email": "Filter by Work email"
        }
      },
      "delete-message": "Deleting this employee will delete all his/her related data. Are you sure you want to delete this employee?",
      "form": {
        "main-title-create": "Create new employee",
        "main-title-edit": "Edit employee",
        "description": "For a quick creation, you enter just the employee's personal and job summaries while their other details could be added any time later.",
        "personal-summary": {
          "title": "Personal summary",
          "full-name": {
            "label": "Full name",
            "description": "You can enter their family name and given name, for example SOK Sovatha"
          },
          "gender": {
            "label": "Gender",
            "description": " ",
            "male": "Male",
            "female": "Female"
          },
          "phone-number": {
            "label": "Phone number",
            "description": "Mobile number(s)"
          },
          "email-address": {
            "label": "Email",
            "description": "Email address(es)"
          }
        },
        "job-summary": {
          "title": "Job summary",
          "hire-data": {
            "label": "Hire date",
            "description": "The exact data the employee starts working. Note that this could be different from the date you create this record."
          },
          "employee-classification": {
            "label": "Employee classification",
            "description1": "Employees with fixed duration contracts (FDCs) or undetermined duration contracts (UDCs). \n",
            "description2": "Employees performing work temporarily, intermittently or seasonally.",
            "regular": "Regular",
            "casual": "Casual"
          }
        }
      },
      "detail": {
        "main-title": "Employee details",
        "description": "To have more accurate profile, you need to update the following sections to reflect the employee's current job. To edit data for a section, click on Edit button on the right of the section title.",
        "summaries": {
          "title": "Summaries",
          "employee-id": "Employee ID",
          "full-name": "Full name",
          "employment-status": "Employment status",
          "employee-classification": "Employee classification",
          "position": "Position",
          "department": "Department",
          "hire-date": "Hire date",
          "end-date": "End date",
          "phone-number": "Phone number"
        },
        "employment-detail": {
          "employment-detail": {
            "title": "Employment Details",
            "subsection": {
              "current-job": "Current Job",
              "compensation": "Compensation and Benefits",
              "employment-contract": "Contracts",
              "bank-info": "Bank Information",
              "family-member": "Family Members",
              "work-contact": "Contacts",
              "insurance": "Insurance"
            }
          },
          "personal-detail": {
            "title": "Personal Details",
            "subsection": {
              "bio-data": "Bio Data",
              "contact": "Contacts",
              "dependent": "Dependents",
              "parent": "Parent Information",
              "insurance": "Insurance Membership/NSSF",
              "work-permit": "Workbook/Work Permit"
            }
          },
          "employment-contract": {
            "list": {
              "main-title": "Employment contracts",
              "filter-box-placeholder": "Filter by Job Title, Type, ... ",
              "table-name": "employment contract",
              "table-header": {
                "job-title": "Job title",
                "type": "Type",
                "status": "Status",
                "start-date": "Start date",
                "end-date": "End date"
              },
              "filter-key": {
                "job-title": "Filter by Job Title",
                "type": "Filter by Type",
                "status": "Filter by Status",
                "start-date": "Filter by Start Date",
                "end-date": "Filter by End Date"
              }
            },
            "form": {
              "enable-reminder": "",
              "send-email-reminder": "",
              "send-to": "",
              "main-title-create": "Create new contract",
              "main-title-edit": "Edit contract",
              "main-title-renew": "Renew contract",
              "type": {
                "label": "Type",
                "description": "FDC: Fixed Duration Contract, UDC: Undetermined Duration Contract, Select PROBATION if the contract for the employee covers just the probation period."
              },
              "employment-type": {
                "label": "Employment type",
                "description": " "
              },
              "start-date": {
                "label": "Start date",
                "description": " "
              },
              "end-date": {
                "label": "End date",
                "description": " "
              },
              "period": "With probation period, end date",
              "job-role": {
                "label": "Job role",
                "description": " ",
                "placeholder": "Select a job profile"
              },
              "department": {
                "label": "Department",
                "description": " ",
                "placeholder": "Select a department"
              },
              "line-manager": {
                "label": "Line manager",
                "description": " ",
                "placeholder": "Select line manager"
              },
              "basic-salary": {
                "label": "Basic salary (monthly)",
                "description": " ",
                "placeholder": " "
              },
              "upload-document": {
                "label": "Upload document",
                "description": " "
              }
            },
            "detail": {
              "main-title": "Employment contract details",
              "overview": {
                "enable-reminder": "",
                "send-email-reminder": "",
                "send-to": "",
                "sub-title": "Overview",
                "contract-type": "Contract type",
                "employment-type": "Employment type",
                "job-role": "Job role",
                "department": "Department",
                "line-manager": "Line manager",
                "start-date": "Start date",
                "end-date": "End date",
                "period": "Probation period end date"
              },
              "related-events": {
                "list": {
                  "main-title": "Employment changes",
                  "table-name": "employment change",
                  "table-header": {
                    "type": "Change type",
                    "effective-date": "Effective date",
                    "description": "Description",
                    "created-date": "Created at",
                    "Created-by": "Created by"
                  }
                },
                "form": {
                  "main-title-create": "Create new employment change",
                  "main-title-edit": "Edit employment change",
                  "description": "Fill in those required and any of optional fields below to soundly reflect this change for the employee.",
                  "type": {
                    "label": "Type",
                    "description": "Select a type applicable to change"
                  },
                  "employment-type": {
                    "label": "Employment type",
                    "description": "Specify a employment type"
                  },
                  "effective-date": {
                    "label": "Effective date",
                    "description": "Specify the date from which the change takes effect."
                  },
                  "reason": {
                    "label": "Reason",
                    "description": "What is the motive for the change?"
                  },
                  "job-role": {
                    "label": "Job role",
                    "description": "If the change affects new job role, specify it one below."
                  },
                  "basic-salary": {
                    "label": "Basic salary (monthly)",
                    "description": "If the change affects new basic salary, specify it below."
                  },
                  "department": {
                    "label": "Department",
                    "description": "If the change affects new department/section, specify it below."
                  },
                  "line-manager": {
                    "label": "Line manager",
                    "description": "If the change affects new line manager, specify it below."
                  }
                },
                "detail": {
                  "main-title": "Employment change details",
                  "desciprtion": "",
                  "type": "Change type",
                  "reason": "Reason",
                  "effective-date": "Effective date",
                  "employment-type": "Employment type",
                  "job-role": "Job role",
                  "department": "Department",
                  "line-manager": "Line manager",
                  "created-at": "Created at",
                  "created-by": "Created by",
                  "updated-at": "Updated at",
                  "updated-by": "Updated by",
                  "benefits": {
                    "sub-title": "Benefits"
                  }
                }
              }
            }
          },
          "current-job": {
            "main-title": "Current job",
            "description": " ",
            "job-profile": {
              "see-detail": "See details",
              "sub-titile": "Job profile",
              "position": "Position",
              "grade": "Grade",
              "level": "Level",
              "working-hours-per-week": "Working hours per week",
              "responsibilities": "Responsibilities",
              "requirements": "Requirements",
              "job-description": "Job description"
            },
            "organizational-structure": {
              "sub-titile": "Organizational structure",
              "department": "Department",
              "number-of-subordinates": "Subordinates",
              "line-manager": "Line manager"
            },
            "employment": {
              "sub-titile": "Employment",
              "status": "Status",
              "type": "Type",
              "contract": "Contract",
              "basic-salary": "Basic salary (monthly)",
              "work-schedule": "Work schedule",
              "annual-leave-balance": "Annual leave balance"
            }
          }
        },
        "responsibilities": {
          "responsibilitiesDescription": "Describe the key duties and accountabilities of this role."
        },
        "requirements": {
          "requirementsDescription": "List required skills, experience and qualifications."
        },
        "jobGradeDescription": "Used for compensation and career progression.",
        "employmentLevelDescription": "Defines seniority and role classification.",
        "day": "Days",
        "entitlementType": {
          "title": "Entitlements",
          "entitlementType": "Entitlement Type",
          "column": {
            "daysEarned": "Days Earned",
            "notes": "Notes",
            "openingBalance": "Opening Balance",
            "carriedForward": "Carried Forward",
            "monthlyAccrual": "Monthly Accrual",
            "seniorityAccrual": "Seniority Accrual"
          }
        }
      },
      "employmentDetails": "Employment Details",
      "jobTitle": "Job Title",
      "jobGrade": "Job Grade",
      "employmentLevel": "Employment Level",
      "baseSalary": "Base Salary",
      "workingHoursPerWeek": "Working Hours per Week",
      "workLocation": "Work Location",
      "scheduleName": "Schedule Name",
      "responsibilities": "Responsibilities",
      "requirements": "Requirements",
      "reportingStructure": "Reporting Structure",
      "directManager": "Direct Manager",
      "reports": "Reports",
      "viewReports": "View Reports",
      "organizationalUnit": "Organizational Unit",
      "organizationalLayer": "Organizational Layer",
      "workingSchedule": "Working Schedule",
      "workingDays": "Working Days",
      "totalWeeklyHours": "Total Weekly Hours"
    },
    "leave": {
      "entitlementsSummary": "Leave Entitlements Summary",
      "totalEntitlement": "Total Entitlement",
      "annualLeaveTaken": "Annual Leave Taken",
      "annualLeaveBalance": "Annual Leave Balance",
      "periodSummary": "Leave Period Summary"
    },
    "job-profile": {
      "list": {
        "main-title": "Job profiles",
        "filter-box-placeholder": "Filter by position, level, grade....",
        "description": " ",
        "table-name": "Job profile",
        "table-header": {
          "position-title": "Position title",
          "level": "Level",
          "grade": "Grade",
          "min-salary": "Min salary",
          "max-salary": "Max salary",
          "working-hours": "Working hours"
        },
        "filter-key": {
          "position-title": "Filter by Position title",
          "level": "Filter by Level",
          "grade": "Filter byGrade",
          "min-salary": "Filter by Min salary",
          "max-salary": "Filter byMax salary",
          "working-hours": "Filter byWorking hours"
        }
      },
      "form": {
        "main-title-create": "Create new job profile",
        "main-title-edit": "Edit job profile",
        "description": " ",
        "general-info": {
          "sub-title": "General information",
          "position": {
            "label": "Position",
            "description": " ",
            "placeholder": "Select a position"
          },
          "job-grade": {
            "label": "Job grade",
            "description": " ",
            "placeholder": "Select a job grade"
          },
          "job-level": {
            "label": "Job level",
            "description": " ",
            "placeholder": "Select a job level"
          },
          "min-salary": {
            "label": "Min. salary",
            "description": " ",
            "placeholder": " "
          },
          "max-salary": {
            "label": "Max. salary",
            "description": " ",
            "placeholder": " "
          },
          "base-currency": {
            "label": "Base currency",
            "description": " ",
            "placeholder": "Select a base currency"
          },
          "working-hours-per-week": {
            "label": "Working hours/per week",
            "description": " ",
            "placeholder": " "
          }
        },
        "responsibilities": {
          "sub-title": "Responsibilities"
        },
        "requirements": {
          "sub-title": "Requirements"
        },
        "required-competency": {
          "sub-title": "Required competencies",
          "description": " "
        },
        "competencies": {
          "sub-title": "Competencies"
        }
      },
      "detail": {
        "main-title": "Job profile details",
        "general-info": {
          "sub-title": "General information",
          "position-title": "Position title",
          "grade": "Grade",
          "level": "Level",
          "min-salary": "Min salary",
          "max-salary": "Max salary",
          "working-hour": "Working hour",
          "created-at": "Created at",
          "created-by": "Created by",
          "updated-at": "Updated at",
          "updated-by": "Updated by"
        },
        "responsibilities": "Responsibilities",
        "requirements": "Requirements"
      }
    },
    "department": {
      "list": {
        "main-title": "Departments",
        "filter-box-placeholder": "Filter by full name, abbreviated name, ...",
        "description": " ",
        "table-name": "department",
        "table-header": {
          "full-name": "Full name",
          "abbreviated-name": "Abbreviated name",
          "status": "Status",
          "parent-department": "Parent department"
        },
        "filter-key": {
          "full-name": "Filter by Full name",
          "abbreviated-name": "Filter by  Abbreviated name",
          "status": "Filter by Status",
          "parent-department": "Filter by Parent department"
        }
      },
      "form": {
        "main-title-create": "Create new department",
        "main-title-edit": "Edit department",
        "full-name": {
          "label": "Full name",
          "description": "Full name for the department/section",
          "placeholder": " "
        },
        "abbreviated-name": {
          "label": "Abbreviated Name",
          "description": "Select an abbreviated name for the department/section",
          "placeholder": " "
        },
        "parent-department": {
          "label": "Parent department",
          "description": "Select a parent for the department/section",
          "placeholder": "Select a parent for the department/section"
        }
      },
      "delete-message": "Are you sure want to delete this department?",
      "detail": {
        "general-info": {
          "sub-title": "General information",
          "full-name": "Full name",
          "status": "Status",
          "abbreviated-name": "Abbreviated name",
          "parent-department": "Parent department",
          "created-at": "Created at",
          "created-by": "Created by",
          "updated-at": "Updated at",
          "updated-by": "Updated by"
        }
      }
    },
    "compensation": {
      "detail": {
        "main-title": "Compensation and benefits",
        "description": "You use this section to record those compensation and benefits offered to the employee.",
        "basic-salary": {
          "sub-title": "Base salary",
          "salary": "Basic salary (monthly)"
        },
        "pay-structure": {
          "sub-title": "Pay structure",
          "pay-structure": "Linked pay structure"
        },
        "pay-structure-form": {
          "main-title": "Edit employee pay structure",
          "description": "The selected pay structure below will be assigned to the {count_employee} selected employee(s).",
          "pay-structure": {
            "label": "Pay structure",
            "description": " "
          }
        }
      }
    },
    "bank-info": {
      "main-title": "Bank information details",
      "sub-header": "Bank information",
      "full-name": "Full name",
      "short-name": "Short name",
      "account-name": "Account name",
      "account-number": "Account number",
      "form": {
        "main-title": "Edit bank information",
        "bank-full-name": "Bank full name",
        "account-name": "Account name",
        "account-number": "Account number"
      }
    },
    "family-member": {
      "main-title": "Family members",
      "spouse": "Spouse",
      "children": "Children",
      "parent": "Parents",
      "table-name-spouse": "spouse",
      "table-name-child": "child",
      "table-name-parent": "parent",
      "btn-lable-spouse": "Edit spouse",
      "btn-lable-children": "Edit children",
      "btn-lable-parent": "Edit parent",
      "table": {
        "name": "Full name",
        "gender": "Gender",
        "date-of-birth": "Date of birth",
        "dependent": "Dependent"
      },
      "form": {
        "edit-spouse": "Edit spouse",
        "edit-child": "Edit child",
        "edit-parent": "Create parent",
        "name": "Full name",
        "gender": "Gender",
        "dependent": {
          "title": "Dependent",
          "true": "True",
          "false": "False"
        }
      }
    },
    "work-contact": {
      "main-title": "Contacts",
      "description": " ",
      "list": {
        "main-title": "Work contacts",
        "description": " ",
        "table": {
          "contact-type": "Contact type",
          "contact-value": "Contact value"
        }
      },
      "form": {
        "main-title": "Edit work contacts",
        "contact-type": "Contact type",
        "contact-value": "Contact value"
      }
    },
    "personal-detail": {
      "personal-contact": {
        "main-title": "Contacts",
        "description": " ",
        "list": {
          "title": "Personal contacts",
          "contact-type": "Contact type",
          "contact-value": "Contact value"
        },
        "form": {
          "title": "Edit personal contact",
          "contact-type": "Contact type",
          "contact-value": "Contact value"
        }
      },
      "emergency-contact": {
        "main-title": "Emergency contacts",
        "description": " ",
        "list": {
          "name": "Name",
          "relationship": "Relationship",
          "contact-type": "Contact type",
          "contact-value": "Contact value"
        },
        "form": {
          "title": "Edit emergency contact",
          "name": "Name",
          "relationship": "Relationship",
          "contact-type": "Contact type",
          "contact-value": "Contact value"
        }
      }
    },
    "job-grade": {
      "mainTabelHeader": "Job Grades & Salary Bands",
      "column": {
        "grade": "Grade Level",
        "level": "Level",
        "typical-titles": "Typical Job Titles",
        "salary-range-currency": "Salary Currency",
        "salary-ranges": "Salary Band"
      },
      "filter-text": "Search by grade level, or job title…"
    }
  },
  "leave": {
    "messageProvisionedResources": {
      "header": "Initialize default tenant resources",
      "message": "Clone default selection process in order to process applications you need to have a selection process. A selection process consists of steps, lined with each other, allowing you to"
    },
    "menu": {
      "dashboard": "Dashboard",
      "leave": "Leave"
    },
    "leave-type": {
      "list": {
        "main-title": "Leave Types",
        "filter-box-placeholder": "Filter by Name, Code, ...",
        "description": "Leave types refers to the different categories or types of leave that employees can take from work. Some common types of leave are vacation leave, sick leave, personal leave or emergency leave, parental or family leave, and bereavement leave.",
        "table-header": {
          "title": "Title",
          "code": "Code",
          "availability": "Availability",
          "status": "Status"
        },
        "filter-key": {
          "title": "Filter by Title:",
          "code": "Filter by Code:"
        }
      },
      "delete-message": "Are you sure want to delete this leave type?",
      "detail": {
        "main-title": "Leave type details",
        "general": "General Information",
        "general-info": {
          "title": "Title",
          "code": "Code",
          "availability": "Availability",
          "status": "Status",
          "created-at": "Created at",
          "created-by": "Created by",
          "updated-at": "Updated at",
          "updated-by": "Updated by"
        }
      },
      "form": {
        "main-title-create": "Create leave type",
        "main-title-edit": "Edit leave type",
        "general-info": {
          "title": "Title",
          "code": "Code",
          "availability": "Availability",
          "availability-des": "ON_AVAILABLE generally applies to ANNUAL_LEAVE, ON_GRANTED generally applies to MATERNITY_LEAVE, ALWAYS generally applies to SICK_LEAVE.",
          "status": "Status",
          "on-available": "ON_AVAILABLE",
          "on-granted": "ON_GRANTED",
          "always": "ALWAYS",
          "active": "Active",
          "inactive": "Inactive"
        }
      }
    },
    "leave-request": {
      "list": {
        "main-title": "Leave Requests",
        "filter-box-placeholder": "Filter by LeaveType.Code, Status, ...",
        "description": " Leave request is an important part of workforce management, as it helps ensure that employees have access to the time off they need while also ensuring that the business can continue to operate effectively.",
        "table-header": {
          "employee-name": "Employee Name",
          "leave-type": "Leave Type",
          "from-date": "From Date",
          "to-date": "To Date",
          "status": "Status"
        },
        "table-field": {
          "employee-name": "Employee.Name",
          "leave-type": "LeaveType.Title",
          "from-date": "FromDate",
          "to-date": "ToDate",
          "status": "Status"
        },
        "filter-key": {
          "code": "Filter by LeaveType.Code:",
          "status": "Filter by Status:"
        }
      },
      "delete-message": "Are you sure want to delete this leave request?",
      "delete-applied-date-message": "Are you sure want to delete this applied date?",
      "submit-message": "Are you sure want to submit this leave request?",
      "approve-message": "Are you sure want to approve this leave request?",
      "detail": {
        "main-title": "Leave request details",
        "general": "General Information",
        "approve": "Approve",
        "reject": "Reject",
        "reason": "Reason",
        "cancel": "Cancel",
        "general-info": {
          "employee-name": "Employee name",
          "leave-type": "Leave type",
          "date": "Date",
          "reason": "Reason",
          "status": "Status",
          "created-at": "Created at",
          "created-by": "Created by",
          "updated-at": "Updated at",
          "updated-by": "Updated by",
          "validated-at": "Validated at",
          "validated-by": "Validated by"
        }
      },
      "form": {
        "main-title-create": "Create Leave Request",
        "main-title-edit": "Edit Leave Request",
        "general-info": {
          "leave-type": "Leave Type",
          "title": "Title",
          "code": "Code",
          "availability": "Availability",
          "status": "Status",
          "date": "Date",
          "period-day": "Period of day",
          "whole-day": "WHOLE DAY",
          "whole-day-value": "WHOLE_DAY",
          "apply-date-create": "Create apply dates",
          "apply-date-edit": "Edit applied date",
          "morning": "MORNING",
          "afternoon": "AFTERNOON",
          "on-available": "ON_AVAILABLE",
          "on-available-des": "This generally applies to ANNUAL_LEAVE",
          "on-granted": "ON_GRANTED",
          "on-granted-des": "This generally applies to MATERNITY_LEAVE, etc.",
          "always": "ALWAYS",
          "always-des": "This generally applies to SICK_LEAVE, etc.",
          "active": "Active",
          "inactive": "Inactive",
          "leave-balance": "Remaining Leave",
          "reasons": "Reason",
          "manager": "Line Manager",
          "cc": "Line Manager CC"
        }
      }
    }
  },
  "payroll": {
    "messageProvisionedResources": {
      "header": "Initialize Default tenant resources",
      "message": "Clone default selection process in order to process applications you need to have a selection process. A selection process consists of steps, lined with each other, allowing you to"
    },
    "employer": {
      "list": {
        "main-title": "Employers",
        "element": {
          "active-employee": "Active employees",
          "pay-structure": "Pay structures",
          "created-payrolls": "Created payrolls"
        }
      },
      "details": {
        "main-title": "Employer details",
        "employees": {
          "title": "Employees",
          "active": "Active"
        },
        "payrolls": {
          "title": "Payrolls",
          "created-payrolls": "Created payrolls"
        },
        "pay-structures": {
          "title": "Pay structures",
          "created-pay-structure": "Created pay structures"
        }
      }
    },
    "payroll": {
      "list": {
        "main-title": "Payrolls",
        "description": "",
        "table-name": "payroll",
        "filter-box-placeholder": "Filter by pay structure name, ...",
        "table-header": {
          "pay-structure": "Pay structure name",
          "pay-period": "Pay period",
          "payroll-template": "Payroll Template",
          "staff": "Staff",
          "status": "Status"
        },
        "filter-key": {
          "pay-structure": "Filter by pay structure name"
        }
      },
      "delete-message": "Are you sure want to delete this payroll?",
      "detail": {
        "main-title": "Payroll details",
        "general-info": {
          "title": "General Information",
          "pay-structure": "Pay structure name",
          "pay-period": "Pay period",
          "template": "Template name",
          "exchange-rate": "Exchange rates",
          "created-at": "Created at",
          "created-by": "Created by",
          "updated-at": "Updated at",
          "updated-by": "Updated by"
        },
        "process-status": {
          "title": "Process status"
        },
        "current-step": {
          "title": "Current step",
          "step-status": "Step Status"
        },
        "step-detail": {
          "title": "Current Step details",
          "pay-structure": "Pay structure",
          "pay-period": "Pay period",
          "payroll-template": "Payroll Template",
          "exchange-rate": "Exchange rates",
          "document": "Document"
        },
        "validate-employee": {
          "result": "Results",
          "included-emloyee": "Found {value} employee(s) included in this payroll",
          "excluded-employee": "Found {value} employee(s) excluded from this payroll"
        }
      },
      "form": {
        "main-title-create": "Create new payroll",
        "main-title-edit": "Edit payroll",
        "description": "The following data are used to identify a payroll based on its Pay Structure, Pay Period and Pay Frequency under a specific Employer.",
        "pay-structure": {
          "label": "Pay structure",
          "description": "What is the pay structure of the payroll entity? E.g. Default Pay Structure."
        },
        "pay-period": {
          "label": "Pay period",
          "description": "What is its pay period? E.g. January"
        },
        "payroll-tempate": {
          "label": "Payroll template",
          "description": "What is its payroll template? E.g. First Payroll Template"
        },
        "exchange-rate": {
          "label": "Exchange rates",
          "description": "Input exchange rates (US$ : KHR) to apply in this payroll. E.g. 1$ = 4000R"
        }
      }
    },
    "employee-incomes-expense": {
      "list": {
        "main-title": "Employees' Incomes/Expenses",
        "table-name": "incomes/expenses",
        "description": " ",
        "filter-key": {
          "employee-name": "Filter by employee name",
          "employee-id": "Filter by employee id"
        },
        "label-btn": {
          "download-record-template": "Download record template (.xlsx)",
          "upload-record": "Upload records (.xlsx)",
          "new-record-manual-input": "New record (manual input)"
        }
      },
      "form": {
        "main-title-create": "Employees' income/expense",
        "employee-name": {
          "label": "Employee name",
          "description": " ",
          "placeholder": "Select the employee needed to add a component pay record"
        },
        "employee-id": {
          "label": "Employee ID",
          "description": " "
        },
        "table": {
          "pay-component": "Pay Component",
          "amount": "Amount (USD)",
          "description": "Description",
          "document": "Document"
        },
        "main-title-edit": "Edit Employees' income/expense",
        "component": {
          "label": "Component",
          "placeholder": "Select a user-input component to record income/expense"
        },
        "amount": "Amount (USD)",
        "description": "Description",
        "upload-document": "Upload document"
      }
    },
    "employee-pay-record": {
      "list": {
        "main-title": "Employee pay records",
        "table-name": "employee pay record"
      },
      "detail-history": {
        "main-title": "Pay record edit history",
        "employee": "Employee",
        "table": {
          "data-time": "Edited at",
          "edited-by": "Edited by",
          "component": "Component",
          "from": "From",
          "to": "To",
          "reason": "Reason"
        }
      }
    },
    "pay-structure": {
      "list": {
        "main-title": "Pay Structures",
        "description": "If you don't have any pay structures yet, you can create one by making an identical copy of the general template from AIML SaaS system. Click <b> Clone  </b> button to create new one for your tenant.",
        "table-name": "pay structure",
        "filter-box-placeholder": "Filter by name, ...",
        "table-header": {
          "name": "Name",
          "employee": "Employee",
          "pay-interval": "Pay Interval",
          "pay-component": "Pay Component",
          "status": "Status"
        },
        "filter-key": {
          "name": "Filter by name"
        }
      },
      "delete-message": "Are you sure want to delete this pay structure?",
      "detail": {
        "main-title": "Pay structure details",
        "basic-info": {
          "title": "Basic Information",
          "name": "Name",
          "legal-requirement": "Legal requirement",
          "pay-method": "Pay method",
          "pay-interval": "Pay Interval",
          "pay-frequency": "Pay frequency",
          "pay-date": "Pay date",
          "pay-process": "Pay process",
          "created-at": "Created at",
          "created-by": "Created by",
          "updated-at": "Updated at",
          "updated-by": "Updated by"
        },
        "menu": {
          "pay-roll-component": "Payroll Components",
          "pay-period": "Pay Periods",
          "payroll-template": "Payroll Templates",
          "payroll-exchange-rate": "Exchange Rates"
        }
      },
      "form": {
        "main-title-create": "Create new pay structure",
        "main-title-edit": "Edit pay structure",
        "description": "",
        "legal-requirement": {
          "label": "Legal requirement",
          "description": " "
        },
        "name": {
          "label": "Name",
          "description": " "
        },
        "pay-method": {
          "label": "Pay method",
          "description": " "
        },
        "pay-interval": {
          "label": "Pay interval",
          "description": " "
        },
        "pay-frequency": {
          "label": "Pay frequency",
          "description": " "
        },
        "pay-date": {
          "label": "Pay date",
          "description": " "
        },
        "pay-process": {
          "label": "Pay process",
          "description": " "
        }
      }
    },
    "payroll-component": {
      "list": {
        "main-title": "Payroll Components",
        "table-name": "payroll component",
        "filter-box-placeholder": "",
        "table-header": {
          "title": "Title",
          "type": "Type",
          "category": "Category",
          "tax-applicability": "Tax applicability",
          "status": "Status",
          "order": "Order",
          "currency-conversion": "Currency conversion",
          "exchange-rate": "Exchange rate",
          "actions": "Actions"
        },
        "filter-key": {
          "title": "Filter by title",
          "type": "Filter by type",
          "category": "Filter by category",
          "tax-applicability": "Filter by tax applicability",
          "status": "Filter by status",
          "currency-conversion": "Filter by currency conversion",
          "exchange-rate": "Filter by exchange rate"
        }
      },
      "form": {
        "main-title-create": "Create payroll component",
        "main-title-edit": "Edit payroll component",
        "title": {
          "title": "Title",
          "placeholder": "E.g. Salary Deduction"
        },
        "group": {
          "title": "Group",
          "placeholder": "Select a group for the component"
        },
        "category": {
          "title": "Category"
        },
        "tax-applicability": {
          "title": "Tax applicability"
        },
        "code": {
          "title": "Code"
        },
        "source-of-value": {
          "title": "Source of value"
        },
        "reference": {
          "title": "Reference"
        },
        "use-as": {
          "title": "Use as"
        },
        "currency": {
          "title": "Currency"
        },
        "status": {
          "title": "Status"
        }
      }
    },
    "payroll-process": {
      "list": {
        "main-title": "Payroll Processes",
        "description": " ",
        "table-name": "payroll process",
        "filter-box-placeholder": "Filter by name, status ...",
        "table-header": {
          "name": "Name",
          "status": "Status",
          "created-at": "Created at",
          "created-by": "Created by"
        },
        "filter-key": {
          "name": "Filter by name",
          "status": "Filter by status"
        }
      },
      "delete-message": "Are you sure want to delete this payroll process?",
      "detail": {
        "main-title": "Payroll process details",
        "name": "Name",
        "status": "Status",
        "created-at": "Created at",
        "created-by": "Created by",
        "updated-at": "Updated at",
        "updated-by": "Updated by"
      },
      "form": {
        "main-title-create": "Create new payroll process",
        "main-title-edit": "Edit payroll process",
        "description": "",
        "overview": {
          "title": "Overview",
          "name": {
            "label": "Name",
            "description": " "
          },
          "status": {
            "label": "Status",
            "description": " "
          }
        }
      }
    },
    "pay-period": {
      "list": {
        "main-title": "Pay Periods",
        "description": "",
        "table-name": "pay period",
        "filter-box-placeholder": "Filter by title, status ...",
        "table-header": {
          "period-name": "Title",
          "start-date": "Start date",
          "end-date": "End date",
          "status": "Status"
        },
        "filter-key": {
          "name": "Filter by title",
          "status": "Filter by status"
        }
      },
      "delete-message": "Are you sure want to delete this pay period?",
      "detail": {
        "main-title": "Pay period details",
        "title": "Title",
        "start-date": "Start date",
        "end-date": "End date",
        "status": "Status",
        "created-at": "Created at",
        "created-by": "Created by",
        "updated-at": "Updated at",
        "updated-by": "Updated by"
      },
      "form": {
        "main-title-create": "Create new pay period",
        "main-title-edit": "Edit pay period",
        "description": "",
        "title": {
          "label": "Title",
          "description": " "
        },
        "start-date": {
          "label": "Start date",
          "description": " "
        },
        "end-date": {
          "label": "End date",
          "description": " "
        },
        "status": {
          "label": "Status",
          "description": " "
        }
      }
    },
    "payroll-template": {
      "list": {
        "main-title": "Payroll Templates",
        "description": "",
        "table-name": "payroll template",
        "filter-box-placeholder": "Filter by name, pay frequency ...",
        "table-header": {
          "name": "Name",
          "pay-frequency": "Pay frequency",
          "created-by": "Created by",
          "created-at": "Created at"
        },
        "filter-key": {
          "name": "Filter by name",
          "status": "Filter by pay frequency"
        }
      },
      "delete-message": "Are you sure want to delete this payroll template?",
      "detail": {
        "main-title": "Payroll template details",
        "overview": "Overview",
        "components": "Components",
        "name": "Name",
        "pay-frequency": "Pay frequency",
        "created-at": "Created at",
        "created-by": "Created by",
        "updated-at": "Updated at",
        "updated-by": "Updated by",
        "table": {
          "title": "Title",
          "type": "Type",
          "category": "Category",
          "tax-applicability": "Tax applicability",
          "status": "Status",
          "order": "Order"
        }
      },
      "form": {
        "main-title-create": "Create new template",
        "main-title-edit": "Edit template",
        "description": "",
        "name": {
          "label": "Name",
          "description": " "
        },
        "pay-frequency": {
          "label": "Pay frequency",
          "description": " "
        },
        "pay-component": {
          "label": "Pay component",
          "description": " "
        }
      }
    },
    "payroll-comparison": {
      "list": {
        "main-title": "Comparison",
        "btn-label": "Get Comparison"
      }
    },
    "exchange-rate": {
      "list": {
        "main-title": "Exchange Rates",
        "description": "",
        "table-name": "Exchange rate",
        "filter-box-placeholder": "Filter by title ...",
        "table-header": {
          "name": "Name",
          "default": "Default",
          "created-at": "Created at",
          "created-by": "Created by"
        },
        "filter-key": {
          "name": "Filter by name"
        }
      },
      "detail": {
        "main-title": "Exchange rate details",
        "title": "Name",
        "created-at": "Created at",
        "created-by": "Created by",
        "updated-at": "Updated at",
        "updated-by": "Updated by"
      },
      "form": {
        "main-title-create": "Create new exchange rate",
        "main-title-edit": "Edit exchange rate",
        "description": "",
        "name": {
          "label": "Name",
          "description": "The name of exchange rate, e.g. GDT for that received from General Department of Taxation, NSSF for that received from NSSF."
        },
        "default-status": {
          "label": "Default",
          "description": "When set to “true”, this exchange rate will be selected by default when used with a pay component having Currency Conversion set to “true”"
        }
      }
    }
  },
  "v2": {
    "app": {
      "name": "OptimalHR"
    },
    "ui": {
      "column-customizer": {
        "title": "កំណត់តារាង",
        "subtitle": "ជ្រើសរើសជួរឈរដែលត្រូវបង្ហាញ និងអូសដើម្បីរៀបលំដាប់ឡើងវិញ។ ជួរឈរដែលត្រូវការមិនអាចលាក់បានទេ។",
        "summary": "ជួរឈរបានជ្រើស · អូសដើម្បីរៀបលំដាប់ | ជួរឈរបានជ្រើស · អូសដើម្បីរៀបលំដាប់",
        "required": "ត្រូវការ",
        "locked": "ចាក់សោ",
        "reset": "កំណត់ឡើងវិញ",
        "apply": "អនុវត្ត",
        "drag-hint": "អូសដើម្បីរៀបលំដាប់",
        "cannot-reorder": "មិនអាចរៀបលំដាប់",
        "move-up": "ផ្លាស់ {label} ឡើងលើ",
        "move-down": "ផ្លាស់ {label} ចុះក្រោម",
        "toggle-aria": "{label} — {state}",
        "shown": "បង្ហាញ",
        "hidden": "លាក់"
      }
    },
    "shell": {
      "org-chip": {
        "switch": "ប្តូរវិសាលភាព",
        "loading": "កំពុងផ្ទុកវិសាលភាព…",
        "empty": "មិនមានវិសាលភាពទេ",
        "global-label": "វិសាលភាពទាំងអស់",
        "global-sub": "ការត្រួតពិនិត្យឆ្លងវិសាលភាព",
        "global-short": "វិសាលភាពទាំងអស់",
        "companies": "ក្រុមហ៊ុន",
        "projects": "គម្រោង",
        "clients": "អតិថិជន",
        "vendors": "អ្នកផ្គត់ផ្គង់",
        "direct": "ផ្ទាល់",
        "direct-suffix": "ផ្ទាល់",
        "clients-projects": "អតិថិជន ▸ គម្រោង",
        "vendors-projects": "អ្នកផ្គត់ផ្គង់ ▸ គម្រោង",
        "oversight": "ការត្រួតពិនិត្យ",
        "own-workforce": "កម្លាំងពលកម្មផ្ទាល់",
        "context-client": "អតិថិជន",
        "context-vendor": "អ្នកផ្គត់ផ្គង់",
        "context-project": "គម្រោង",
        "context-company": "ក្រុមហ៊ុន",
        "show-more": "បង្ហាញបន្ថែម ({count})",
        "show-less": "បង្ហាញតិច",
        "create-company": "បង្កើតក្រុមហ៊ុនថ្មី"
      },
      "search": {
        "label": "Search"
      },
      "notifications": {
        "label": "Notifications"
      },
      "resume-pill": {
        "label": "បន្តដំណើរការប្រាក់ខែ",
        "title": "បន្តដំណើរការប្រាក់ខែដែលកំពុងធ្វើ"
      },
      "pay-subnav": {
        "center": "មជ្ឈមណ្ឌលប្រាក់ខែ",
        "input": "ធាតុចូលប្រាក់ខែ",
        "reports": "របាយការណ៍",
        "templates": "គំរូ",
        "configurations": "ការកំណត់"
      },
      "user-menu": {
        "profile": "Profile",
        "change-password": "Change password",
        "switch-language": "Switch language",
        "sign-out": "Sign out"
      },
      "nav": {
        "home": "ផ្ទះ",
        "people": "បុគ្គលិក",
        "work": "ប្រតិបត្តិការ HR",
        "pay": "បើកប្រាក់ខែ",
        "billing": "វិក្កយបត្រ",
        "workmgmt": "គ្រប់គ្រងការងារ",
        "perform": "ការអនុវត្តន៍",
        "fieldops": "ប្រតិបត្តិការវាល",
        "insights": "ការវិភាគ",
        "moreapps": "កម្មវិធីបន្ថែម",
        "organization": "អង្គភាព"
      }
    },
    "auth": {
      "brand-panel": {
        "tagline": "ប្រតិបត្តិការធនធានមនុស្ស · កម្ពុជា",
        "hero-title": "សូមស្វាគមន៍ការត្រឡប់មកវិញ",
        "hero-lede": "ចូលគណនីដើម្បីគ្រប់គ្រងវត្តមាន ច្បាប់ឈប់សម្រាក ការងារបន្ថែមម៉ោង ការធ្វើដំណើរ ការចំណាយ និងបើកប្រាក់ខែសម្រាប់ក្រុមរបស់អ្នក — ទាំងអស់នៅកន្លែងតែមួយ។",
        "bullets": {
          "compliance": "បានបំពាក់នូវច្បាប់ការងារកម្ពុជា — បសស ពន្ធលើប្រាក់ខែ និងថ្ងៃឈប់សម្រាកផ្លូវការ",
          "outsourced": "ផ្លូវអនុម័តសម្រាប់បុគ្គលិកឲ្យប្រើខាងក្រៅ និងអ្នកគ្រប់គ្រងជួរខាងក្រៅ",
          "mobile": "សេវាបុគ្គលិកដោយខ្លួនឯងតាមទូរស័ព្ទ — ស្នើ និងអនុម័តគ្រប់ទីកន្លែង"
        },
        "copyright": "© {year} OptimalHR · ផលិតផលរបស់ Optimal P HR Strategic Partner Co., Ltd.",
        "address": "ភ្នំពេញ កម្ពុជា · {email}"
      },
      "aria": {
        "locale-switcher": "ប្ដូរភាសា"
      },
      "welcome": {
        "title": "សូមស្វាគមន៍",
        "subtitle": "បញ្ចូលកន្លែងធ្វើការរបស់អ្នកដើម្បីបន្ត។",
        "workspace-label": "កន្លែងធ្វើការ",
        "workspace-placeholder": "optimalp",
        "workspace-hint": "តួអក្សរអក្ខរក្រមតូច លេខ និងសញ្ញាដាច់ៗប៉ុណ្ណោះ។ ផ្ដល់ដោយអ្នកគ្រប់គ្រងធនធានមនុស្សរបស់អ្នក។",
        "continue": "បន្ត",
        "continuing": "កំពុងផ្ទុកកន្លែងធ្វើការ…",
        "recent-label": "កន្លែងធ្វើការថ្មីៗ",
        "find-prefix": "មិនដឹងកន្លែងធ្វើការរបស់អ្នកទេ?",
        "find-link": "ស្វែងរកកន្លែងធ្វើការ",
        "find-toast": "ទាក់ទងអ្នកគ្រប់គ្រងធនធានមនុស្សរបស់អ្នកដើម្បីដឹងឈ្មោះកន្លែងធ្វើការ",
        "privacy": {
          "title": "តើកន្លែងធ្វើការរបស់ខ្ញុំត្រូវបានការពារយ៉ាងដូចម្ដេច?",
          "intro": "ឈ្មោះកន្លែងធ្វើការរបស់អ្នកគឺជាអាសយដ្ឋានសាធារណៈ — ដូចជា {hostExample}។ ដឹងឈ្មោះមិនមែនជាការផ្ដល់សិទ្ធិចូលដំណើរការទេ។ គណនីរបស់អ្នកនៅតែសុវត្ថិភាពតាមរយៈ៖",
          "items": {
            "mfa": {
              "title": "ពាក្យសម្ងាត់ + MFA",
              "desc": "អ្នកគ្រប់គ្រងធនធានមនុស្ស និងតួនាទីប្រាក់ខែតម្រូវឲ្យប្រើការផ្ទៀងផ្ទាត់ច្រើនកត្តា។"
            },
            "monitoring": {
              "title": "ការតាមដានឆ្លាតវៃ",
              "desc": "ការកំណត់អត្រា និងការចាក់សោគណនី បិទការវាយប្រហារដោយស្វ័យប្រវត្តិ; ការចូលគណនីដែលគ្មានគុណលក្ខណៈធម្មតានឹងបង្កើតការជូនដំណឹង។"
            },
            "audit": {
              "title": "កំណត់ហេតុសវនកម្មពេញលេញ",
              "desc": "ការចូលគណនីនីមួយៗ (ជោគជ័យ និងបរាជ័យ) ត្រូវបានកត់ត្រា និងមើលឃើញដោយអ្នកគ្រប់គ្រងរបស់អ្នក។"
            },
            "hidden": {
              "title": "របៀបកន្លែងធ្វើការឯកជន",
              "desc": "អតិថិជនសហគ្រាសអាចលាក់ទំព័រចូលគណនីរបស់ពួកគេទាំងស្រុង — ចូលដំណើរការតែតាមរយៈតំណរអញ្ជើញដែលបានចុះហត្ថលេខាប៉ុណ្ណោះ។"
            }
          },
          "footer": "មានសំណួរ? ទាក់ទង {email}"
        },
        "errors": {
          "workspace-required": "បញ្ចូលកន្លែងធ្វើការដើម្បីបន្ត។",
          "workspace-invalid": "ប្រើតែតួអក្សរអក្ខរក្រមតូច លេខ និងសញ្ញាដាច់ៗប៉ុណ្ណោះ។",
          "workspace-not-found": "យើងមិនអាចរកឃើញកន្លែងធ្វើការនោះទេ។ សូមពិនិត្យអក្ខរាវិរុទ្ធ ហើយព្យាយាមម្ដងទៀត។"
        }
      },
      "sign-in": {
        "switch-workspace": "← ប្ដូរកន្លែងធ្វើការ",
        "title-template": "ចូលគណនី {name}",
        "subtitle": "សូមស្វាគមន៍ការត្រឡប់មកវិញ។ បញ្ចូលព័ត៌មានរបស់អ្នកដើម្បីចូលប្រើគណនី។",
        "method-email": "អុីមែល",
        "method-phone": "ទូរស័ព្ទ + OTP",
        "work-email": "អុីមែលការងារ",
        "email-placeholder": "you\\@optimal-p.com",
        "password": "ពាក្យសម្ងាត់",
        "forgot": "ភ្លេច?",
        "remember": "ចងចាំខ្ញុំសម្រាប់ 30 ថ្ងៃ",
        "submit": "ចូលគណនី",
        "submitting": "កំពុងចូល…",
        "fine-print": "ដោយចូលគណនី អ្នកយល់ព្រមនឹង{terms} និង{privacy}។",
        "errors": {
          "fields-required": "អុីមែល និងពាក្យសម្ងាត់ត្រូវតែបំពេញ",
          "workspace-required": "លេខសម្គាល់កន្លែងធ្វើការត្រូវតែបំពេញ",
          "workspace-not-found": "រកមិនឃើញកន្លែងធ្វើការ"
        },
        "reset-success": "ពាក្យសម្ងាត់របស់អ្នកត្រូវបានកំណត់ឡើងវិញ។ សូមចូលគណនីដោយប្រើពាក្យសម្ងាត់ថ្មី។"
      },
      "forgot": {
        "title": "កំណត់ពាក្យសម្ងាត់ឡើងវិញ",
        "subtitle": "បញ្ចូលអុីមែលការងារដែលភ្ជាប់នឹងគណនីរបស់អ្នក ហើយយើងនឹងផ្ញើកូដបញ្ជាក់ជូន។",
        "send-code": "ផ្ញើកូដ",
        "sending": "កំពុងផ្ញើ…",
        "back-to-sign-in": "← ត្រឡប់ទៅចូលគណនី",
        "errors": {
          "email-required": "អុីមែលត្រូវតែបំពេញ",
          "code-mismatch": "កូដនេះមិនត្រឹមត្រូវ។ សូមពិនិត្យអុីមែល ហើយព្យាយាមម្ដងទៀត។",
          "expired-code": "កូដនេះផុតកំណត់ហើយ។ សូមស្នើកូដថ្មីខាងក្រោម។",
          "limit-exceeded": "ការព្យាយាមច្រើនពេក។ សូមរង់ចាំពីរបីនាទី ហើយព្យាយាមម្ដងទៀត។",
          "user-not-found": "យើងរកមិនឃើញគណនីសម្រាប់អុីមែលនេះទេ។",
          "invalid-password": "ពាក្យសម្ងាត់នេះមិនត្រូវតាមលក្ខខណ្ឌ។ សូមប្រើយ៉ាងតិច 8 តួអក្សរ ដែលមានអក្សរ លេខ និងនិមិត្តសញ្ញា។",
          "generic": "មានបញ្ហាមួយកើតឡើង។ សូមព្យាយាមម្ដងទៀត។"
        },
        "work-email": "អុីមែលការងារ",
        "contact-hint": "នៅតែជាប់ឬ? សូមទាក់ទងអ្នកគ្រប់គ្រង HR របស់អ្នកដើម្បីសង្គ្រោះគណនី។",
        "strength": {
          "empty": "កម្រិត៖ ទទេ",
          "weak": "កម្រិត៖ ខ្សោយ",
          "medium": "កម្រិត៖ មធ្យម",
          "strong": "កម្រិត៖ ខ្លាំង",
          "excellent": "កម្រិត៖ ល្អបំផុត"
        }
      },
      "confirm-forgot": {
        "title": "កំណត់ពាក្យសម្ងាត់ថ្មី",
        "code": "កូដបញ្ជាក់",
        "new-password": "ពាក្យសម្ងាត់ថ្មី",
        "confirm-password": "បញ្ជាក់ពាក្យសម្ងាត់",
        "submit": "កំណត់ពាក្យសម្ងាត់ឡើងវិញ",
        "submitting": "កំពុងកំណត់ឡើងវិញ…",
        "errors": {
          "code-required": "កូដបញ្ជាក់ត្រូវតែបំពេញ",
          "mismatch": "ពាក្យសម្ងាត់មិនត្រូវគ្នា",
          "weak-password": "សូមជ្រើសរើសពាក្យសម្ងាត់ខ្លាំងជាង — យ៉ាងតិច 8 តួអក្សរ ដែលលាយអក្សរ លេខ និងនិមិត្តសញ្ញា។",
          "missing-username": "វគ្គកំណត់ឡើងវិញរបស់អ្នកផុតកំណត់ហើយ។ សូមចាប់ផ្ដើមឡើងវិញពីអេក្រង់ភ្លេចពាក្យសម្ងាត់។",
          "code-mismatch": "កូដនេះមិនត្រឹមត្រូវ។ សូមពិនិត្យអុីមែល ហើយព្យាយាមម្ដងទៀត។",
          "expired-code": "កូដនេះផុតកំណត់ហើយ។ សូមស្នើកូដថ្មីខាងក្រោម។",
          "limit-exceeded": "ការព្យាយាមច្រើនពេក។ សូមរង់ចាំពីរបីនាទី ហើយព្យាយាមម្ដងទៀត។",
          "user-not-found": "យើងរកមិនឃើញគណនីសម្រាប់អុីមែលនេះទេ។",
          "invalid-password": "ពាក្យសម្ងាត់នេះមិនត្រូវតាមលក្ខខណ្ឌ។ សូមប្រើយ៉ាងតិច 8 តួអក្សរ ដែលមានអក្សរ លេខ និងនិមិត្តសញ្ញា។",
          "generic": "មានបញ្ហាមួយកើតឡើង។ សូមព្យាយាមម្ដងទៀត។"
        },
        "subtitle": "យើងបានផ្ញើកូដទៅ {email}។ សូមបញ្ចូលវាខាងក្រោម ជាមួយពាក្យសម្ងាត់ថ្មីដែលអ្នកមិនធ្លាប់ប្រើ។",
        "start-over": "← ចាប់ផ្ដើមឡើងវិញ",
        "no-code": "មិនបានទទួលកូដឬ?",
        "resend": "ផ្ញើកូដម្ដងទៀត",
        "resending": "កំពុងផ្ញើឡើងវិញ…",
        "resent": "កូដថ្មីកំពុងផ្ញើទៅ — សូមពិនិត្យប្រអប់សំបុត្ររបស់អ្នក។",
        "success-title": "ពាក្យសម្ងាត់ត្រូវបានធ្វើបច្ចុប្បន្នភាព",
        "success-subtitle": "ពាក្យសម្ងាត់របស់អ្នកត្រូវបានកំណត់ឡើងវិញ។ ឥឡូវនេះអ្នកអាចចូលគណនីដោយប្រើពាក្យសម្ងាត់ថ្មី។",
        "success-cta": "បន្តទៅចូលគណនី"
      },
      "force-change": {
        "title": "កំណត់ពាក្យសម្ងាត់ថ្មី",
        "subtitle": "គណនីរបស់អ្នកត្រូវការពាក្យសម្ងាត់ថ្មីមុនពេលបន្ត។",
        "submit": "បន្ត",
        "submitting": "កំពុងរក្សាទុក…"
      },
      "mfa": {
        "title": "ការផ្ទៀងផ្ទាត់ពីរជំហាន",
        "subtitle-sms": "បញ្ចូលកូដ 6 ខ្ទង់ដែលបានផ្ញើទៅទូរសព្ទរបស់អ្នក។",
        "subtitle-totp": "បញ្ចូលកូដ 6 ខ្ទង់ពីកម្មវិធីផ្ទៀងផ្ទាត់របស់អ្នក។",
        "code": "កូដ 6 ខ្ទង់",
        "submit": "ផ្ទៀងផ្ទាត់",
        "submitting": "កំពុងផ្ទៀងផ្ទាត់…",
        "errors": {
          "code-required": "កូដត្រូវតែបំពេញ"
        }
      },
      "change-password": {
        "title": "ប្ដូរពាក្យសម្ងាត់",
        "current-password": "ពាក្យសម្ងាត់បច្ចុប្បន្ន",
        "save": "រក្សាទុក",
        "saving": "កំពុងរក្សាទុក…",
        "cancel": "បោះបង់",
        "success-toast": "ពាក្យសម្ងាត់បានធ្វើបច្ចុប្បន្នភាព",
        "errors": {
          "fields-required": "វាលទាំងអស់ត្រូវតែបំពេញ",
          "mismatch": "ពាក្យសម្ងាត់ថ្មីមិនត្រូវគ្នា"
        }
      },
      "legal-links": {
        "terms": "លក្ខខណ្ឌប្រើប្រាស់",
        "privacy": "គោលនយោបាយឯកជនភាព"
      }
    },
    "home": {
      "welcome-fallback": "អ្នកប្រើ",
      "global": {
        "title": "វិសាលភាពទាំងអស់",
        "subtitle": "ទិដ្ឋភាពរួមបញ្ចូលគ្នាលើគ្រប់ក្រុមហ៊ុន អតិថិជន អ្នកផ្គត់ផ្គង់ និងគម្រោងទាំងអស់។",
        "error": "មិនអាចផ្ទុកទិដ្ឋភាពឆ្លងវិសាលភាពបានទេ។",
        "retry": "ព្យាយាមម្តងទៀត",
        "empty-title": "មិនទាន់មានអ្វីបង្ហាញនៅឡើយ",
        "empty-desc": "នៅពេលវិសាលភាពមានបុគ្គលិក និងកិច្ចសន្យា សូចនាករรួមរបស់ពួកគេនឹងបង្ហាញនៅទីនេះ។",
        "preview-note": "មើលជាមុន · ទិន្នន័យគំរូបង្ហាញខាងក្រោម រហូតដល់ទិន្នន័យឆ្លងវិសាលភាពត្រូវបានភ្ជាប់",
        "kpi": {
          "expiring": "កិច្ចសន្យាផុតកំណត់ ≤៣០ថ្ងៃ",
          "understaffed": "គម្រោងខ្វះបុគ្គលិក",
          "probation": "កំពុងសាកល្បង",
          "onboarding": "ការចូលធ្វើការកំពុងដំណើរការ",
          "headcount": "ចំនួនបុគ្គលិកសកម្ម"
        },
        "persona": {
          "clients": "អតិថិជន",
          "vendors": "អ្នកផ្គត់ផ្គង់",
          "projects": "គម្រោងសកម្ម {count}"
        }
      },
      "hero": {
        "greeting": "សូមស្វាគមន៍ការត្រឡប់មកវិញ",
        "today-pill": "ថ្ងៃនេះ",
        "subtitle-tail": "ផ្ទាំងព័ត៌មានសម្រាប់ថ្ងៃនេះរបស់អ្នក",
        "announce": "ប្រកាស",
        "quick-add": "បន្ថែមរហ័ស"
      },
      "toasts": {
        "announce": "ប្រកាស — ផ្ញើដល់បុគ្គលិកទាំងអស់",
        "quick-add": "បន្ថែមរហ័ស — ជ្រើសរើសបុគ្គលិក / ម៉ោង / ច្បាប់ / ការចំណាយ"
      },
      "alert": {
        "compliance": {
          "text": "មាន {count} ធាតុការអនុលោមដល់កំណត់ ឬហួសកាលកំណត់ក្នុងរយៈពេល ៧ ថ្ងៃខាងមុខ",
          "cta": "មើលការអនុលោម"
        }
      },
      "action-center": {
        "title": "មជ្ឈមណ្ឌលសកម្មភាព",
        "subtitle": "អ្វីដែលត្រូវការការយកចិត្តទុកដាក់ឥឡូវនេះ"
      },
      "action-tiles": {
        "approvals": "ការអនុម័តរង់ចាំ",
        "compliance": "ការអនុលោម · ៧ ថ្ងៃ",
        "payroll": "ឧបសគ្គបើកប្រាក់ខែ",
        "issues": "បញ្ហាត្រូវដោះស្រាយ"
      },
      "kpi": {
        "attendance": {
          "label": "វត្តមានថ្ងៃនេះ",
          "title": "បើកវត្តមាន · សង្ខេបប្រចាំថ្ងៃ",
          "detail": "{present} ក្នុង {total} មានវត្តមាន",
          "vs-yesterday": "ធៀបនឹងម្សិលមិញ"
        },
        "payroll": {
          "label": "វដ្តប្រាក់ខែ",
          "title": "បើកប្រាក់ខែ · វដ្តបច្ចុប្បន្ន",
          "step": "ជំហាន {step}/{total}",
          "cutoff-in": "កាលបរិច្ឆេទកំណត់នៅសល់",
          "cutoff-days": "{days} ថ្ងៃ"
        },
        "eor": {
          "label": "សន្ទស្សន៍ EOR",
          "title": "បើកកម្លាំងពលកម្មក្រៅ",
          "detail": "បុគ្គលិកក្រៅ · {projects} គម្រោងសកម្ម",
          "stale": "{count} ប្រធានគណបក្សក្រៅហួសសម័យ"
        },
        "compliance": {
          "label": "ពិន្ទុការអនុលោម",
          "title": "បើកការអនុលោម"
        }
      },
      "people-card": {
        "title": "មនុស្ស — សប្ដាហ៍នេះ",
        "count": "{count} ព្រឹត្តិការណ៍",
        "more": "ផ្សេងទៀត",
        "empty": "គ្មានព្រឹត្តិការណ៍សំខាន់ក្នុងសប្ដាហ៍នេះ"
      },
      "people-events": {
        "joining": "ចូលធ្វើការសប្ដាហ៍នេះ",
        "separating": "បានឆ្លៀតសប្ដាហ៍នេះ (ត្រូវប្រកាស MOL)",
        "upcoming-exit": "ចេញនាពេលខាងមុខ (៣០ ថ្ងៃ)",
        "probation-due": "ការវាយតម្លៃសាកល្បងដល់ពេល (៣០ ថ្ងៃ)",
        "on-leave-today": "សម្រាកថ្ងៃនេះ",
        "on-leave-static": "សម្រាករយៈពេលវែង (ស្ថានភាព)",
        "returning-today": "វិលត្រឡប់ថ្ងៃនេះ"
      },
      "activity-card": {
        "title": "សកម្មភាពថ្មីៗ",
        "count": "{count} ព្រឹត្តិការណ៍",
        "empty": "គ្មានសកម្មភាពថ្មីៗ",
        "open": "បើកការអនុលោម"
      },
      "payroll-card": {
        "title": "វដ្តប្រាក់ខែ",
        "cutoff": "កាលបរិច្ឆេទកំណត់ {date}",
        "pay-date": "ថ្ងៃបើកប្រាក់ {date}",
        "blockers": "{count} ឧបសគ្គ",
        "clear-before": "ដោះស្រាយមុនកាលបរិច្ឆេទកំណត់",
        "no-blockers": "គ្មានឧបសគ្គ",
        "resume": "បន្តប្រាក់ខែ"
      },
      "calendar-card": {
        "title": "សប្ដាហ៍នេះ",
        "count": "{count} ព្រឹត្តិការណ៍",
        "empty": "គ្មានព្រឹត្តិការណ៍ក្នុងសប្ដាហ៍នេះ",
        "open": "បើកការអនុលោម"
      }
    },
    "shared": {
      "stub-panel": {
        "v6-tag": "v6 stub",
        "tbd-tag": "ការរចនាលម្អិតមិនទាន់មាន"
      }
    },
    "work": {
      "title": "HR Ops",
      "subtitle": "Optimal P · មេសា 2026 · ប្រតិបត្តិការ HR",
      "tabs": {
        "attendance": "វត្តមាន",
        "schedules": "កាលវិភាគ",
        "leave": "ច្បាប់",
        "overtime": "ម៉ោងបន្ថែម",
        "travel": "ការធ្វើដំណើរ",
        "expenses": "ការចំណាយ",
        "approvals": "ការអនុម័ត",
        "approvals-count": "ការអនុម័ត ({count})"
      },
      "attendance": {
        "pills": {
          "snapshot": "សង្ខេបប្រចាំថ្ងៃ",
          "reports": "របាយការណ៍វត្តមាន",
          "records": "កំណត់ហេតុលម្អិត",
          "geofence": "ដែនភូមិសាស្ត្រ"
        },
        "snapshot": {
          "title": "សង្ខេបប្រចាំថ្ងៃ",
          "active-schedules": "កាលវិភាគសកម្ម",
          "clocked-in": "បានចូល",
          "not-yet-clocked-in": "មិនទាន់ចូល",
          "clocked-out": "បានចេញ",
          "not-yet-clocked-out": "មិនទាន់ចេញ",
          "on-leave": "ស្ថិតក្នុងច្បាប់",
          "error-title": "មិនអាចផ្ទុកសង្ខេបបានទេ",
          "drawer": {
            "clocked-in": "បុគ្គលិកបានចូល ({count})",
            "not-yet-clocked-in": "បុគ្គលិកមិនទាន់ចូល ({count})",
            "clocked-out": "បុគ្គលិកបានចេញ ({count})",
            "not-yet-clocked-out": "បុគ្គលិកមិនទាន់ចេញ ({count})",
            "on-leave": "បុគ្គលិកស្ថិតក្នុងច្បាប់ ({count})",
            "empty": "គ្មានបុគ្គលិកក្នុងក្រុមនេះ។"
          }
        },
        "reports": {
          "scope": {
            "label": "ដាក់ជាក្រុមតាម",
            "employees": "បុគ្គលិកទាំងអស់",
            "departments": "អង្គភាពទាំងអស់"
          },
          "from": "ពី",
          "to": "ដល់",
          "search-label": "ស្វែងរក",
          "search-placeholder": "ឈ្មោះ លេខសម្គាល់ ឬអង្គភាព",
          "count": "កំណត់ហេតុ {count}",
          "export": "នាំចេញ CSV",
          "col": {
            "name": "ឈ្មោះពេញ",
            "code": "លេខបុគ្គលិក",
            "org-unit": "អង្គភាព",
            "shift": "វេន",
            "total": "សរុប",
            "status": "ស្ថានភាព"
          },
          "legend": {
            "on-time": "ទាន់ពេល",
            "late-in": "ចូលយឺត",
            "early-out": "ចេញមុន",
            "missed-clock-out": "មិនបានចេញ",
            "absent": "អវត្តមាន",
            "leave": "ច្បាប់",
            "day-off": "ថ្ងៃឈប់",
            "public-holiday": "បុណ្យសាធារណៈ"
          },
          "error-title": "មិនអាចផ្ទុករបាយការណ៍បានទេ",
          "empty-title": "គ្មានកំណត់ហេតុវត្តមាន",
          "empty-desc": "គ្មានកំណត់ហេតុត្រូវនឹងចន្លោះ និងតម្រងបច្ចុប្បន្ន។"
        },
        "records": {
          "day": "ថ្ងៃ",
          "status": "ស្ថានភាព",
          "clock-in": "ចូល",
          "clock-out": "ចេញ",
          "duration": "រយៈពេល",
          "remark": "កំណត់សម្គាល់",
          "count": "កំណត់ហេតុ {count}",
          "remarks": {
            "late-in": "ចូលយឺត",
            "early-out": "ចេញមុន",
            "missed-clock-out": "មិនបានចេញ",
            "resolved-missed-clock-out": "ដោះស្រាយការមិនបានចេញ",
            "absence": "អវត្តមាន",
            "resolved-absence": "ដោះស្រាយអវត្តមាន"
          }
        },
        "geofence": {
          "title": "របាយការណ៍ដែនភូមិសាស្ត្រ",
          "subtitle": "កំណត់ហេតុនៃការព្យាយាមចូល-ចេញដែលត្រូវបានរារាំង។",
          "all-employees": "បុគ្គលិកទាំងអស់",
          "all-zones": "តំបន់ទាំងអស់",
          "violators-only": "តែអ្នកល្មើស",
          "count": "ជួរ {count}",
          "stat": {
            "total": "ការរារាំងសរុប",
            "employees": "បុគ្គលិកប្លែក",
            "zones": "តំបន់ប្លែក",
            "alerts": "ការជូនដំណឹងល្មើស"
          },
          "action": {
            "clock-in": "ចូល",
            "clock-out": "ចេញ"
          },
          "reason": {
            "outside": "ក្រៅតំបន់កំណត់",
            "none": "គ្មានតំបន់កំណត់សម្រាប់ទីតាំងនេះ"
          },
          "col": {
            "when": "ពេលណា",
            "employee": "បុគ្គលិក",
            "code": "លេខបុគ្គលិក",
            "org-unit": "អង្គភាព",
            "action": "សកម្មភាព",
            "zone": "តំបន់ការងារ",
            "distance": "ចម្ងាយ",
            "reason": "មូលហេតុ",
            "blocked": "បានរារាំង",
            "zones": "តំបន់",
            "first": "រារាំងលើកដំបូង",
            "last": "រារាំងលើកចុងក្រោយ"
          },
          "empty-title": "គ្មានការព្យាយាមដែលត្រូវរារាំង",
          "empty-desc": "គ្មានការល្មើសដែនភូមិសាស្ត្រក្នុងចន្លោះដែលបានជ្រើស។"
        }
      },
      "schedules": {
        "pills": {
          "schedules": "កាលវិភាគ",
          "holidays": "ថ្ងៃឈប់សម្រាក",
          "meals": "ការសម្រាកអាហារ"
        },
        "create": {
          "schedule": "កាលវិភាគថ្មី",
          "holiday": "ថ្ងៃឈប់សម្រាកថ្មី",
          "meal": "ការសម្រាកអាហារថ្មី"
        },
        "create-toast": "{name} — អ្នកមគ្គទេសក៍នឹងមកដល់ក្នុងស្រាប់ៗ",
        "created-toast": "បានបង្កើត {name}",
        "search": {
          "schedules": "ស្វែងរកតាមឈ្មោះ ប្រភេទ ឬថ្ងៃឈប់…",
          "holidays": "ស្វែងរកតាមឈ្មោះ កូដ ឬឆ្នាំ…",
          "meals": "ស្វែងរកតាមឈ្មោះ…"
        },
        "showing": "បង្ហាញ {filtered} ក្នុងចំណោម {total} {kind}",
        "kind": {
          "schedules": "កាលវិភាគ",
          "holidays": "បញ្ជីថ្ងៃឈប់សម្រាក",
          "meals": "ការសម្រាកអាហារ"
        },
        "kpi": {
          "schedules": "កាលវិភាគ",
          "employees-assigned": "បុគ្គលិកដែលបានកំណត់",
          "unused-templates": "គំរូមិនបានប្រើ",
          "avg-hours": "ម៉ោងជាមធ្យម/សប្ដាហ៍",
          "holiday-lists": "បញ្ជីថ្ងៃឈប់សម្រាក",
          "active": "សកម្ម",
          "total-dates": "កាលបរិច្ឆេទសរុប",
          "current-year": "ឆ្នាំបច្ចុប្បន្ន ({year})",
          "meal-breaks": "ការសម្រាកអាហារ",
          "schedules-using-breaks": "កាលវិភាគប្រើការសម្រាក",
          "avg-duration": "រយៈពេលជាមធ្យម",
          "cambodia-standard": "ស្ដង់ដារកម្ពុជា"
        },
        "filters": {
          "all": "ទាំងអស់",
          "all-years": "គ្រប់ឆ្នាំ",
          "all-statuses": "គ្រប់ស្ថានភាព",
          "active": "សកម្ម",
          "inactive": "មិនសកម្ម"
        },
        "actions": {
          "clear-filters": "សម្អាតការត្រង",
          "export": "នាំចេញ",
          "edit": "កែសម្រួល",
          "delete": "លុប"
        },
        "schedules-table": {
          "name": "ឈ្មោះ",
          "type": "ប្រភេទ",
          "weekly-day-off": "ថ្ងៃឈប់ប្រចាំសប្ដាហ៍",
          "hours-week": "ម៉ោង/សប្ដាហ៍",
          "employees": "បុគ្គលិក",
          "edit": "កែសម្រួល",
          "empty": "គ្មានកាលវិភាគណាមួយស៊ីគ្នានឹងការត្រងនេះទេ",
          "info": "កាលវិភាគគឺជាគំរូ — HR ភ្ជាប់មួយពេលធ្វើបេសកកម្មបញ្ចូលបុគ្គលិក (ជំហានទី ២ នៃជំនួយការ Add Person)។ ការកែប្រែនៅទីនេះនឹងធ្វើបច្ចុប្បន្នភាពបុគ្គលិកដែលបានភ្ជាប់ទាំងអស់ឆ្ពោះទៅមុខ។",
          "empty-none": "មិនទាន់មានកាលវិភាគទេ — បង្កើតមួយដើម្បីកំណត់សប្ដាហ៍ធ្វើការ។"
        },
        "holidays-table": {
          "name": "ឈ្មោះ",
          "code": "កូដ",
          "year": "ឆ្នាំ",
          "type": "ប្រភេទ",
          "dates": "កាលបរិច្ឆេទ",
          "status": "ស្ថានភាព",
          "edit": "កែសម្រួល",
          "empty": "គ្មានថ្ងៃឈប់សម្រាកណាមួយស៊ីគ្នានឹងការត្រងនេះទេ",
          "info": "បញ្ជី PH ស្តង់ដារត្រូវបានថែទាំដោយ Optimal HR។ អតិថិជនអាចចម្លងឆ្នាំមួយ ហើយកែតម្រូវខ្លួនឯងបាន (បន្ថែម/លុបកាលបរិច្ឆេទ រឺវ៉ារ្យ៉ង់តាមតំបន់)។ កម្ពុជាមាន PH ~22 ក្នុងមួយឆ្នាំ — ការធ្វើបច្ចុប្បន្នភាពប្រចាំឆ្នាំនៅខែមករា។",
          "empty-none": "មិនទាន់មានបញ្ជីថ្ងៃឈប់សម្រាកទេ — បង្កើតមួយសម្រាប់ឆ្នាំប្រតិទិន។"
        },
        "meals-table": {
          "name": "ឈ្មោះ",
          "start": "ម៉ោងចាប់ផ្តើម",
          "end": "ម៉ោងបញ្ចប់",
          "duration": "រយៈពេល",
          "schedules-using": "កាលវិភាគដែលប្រើ",
          "edit": "កែសម្រួល",
          "minutes": "{n} នាទី",
          "empty": "គ្មានការសម្រាកអាហារណាមួយស៊ីគ្នានឹងការស្វែងរកនេះទេ",
          "info": "ការសម្រាកអាហារអាចប្រើឡើងវិញ — ជ្រើសរើសមួយពេលអ្នកបង្កើតកាលវិភាគ។ កាលវិភាគ Optimal P ភាគច្រើនប្រើពេលសម្រាកអាហារ ៦០ នាទី (១២:០០–១៣:០០)។ ច្បាប់ការងារកម្ពុជាមិនបង្ខំទេ ប៉ុន្តែ ៦០ នាទីគឺជាស្ដង់ដារឧស្សាហកម្ម។",
          "empty-none": "មិនទាន់មានពេលសម្រាកអាហារទេ។"
        },
        "drawer": {
          "close": "បិទ",
          "fields": {
            "type": "ប្រភេទ",
            "days-off": "ថ្ងៃឈប់ប្រចាំសប្ដាហ៍",
            "hours-week": "ម៉ោង / សប្ដាហ៍",
            "assigned": "បុគ្គលិកដែលបានកំណត់",
            "public-holiday": "បញ្ជីថ្ងៃឈប់សាធារណៈ",
            "other-holidays": "ថ្ងៃឈប់ដទៃ",
            "year": "ឆ្នាំ",
            "code": "កូដ",
            "status": "ស្ថានភាព",
            "dates": "កាលបរិច្ឆេទ",
            "start": "ចាប់ផ្តើម",
            "end": "បញ្ចប់",
            "duration": "រយៈពេល",
            "schedules-using": "កាលវិភាគដែលប្រើការសម្រាកនេះ",
            "activity": "សកម្មភាព",
            "weekly-hours": "ម៉ោងក្នុងសប្ដាហ៍"
          },
          "no-value": "—"
        },
        "modal": {
          "schedule": {
            "title": "បង្កើតកាលវិភាគ",
            "lede": "គំរូសប្ដាហ៍ការងារ",
            "fields": {
              "name": "ឈ្មោះ",
              "type": "ប្រភេទ"
            },
            "placeholders": {
              "name": "ឧ. OP_Field_Crew"
            },
            "validation": {
              "name-required": "ត្រូវការឈ្មោះកាលវិភាគ។"
            }
          },
          "holiday": {
            "title": "បង្កើតបញ្ជីថ្ងៃឈប់សម្រាក",
            "lede": "បញ្ជីថ្ងៃឈប់សាធារណៈសម្រាប់ឆ្នាំប្រតិទិន",
            "fields": {
              "name": "ឈ្មោះ",
              "code": "កូដ",
              "year": "ឆ្នាំ"
            },
            "placeholders": {
              "name": "ឧ. បញ្ជីថ្ងៃឈប់សម្រាកស្ដង់ដារសម្រាប់ឆ្នាំ ២០២៧",
              "code": "Standard / Custom-XX"
            },
            "validation": {
              "name-required": "ត្រូវការឈ្មោះបញ្ជី។",
              "code-required": "ត្រូវការកូដ។",
              "year-invalid": "ឆ្នាំត្រូវតែជាលេខ ៤ ខ្ទង់។"
            }
          },
          "meal": {
            "title": "បង្កើតការសម្រាកអាហារ",
            "lede": "ការសម្រាកអាហារដែលអាចប្រើឡើងវិញ",
            "fields": {
              "name": "ឈ្មោះ",
              "start": "ម៉ោងចាប់ផ្តើម",
              "end": "ម៉ោងបញ្ចប់"
            },
            "placeholders": {
              "name": "ឧ. OP_Field_Lunch Break"
            },
            "validation": {
              "name-required": "ត្រូវការឈ្មោះការសម្រាក។",
              "time-required": "ត្រូវការម៉ោងចាប់ផ្តើម និងបញ្ចប់។",
              "time-order": "ម៉ោងបញ្ចប់ត្រូវមកក្រោយម៉ោងចាប់ផ្តើម។"
            }
          },
          "cancel": "បោះបង់",
          "submit": "បង្កើត"
        },
        "error": "មិនអាចផ្ទុកទិន្នន័យបានទេ។",
        "retry": "ព្យាយាមម្ដងទៀត",
        "deleted-toast": "បានលុប {name}",
        "action-failed": "មានបញ្ហាមួយ។ សូមព្យាយាមម្ដងទៀត។"
      },
      "leave": {
        "heading": "ច្បាប់",
        "views": {
          "records": "កំណត់ត្រា",
          "calendar": "ប្រតិទិន",
          "usage": "ការប្រើប្រាស់"
        },
        "new-request": "សំណើច្បាប់ថ្មី",
        "create-toast": "អ្នកមគ្គទេសក៍សំណើច្បាប់នឹងមកដល់ក្នុងស្រាប់ៗ",
        "kpi": {
          "pending": "កំពុងរង់ចាំ",
          "approved": "បានអនុម័ត (ក្នុងជួរ)",
          "active-today": "ស្ថិតក្នុងច្បាប់ថ្ងៃនេះ",
          "rejected": "បានបដិសេធ"
        },
        "filters": {
          "all": "ទាំងអស់",
          "all-orgs": "អង្គភាពទាំងអស់",
          "all-types": "ប្រភេទទាំងអស់",
          "all-statuses": "ស្ថានភាពទាំងអស់",
          "pending-lm": "កំពុងរង់ចាំ LM",
          "approved": "បានអនុម័ត",
          "rejected": "បានបដិសេធ",
          "clear-filters": "សម្អាតតម្រង",
          "include-outsourced": "រួមបញ្ចូលក្រៅប្រព័ន្ធ",
          "all-employees": "បុគ្គលិកទាំងអស់",
          "cancelled": "បានលុបចោល",
          "unknown": "មិនស្គាល់",
          "submitted": "បានដាក់ស្នើ"
        },
        "search-placeholder": "ស្វែងរកនិយោជិក កូដ ឬមូលហេតុ…",
        "info-banner": "សម្រាប់បុគ្គលិកក្រៅប្រព័ន្ធ៖ ច្បាប់ត្រូវបានផ្តល់តាមគោលការណ៍ Optimal HR; ប្រធានខាងក្រៅអនុម័តសំណើ (Optimal គ្រប់គ្រងទំនាក់ទំនងការងារ)។ បុគ្គលិកផ្ទាល់ដំណើរការតាមប្រធានផ្ទាល់របស់ខ្លួន។",
        "labels-line": "ស្លាក៖",
        "label-fh": "FH — ពាក់កណ្តាលដំបូង",
        "label-sh": "SH — ពាក់កណ្តាលក្រោយ",
        "label-fd": "FD — ពេញមួយថ្ងៃ",
        "open-approvals": "បើកការអនុម័ត",
        "export": "នាំចេញ",
        "records": {
          "title": "កំណត់ហេតុច្បាប់",
          "showing": "បង្ហាញ {filtered} ក្នុង {total}",
          "click-hint": "ចុចជួរណាមួយដើម្បីបើកព័ត៌មានច្បាប់",
          "empty-title": "មិនមានសំណើច្បាប់ត្រូវនឹងតម្រងទេ",
          "empty-lede": "សូមកែតម្រង ឬសម្អាតពួកវាដើម្បីមើលបញ្ជីពេញលេញ។"
        },
        "table": {
          "request-no": "លេខសំណើ",
          "full-name": "ឈ្មោះពេញ",
          "employee-id": "លេខសម្គាល់និយោជិក",
          "org-unit": "អង្គភាព",
          "requested": "បានស្នើ",
          "leave-request-details": "ព័ត៌មានសំណើច្បាប់",
          "total": "សរុប",
          "approver": "អ្នកអនុម័ត",
          "status": "ស្ថានភាព",
          "type": "ប្រភេទ",
          "date": "កាលបរិច្ឆេទ",
          "duration": "រយៈពេល",
          "eor-chip": "EOR"
        },
        "calendar": {
          "legend-today": "ថ្ងៃនេះ",
          "legend-pending": "កំពុងរង់ចាំ LM (ស៊ុមដាច់ៗ)",
          "legend-click-hint": "ចុចលើច្បាប់ដើម្បីបើកព័ត៌មានសំណើ។",
          "empty-title": "មិនមានច្បាប់ក្នុងខែនេះទេ",
          "empty-lede": "សូមកែតម្រង ឬជ្រើសខែផ្សេង។"
        },
        "balances": {
          "title": "សមតុល្យច្បាប់ · តាមនិយោជិក × តាមប្រភេទ",
          "subtitle": "សមស្រប SRS · ផ្តល់ប្រចាំឆ្នាំ ១៨ថ្ងៃ AL · បន្ថែមអាយុការងារ +១ថ្ងៃ/៥ឆ្នាំ (មាត្រា ១៦៦) · ឆ្នាំប្រតិទិន",
          "settings": "ការកំណត់",
          "settings-toast": "ការកំណត់ច្បាប់ — នឹងមកដល់ក្នុងស្រាប់ៗ",
          "col-employee": "និយោជិក",
          "col-org-unit": "អង្គភាព",
          "col-type": "ប្រភេទ",
          "col-service": "សេវាកម្ម",
          "col-annual": "ប្រចាំឆ្នាំ",
          "col-sick": "ឈឺ",
          "col-special": "ពិសេស",
          "col-maternity": "មាតុភាព",
          "col-paternity": "បិតុភាព",
          "col-unpaid": "មិនទទួលប្រាក់",
          "on-demand": "តាមតម្រូវការ",
          "footnote-line1": "ការអានក្រឡា៖ លេខធំ = នៅសល់ · បន្ទាត់តូចបង្ហាញការផ្តល់ (ជាមួយបន្ថែមអាយុការងារក្នុងវង់ក្រចក), បានប្រើ, និងនាំទៅពីឆ្នាំមុន។",
          "footnote-line2": "តម្លៃលំនាំដើម៖ AL ១៨ថ្ងៃ/ឆ្នាំ · ឈឺ ១៤ថ្ងៃ/ឆ្នាំ · ពិសេស ៧ថ្ងៃ/ឆ្នាំ (កាត់ពី AL) · មាតុភាព ៩០ថ្ងៃ · បិតុភាព ៧ថ្ងៃ។"
        },
        "drawer": {
          "title-prefix": "សំណើច្បាប់",
          "subtitle": "{type} · {total} ថ្ងៃ · {status}",
          "close": "បិទប្រអប់",
          "status-pending-line": "បានស្នើ {at} · កំពុងរង់ចាំ LM",
          "status-approved-line": "បានអនុម័តនៅ {at}",
          "status-rejected-line": "បានបដិសេធនៅ {at}",
          "request-details": "ព័ត៌មានសំណើ",
          "field-employee": "និយោជិក៖",
          "field-org-unit": "អង្គភាព៖",
          "field-type": "ប្រភេទ៖",
          "field-total": "សរុប៖",
          "field-total-days": "{total} ថ្ងៃ",
          "field-routes-to": "ផ្ញើទៅ៖",
          "external-lm": "LM ខាងក្រៅ",
          "escalates-hr": "បញ្ជូនបន្តទៅ HR",
          "field-reason": "មូលហេតុ៖",
          "dates-heading": "កាលបរិច្ឆេទ ({count})",
          "history-heading": "ប្រវត្តិសវនកម្ម ({count})",
          "history-empty": "មិនមានប្រវត្តិ។",
          "action-approve": "អនុម័ត",
          "action-reject": "បដិសេធ",
          "action-approve-toast": "ច្បាប់ {id} ត្រូវបានអនុម័ត · កាត់ចេញ {total} ថ្ងៃពីសមតុល្យ",
          "action-reject-toast": "ច្បាប់ {id} ត្រូវបានបដិសេធ · បានវិលត្រឡប់ទៅ HR/និយោជិក",
          "status-requested-line": "បានស្នើសុំ {at}",
          "action-error": "មិនអាចបញ្ចប់សកម្មភាពបានទេ។ សូមព្យាយាមម្តងទៀត។",
          "field-rejection": "មូលហេតុនៃការបដិសេធ៖",
          "cancelled": "បានលុបចោល {days}ថ្ងៃ",
          "by-line-manager": "ដោយប្រធានផ្ទាល់"
        },
        "export-toast": "ការនាំចេញច្បាប់ឈប់សម្រាក — នឹងមកដល់នៅផ្នែកបន្ទាប់",
        "error-title": "មិនអាចផ្ទុកច្បាប់ឈប់សម្រាកបានទេ",
        "error-lede": "មិនអាចផ្ទុករបាយការណ៍ច្បាប់ឈប់សម្រាកបានទេ។ សូមពិនិត្យការតភ្ជាប់របស់អ្នក ហើយព្យាយាមម្តងទៀត។",
        "retry": "ព្យាយាមម្តងទៀត",
        "usage": {
          "title": "ការប្រើប្រាស់ច្បាប់ឈប់សម្រាក · តាមបុគ្គលិក × តាមប្រភេទ",
          "subtitle": "ចំនួនថ្ងៃសុទ្ធដែលបានយកក្នុងចន្លោះពេលដែលបានជ្រើស (មិនរាប់បញ្ចូលអ្នកដែលត្រូវបានបដិសេធ · ដកការលុបចោល)",
          "col-employee": "បុគ្គលិក",
          "col-org-unit": "អង្គភាព",
          "col-total": "សរុប",
          "footnote": "ការប្រើប្រាស់ត្រូវបានគណនាពីរបាយការណ៍ច្បាប់ឈប់សម្រាកសម្រាប់ចន្លោះកាលបរិច្ឆេទដែលបានជ្រើស។ ការបែងចែកតាមបុគ្គលិក ការបន្តពីឆ្នាំមុន និងសមតុល្យនៅសល់ ត្រូវការ endpoint សមតុល្យតាមបុគ្គលិក ហើយនឹងមកដល់នៅផ្នែកបន្ទាប់។"
        },
        "reject-modal": {
          "title": "បដិសេធសំណើច្បាប់ឈប់សម្រាក",
          "description": "សូមផ្តល់មូលហេតុក្នុងការបដិសេធសំណើនេះ។ បុគ្គលិកនឹងឃើញកំណត់សម្គាល់នេះ។",
          "placeholder": "មូលហេតុនៃការបដិសេធ…",
          "cancel": "បោះបង់",
          "confirm": "បដិសេធសំណើ"
        }
      },
      "overtime": {
        "title": "ម៉ោងបន្ថែម",
        "subtitle": "តាមដានសំណើ និងកំណត់ត្រាម៉ោងបន្ថែមពេញវដ្តបើកប្រាក់",
        "export": "នាំចេញ CSV",
        "search-label": "ស្វែងរក",
        "search-placeholder": "ស្វែងរកតាមឈ្មោះ លេខសម្គាល់ ឯកតា ឬលេខសំណើ",
        "kpi": {
          "all-requests": "សំណើទាំងអស់",
          "employees": "បុគ្គលិក",
          "total-overtime": "ម៉ោងបន្ថែមសរុប"
        },
        "filters": {
          "all": "ទាំងអស់",
          "scope-label": "មើលតាម",
          "scope-id-label": "តម្រង",
          "by-employees": "តាមបុគ្គលិក",
          "by-org-units": "តាមឯកតា",
          "all-employees": "បុគ្គលិកទាំងអស់",
          "all-org-units": "ឯកតាទាំងអស់",
          "from": "ពីថ្ងៃ",
          "to": "ដល់ថ្ងៃ"
        },
        "status": {
          "confirmed": "បានបញ្ជាក់",
          "unconfirmed": "មិនទាន់បញ្ជាក់",
          "absent": "អវត្តមាន",
          "pending": "កំពុងរង់ចាំ",
          "unknown": "មិនស្គាល់",
          "submitted": "បានដាក់ស្នើ",
          "approved": "បានអនុម័ត",
          "rejected": "បានបដិសេធ"
        },
        "day-type": {
          "weekday": "ថ្ងៃធ្វើការ",
          "public-holiday": "ថ្ងៃឈប់សម្រាក",
          "night": "ពេលយប់",
          "day-off": "ថ្ងៃឈប់"
        },
        "table": {
          "req-no": "លេខសំណើ",
          "employee": "បុគ្គលិក",
          "code": "លេខសម្គាល់បុគ្គលិក",
          "org-unit": "ឯកតា",
          "ot-date": "កាលបរិច្ឆេទ OT",
          "time": "ម៉ោង",
          "start-time": "ម៉ោងចាប់ផ្តើម",
          "end-time": "ម៉ោងបញ្ចប់",
          "total-hrs": "ម៉ោងសរុប",
          "payment": "ការទូទាត់",
          "status": "ស្ថានភាព",
          "line-manager": "ប្រធានផ្ទាល់",
          "showing": "បង្ហាញ {filtered} ក្នុងចំណោម {total}",
          "total-payment": "ការទូទាត់សរុប"
        },
        "actions": {
          "clear-filters": "សម្អាតតម្រង"
        },
        "empty": {
          "title": "គ្មានកំណត់ត្រាម៉ោងបន្ថែមត្រូវនឹងតម្រង",
          "lede": "សូមកែសម្រួលចន្លោះកាលបរិច្ឆេទ ឬតម្រងដើម្បីមើលកំណត់ត្រាម៉ោងបន្ថែម។"
        },
        "error": {
          "title": "មិនអាចផ្ទុកម៉ោងបន្ថែមបានទេ"
        },
        "drawer": {
          "title": "ព័ត៌មានលម្អិតសំណើម៉ោងបន្ថែម",
          "close": "បិទ",
          "error-title": "មិនអាចផ្ទុកសំណើបានទេ",
          "no-periods": "គ្មានចន្លោះពេលដែលបានស្នើនៅលើសំណើនេះ។",
          "fields": {
            "req-no": "លេខសំណើ",
            "employee-code": "លេខសម្គាល់បុគ្គលិក",
            "org-unit": "ឯកតា",
            "status": "ស្ថានភាព",
            "line-manager": "ប្រធានផ្ទាល់",
            "reason": "គោលបំណង",
            "requested-duration": "រយៈពេលដែលបានស្នើ"
          }
        }
      },
      "travel": {
        "title": "បេសកកម្ម",
        "subtitle": "អនុម័តដំណើរ ផ្តល់ប្រាក់ខ្ចីជាមុន និងផ្ទៀងផ្ទាត់ការចំណាយនៅពេលត្រឡប់មកវិញ។",
        "new-request": "សំណើបេសកកម្មថ្មី",
        "create-toast": "បានដាក់ស្នើសំណើបេសកកម្ម",
        "columns": "ជួរ",
        "search-placeholder": "ស្វែងរកនិយោជិក លេខកូដ ទីកន្លែង គោលបំណង…",
        "info-banner": "ផែនការ → អនុម័ត → ផ្តល់ប្រាក់ → ធ្វើដំណើរ → ផ្ទៀងផ្ទាត់។ ដំណើរដែលបញ្ចប់នឹងបញ្ជូនទៅទិដ្ឋភាពផ្ទៀងផ្ទាត់ ដើម្បីដោះស្រាយជាមួយវិក្កយបត្រពិតប្រាកដ។",
        "views": {
          "requests": "សំណើ",
          "reconciliation": "ការផ្ទៀងផ្ទាត់"
        },
        "filters": {
          "all": "ទាំងអស់",
          "pending": "កំពុងរង់ចាំ",
          "approved": "បានអនុម័ត",
          "in-progress": "កំពុងដំណើរការ",
          "completed": "បានបញ្ចប់",
          "reconciled": "បានផ្ទៀងផ្ទាត់",
          "all-depts": "នាយកដ្ឋានទាំងអស់",
          "all-destinations": "ទីកន្លែងទាំងអស់"
        },
        "kpi": {
          "pending-requests": "សំណើកំពុងរង់ចាំ",
          "trips-this-month": "ដំណើរខែនេះ",
          "advance-outstanding": "ប្រាក់ខ្ចីនៅជំពាក់",
          "reconciliation-pending": "ការផ្ទៀងផ្ទាត់កំពុងរង់ចាំ"
        },
        "table": {
          "id": "លេខសម្គាល់",
          "code": "លេខកូដ",
          "employee": "និយោជិក",
          "destination": "ទីកន្លែង",
          "dates": "កាលបរិច្ឆេទ",
          "departure": "ចេញដំណើរ",
          "return": "ត្រឡប់មកវិញ",
          "purpose": "គោលបំណង",
          "cost": "ចំណាយ",
          "estimate": "ប៉ាន់ស្មាន",
          "advance": "ប្រាក់ខ្ចីជាមុន",
          "exp-rpt": "របាយការណ៍ចំណាយ",
          "status": "ស្ថានភាព",
          "actions": "សកម្មភាព",
          "actual-dates": "កាលបរិច្ឆេទពិត",
          "estimated": "ប៉ាន់ស្មាន",
          "actual": "ពិតប្រាកដ",
          "variance": "ភាពខុសគ្នា",
          "submitted-date": "បានដាក់ស្នើ",
          "row-actions": "សកម្មភាពជួរ",
          "showing": "បង្ហាញ {filtered} ក្នុងចំណោម {total}",
          "click-hint": "ចុចលើជួរណាមួយដើម្បីបើកព័ត៌មានលម្អិតនៃដំណើរ"
        },
        "actions": {
          "view": "មើល",
          "approve": "អនុម័ត",
          "reject": "បដិសេធ",
          "mark-departed": "សម្គាល់ថាបានចេញដំណើរ",
          "approve-reconciliation": "អនុម័តការផ្ទៀងផ្ទាត់",
          "request-more-docs": "ស្នើសុំឯកសារបន្ថែម",
          "clear-filters": "សម្អាតតម្រង",
          "approve-toast": "សំណើបេសកកម្ម {code} ត្រូវបានអនុម័ត",
          "reject-toast": "សំណើបេសកកម្ម {code} ត្រូវបានបដិសេធ",
          "mark-departed-toast": "សំណើបេសកកម្ម {code} ត្រូវបានសម្គាល់ថាបានចេញដំណើរ",
          "approve-recon-toast": "ការផ្ទៀងផ្ទាត់ {code} ត្រូវបានអនុម័ត",
          "request-docs-toast": "សំណើឯកសារត្រូវបានផ្ញើសម្រាប់ {code}"
        },
        "empty": {
          "title": "មិនមានសំណើបេសកកម្ម",
          "lede": "សូមព្យាយាមកែសម្រួលតម្រង ឬសម្អាតតម្រងសកម្ម។"
        },
        "drawer": {
          "close": "បិទ",
          "no-attachments": "មិនមានឯកសារភ្ជាប់ឡើយ។",
          "no-itinerary": "មិនមានផ្នែកដំណើរត្រូវបានកត់ត្រា។",
          "fields": {
            "code": "លេខកូដបេសកកម្ម",
            "kind": "ប្រភេទដំណើរ",
            "destination": "ទីកន្លែង",
            "country": "ប្រទេស",
            "departure": "ចេញដំណើរ",
            "return": "ត្រឡប់មកវិញ",
            "purpose": "គោលបំណង",
            "estimated-cost": "ប្រាក់ប៉ាន់ស្មាន",
            "actual-cost": "ប្រាក់ពិតប្រាកដ",
            "advance": "ប្រាក់ខ្ចីជាមុន",
            "approver": "អ្នកអនុម័ត",
            "status": "ស្ថានភាព",
            "submitted-date": "បានដាក់ស្នើ",
            "decided-date": "បានសម្រេច",
            "itinerary": "កាលវិភាគដំណើរ",
            "cost-breakdown": "ការបែងចែកការចំណាយ",
            "attachments": "ឯកសារភ្ជាប់",
            "timeline": "ពេលវេលាស្ថានភាព"
          },
          "itinerary": {
            "leg": "ផ្នែក",
            "date": "កាលបរិច្ឆេទ",
            "from": "ពី",
            "to": "ទៅ",
            "mode": "មធ្យោបាយ",
            "reference": "ឯកសារយោង"
          },
          "cost": {
            "category": "ប្រភេទ",
            "estimated": "ប៉ាន់ស្មាន",
            "actual": "ពិតប្រាកដ"
          }
        },
        "modal": {
          "title": "សំណើបេសកកម្មថ្មី",
          "lede": "ចាប់យកផែនការដំណើរ ការផ្តល់ប្រាក់ខ្ចីនឹងធ្វើឡើងបន្ទាប់ពីការអនុម័ត។",
          "cancel": "បោះបង់",
          "submit": "ដាក់ស្នើ",
          "fields": {
            "employee": "និយោជិក",
            "destination": "ទីកន្លែង",
            "departure-date": "កាលបរិច្ឆេទចេញដំណើរ",
            "return-date": "កាលបរិច្ឆេទត្រឡប់",
            "purpose": "គោលបំណង",
            "estimated-cost": "ប្រាក់ប៉ាន់ស្មាន",
            "advance": "ប្រាក់ខ្ចីជាមុន"
          },
          "placeholders": {
            "employee": "ឈ្មោះនិយោជិក",
            "destination": "ទីក្រុង",
            "purpose": "ហេតុអ្វីបានជាដំណើរនេះត្រូវការ?",
            "amount": "0.00"
          },
          "validation": {
            "employee-required": "ឈ្មោះនិយោជិកត្រូវការ។",
            "destination-required": "ទីកន្លែងត្រូវការ។",
            "departure-required": "កាលបរិច្ឆេទចេញដំណើរត្រូវការ។",
            "return-required": "កាលបរិច្ឆេទត្រឡប់ត្រូវការ។",
            "return-after-departure": "កាលបរិច្ឆេទត្រឡប់ត្រូវធំជាងឬស្មើនឹងកាលបរិច្ឆេទចេញដំណើរ។",
            "cost-invalid": "ប្រាក់ប៉ាន់ស្មានត្រូវតែជាចំនួនវិជ្ជមាន។",
            "purpose-required": "គោលបំណងត្រូវការ។"
          }
        },
        "reconciliation": {
          "info-banner": "ជួរនីមួយៗបង្ហាញភាពខុសគ្នារវាងការប៉ាន់ស្មាននិងវិក្កយបត្រពិតប្រាកដ។ អនុម័តដើម្បីដោះស្រាយប្រាក់ខ្ចីជាមុន សម្គាល់ឯកសារដែលបាត់ដើម្បីផ្ញើសំណើទៅនិយោជិក។"
        }
      },
      "expenses": {
        "heading": "សំណើចំណាយ",
        "new-claim": "សំណើថ្មី",
        "settings": "ការកំណត់",
        "create-toast": "អ្នកមគ្គទេសក៍សំណើចំណាយនឹងមកដល់ក្នុងស្រាប់ៗ",
        "settings-toast": "ការកំណត់ការចំណាយ — ដំណាក់កាល B",
        "info-banner-title": "លំហូរពីរ។",
        "info-banner": "ការទាមទារប្រាក់ខ្ចីជាមុន៖ សំណើ → LM អនុម័ត → ហិរញ្ញវត្ថុបើកប្រាក់ → និយោជិកចំណាយ → ដាក់ស្នើការដោះស្រាយជាមួយវិក្កយបត្រ → ហិរញ្ញវត្ថុផ្ទៀងផ្ទាត់ → តុល្យភាពដោះស្រាយ។ ការសងវិញ៖ និយោជិកបង់ខ្លួនឯង → ដាក់ស្នើវិក្កយបត្រ → LM អនុម័ត → ហិរញ្ញវត្ថុសងវិញតាមរយៈប្រាក់បៀវត្ស/សាច់ប្រាក់/ធនាគារ។ ទាំងពីរអាចភ្ជាប់ទៅគម្រោងមួយ និងផ្សារភ្ជាប់ជាមួយការធ្វើដំណើរ (TRV-xxxx)។",
        "search-placeholder": "ស្វែងរកតាមឈ្មោះនិយោជិក…",
        "kind": {
          "all": "ប្រភេទទាំងពីរ",
          "advance-only": "តែប្រាក់ខ្ចីជាមុន",
          "reimbursement-only": "តែការសងវិញ"
        },
        "include-outsourced": "បូកបញ្ចូលជាប់កិច្ចសន្យា",
        "showing": "បង្ហាញ {filtered} នៃ {total}",
        "outsourced-suffix": "ជាប់កិច្ចសន្យា",
        "filters": {
          "all": "ទាំងអស់",
          "needs-action": "⚑ ត្រូវការសកម្មភាព",
          "pending": "កំពុងរង់ចាំ",
          "approved": "បានអនុម័ត",
          "disbursed": "បានចំណាយ",
          "returned": "បានត្រឡប់",
          "clearance-submitted": "ដោះស្រាយដាក់",
          "clearance-overdue": "ដោះស្រាយហួសកាល",
          "reimbursed": "បានសងវិញ",
          "settled": "បានដោះស្រាយ",
          "issue": "បញ្ហា",
          "rejected": "បានបដិសេធ",
          "cancelled": "បានបោះបង់"
        },
        "kpi": {
          "needs-action": "ត្រូវការសកម្មភាពរបស់អ្នក",
          "needs-action-sub": "{overdue} ហួសកាល · {issue} បញ្ហា",
          "pending-approval": "កំពុងរង់ចាំការអនុម័ត",
          "pending-approval-sub": "កំពុងរង់ចាំការពិនិត្យពី LM",
          "advance-outstanding": "ប្រាក់ខ្ចីនៅជំពាក់",
          "advance-outstanding-sub": "បានបើកប្រាក់ ប៉ុន្តែមិនទាន់ដោះស្រាយ",
          "reimbursement-pending": "ការសងវិញកំពុងរង់ចាំ",
          "reimbursement-pending-sub": "បានអនុម័ត ឬកំពុងរង់ចាំការអនុម័ត"
        },
        "table": {
          "id": "លេខសម្គាល់",
          "employee": "និយោជិក",
          "kind": "ប្រភេទ",
          "purpose": "គោលបំណង / គម្រោង",
          "date": "កាលបរិច្ឆេទ",
          "requested": "ស្នើសុំ",
          "paid-out": "បានបើកប្រាក់",
          "actual": "តាមពិត",
          "status": "ស្ថានភាព",
          "internal": "ផ្ទៃក្នុង",
          "linked": "ភ្ជាប់ {id}",
          "days-overdue": "ហួសកាល {days} ថ្ងៃ",
          "kind-advance": "ប្រាក់ខ្ចីជាមុន",
          "kind-reimbursement": "សងវិញ",
          "kind-travel-clearance": "ដោះស្រាយដំណើរ"
        },
        "status": {
          "Pending": "កំពុងរង់ចាំ",
          "Approved": "បានអនុម័ត",
          "Disbursed": "បានបើកប្រាក់",
          "Returned": "បានត្រឡប់",
          "Clearance Submitted": "ដោះស្រាយដាក់",
          "Clearance Overdue": "ដោះស្រាយហួសកាល",
          "Reimbursed": "បានសងវិញ",
          "Settled": "បានដោះស្រាយ",
          "Rejected": "បានបដិសេធ",
          "Cancelled": "បានបោះបង់",
          "Issue to Resolve": "បញ្ហាត្រូវដោះស្រាយ"
        },
        "issue": {
          "lost-receipt": "បាត់វិក្កយបត្រ",
          "over-budget": "លើសថវិកា",
          "duplicate": "អាចស្ទួន",
          "category-wrong": "ប្រភេទមិនត្រឹមត្រូវ"
        },
        "empty": "មិនមានសំណើដែលត្រូវនឹងតម្រងនេះទេ។",
        "drawer": {
          "title": "សំណើចំណាយ",
          "subtitle": "{id} · {employee} ({code}) · {purpose}",
          "section-status": "ស្ថានភាព",
          "section-overview": "ទិដ្ឋភាពទូទៅ",
          "section-lines": "ធាតុនៃជួរ",
          "section-audit": "សកម្មភាព",
          "field-employee": "និយោជិក",
          "field-approver": "អ្នកអនុម័ត",
          "field-kind": "ប្រភេទ",
          "field-project": "គម្រោង",
          "field-linked": "ការធ្វើដំណើរដែលផ្សារភ្ជាប់",
          "field-date": "កាលបរិច្ឆេទដាក់ស្នើ",
          "field-requested-advance": "ប្រាក់ខ្ចីស្នើសុំ",
          "field-disbursed": "បានបើកប្រាក់",
          "field-actual": "តាមពិត (តាមវិក្កយបត្រ)",
          "field-net": "តុល្យភាពសុទ្ធ",
          "field-reimbursement-requested": "ការសងវិញដែលស្នើ",
          "field-reimbursement-paid": "ការសងវិញដែលបានបង់",
          "net-owed": "ជំពាក់",
          "net-due": "ត្រូវសង",
          "lines-total": "សរុបធាតុ",
          "lines-empty": "មិនទាន់មានធាតុនៃជួរទេ (ប្រាក់ខ្ចីមិនទាន់ដោះស្រាយ)។",
          "line-receipt": "វិក្កយបត្រ",
          "line-amount": "ចំនួន",
          "line-category": "ប្រភេទ",
          "line-description": "ការពិពណ៌នា",
          "line-date": "កាលបរិច្ឆេទ",
          "close": "បិទ",
          "approve": "អនុម័ត",
          "reject": "បដិសេធ",
          "settle": "ដោះស្រាយ",
          "approve-toast": "បានអនុម័ត {id} ({amount})",
          "reject-toast": "បានបដិសេធ {id}",
          "settle-toast": "ការដោះស្រាយ — ដំណាក់កាល B"
        }
      },
      "approvals": {
        "heading": {
          "oversight": "ការអនុម័ត — ការត្រួតពិនិត្យ HR",
          "my-queue": "ប្រអប់ទទួលរបស់ខ្ញុំ",
          "my-queue-acting-as": "ប្រអប់ទទួលរបស់ខ្ញុំ (កំពុងធ្វើជា {approver})"
        },
        "subtitle": {
          "oversight": "ទិដ្ឋភាពទូទាំងក្រុមហ៊ុនឆ្លងអ្នកអនុម័តទាំងអស់។ ឈូស អនុម័តជំនួស ឬចូលក្នុងប្រអប់នីមួយៗ។",
          "my-queue": "សំណើដែលផ្ញើទៅ {approver} សម្រាប់ការអនុម័តផ្ទាល់។ ចុចលើជួរណាមួយដើម្បីមើលលម្អិតពេញលេញ។",
          "you": "អ្នក"
        },
        "views": {
          "oversight": "ការត្រួតពិនិត្យ",
          "my-queue": "ប្រអប់ទទួលរបស់ខ្ញុំ"
        },
        "kinds": {
          "all": "ទាំងអស់",
          "attendance": "វត្តមាន",
          "leave": "ច្បាប់",
          "overtime": "OT",
          "travel": "ការធ្វើដំណើរ",
          "expense": "ការចំណាយ"
        },
        "kpi": {
          "total-pending": "កំពុងរង់ចាំសរុប",
          "total-pending-sub": "ឆ្លងអ្នកអនុម័ត {approvers} នាក់",
          "aging-over": "ចាស់លើស ៥ ថ្ងៃ",
          "aging-over-sub": "{aging} ទៀតក្នុងចន្លោះ ៣–៥ ថ្ងៃ · {fresh} ថ្មីៗ (≤២ថ្ងៃ)",
          "blocks-payroll": "រារាំងប្រាក់ខែ",
          "blocks-payroll-sub": "វត្តមាន + OT — ត្រូវសម្រេចមុនកាលបរិច្ឆេទកាត់",
          "external-lms": "LM ខាងក្រៅ",
          "external-lms-sub": "អ្នកអនុម័តខាងក្រៅដែលមានសំណើរង់ចាំ"
        },
        "approver-kinds": {
          "direct": "LM ផ្ទៃក្នុង",
          "external": "LM ខាងក្រៅ",
          "self": "អនុម័តដោយខ្លួនឯង"
        },
        "approver-chip": {
          "external": "ខាងក្រៅ"
        },
        "by-approver": {
          "title": "កំពុងរង់ចាំតាមអ្នកអនុម័ត ({count})",
          "subtitle": "តម្រៀបតាមរង់ចាំចាស់បំផុត។ Chase រំលឹក LM; Act As អនុញ្ញាតឲ្យអ្នកដោះស្រាយប្រអប់របស់ពួកគេ។",
          "col-approver": "អ្នកអនុម័ត",
          "col-count": "ចំនួន",
          "col-avg-age": "មធ្យមថ្ងៃ",
          "col-oldest": "ចាស់បំផុត",
          "col-kinds": "ប្រភេទ",
          "col-actions": "សកម្មភាព",
          "empty": "គ្មានសំណើរង់ចាំ"
        },
        "all-pending": {
          "title": "សំណើរង់ចាំទាំងអស់ ({count})",
          "subtitle": "ចុចជួរដើម្បីមើលសំណើពេញលេញ។ ប្រើ Override តែពេល LM មិនអាចទាក់ទងបាន ហើយកាលបរិច្ឆេទប្រឈមនឹងហួសពេល។",
          "col-id": "លេខសម្គាល់",
          "col-kind": "ប្រភេទ",
          "col-employee": "បុគ្គលិក",
          "col-summary": "សង្ខេប",
          "col-amount": "ចំនួនទឹកប្រាក់",
          "col-approver": "អ្នកអនុម័ត",
          "col-age": "ថ្ងៃ",
          "col-actions": "សកម្មភាព",
          "empty": "គ្មានសំណើរង់ចាំ"
        },
        "my-queue": {
          "col-submitted": "បានដាក់ស្នើ",
          "empty": "គ្មានសំណើដែលផ្ញើមកអ្នក។",
          "empty-acting-as": "អ្នកអនុម័តនេះគ្មានសំណើរង់ចាំទេ។"
        },
        "actions": {
          "chase": "ឈូស",
          "chase-toast": "ការរំលឹកបានទម្លាក់ឲ្យ {approver}",
          "act-as": "ធ្វើជា",
          "act-as-toast": "កំពុងធ្វើជា {approver} — ទិដ្ឋភាពបង្ហាញប្រអប់របស់ពួកគេ",
          "view": "មើល",
          "override": "Override ✓",
          "override-title": "HR អនុម័តជំនួសជាមួយមូលហេតុ",
          "override-toast": "HR override-approve បានកត់ត្រាសម្រាប់ {id}",
          "approve": "អនុម័ត",
          "reject": "បដិសេធ"
        },
        "acting-as": {
          "banner": "កំពុងធ្វើជា {approver} — កំពុងមើលប្រអប់ផ្ទាល់ខ្លួនរបស់ពួកគេ។ សកម្មភាព Approve/Reject នៅទីនេះត្រូវកត់ត្រាជា HR-on-behalf។",
          "exit": "ចេញពី Act-As"
        },
        "persona-note": "តួនាទី HR ប្រើ Oversight ជាលំនាំដើម; LM ប្រើ My Queue ជាលំនាំដើម។ ប្រើកុងតាក់ខាងស្ដាំខាងលើដើម្បីប្ដូរ។ HR អាច Act As អ្នកអនុម័តណាមួយពី Oversight ដើម្បីសម្អាតបន្ទុករបស់ពួកគេ (ឧ. LM កំពុងឈប់សម្រាក)។",
        "drawer": {
          "title-prefix": "សំណើ",
          "subtitle": "{kind} · បានដាក់ស្នើ {submitted} · កាលពី {age} ថ្ងៃ",
          "status-pending": "កំពុងរង់ចាំ LM",
          "status-pending-line": "បានដាក់ស្នើ {at} · កំពុងរង់ចាំ LM ({age} ថ្ងៃ)",
          "request-details": "ព័ត៌មានលម្អិតសំណើ",
          "field-employee": "បុគ្គលិក៖",
          "field-org-unit": "អង្គភាព៖",
          "field-kind": "ប្រភេទ៖",
          "field-amount": "ចំនួនទឹកប្រាក់៖",
          "field-summary": "សង្ខេប៖",
          "field-meta": "កំណត់ចំណាំ៖",
          "field-routes-to": "ផ្ញើទៅ៖",
          "external-lm": "LM ខាងក្រៅ",
          "history-heading": "ប្រវត្តិសវនកម្ម ({count})",
          "history-empty": "គ្មានប្រវត្តិ។",
          "action-approve": "អនុម័ត",
          "action-reject": "បដិសេធ",
          "action-approve-toast": "បានអនុម័ត {id}",
          "action-reject-toast": "បានបដិសេធ {id}",
          "close": "បិទ"
        }
      },
      "subtitle-suffix": "មេសា 2026 · ប្រតិបត្តិការ HR"
    },
    "workmgmt": {
      "title": "ការគ្រប់គ្រងការងារ",
      "subtitle": "{scope} · {active} ធាតុការងារសកម្ម · {critical} សំខាន់",
      "tabs": {
        "dashboard": "ផ្ទាំងព័ត៌មាន",
        "mywork": "ការងាររបស់ខ្ញុំ",
        "teamwork": "ការងារក្រុម",
        "queues": "ជួរការងារ",
        "recurring": "ការងារដែលកើតឡើងឡើងវិញ",
        "reviews": "ការវាយតម្លៃ",
        "reports": "របាយការណ៍"
      },
      "dashboard": {
        "heading": "ទិដ្ឋភាពប្រតិបត្តិការ",
        "heading-sub": "{review} កំពុងរង់ចាំការវាយតម្លៃ · {overdue} ហួសកាលកំណត់ · {critical} សំខាន់ · {active} សកម្ម",
        "request-work": "ស្នើសុំការងារ",
        "new-work": "ការងារថ្មី",
        "create-toast": "អ្នកមគ្គទេសក៍បង្កើតការងារនឹងមកដល់ក្នុងស្រាប់ៗ",
        "request-toast": "ទម្រង់ស្នើសុំការងារនឹងមកដល់ក្នុងស្រាប់ៗ",
        "banner-lead": "ការគ្រប់គ្រងការងារ",
        "banner-body": "រៀបចំការអនុវត្តប្រតិបត្តិការ។ ការអនុម័តនៅតែស្ថិតក្នុងម៉ូឌុលប្រភពរបស់ខ្លួន (ច្បាប់ / OT / ការធ្វើដំណើរ / ការចំណាយ)។ អ្នកវាយតម្លៃអាចវាយដំណើរការនៃការងារដែលបានបញ្ចប់ — ការវាយតម្លៃគឺជាជម្រើស និងផ្ដល់ដល់ Contribution Score សម្រាប់ការគ្រប់គ្រងការអនុវត្តន៍។",
        "view-all": "មើលទាំងអស់",
        "kpi": {
          "my-open": "ការងារបើករបស់ខ្ញុំ",
          "my-open-meta": "កំពុងដំណើរការ + បើក",
          "awaiting-review": "កំពុងរង់ចាំការវាយតម្លៃ",
          "awaiting-review-meta": "បានដាក់ស្នើ ជាមួយអ្នកវាយតម្លៃ",
          "overdue": "ហួសកាលកំណត់",
          "overdue-meta": "ត្រូវការការយកចិត្តទុកដាក់",
          "contribution": "ពិន្ទុការរួមចំណែករបស់ខ្ញុំ",
          "contribution-meta": "ពិន្ទុរំកិលត្រីមាស",
          "vs-prev": "ធៀបនឹង ៩០ ថ្ងៃមុន",
          "no-rated": "មិនទាន់មានការងារបានវាយតម្លៃ"
        },
        "table": {
          "work-item": "ការងារ",
          "type": "ប្រភេទ",
          "status": "ស្ថានភាព",
          "priority": "អាទិភាព",
          "assignee": "អ្នកទទួលការងារ",
          "due": "កំណត់"
        },
        "awaiting": {
          "heading": "កំពុងរង់ចាំការវាយតម្លៃរបស់ខ្ញុំ",
          "sub": "{pending} កំពុងរង់ចាំ · {active} កំពុងដំណើរការ",
          "empty": "មិនមានការងារកំពុងរង់ចាំការវាយតម្លៃ។"
        },
        "workload": {
          "heading": "បន្ទុកការងារក្រុម",
          "sub": "ការងារសកម្មក្នុងម្នាក់ៗ",
          "view-team": "មើលក្រុម",
          "active": "{n} សកម្ម",
          "overdue": "{n} ហួសកាលកំណត់",
          "empty": "មិនមានសមាជិកក្រុមនៅក្នុងវិសាលភាព។"
        },
        "contributors": {
          "heading": "អ្នករួមចំណែកកំពូល (៩០ ថ្ងៃ)",
          "sub": "តម្រៀបតាមពិន្ទុការរួមចំណែក",
          "all-scores": "ពិន្ទុទាំងអស់",
          "rated": "បានវាយតម្លៃ {n}",
          "empty": "មិនទាន់មានការងារបានវាយតម្លៃ។"
        },
        "activity": {
          "heading": "សកម្មភាពកន្លែងធ្វើការ",
          "sub": "៣០ ថ្ងៃចុងក្រោយ",
          "active": "ការងារសកម្ម",
          "completed": "បានបញ្ចប់ (៣០ថ្ងៃ)",
          "overdue": "ហួសកាលកំណត់",
          "avg-score": "ពិន្ទុរួមចំណែកជាមធ្យម"
        },
        "recent": {
          "heading": "ការងារថ្មីៗរបស់ខ្ញុំ",
          "sub": "បើក + កំពុងដំណើរការ + កំពុងរង់ចាំការវាយតម្លៃ",
          "empty": "មិនមានការងារថ្មីៗក្នុងជួរអ្នក។"
        },
        "drawer": {
          "assignee": "អ្នកទទួលការងារ",
          "reviewer": "អ្នកវាយតម្លៃ",
          "assigner": "អ្នកប្រគល់ការងារ",
          "due": "កំណត់",
          "dept": "នាយកដ្ឋាន",
          "linked-module": "ម៉ូឌុលភ្ជាប់",
          "rating": "ការវាយតម្លៃរួមចំណែក",
          "review-comment": "មតិយោបល់របស់អ្នកវាយតម្លៃ",
          "close": "បិទ"
        }
      },
      "mywork": {
        "heading": "ការងាររបស់ខ្ញុំ",
        "heading-sub": "{total} សរុប",
        "self-work": "ការងារខ្លួនឯង",
        "create-toast": "ទម្រង់បង្កើតការងារខ្លួនឯងនឹងមកដល់ក្នុងស្រាប់ៗ",
        "kpi": {
          "open": "បើក",
          "progress": "កំពុងដំណើរការ",
          "review": "ការវាយតម្លៃ",
          "overdue": "ហួសកាលកំណត់"
        },
        "filters": {
          "search-placeholder": "ស្វែងរកតាមចំណងជើង ឬ ID…",
          "all-statuses": "ស្ថានភាពទាំងអស់",
          "status-open": "បើក",
          "status-progress": "កំពុងដំណើរការ",
          "status-review": "ការវាយតម្លៃ",
          "status-done": "បានបញ្ចប់",
          "all-types": "ប្រភេទការងារទាំងអស់",
          "type-adhoc": "Ad-hoc",
          "type-recurring": "កើតឡើងវិញ",
          "all-priorities": "អាទិភាពទាំងអស់",
          "priority-high": "ខ្ពស់",
          "priority-med": "មធ្យម",
          "priority-low": "ទាប"
        },
        "stub": {
          "title": "វត្ថុការងាររបស់ខ្ញុំ",
          "lede": "ក្ដារការងារផ្ទាល់ខ្លួនដាក់ជាក្រុមតាមស្ថានភាព ជាមួយ badge ហួសកាលកំណត់ ស្នាមជើងកើតឡើងវិញ និង callback វាយតម្លៃការរួមចំណែក។ ទិដ្ឋភាព grid និង drawer នឹងមកដល់ក្នុងស្រាប់ៗ។"
        }
      },
      "teamwork": {
        "heading": "ការងារក្រុម",
        "heading-sub": "ការងារដែលអ្នកវាយតម្លៃ · {total} សរុប",
        "heading-sub-admin": "ការងារទាំងអស់ក្នុងកន្លែងធ្វើការ · {total} សរុប",
        "assign-work": "ផ្ដល់ការងារ",
        "create-toast": "ទម្រង់ផ្ដល់ការងារនឹងមកដល់ក្នុងស្រាប់ៗ",
        "result-count": "ការងារ {n}",
        "kpi": {
          "open": "បើក",
          "progress": "កំពុងដំណើរការ",
          "review": "ការវាយតម្លៃ",
          "overdue": "ហួសកាលកំណត់"
        },
        "filters": {
          "search-placeholder": "ស្វែងរក…",
          "all-statuses": "ស្ថានភាពទាំងអស់",
          "all-types": "ប្រភេទការងារទាំងអស់",
          "all-assignees": "បុគ្គលិកទាំងអស់"
        },
        "table": {
          "work-item": "ការងារ",
          "type": "ប្រភេទ",
          "status": "ស្ថានភាព",
          "priority": "អាទិភាព",
          "assignee": "បុគ្គលិកទទួលបន្ទុក",
          "due": "កាលកំណត់"
        },
        "empty": {
          "title": "មិនមានការងារត្រូវនឹងតម្រង",
          "lede": "សូមបន្ធូរតម្រងមួយ ឬសម្អាតការស្វែងរក ដើម្បីមើលការងារបន្ថែម។"
        },
        "drawer": {
          "close": "បិទផ្ទាំង",
          "dept": "នាយកដ្ឋាន · {dept}",
          "description": "ការពិពណ៌នា",
          "assignee": "បុគ្គលិកទទួលបន្ទុក",
          "reviewer": "អ្នកវាយតម្លៃ",
          "assigner": "ផ្ដល់ដោយ",
          "due": "កាលកំណត់",
          "start": "ចាប់ផ្ដើម",
          "linked": "ភ្ជាប់ទៅ",
          "tags": "ស្លាក"
        }
      },
      "queues": {
        "heading": "ជួរការងារ",
        "heading-sub": "Optimal P · {total} វត្ថុការងារសកម្មនៅទូទាំងជួរ",
        "banner-lead": "ជួរការងារ",
        "banner-body": "ដាក់ការងារសកម្មជាក្រុមតាមតំបន់ប្រតិបត្តិការសម្រាប់ការត្រួតពិនិត្យ។ ជួរសំខាន់បង្ហាញនូវវត្ថុហួសកាលកំណត់ និងប្រឈមនឹងហានិភ័យដែលត្រូវការការយកចិត្តទុកដាក់ភ្លាមៗ។",
        "view-all": "មើលទាំងអស់ក្នុងជួរ",
        "all-clear": "គ្មានការងារសំខាន់ក្នុងជួរនេះទេ",
        "card-aria": "បើកព័ត៌មានលម្អិតរបស់ {name}",
        "counts": {
          "active": "សកម្ម",
          "at-risk": "ប្រឈមនឹងហានិភ័យ",
          "overdue": "ហួសកាលកំណត់"
        },
        "cards": {
          "payroll": {
            "name": "ជួរប្រាក់ខែ",
            "desc": "ប្រតិបត្តិការប្រាក់ខែ និងការតាមដាន"
          },
          "hrops": {
            "name": "ជួរប្រតិបត្តិការ HR",
            "desc": "ប្រតិបត្តិការ HR ការទទួលបុគ្គលិកថ្មី និងការផ្លាស់ប្ដូរបុគ្គលិក"
          },
          "compliance": {
            "name": "ជួរការអនុលោម",
            "desc": "ការប្រកាសច្បាប់ ការត្រួតពិនិត្យ និងលិខិតអនុញ្ញាត"
          },
          "fieldops": {
            "name": "ជួរប្រតិបត្តិការវាល",
            "desc": "ការពិនិត្យកន្លែង និងប្រតិបត្តិការវាល"
          },
          "critical": {
            "name": "ជួរសំខាន់",
            "desc": "ត្រូវការការយកចិត្តទុកដាក់បន្ទាន់ (ហួសកាលកំណត់ ប្រឈមនឹងហានិភ័យ សំខាន់)"
          }
        },
        "drawer": {
          "sub": "{n} សកម្ម",
          "empty": "គ្មានការងារសកម្មក្នុងជួរនេះទេ។",
          "close": "បិទផ្ទាំងជ្រើស",
          "cols": {
            "work-item": "វត្ថុការងារ",
            "status": "ស្ថានភាព",
            "assignee": "អ្នកទទួលបន្ទុក",
            "due": "កាលកំណត់"
          }
        }
      },
      "recurring": {
        "heading": "ការងារដែលកើតឡើងឡើងវិញ",
        "heading-sub": "បង្កើតដោយស្វ័យប្រវត្តិតាមកាលវិភាគពីគំរូប្រតិបត្តិការ · សកម្ម {total}",
        "new-template": "គំរូថ្មី",
        "create-toast": "កម្មវិធីកែសម្រួលគំរូនឹងមកដល់ក្នុងស្រាប់ៗ",
        "banner": "គំរូបង្កើតការងារប្រតិបត្តិការតាមកាលវិភាគ (ឧ. ការប្រកាស NSSF ប្រចាំខែ, ការពិនិត្យកន្លែងប្រចាំសប្ដាហ៍)។ កម្មវិធីកែសម្រួលសម្រាប់ checklists, ច្បាប់អ្នកវាយតម្លៃ, និងលំនាំដើម SLA នឹងមកដល់ក្នុងស្រាប់ៗ។",
        "result-count": "ការងារ {n}",
        "kpi": {
          "open": "បើក",
          "progress": "កំពុងដំណើរការ",
          "review": "ការវាយតម្លៃ",
          "overdue": "ហួសកាលកំណត់"
        },
        "filters": {
          "search-placeholder": "ស្វែងរក…",
          "all-statuses": "ស្ថានភាពទាំងអស់",
          "all-priorities": "អាទិភាពទាំងអស់",
          "all-assignees": "បុគ្គលិកទាំងអស់"
        },
        "table": {
          "work-item": "ការងារ",
          "type": "ប្រភេទ",
          "status": "ស្ថានភាព",
          "priority": "អាទិភាព",
          "assignee": "បុគ្គលិកទទួលបន្ទុក",
          "due": "កាលកំណត់"
        },
        "empty": {
          "title": "មិនមានការងារដែលកើតឡើងវិញត្រូវនឹងតម្រង",
          "lede": "សូមបន្ធូរតម្រងមួយ ឬសម្អាតការស្វែងរក ដើម្បីមើលការងារកើតឡើងវិញបន្ថែម។"
        },
        "drawer": {
          "close": "បិទផ្ទាំង",
          "dept": "នាយកដ្ឋាន · {dept}",
          "description": "ការពិពណ៌នា",
          "assignee": "បុគ្គលិកទទួលបន្ទុក",
          "reviewer": "អ្នកវាយតម្លៃ",
          "assigner": "ផ្ដល់ដោយ",
          "due": "កាលកំណត់",
          "start": "ចាប់ផ្ដើម",
          "linked": "ភ្ជាប់ទៅ",
          "tags": "ស្លាក"
        }
      },
      "reviews": {
        "heading": "ការវាយតម្លៃ",
        "heading-sub": "{pending} កំពុងរង់ចាំការវាយតម្លៃរបស់អ្នក",
        "export-evidence": "នាំចេញកញ្ចប់ភស្តុតាង",
        "export-toast": "កញ្ចប់ភស្តុតាងការអនុវត្តន៍ — នឹងមកដល់ជាមួយម៉ូឌុលការអនុវត្តន៍",
        "banner-lead": "ការវាយតម្លៃភាពចូលរួម៖",
        "banner-body": "នៅពេលអ្នកវាយតម្លៃវាយលើការងារ (៤ វិមាត្រ × ផ្កាយ ១–៥) ការងារនីមួយៗទទួលបានពិន្ទុ។ ពិន្ទុត្រូវបានសរុបតាមបុគ្គលិកលើរយៈពេល ៩០ ថ្ងៃ ដោយថ្លឹងតាមផលប៉ះពាល់ (ខ្ពស់ × ២.០, មធ្យម × ១.៥, ទាប × ១.០)។ ការវាយតម្លៃជាជម្រើស — ការទទួលយកដោយមិនវាយតម្លៃក៏ល្អដែរសម្រាប់ការងារទាបស្តើង។",
        "empty": "គ្មានការងារនៅទីនេះទេ។",
        "system": "ប្រព័ន្ធ",
        "unknown": "មិនស្គាល់",
        "contrib": {
          "label": "ពិន្ទុចូលរួមរបស់ខ្ញុំ · ៩០ ថ្ងៃចុងក្រោយ",
          "meta": "ផ្អែកលើការងារដែលបានវាយតម្លៃ {count} · {arrow} {delta} ធៀបនឹងរយៈពេលមុន"
        },
        "pills": {
          "pending": "កំពុងរង់ចាំការវាយតម្លៃ ({n})",
          "received": "ការវាយតម្លៃបានទទួល ({n})",
          "given": "ការវាយតម្លៃបានផ្ដល់ ({n})"
        },
        "cols": {
          "work-item": "ការងារ",
          "type": "ប្រភេទ",
          "status": "ស្ថានភាព",
          "priority": "អាទិភាព",
          "assignee": "អ្នកទទួលបន្ទុក",
          "due": "ផុតកំណត់",
          "score": "ពិន្ទុ",
          "q": "គុណ",
          "time": "ពេល",
          "init": "បុ.",
          "coll": "សហ.",
          "badge": "ឡើងតម្លៃ",
          "rated": "បានវាយ"
        },
        "status": {
          "open": "បើក",
          "progress": "កំពុងដំណើរការ",
          "review": "កំពុងរង់ការវាយតម្លៃ",
          "done": "បានបញ្ចប់",
          "revision": "ត្រូវការកែប្រែ",
          "overdue": "ហួសកំណត់",
          "cancelled": "បានបោះបង់"
        },
        "type": {
          "assigned": "បានចាត់តាំង",
          "request": "សំណើការងារ",
          "self": "ការងារផ្ទាល់ខ្លួន",
          "recurring": "ដដែលៗ",
          "system": "ប្រព័ន្ធ"
        },
        "priority": {
          "low": "ទាប",
          "normal": "ធម្មតា",
          "high": "ខ្ពស់",
          "urgent": "បន្ទាន់"
        },
        "impact": {
          "low": "ទាប",
          "medium": "មធ្យម",
          "high": "ខ្ពស់"
        },
        "sla": {
          "warning": "ប្រឈម",
          "critical": "សំខាន់",
          "breached": "ហួសកំណត់"
        },
        "aging": {
          "overdue": "{n}ថ. ហួសកំណត់",
          "today": "ផុតកំណត់ថ្ងៃនេះ",
          "tomorrow": "ផុតកំណត់ស្អែក",
          "in-days": "ផុតកំណត់ក្នុង {n}ថ."
        },
        "rel": {
          "in-days": "ក្នុង {n}ថ.",
          "today": "ថ្ងៃនេះ",
          "days-ago": "{n}ថ. មុន",
          "weeks-ago": "{n}អ. មុន",
          "months-ago": "{n}ខែ មុន",
          "years-ago": "{n}ឆ្នាំ មុន"
        },
        "dim": {
          "quality": {
            "label": "គុណភាព",
            "help": "បានបំពេញតាមស្តង់ដារ?"
          },
          "timeliness": {
            "label": "ទាន់ពេលវេលា",
            "help": "ទាន់ពេលឬទេ?"
          },
          "initiative": {
            "label": "បុរុករាប់ខ្លួន",
            "help": "បានទទួលយកការទទួលខុសត្រូវឬទេ?"
          },
          "collab": {
            "label": "ការសហការ",
            "help": "ធ្វើការជាមួយអ្នកដទៃបានល្អឬទេ?"
          }
        },
        "badge": {
          "helpful": "មានប្រយោជន៍",
          "fast": "ឆ្លើយតបឆាប់រហ័ស",
          "reliable": "ទុកចិត្តបាន",
          "accurate": "ត្រឹមត្រូវ",
          "solver": "អ្នកដោះស្រាយ",
          "collab": "សហការ",
          "proactive": "បុរុករាប់ខ្លួន",
          "above": "លើសពីការរំពឹងទុក"
        },
        "aside": {
          "dim-heading": "ការបំបែកតាមវិមាត្ររបស់ខ្ញុំ",
          "dim-sub": "មធ្យមតាមវិមាត្រ",
          "top-heading": "អ្នកចូលរួមកំពូល",
          "top-sub": "តម្រៀបតាមពិន្ទុចូលរួម",
          "rated-count": "បានវាយ {n}",
          "you-tag": "អ្នក"
        },
        "drawer": {
          "close": "បិទផ្ទាំង",
          "assigned-by": "បានចាត់តាំងដោយ {name}",
          "due": "ផុតកំណត់ {date}",
          "description": "ការពិពណ៌នា",
          "assignee": "អ្នកទទួលបន្ទុក",
          "reviewer": "អ្នកវាយតម្លៃ",
          "start": "បានចាប់ផ្ដើម",
          "due-label": "ផុតកំណត់",
          "linked-module": "ម៉ូឌុលដែលភ្ជាប់",
          "linked-record": "កំណត់ត្រាដែលភ្ជាប់",
          "impact-label": "ផលប៉ះពាល់ {level}",
          "rating-heading": "ការវាយតម្លៃ",
          "overall-label": "ពិន្ទុរួម",
          "overall-meta": "បានវាយដោយ {name} · {when}",
          "badge-label": "ឡើងតម្លៃ",
          "no-rating": "មិនទាន់បានវាយតម្លៃ — ការវាយតម្លៃជាជម្រើស ហើយអាចបន្ថែមនៅពេលទទួលយកការងារ។"
        }
      },
      "reports": {
        "heading": "របាយការណ៍",
        "heading-sub": "ការវិភាគប្រតិបត្តិការនៅទូទាំងម៉ូឌុល",
        "toast-open": "បើករបាយការណ៍ {name}",
        "tiles": {
          "throughput": {
            "label": "Throughput",
            "desc": "ការងារដែលបានបញ្ចប់ក្នុងមួយរយៈពេល · តាមក្រុម / ជួរ / បុគ្គល"
          },
          "cycle-time": {
            "label": "Cycle Time",
            "desc": "ពេលវេលាមធ្យម / កណ្ដាល ពី open → done បំបែកតាមការផ្លាស់ប្ដូរស្ថានភាព"
          },
          "sla": {
            "label": "SLA Adherence",
            "desc": "% ក្នុង SLA, មូលហេតុបាត់, អ្នកល្មើសច្រើនដង"
          },
          "workload": {
            "label": "Workload Distribution",
            "desc": "តុល្យភាពបន្ទុកតាមបុគ្គលិកជាមួយការរកឃើញការផ្ទុកលើស / ខ្វះ"
          }
        }
      }
    },
    "perform": {
      "title": "ការអនុវត្តន៍",
      "subtitle": "ការអនុវត្តន៍បន្ត · បញ្ញាកម្លាំងពលកម្ម · ផ្អែកលើភស្តុតាង · ក្រោមការគ្រប់គ្រងរបស់ HR និងអ្នកគ្រប់គ្រងផ្ទាល់",
      "persona": {
        "current": "ទិដ្ឋភាពបច្ចុប្បន្ន",
        "demo-label": "សាកល្បង · ប្ដូរតួនាទី",
        "admin": {
          "label": "HR Admin / HR Director",
          "note": "អភិបាលកិច្ច · គំរូ · វដ្ត · ការសម្របសម្រួល · ការត្រួតពិនិត្យភាពយុត្តិធម៌ · សវនកម្ម"
        },
        "lm": {
          "label": "អ្នកគ្រប់គ្រងផ្ទាល់",
          "note": "ការណែនាំ · ការតម្រឹម KPI · ការផ្ទៀងផ្ទាត់ភស្តុតាង · ការវាយតម្លៃរបស់អ្នកគ្រប់គ្រង"
        },
        "employee": {
          "label": "បុគ្គលិក",
          "note": "ការអភិវឌ្ឍខ្លួនឯង · ស្នើ KPI · កត់ត្រាការវិវត្ត · ទទួលស្គាល់"
        }
      },
      "tabs": {
        "dashboard": "ផ្ទាំងគ្រប់គ្រង",
        "cycles": "វដ្ត",
        "templates": "គំរូ",
        "competency": "បណ្ណាល័យសមត្ថភាព",
        "goals": "គោលដៅ និង KPI",
        "reviews": "ការវាយតម្លៃ",
        "calibration": "ការសម្របសម្រួល",
        "devplans": "ផែនការអភិវឌ្ឍ",
        "reports": "របាយការណ៍",
        "settings": "ការកំណត់"
      },
      "dashboard": {
        "title": "ផ្ទាំងគ្រប់គ្រងរបស់ HR Admin",
        "view-mode": "ទិដ្ឋភាព",
        "view-standard": "ស្តង់ដារ",
        "view-executive": "នាយក",
        "exec-view-toast": "ទិដ្ឋភាពនាយក — នឹងមកដល់ក្នុងកំណែបន្ត",
        "cycle-sub": "{cycle} · ដំណាក់កាល {stage} · បុគ្គលិកដែលមានសិទ្ធិ {participants} នាក់",
        "banner": "{cycle} · ដំណាក់កាល {stage} · ការវាយតម្លៃខ្លួនឯងបានដាក់ស្នើ {selfPct}% · ការវាយតម្លៃរបស់អ្នកគ្រប់គ្រងបានដាក់ស្នើ {mgrPct}% · កាលបរិច្ឆេទផុតកំណត់នៃការវាយតម្លៃរបស់អ្នកគ្រប់គ្រង {deadline}",
        "action": {
          "settings": "ការកំណត់",
          "open-cycle": "បើកវដ្តសកម្ម"
        },
        "attention": {
          "title": "ត្រូវការការយកចិត្តទុកដាក់",
          "open-cycle": "បើកវដ្ត →",
          "overdue-rev": {
            "title": "ការវាយតម្លៃរបស់អ្នកគ្រប់គ្រង ១៤ ហួសកាលបរិច្ឆេទ",
            "sub": "H1 2026 · ត្រូវការរាយការណ៍ដល់ប្រធានផ្នែក",
            "cta": "ដោះស្រាយ"
          },
          "calib-stalled": {
            "title": "ការសម្របសម្រួលជាប់នៅជំហានទី ២ នៃ ៤",
            "sub": "ការសម្របសម្រួលរបស់ HR + ហិរញ្ញវត្ថុ · នៅទំនេរ ៥ ថ្ងៃ",
            "cta": "បើកឡើងវិញ"
          },
          "risk-flagged": {
            "title": "បុគ្គលិក ៣ នាក់ត្រូវបានសម្គាល់ថាមានហានិភ័យខ្ពស់",
            "sub": "ការអនុវត្តន៍ខ្សោយ + ខកខានកិច្ចប្រជុំ 1:1 ក្នុងរយៈ ៦០ ថ្ងៃចុងក្រោយ",
            "cta": "ត្រួតពិនិត្យ"
          },
          "feedback-gap": {
            "title": "មតិកែលម្អនៅ ៣៨% — គោលដៅ ៧០%",
            "sub": "ខ្វះច្រើនបំផុត៖ Engineering pod B · Customer Success",
            "cta": "រំលឹក"
          }
        },
        "kpi": {
          "section": "ទិដ្ឋភាព KPI",
          "active-cycles": {
            "label": "វដ្តវាយតម្លៃសកម្ម",
            "meta": "H1 2026 · ដំណាក់កាលវាយតម្លៃរបស់អ្នកគ្រប់គ្រង"
          },
          "pending-evals": {
            "label": "ការវាយតម្លៃកំពុងរង់ចាំ",
            "meta": "កំពុងរង់ចាំការវាយតម្លៃរបស់អ្នកគ្រប់គ្រង · ផុតកំណត់ ២៥ ឧសភា"
          },
          "overdue-mgr": {
            "label": "ការវាយតម្លៃរបស់អ្នកគ្រប់គ្រងហួសកំណត់",
            "meta": "ហួសកាលបរិច្ឆេទវដ្ត · ត្រូវការរាយការណ៍"
          },
          "calibration-pending": {
            "label": "ការសម្របសម្រួលកំពុងរង់ចាំ",
            "meta": "HR + ហិរញ្ញវត្ថុ ត្រៀមរួចសម្រាប់ការសម្របសម្រួល"
          },
          "completed": {
            "label": "ការវាយតម្លៃបានបញ្ចប់",
            "meta": "៤១% នៃវដ្តបានបញ្ចប់"
          },
          "below-expect": {
            "label": "ក្រោមការរំពឹងទុក",
            "meta": "បុគ្គលិកដែលត្រូវការការគាំទ្រ"
          },
          "top-performers": {
            "label": "អ្នកអនុវត្តន៍កំពូល",
            "meta": "Outstanding + Exceeds"
          },
          "dev-pending": {
            "label": "ផែនការអភិវឌ្ឍកំពុងរង់ចាំ",
            "meta": "កំពុងរង់ចាំការអនុម័តរបស់អ្នក"
          }
        },
        "stub": {
          "title": "ផ្នែកផ្ទាំងគ្រប់គ្រងខាងក្រោម",
          "lede": "ផែនទីកំដៅ variance · សន្ទស្សន៍ហានិភ័យ · គ្រាហ្វីកការចែកចាយ · ពេលវេលាការវិវត្តនៃវដ្ត · ៥ អ្នកគ្រប់គ្រងហួសកំណត់ច្រើនបំផុត។ កំណែនឹងមកដល់បន្តិចម្ដងៗចាប់ពី P19។"
        },
        "watchlist": {
          "title": "សន្ទស្សន៍ហានិភ័យការអនុវត្តន៍",
          "formula": "សមាសភាពនៃ វត្តមាន · ការងារបន្ថែម · SLA · គោលដៅយឺត · variance នៃការសម្របសម្រួល · ការចូលរួម",
          "hint": "បុគ្គលអាទិភាពខ្ពស់ · {n} នាក់ស្ថិតក្នុងបញ្ជីតាមដាន · ចុចជួរដេកដើម្បីបើកប្រវត្តិហានិភ័យ",
          "bucket": {
            "low-sub": "អនុវត្តន៍ល្អ · គ្មានសញ្ញាព្រមាន",
            "med-sub": "មានសញ្ញា ១–២ · បញ្ជីតាមដាន",
            "high-sub": "៣ សញ្ញាឡើងលើ · ត្រូវការអន្តរាគមន៍",
            "critical-sub": "ត្រូវការអន្តរាគមន៍ភ្លាមៗ"
          },
          "tier": {
            "low": "ទាប",
            "med": "មធ្យម",
            "high": "ខ្ពស់",
            "critical": "គ្រោះថ្នាក់"
          },
          "col": {
            "employee": "បុគ្គលិក",
            "dept": "នាយកដ្ឋាន",
            "signals": "សញ្ញាហានិភ័យ",
            "score": "ពិន្ទុ",
            "tier": "កម្រិត",
            "actions": "សកម្មភាព"
          },
          "action": {
            "open": "បើកព័ត៌មានលម្អិតពេញលេញ",
            "coaching": "បង្កើតផែនការគ្រូ",
            "schedule": "កំណត់ពេលជួប ១:១",
            "coaching-toast": "ផែនការគ្រូសម្រាប់ {name} — នឹងមកដល់ក្នុងកំណែបន្ទាប់",
            "schedule-toast": "កំណត់ពេលជួប ១:១ ជាមួយ {name} — នឹងមកដល់ក្នុងកំណែបន្ទាប់"
          },
          "drawer": {
            "title": "ប្រវត្តិហានិភ័យ · {name}",
            "subtitle": "ពិន្ទុហានិភ័យ {score}/100 · {tier}",
            "close": "បិទ",
            "devplans": "បើកផែនការអភិវឌ្ឍ",
            "banner": {
              "critical": "ពិន្ទុហានិភ័យសមាស · ត្រូវការអន្តរាគមន៍ភ្លាមៗ",
              "high": "ពិន្ទុហានិភ័យសមាស · ត្រូវការអន្តរាគមន៍ក្នុងរយៈពេល ២ សប្ដាហ៍",
              "med": "ពិន្ទុហានិភ័យសមាស · បញ្ជីតាមដាន · ពិនិត្យរៀងរាល់ខែ",
              "low": "ពិន្ទុហានិភ័យសមាស · អាទិភាពទាប"
            },
            "why-title": "ហេតុអ្វីបានជាពិន្ទុនេះ · ការបែងចែកទម្ងន់",
            "composite": "ហានិភ័យសមាស = {points} ពិន្ទុ (សញ្ញា) ≈ {score}/100 (បានធ្វើនិយម)",
            "col": {
              "signal": "សញ្ញា",
              "weight": "ទម្ងន់",
              "source": "ប្រភពទិន្នន័យ"
            },
            "scale": "មាត្រដ្ឋាន៖ {scale}។ សញ្ញាត្រូវបានធ្វើបច្ចុប្បន្នភាពពេលយប់ពីម៉ូឌុលដែលបានភ្ជាប់ · ការធ្វើបច្ចុប្បន្នភាពចុងក្រោយ៖ ព្រឹកនេះ ម៉ោង ០៤:០០។",
            "context": "បរិបទបុគ្គលិក",
            "kv": {
              "role": "តួនាទី",
              "dept": "នាយកដ្ឋាន",
              "manager": "អ្នកគ្រប់គ្រង",
              "score": "ពិន្ទុហានិភ័យបច្ចុប្បន្ន"
            },
            "actions-title": "សកម្មភាពដែលណែនាំ",
            "actions": {
              "schedule-1on1": "កំណត់ពេលជួប ១:១ ជាមួយអ្នកគ្រប់គ្រងក្នុងរយៈពេល ៧ ថ្ងៃ",
              "review-devplan": "ពិនិត្យផែនការអភិវឌ្ឍ · កែប្រែបើចាំបាច់",
              "reduce-workload": "កាត់បន្ថយបន្ទុកការងារ / ការងារបន្ថែម បើពាក់ព័ន្ធ",
              "coaching-engagement": "ពិចារណាការចូលរួមជាគ្រូ ឬការត្រួតពិនិត្យសុខភាព",
              "monitor-weekly": "តាមដានសញ្ញារៀងរាល់សប្ដាហ៍",
              "recheck-cycle": "ពិនិត្យឡើងវិញនៅវដ្តបន្ទាប់",
              "add-watchlist": "បន្ថែមទៅបញ្ជីតាមដានរបស់អ្នកគ្រប់គ្រង",
              "maintain": "រក្សាគន្លងបច្ចុប្បន្ន",
              "reevaluate": "វាយតម្លៃឡើងវិញរៀងរាល់ត្រីមាស"
            },
            "copilot-title": "សកម្មភាព AI Copilot"
          }
        }
      },
      "lm": {
        "tabs": {
          "my-perf": "ការអនុវត្តន៍របស់ខ្ញុំ",
          "my-goals": "គោលដៅរបស់ខ្ញុំ",
          "my-review": "ការវាយតម្លៃរបស់ខ្ញុំ",
          "my-feedback": "មតិកែលម្អដែលបានទទួល",
          "my-dev": "ការអភិវឌ្ឍ និងប្រវត្តិ",
          "team-reviews": "ការវាយតម្លៃក្រុមរបស់ខ្ញុំ",
          "team-goals": "គោលដៅក្រុម",
          "feedback-given": "មតិកែលម្អដែលបានផ្ដល់",
          "team-snapshot": "ទិដ្ឋភាពរួមនៃក្រុម"
        },
        "stubs": {
          "my-perf": {
            "title": "ការអនុវត្តន៍របស់ខ្ញុំ",
            "lede": "ផ្ទាំងគ្រប់គ្រងការអនុវត្តន៍ផ្ទាល់ខ្លួន — ការវិវត្តនៃវដ្តបច្ចុប្បន្ន · ការមើលជាមុននៃការវាយតម្លៃ · ភស្តុតាងពីអ្នកគ្រប់គ្រង · សមិទ្ធផល KPI។ កំណែនឹងមកដល់នៅ Phase B។"
          },
          "my-goals": {
            "title": "គោលដៅរបស់ខ្ញុំ",
            "lede": "វដ្តគោលដៅរបស់អ្នក (សកម្ម · សំណើ · សេចក្ដីព្រាង · បានបិទ) · ការតភ្ជាប់ទៅគោលដៅក្រុម · ការវិវត្ត KPI · ដំណាក់កាល។ កំណែនឹងមកដល់នៅ Phase B។"
          },
          "my-review": {
            "title": "ការវាយតម្លៃរបស់ខ្ញុំ",
            "lede": "ទម្រង់វាយតម្លៃខ្លួនឯង (វដ្តបច្ចុប្បន្ន) + ការមើលជាមុននៃការវាយតម្លៃរបស់អ្នកគ្រប់គ្រង + ទទួលស្គាល់បន្ទាប់ពីការផ្សព្វផ្សាយ។ កំណែនឹងមកដល់នៅ Phase B។"
          },
          "my-feedback": {
            "title": "មតិកែលម្អដែលបានទទួល",
            "lede": "មតិកែលម្អពីអ្នកគ្រប់គ្រងរបស់អ្នក មិត្តរួមការងារ និងថ្នាក់លើ។ អាចត្រងតាមស្លាក រយៈពេល និងអារម្មណ៍។ កំណែនឹងមកដល់នៅ Phase B។"
          },
          "my-dev": {
            "title": "ការអភិវឌ្ឍ និងប្រវត្តិ",
            "lede": "ផែនការអភិវឌ្ឍសកម្មរបស់អ្នក · វដ្តដែលបានបញ្ចប់ · ប្រវត្តិការវាយតម្លៃ · ការបណ្ដុះបណ្ដាលបានបញ្ចប់។ កំណែនឹងមកដល់នៅ Phase B។"
          },
          "team-reviews": {
            "title": "ការវាយតម្លៃក្រុម",
            "lede": "ស្ថានភាពវាយតម្លៃរបស់បុគ្គលិកក្រោមឱវាទ · ដានភស្តុតាង · ទម្រង់វាយតម្លៃរបស់អ្នកគ្រប់គ្រង · អនុម័ត និងដាក់ស្នើ។ កំណែនឹងមកដល់នៅ Phase B។"
          },
          "team-goals": {
            "title": "គោលដៅក្រុម",
            "lede": "ទិដ្ឋភាពតភ្ជាប់ដែលបានត្រងនៃគោលដៅរបស់បុគ្គលិកក្រោមឱវាទ · ការអនុម័តកំពុងរង់ចាំ · កម្រិត KPI។ កំណែនឹងមកដល់នៅ Phase B។"
          },
          "feedback-given": {
            "title": "មតិកែលម្អដែលបានផ្ដល់",
            "lede": "កំណត់ហេតុមតិកែលម្អដែលអ្នកបានផ្ញើទៅក្រុមរបស់អ្នក។ សេចក្ដីព្រាង កាលវិភាគ និងប្រវត្តិ។ កំណែនឹងមកដល់នៅ Phase B។"
          },
          "team-snapshot": {
            "title": "ទិដ្ឋភាពរួមនៃក្រុម",
            "lede": "សុខភាពក្រុមមួយមើល — ការបញ្ចប់ការវាយតម្លៃ · ការមើលជាមុននៃការចែកចាយការវាយតម្លៃ · សញ្ញាវត្តមាន/ការផ្សារភ្ជាប់ពី HR Ops។ កំណែនឹងមកដល់នៅ Phase B។"
          }
        }
      },
      "ee": {
        "tabs": {
          "my-perf": "ការអនុវត្តន៍របស់ខ្ញុំ",
          "my-goals": "គោលដៅរបស់ខ្ញុំ",
          "my-review": "ការវាយតម្លៃរបស់ខ្ញុំ",
          "my-feedback": "មតិកែលម្អដែលបានទទួល",
          "my-dev": "ការអភិវឌ្ឍ និងប្រវត្តិ"
        },
        "stubs": {
          "my-perf": {
            "title": "ការអនុវត្តន៍របស់ខ្ញុំ",
            "lede": "ផ្ទាំងគ្រប់គ្រងការអនុវត្តន៍ផ្ទាល់ខ្លួន — ការវិវត្តនៃវដ្តបច្ចុប្បន្ន · ការមើលជាមុននៃការវាយតម្លៃ · ភស្តុតាងពីអ្នកគ្រប់គ្រង · សមិទ្ធផល KPI។ កំណែនឹងមកដល់នៅ Phase B។"
          },
          "my-goals": {
            "title": "គោលដៅរបស់ខ្ញុំ",
            "lede": "វដ្តគោលដៅរបស់អ្នក (សកម្ម · សំណើ · សេចក្ដីព្រាង · បានបិទ) · ការវិវត្ត KPI · ដំណាក់កាល។ កំណែនឹងមកដល់នៅ Phase B។"
          },
          "my-review": {
            "title": "ការវាយតម្លៃរបស់ខ្ញុំ",
            "lede": "ទម្រង់វាយតម្លៃខ្លួនឯង (វដ្តបច្ចុប្បន្ន) + ការមើលជាមុននៃការវាយតម្លៃរបស់អ្នកគ្រប់គ្រង + ទទួលស្គាល់បន្ទាប់ពីការផ្សព្វផ្សាយ។ កំណែនឹងមកដល់នៅ Phase B។"
          },
          "my-feedback": {
            "title": "មតិកែលម្អដែលបានទទួល",
            "lede": "មតិកែលម្អពីអ្នកគ្រប់គ្រងរបស់អ្នក មិត្តរួមការងារ និងថ្នាក់លើ។ អាចត្រងតាមស្លាក រយៈពេល និងអារម្មណ៍។ កំណែនឹងមកដល់នៅ Phase B។"
          },
          "my-dev": {
            "title": "ការអភិវឌ្ឍ និងប្រវត្តិ",
            "lede": "ផែនការអភិវឌ្ឍសកម្មរបស់អ្នក · វដ្តដែលបានបញ្ចប់ · ប្រវត្តិការវាយតម្លៃ · ការបណ្ដុះបណ្ដាលបានបញ្ចប់។ កំណែនឹងមកដល់នៅ Phase B។"
          }
        }
      },
      "cycles": {
        "title": "វដ្តវាយតម្លៃ",
        "subtitle": "វដ្តវាយតម្លៃទាំងអស់ · {total} សរុប · {active} សកម្ម",
        "templates-btn": "គំរូ",
        "create": "បង្កើតវដ្ត",
        "banner-strong": "គំរូវាយតម្លៃ {templates}",
        "banner-rest": "មាន · ប្រើដោយបុគ្គលិក {usage} នាក់ឆ្លងវដ្តទាំងអស់",
        "confirm-close": "បិទវដ្តនេះមែនទេ? ការវាយតម្លៃមិនទាន់បញ្ចប់ទាំងអស់នឹងត្រូវរក្សាទុក។",
        "col": {
          "cycle": "វដ្ត",
          "period": "រយៈពេល",
          "status": "ស្ថានភាព",
          "stage": "ដំណាក់កាល",
          "progress": "ការវិវត្ត",
          "participants": "អ្នកចូលរួម",
          "actions": "សកម្មភាព"
        },
        "cell": {
          "self-mgr": "{self} ខ្លួនឯង · {mgr} អ្នកគ្រប់គ្រង",
          "overall": "{pct}% សរុប"
        },
        "action": {
          "view": "មើល",
          "edit": "កែ"
        },
        "timeline": {
          "setup": "រៀបចំ",
          "self": "វាយតម្លៃខ្លួនឯង",
          "mgr": "អ្នកគ្រប់គ្រងវាយតម្លៃ",
          "calib": "ការសម្រួល",
          "close": "បានបិទ"
        },
        "drawer": {
          "close": "បិទ",
          "close-cta": "បិទ",
          "close-cycle": "បិទវដ្ត",
          "edit-timeline": "កែតម្រូវកាលវិភាគ",
          "sub": "{period} · បុគ្គលិកមានសិទ្ធិ {count} នាក់ · ស្ថានភាព៖ {status}",
          "id": "លេខសម្គាល់វដ្ត",
          "type": "ប្រភេទ",
          "template": "គំរូ",
          "mixed": "ផ្សំ (តាមគ្រួសារតួនាទី)",
          "current-stage": "ដំណាក់កាលបច្ចុប្បន្ន",
          "self-reviews": "ការវាយតម្លៃខ្លួនឯង",
          "mgr-reviews": "ការវាយតម្លៃរបស់អ្នកគ្រប់គ្រង",
          "calibrated": "បានសម្រួល",
          "submitted": "{done}/{total} បានដាក់",
          "timeline": "កាលវិភាគ"
        },
        "toast": {
          "closed": "បានបិទវដ្ត · {name}"
        },
        "wizard": {
          "rail-title": "ជំហានរៀបចំ",
          "cancel": "បោះបង់",
          "back": "ថយក្រោយ",
          "next": "បន្ទាប់",
          "save-draft": "រក្សាទុកព្រាង",
          "save-changes": "រក្សាទុកការផ្លាស់ប្តូរ",
          "create-launch": "បង្កើត និងចាប់ផ្តើម",
          "title": {
            "create": "បង្កើតវដ្តវាយតម្លៃថ្មី",
            "edit": "កែវដ្ត — {name}",
            "unnamed": "មិនទាន់ដាក់ឈ្មោះ",
            "sub": "ជំហានទី {n} នៃ {total} · {label}"
          },
          "step": {
            "setup": {
              "label": "រៀបចំ",
              "desc": "ឈ្មោះវដ្ត ប្រភេទ និងរយៈពេលសរុប។"
            },
            "eligibility": {
              "label": "សិទ្ធិចូលរួម",
              "desc": "នរណាដែលត្រូវរួមបញ្ចូលក្នុងវដ្តនេះ។"
            },
            "template": {
              "label": "គំរូ",
              "desc": "គំរូវាយតម្លៃណាដែលត្រូវអនុវត្ត។"
            },
            "calibration": {
              "label": "ការសម្រួល",
              "desc": "រយៈពេល និងច្បាប់សម្រាប់ការសម្រួល។"
            },
            "notify": {
              "label": "ការជូនដំណឹង",
              "desc": "នរណាដែលត្រូវជូនដំណឹង និងពេលណា។"
            },
            "review": {
              "label": "ពិនិត្យ និងបង្កើត",
              "desc": "ការពិនិត្យចុងក្រោយមុនបើកដំណើរការ។"
            }
          },
          "setup": {
            "name": "ឈ្មោះវដ្ត",
            "name-ph": "ឧ. ការវាយតម្លៃការអនុវត្ត H2 2026",
            "type": "ប្រភេទវដ្ត",
            "start": "ចាប់ផ្តើមរយៈពេល",
            "end": "បញ្ចប់រយៈពេល",
            "self-deadline": "ថ្ងៃផុតកំណត់វាយតម្លៃខ្លួនឯង",
            "mgr-deadline": "ថ្ងៃផុតកំណត់វាយតម្លៃរបស់អ្នកគ្រប់គ្រង",
            "period-label": "រយៈពេល"
          },
          "type": {
            "half-yearly": "ពាក់កណ្តាលឆ្នាំ",
            "quarterly": "ត្រីមាស",
            "annual": "ប្រចាំឆ្នាំ",
            "project-based": "ផ្អែកលើគម្រោង",
            "probation": "សាកល្បង",
            "mid-cycle": "ពាក់កណ្តាលវដ្ត"
          },
          "elig": {
            "dept": "នាយកដ្ឋាន",
            "dept-all": "នាយកដ្ឋានទាំងអស់",
            "emp-type": "ប្រភេទការងារ",
            "emp-all": "ទាំងអស់ (ផ្ទាល់ + ខាងក្រៅ)",
            "emp-direct": "បុគ្គលិកផ្ទាល់តែប៉ុណ្ណោះ",
            "emp-outsourced": "បុគ្គលិកខាងក្រៅតែប៉ុណ្ណោះ",
            "emp-external": "ខាងក្រៅ (អតិថិជន) — ជាធម្មតាមិនរាប់បញ្ចូល",
            "emp-hint": "បុគ្គលិកខាងក្រៅជាធម្មតាមិនធ្វើការវាយតម្លៃការអនុវត្ត (គ្រប់គ្រងដោយអតិថិជន)។",
            "manager": "អ្នកគ្រប់គ្រង (ស្រេចចិត្ត · កំណត់ត្រូវក្រុមរបស់អ្នកគ្រប់គ្រងម្នាក់)",
            "manager-all": "អ្នកគ្រប់គ្រងទាំងអស់",
            "live-preview": "បុគ្គលិកមានសិទ្ធិ · មើលផ្ទាល់",
            "empty": "គ្មានបុគ្គលិកត្រូវនឹងលក្ខខណ្ឌ។ សូមបន្ធូរតម្រង។",
            "sample": "គណនាផ្ទាល់ពីបុគ្គលិកសកម្ម + តម្រង។"
          },
          "tpl": {
            "pick": "ជ្រើសរើសគំរូវាយតម្លៃ",
            "meta": "ផ្នែក {comps} · កំពុងប្រើ {usage}"
          },
          "calib": {
            "required": "តម្រូវឱ្យមានការសម្រួលឬ?",
            "yes": "បាទ/ចាស (ណែនាំ) — ពិភាក្សាការវាយតម្លៃមុនពេលចាក់សោចុងក្រោយ",
            "no": "ទេ — ការវាយតម្លៃរបស់អ្នកគ្រប់គ្រងជាចុងក្រោយ",
            "deadline": "ថ្ងៃផុតកំណត់សម្រួល",
            "window": "រយៈពេលសម្រួល (ថ្ងៃ)",
            "w7": "១ សប្តាហ៍",
            "w14": "២ សប្តាហ៍ (ធម្មតា)",
            "w21": "៣ សប្តាហ៍",
            "w30": "១ ខែ",
            "info": "ក្នុងពេលសម្រួល HR + អ្នកគ្រប់គ្រងពិភាក្សាករណីខុសប្រក្រតី និងភាពខុសគ្នា។ ការវាយតម្លៃនឹងចាក់សោនៅចុងបញ្ចប់នៃរយៈពេលនេះ។",
            "skip": "មិនណែនាំឱ្យរំលងការសម្រួលទេ — ភាពខុសគ្នានៃការវាយតម្លៃរបស់អ្នកគ្រប់គ្រងនឹងមិនត្រូវបានពិនិត្យ។"
          },
          "notify": {
            "launch": "ផ្ញើសេចក្ដីប្រកាសបើកដំណើរការ",
            "launch-hint": "ផ្ញើអ៊ីមែលដល់បុគ្គលិកដែលមានសិទ្ធិទាំងអស់ពេលវដ្តបើក។",
            "r7": "ការរំលឹក ៧ ថ្ងៃមុនថ្ងៃផុតកំណត់",
            "r7-hint": "ការរំលឹកស្វ័យប្រវត្តិមួយសប្តាហ៍មុនថ្ងៃផុតកំណត់នីមួយៗ។",
            "r1": "ការរំលឹក ១ ថ្ងៃមុនថ្ងៃផុតកំណត់",
            "r1-hint": "ការរំលឹកចុងក្រោយ ២៤ ម៉ោងមុនថ្ងៃផុតកំណត់នីមួយៗ។",
            "mgr": "ការរំលឹកអ្នកគ្រប់គ្រង",
            "mgr-hint": "សង្ខេបប្រចាំថ្ងៃដល់អ្នកគ្រប់គ្រងបង្ហាញការវាយតម្លៃដែលនៅសេសសល់។",
            "exec": "សង្ខេបនាយកប្រតិបត្តិ",
            "exec-hint": "សង្ខេបប្រចាំសប្តាហ៍ដល់នាយក HR និង CEO ក្នុងពេលវដ្ត។",
            "welcome": "សារស្វាគមន៍ដល់អ្នកចូលរួម (ស្រេចចិត្ត)",
            "welcome-ph": "សារស្រេចចិត្តបញ្ចូលក្នុងអ៊ីមែលបើកដំណើរការ។"
          },
          "review": {
            "ready": "រួចរាល់ហើយក្នុងការបើកដំណើរការ។ សូមពិនិត្យសេចក្តីសង្ខេបខាងក្រោម និងបញ្ជាក់។",
            "missing": "វដ្តខ្វះព័ត៌មានចាំបាច់ ({bits})។ ត្រឡប់ក្រោយដើម្បីបំពេញ។",
            "no-name": "ឈ្មោះ",
            "no-elig": "គ្មានបុគ្គលិកមានសិទ្ធិ",
            "eligible": "ចំនួនមានសិទ្ធិ",
            "selected": "បានជ្រើសរើស",
            "yes": "បាទ/ចាស",
            "no": "ទេ",
            "on": "បើក",
            "off": "បិទ"
          },
          "toast": {
            "missing": "មិនអាចបើកដំណើរការ — សូមជួសជុលព័ត៌មានដែលខ្វះក្នុងជំហានពិនិត្យ។",
            "saved": "បានរក្សាទុកវដ្ត · {name}",
            "launched": "បានបង្កើត និងបើកដំណើរការវដ្ត \"{name}\" (អ្នកចូលរួម {count} នាក់)។",
            "draft": "បានរក្សាទុកវដ្ត \"{name}\" ជាព្រាង។"
          }
        }
      },
      "templates": {
        "title": "គំរូវាយតម្លៃ",
        "subtitle": "{count} គំរូ · ប្រើដោយបុគ្គលិក {employees} នាក់ក្នុងវដ្តបច្ចុប្បន្ន",
        "create": "គំរូថ្មី",
        "create-toast": "កម្មវិធីកែគំរូ — នឹងមកដល់ក្នុងកំណែបន្ត",
        "open-toast": "ប្រអប់លម្អិតគំរូ — នឹងមកដល់ក្នុងកំណែបន្ត",
        "usage": "ប្រើដោយបុគ្គលិក {n} នាក់",
        "usage-suffix": "{n} កំពុងប្រើ",
        "weight-distribution": "ការបែងចែកទម្ងន់ផ្នែក",
        "components-head": "ផ្នែក ({n})",
        "more": "+{n} ផ្សេងទៀត",
        "open-cta": "ចុចដើម្បីមើល / កែ →",
        "versions": "គ្មានកំណែ | {n} កំណែ | {n} កំណែ",
        "cycles": "គ្មានវដ្ត | {n} វដ្ត | {n} វដ្ត",
        "version": {
          "active": "សកម្ម",
          "archived": "ដាក់ក្នុងបណ្ណាល័យ"
        },
        "items": {
          "tpl-mgmt": {
            "name": "យុទ្ធសាស្ត្រ / អភិបាល",
            "roles": "ប្រធានផ្នែក · អ្នកគ្រប់គ្រងជាន់ខ្ពស់ · នាយក",
            "owner": "នាយកធនធានមនុស្ស"
          },
          "tpl-ops": {
            "name": "ប្រតិបត្តិការ / ការិយាល័យក្រោយ",
            "roles": "ហិរញ្ញវត្ថុ · ធនធានមនុស្ស · ព័ត៌មានវិទ្យា · ប្រតិបត្តិការ · រដ្ឋបាល",
            "owner": "នាយកប្រតិបត្តិការ"
          },
          "tpl-sales": {
            "name": "ការលក់",
            "roles": "អ្នកលក់ · អ្នកលក់ផ្ទាល់ · ប្រធានការលក់",
            "owner": "នាយកការលក់"
          },
          "tpl-tech": {
            "name": "វិស្វកម្ម / បច្ចេកវិទ្យា",
            "roles": "វិស្វករ · អ្នករចនា · ទិន្នន័យ",
            "owner": ""
          }
        }
      },
      "competency": {
        "title": "បណ្ណាល័យសមត្ថភាព",
        "subtitle": "{total} សមត្ថភាព · {system} លំនាំដើមប្រព័ន្ធ · {tenant} ផ្ទាល់ខ្លួន · អាចប្រើឡើងវិញនៅគ្រប់ការវាយតម្លៃ ផែនការអភិវឌ្ឍ ការតម្រៀបអ្នកស្នង និងទម្រង់ការងារ",
        "import": "នាំចូល",
        "export": "នាំចេញ",
        "new": "សមត្ថភាពថ្មី",
        "result-count": "បង្ហាញ {n} ក្នុង {total}",
        "action": {
          "import-toast": "នាំចូល CSV / XLSX — នឹងមកដល់ក្នុងកំណែបន្ត",
          "export-toast": "នាំចេញបញ្ជីដែលបានច្រោះ — នឹងមកដល់ក្នុងកំណែបន្ត",
          "new-toast": "កម្មវិធីកែសមត្ថភាព — នឹងមកដល់ក្នុងកំណែបន្ត",
          "add-category-toast": "បន្ថែមប្រភេទ — នឹងមកដល់ក្នុងកំណែបន្ត",
          "bulk-archive-toast": "រក្សាទុក {n} ដែលបានជ្រើស — នឹងមកដល់ក្នុងកំណែបន្ត",
          "row-edit-toast": "កែ {name} — នឹងមកដល់ក្នុងកំណែបន្ត",
          "row-clone-toast": "ចម្លង {name} ទៅបណ្ណាល័យផ្ទាល់ខ្លួន — នឹងមកដល់ក្នុងកំណែបន្ត",
          "row-archive-toast": "រក្សាទុក {name} — នឹងមកដល់ក្នុងកំណែបន្ត",
          "row-delete-toast": "លុប {name} — នឹងមកដល់ក្នុងកំណែបន្ត",
          "view": "មើល",
          "edit": "កែ",
          "clone": "ចម្លងដើម្បីកែ",
          "archive": "រក្សាទុក",
          "delete": "លុប"
        },
        "summary": {
          "total": "សមត្ថភាពសរុប",
          "total-sub": "{system} ប្រព័ន្ធ · {tenant} ផ្ទាល់ខ្លួន",
          "categories": "ប្រភេទសកម្ម",
          "categories-sub": "ក្នុងចំណោម {total} ដែលមាន",
          "templates": "គំរូប្រើ",
          "templates-sub": "ក្នុងចំណោម {total} គំរូភ្ជាប់សមត្ថភាព",
          "draft": "សមត្ថភាពព្រាង",
          "draft-sub": "{archived} ដាក់ក្នុងបណ្ណាល័យ"
        },
        "sidebar": {
          "title": "ប្រភេទ",
          "all": "សមត្ថភាពទាំងអស់",
          "add": "បន្ថែមប្រភេទថ្មី",
          "expand": "ពង្រីករបារខាង",
          "collapse": "បង្រួមរបារខាង",
          "hint": "ព័ត៌មាន · ចុច + ខាងលើ ដើម្បីបន្ថែមប្រភេទផ្ទាល់ខ្លួន។"
        },
        "filter": {
          "search-placeholder": "ស្វែងរកតាមឈ្មោះ ឬការពិពណ៌នា…",
          "search-aria": "ស្វែងរកសមត្ថភាព",
          "advanced": "បង្ហាញការកំណត់ខ្ពស់",
          "source": {
            "label": "ប្រភព",
            "all": "ប្រភពទាំងអស់"
          },
          "type": {
            "label": "ប្រភេទ",
            "all": "ប្រភេទទាំងអស់"
          },
          "status": {
            "label": "ស្ថានភាព",
            "all": "ស្ថានភាពទាំងអស់"
          }
        },
        "view": {
          "label": "ប្តូរទិដ្ឋភាព",
          "cards": "ទិដ្ឋភាពកាត",
          "table": "ទិដ្ឋភាពតារាង"
        },
        "bulk": {
          "aria": "សកម្មភាពច្រើន",
          "selected": "សមត្ថភាពបានជ្រើស | សមត្ថភាពបានជ្រើស",
          "archive": "រក្សាទុក",
          "clear": "សម្អាត"
        },
        "source": {
          "system": "លំនាំដើមប្រព័ន្ធ",
          "tenant": "ផ្ទាល់ខ្លួន"
        },
        "status": {
          "active": "សកម្ម",
          "draft": "ព្រាង",
          "archived": "បានរក្សាទុក"
        },
        "card": {
          "templates": "គំរូ | គំរូ",
          "versions": "កំណែ | កំណែ",
          "owner": "ម្ចាស់អភិបាលកិច្ច",
          "updated": "ធ្វើបច្ចុប្បន្នភាពចុងក្រោយ"
        },
        "table": {
          "select-all": "ជ្រើសជួរទាំងអស់",
          "name": "ឈ្មោះសមត្ថភាព",
          "category": "ប្រភេទ",
          "type": "ប្រភេទ",
          "levels": "កម្រិត",
          "templates": "គំរូភ្ជាប់",
          "templates-suffix": "គំរូ | គំរូ",
          "status": "ស្ថានភាព",
          "updated": "ធ្វើបច្ចុប្បន្នភាពចុងក្រោយ",
          "version": "កំណែ",
          "actions": "សកម្មភាព"
        },
        "empty": {
          "archived": {
            "title": "មិនមានសមត្ថភាពដែលបានរក្សាទុក",
            "body": "សមត្ថភាពដែលបានរក្សាទុកលេចឡើងនៅទីនេះ។ មិនទាន់មានសមត្ថភាពផ្ទាល់ខ្លួនណាបានរក្សាទុកឡើយ។",
            "cta": "បង្ហាញសមត្ថភាពសកម្ម"
          },
          "category": {
            "title": "មិនទាន់មានអ្វីនៅក្នុង {label}",
            "body": "មិនមានសមត្ថភាពណាដែលបានកំណត់ជាមួយប្រភេទនេះ។ បង្កើតថ្មីមួយ ឬរុករកប្រភេទផ្សេងពីរបារខាង។",
            "cta": "សមត្ថភាពទាំងអស់"
          },
          "search": {
            "title": "មិនមានលទ្ធផលសម្រាប់ \"{q}\"",
            "body": "ព្យាយាមពាក្យខ្លីជាង ឬពិនិត្យអក្ខរាវិរុទ្ធ។ ការស្វែងរកគ្របដណ្ដប់ឈ្មោះ និងការពិពណ៌នា។",
            "cta": "សម្អាតការស្វែងរក"
          },
          "filter": {
            "title": "មិនមានសមត្ថភាពដែលត្រូវនឹងការរួមបញ្ចូលច្រោះបច្ចុប្បន្ន",
            "body": "សាកល្បងសម្អាតច្រោះមួយ ឬច្រើន ដើម្បីពង្រីកលទ្ធផល។",
            "cta": "សម្អាតច្រោះទាំងអស់"
          }
        },
        "drawer": {
          "close": "បិទប្រអប់",
          "close-cta": "បិទ",
          "system-readonly": "លំនាំដើមប្រព័ន្ធ (មើលតែប៉ុណ្ណោះ)",
          "system-banner": {
            "title": "លំនាំដើមប្រព័ន្ធ",
            "body": "ផ្តល់ដោយ Optimal HR ជាចំណុចចាប់ផ្តើម។ មើលតែប៉ុណ្ណោះ — ដើម្បីប្ដូរ សូមចម្លងទៅបណ្ណាល័យផ្ទាល់ខ្លួន។"
          },
          "description": "ការពិពណ៌នា",
          "no-desc": "មិនមានការពិពណ៌នា។",
          "category": "ប្រភេទ",
          "type": "ប្រភេទសមត្ថភាព",
          "source-k": "ប្រភពបណ្ណាល័យ",
          "status": "ស្ថានភាព",
          "owner": "ម្ចាស់អភិបាលកិច្ច",
          "scale": "មាត្រដ្ឋានជំនាញ",
          "version": "កំណែសកម្ម",
          "cloned-from": "ចម្លងពី",
          "levels": "កម្រិតជំនាញ ({n})",
          "usage": "ការគ្រោងប្រើប្រាស់",
          "usage-templates": "គំរូ ({n})",
          "usage-departments": "នាយកដ្ឋាន",
          "no-templates": "មិនទាន់ភ្ជាប់ទៅគំរូណាមួយ — អាចលុបបាន",
          "all-depts": "នាយកដ្ឋានទាំងអស់",
          "history": "ប្រវត្តិកំណែ ({n})",
          "clone": "ចម្លងទៅបណ្ណាល័យផ្ទាល់ខ្លួន",
          "duplicate": "ស្ទួន",
          "archive": "រក្សាទុក",
          "edit": "កែ"
        }
      },
      "goals": {
        "title": "គោលដៅ និង OKR",
        "subtitle": "ស្បួននៃ SMART + OKR · {total} គោលដៅ ({smart} SMART · {okr} OKR) · {aligned} បានចុះតាមថ្នាក់",
        "cascade": "ចុះតាមថ្នាក់សាជីវកម្ម",
        "cascade-toast": "ប្រអប់ចុះតាមថ្នាក់សាជីវកម្ម — នឹងមកដល់ក្នុងកំណែបន្ត",
        "create": "គោលដៅថ្មី",
        "create-toast": "ប្រអប់បង្កើតគោលដៅ — នឹងមកដល់ក្នុងកំណែបន្ត",
        "checkin-toast": "ប្រអប់កត់ត្រាដំណើរការសម្រាប់ {id} — នឹងមកដល់ក្នុងកំណែបន្ត",
        "edit-toast": "ប្រអប់កែគោលដៅ {id} — នឹងមកដល់ក្នុងកំណែបន្ត",
        "adjust-toast": "ប្រអប់កែតម្រូវកណ្ដាលវដ្ត {id} — នឹងមកដល់ក្នុងកំណែបន្ត",
        "complete": "បានសម្រេច",
        "result-count": "ត្រូវនឹង {n} គោលដៅ",
        "kpi": {
          "active": "គោលដៅសកម្ម",
          "active-sub": "{smart} SMART · {okr} OKR",
          "on-track": "ដើរតាមផ្លូវ ឬសម្រេច",
          "on-track-sub": "{achieved} សម្រេច",
          "at-risk": "មានហានិភ័យ ឬខុសផ្លូវ",
          "at-risk-sub": "{low} ទំនុកចិត្តទាប",
          "avg-progress": "ការវិវត្តមធ្យម",
          "avg-progress-sub": "នៅគ្រប់គោលដៅទាំងអស់",
          "alignment": "ការគ្របដណ្ដប់ការតម្រឹម",
          "alignment-sub": "{aligned} បានចុះតាមថ្នាក់"
        },
        "filter": {
          "type": {
            "label": "ប្រភេទ",
            "all": "គ្រប់ប្រភេទ",
            "smart": "SMART KPI តែប៉ុណ្ណោះ",
            "okr": "OKR តែប៉ុណ្ណោះ"
          },
          "status": {
            "label": "ស្ថានភាព",
            "all": "គ្រប់ស្ថានភាព"
          },
          "dept": {
            "label": "ផ្នែក",
            "all": "គ្រប់ផ្នែក"
          }
        },
        "status": {
          "not_started": "មិនទាន់ចាប់ផ្ដើម",
          "on_track": "ដើរតាមផ្លូវ",
          "at_risk": "មានហានិភ័យ",
          "off_track": "ខុសផ្លូវ",
          "achieved": "សម្រេច",
          "missed": "ខកខាន"
        },
        "type-desc": {
          "smart": "ច្បាស់លាស់ វាស់វែងបាន សម្រេចបាន ពាក់ព័ន្ធ និងមានពេលកំណត់។ ការគណនាមានទម្ងន់ក្នុងការវាយតម្លៃ។",
          "okr": "គោលបំណង + លទ្ធផលគន្លឹះ ៣-៥ ។ ការគណនាមានសង្ឃឹមខ្ពស់ (0.0-1.0 ក្នុង KR មួយ ដែលគណនាជាមធ្យម)។"
        },
        "col": {
          "goal": "គោលដៅ",
          "type": "ប្រភេទ",
          "owner": "ម្ចាស់",
          "lifecycle": "វដ្តជីវិត",
          "source": "ប្រភព",
          "weight": "ទម្ងន់",
          "progress": "វិវត្ត",
          "status": "ស្ថានភាព",
          "confidence": "ទំនុកចិត្ត",
          "last-checkin": "ចុះឈ្មោះចុងក្រោយ",
          "actions": "សកម្មភាព"
        },
        "action": {
          "view": "មើល",
          "checkin": "កត់ត្រាដំណើរការ",
          "edit": "កែ",
          "adjust": "កែតម្រូវកណ្ដាលវដ្ត"
        },
        "empty": {
          "title": "មិនមានគោលដៅណាមួយត្រូវនឹងតម្រងរបស់អ្នកទេ",
          "sub": "សូមសាកល្បងសម្អាតតម្រងណាមួយខាងលើ។",
          "clear": "សម្អាតតម្រង"
        },
        "drawer": {
          "close": "បិទប្រអប់",
          "close-cta": "បិទ",
          "lifecycle": "វដ្តជីវិត",
          "step": "ជំហាន {n}/10",
          "progress": "វិវត្ត",
          "status": "ស្ថានភាព",
          "confidence": "ទំនុកចិត្ត",
          "weight": "ទម្ងន់",
          "owner": "ម្ចាស់",
          "source": "ប្រភព",
          "parent": "មាតាបិតា",
          "cycle": "វដ្ត",
          "last-checkin": "ចុះឈ្មោះចុងក្រោយ",
          "alignment": "ការតម្រឹម",
          "description": "ការពិពណ៌នា"
        }
      },
      "reviews": {
        "title": "បំពង់វាយតម្លៃ",
        "subtitle": "វដ្ត H1 2026 · ស្ថានភាពវាយតម្លៃរបស់អ្នកគ្រប់គ្រងទូទាំងស្ថាប័ន · {total} ការវាយតម្លៃនៅគ្រប់ {managers} អ្នកគ្រប់គ្រង · {pct}% បានដាក់ស្នើ ឬលើស",
        "nudge": "រំលឹកអ្នកគ្រប់គ្រងកំពុងរង់ចាំ",
        "nudge-toast": "បានផ្ញើការរំលឹកជាក្រុមដល់អ្នកគ្រប់គ្រងកំពុងរង់ចាំទាំងអស់ (សាកល្បង)",
        "go-calibration": "ទៅការសម្របសម្រួល",
        "state": {
          "not_started": "មិនបានចាប់ផ្ដើម",
          "self_in_progress": "សេចក្ដីព្រាងខ្លួនឯង",
          "self_submitted": "ខ្លួនឯងបានដាក់ស្នើ",
          "manager_in_progress": "ការវាយតម្លៃរបស់អ្នកគ្រប់គ្រង",
          "manager_submitted": "អ្នកគ្រប់គ្រងបានដាក់ស្នើ",
          "pending_calibration": "កំពុងរង់ចាំការសម្របសម្រួល",
          "calibrated": "បានសម្របសម្រួល",
          "acknowledged": "ទទួលស្គាល់"
        },
        "filter": {
          "all": "គ្រប់ស្ថានភាព",
          "pending": "កំពុងរង់ចាំ (អ្នកគ្រប់គ្រងមិនទាន់ដាក់ស្នើ)",
          "submitted": "អ្នកគ្រប់គ្រងបានដាក់ស្នើ",
          "complete": "បានសម្របសម្រួល / ទទួលស្គាល់"
        },
        "mgr": {
          "summary": "{dept} · {total} បុគ្គលិកផ្ទាល់ · {submitted} បានដាក់ស្នើ",
          "submitted-pct": "បានដាក់ស្នើ {pct}%",
          "nudge-toast": "បានផ្ញើការរំលឹកទៅ {name} (សាកល្បង)",
          "expand": "បើក {name}",
          "collapse": "បិទ {name}",
          "nudge-aria": "រំលឹក {name}"
        },
        "row": {
          "employee": "បុគ្គលិក",
          "self-submitted": "ខ្លួនឯងបានដាក់ស្នើ",
          "manager-submitted": "អ្នកគ្រប់គ្រងបានដាក់ស្នើ",
          "state": "ស្ថានភាព",
          "rating-self": "ការវាយតម្លៃខ្លួនឯង",
          "rating-manager": "ការវាយតម្លៃអ្នកគ្រប់គ្រង",
          "open": "បើក",
          "open-aria": "បើកកន្លែងធ្វើការវាយតម្លៃរបស់ {name}",
          "open-toast": "កន្លែងធ្វើការវាយតម្លៃរបស់ {name} — នឹងមកដល់ក្នុងកំណែបន្ត"
        },
        "empty-filter": "មិនមានអ្នកគ្រប់គ្រងណាដែលផ្គូផ្គងនឹងតម្រងនេះទេ។"
      },
      "calibration": {
        "title": "សិក្ខាសាលាសម្របសម្រួល",
        "subtitle-pill": "H1 2026 · {pending} កំពុងរង់ចាំការចុះហត្ថលេខា",
        "subtitle": "សមត្ថភាព × សក្តានុពល · អូសបុគ្គលិករវាងក្រឡា ឬប្រើម៉ឺនុយ ⋮ · ចុះហត្ថលេខាដើម្បីចាក់សោការវាយតម្លៃ និងផ្ទេរការវាយតម្លៃទៅជា {calibrated}",
        "calibrated-bold": "បានសម្របសម្រួល",
        "export-csv": "នាំចេញ CSV",
        "export-pdf": "នាំចេញ PDF",
        "sign-off-lock-n": "ចុះហត្ថលេខា & ចាក់សោ ({count})",
        "sign-off-lock": "ចុះហត្ថលេខា & ចាក់សោការវាយតម្លៃ",
        "nudge": "រំលឹកអ្នកគ្រប់គ្រងដែលមានទង់ប្រែប្រួល",
        "open": "បើកសម័យ",
        "open-toast": "UI សម័យសម្របសម្រួល — នឹងមកដល់ក្នុងកំណែបន្ត",
        "export-csv-toast": "បាននាំចេញ CSV ការសម្របសម្រួល (សាកល្បង)",
        "export-pdf-toast": "បាននាំចេញ PDF ការសម្របសម្រួល (សាកល្បង)",
        "sign-off-toast": "ចុះហត្ថលេខា & ចាក់សោ — នឹងមកដល់ក្នុងកំណែបន្ត",
        "nudge-toast": "បានផ្ញើការរំលឹកទៅអ្នកគ្រប់គ្រងដែលមានទង់ប្រែប្រួល (សាកល្បង)",
        "axis": {
          "perf-low": "← សមត្ថភាពទាបជាង",
          "perf-solid": "សមត្ថភាពមធ្យម",
          "perf-high": "សមត្ថភាពខ្ពស់ជាង →",
          "pot-high": "↑ សក្តានុពលខ្ពស់ជាង",
          "pot-solid": "សក្តានុពលមធ្យម",
          "pot-low": "↓ សក្តានុពលមានកម្រិត"
        },
        "cell": {
          "empty": "— ទទេ —",
          "1A": "ពេជ្រកំពុងលាក់",
          "2A": "តារាអនាគត",
          "3A": "តារា",
          "1B": "អ្នកលេងមិនស្ថិតស្ថេរ",
          "2B": "អ្នកលេងស្នូល",
          "3B": "អ្នករួមចំណែកគន្លឹះ",
          "1C": "ក្តីបារម្ភ",
          "2C": "អ្នកសម្តែងស្ថិតស្ថេរ",
          "3C": "អ្នកជំនាញ",
          "1A-desc": "សក្តានុពលរឹងមាំ ប៉ុន្តែសមត្ថភាពមិនទាន់ឈានដល់។ ប្រឹក្សារឹងមាំ។",
          "2A-desc": "សមត្ថភាពមធ្យមជាមួយសក្តានុពលខ្ពស់។ មួយជំហានពីតារា។",
          "3A-desc": "សមត្ថភាពខ្ពស់ និងសក្តានុពលខ្ពស់។ ទេពកោសល្យកំពូល។",
          "1B-desc": "សក្តានុពលមធ្យម សមត្ថភាពទាប។ ស៊ើបអង្កេត។",
          "2B-desc": "អ្នករួមចំណែកមធ្យមដែលអាចទុកចិត្តបាន។ ឆ្អឹងខ្នង។",
          "3B-desc": "អ្នកសម្តែងខ្ពស់ក្នុងតួនាទីបច្ចុប្បន្ន។ សក្តានុពលមធ្យម។",
          "1C-desc": "សមត្ថភាពទាប និងសក្តានុពលមានកម្រិត។ លំបាក។",
          "2C-desc": "ឈានដល់កម្រិតយ៉ាងជឿជាក់។ បន្ទប់រីកលូតលាស់មានកម្រិត។",
          "3C-desc": "សមត្ថភាពខ្ពស់ ជំនាញពិសេស។ ការផ្លាស់ប្តូរមានកម្រិត។"
        },
        "legend": {
          "variance": "ខ្លួនឯង ≠ ការវាយតម្លៃរបស់អ្នកគ្រប់គ្រង (ប្រែប្រួល)",
          "promo": "បានណែនាំការតម្លើងឋានៈ",
          "menu": "ចុចសម្រាប់ម៉ឺនុយផ្លាស់ទី"
        },
        "card-menu": {
          "title": "ផ្លាស់ទី \"{name}\" ទៅ",
          "current": "(បច្ចុប្បន្ន)",
          "detail": "ព័ត៌មានលម្អិតការសម្របសម្រួល (ចំណាំ · ប្រវត្តិ)",
          "open-workspace": "បើកកន្លែងធ្វើការវាយតម្លៃ"
        },
        "side": {
          "session": {
            "title": "ទិដ្ឋភាពទូទៅសម័យ",
            "in-matrix": "ក្នុងម៉ាទ្រីស",
            "pending": "កំពុងរង់ចាំចុះហត្ថលេខា",
            "locked": "បានចាក់សោរួច",
            "variance": "ទង់ប្រែប្រួល"
          },
          "dist": {
            "title": "សុខភាពការចែកចាយ",
            "sub": "គោលដៅ vs ជាក់ស្តែង",
            "lede": "សញ្ញាខ្មៅសម្គាល់គោលដៅ។ ប្រែប្រួលធំ = ការផ្លាស់ប្ដូរការចែកចាយដោយបង្ខំ។",
            "foot": "គោលដៅ = ការចែកចាយដោយបង្ខំដែលបានណែនាំ។ ±8% នៅក្នុងរង្វាល់សុខភាព; លើសពីនោះ ការរអាក់រអួលក្នុងការសម្របសម្រួលទំនងជាកើតឡើង។"
          },
          "variance": {
            "title": "ការដោះស្រាយការប្រែប្រួល",
            "flagged": "{count} បានដាក់ទង់",
            "empty": "គ្មានអ្នកគ្រប់គ្រងលើសកម្រិតប្រែប្រួល ±0.50 ឡើយ។ ការចែកចាយមានសុខភាពល្អ។",
            "over": "វាយតម្លៃលើស",
            "under": "វាយតម្លៃក្រោម",
            "row": "{dir} ដោយ {amount} (មធ្យម {avg} vs អង្គភាព 3.55) · {n} ការវាយតម្លៃបានដាក់ស្នើ"
          },
          "lock": {
            "title": "ការចាក់សោចុះហត្ថលេខា",
            "body": "នៅពេលអ្នកចុះហត្ថលេខា rating_manager ក្លាយជាការវាយតម្លៃចុងក្រោយសម្រាប់ការវាយតម្លៃកំពុងរង់ចាំទាំងអស់ កំណែគំរូដែលបានប្រើត្រូវបានបង្កក និងបុគ្គលិកត្រូវបានជូនដំណឹងឲ្យទទួលស្គាល់។ ការកែសម្រួលគំរូនាពេលអនាគតនឹងមិនផ្លាស់ប្ដូរការវាយតម្លៃទាំងនេះឡើយ។"
          }
        },
        "footer": {
          "summary": "{reviews-bold} រួចរាល់សម្រាប់ចុះហត្ថលេខា · {flags-bold} ត្រូវដោះស្រាយ · នៅពេលចាក់សោ ការវាយតម្លៃជាចុងក្រោយ",
          "reviews-one": "1 ការវាយតម្លៃ",
          "reviews-other": "{count} ការវាយតម្លៃ",
          "flags-one": "1 ទង់ប្រែប្រួល",
          "flags-other": "{count} ទង់ប្រែប្រួល"
        }
      },
      "devplans": {
        "title": "ផែនការអភិវឌ្ឍ",
        "subtitle": "{total} ផែនការសកម្ម · {pending} កំពុងរង់ចាំការអនុម័ត · {approved} បានអនុម័ត",
        "push": "ផ្ញើទៅ L&D",
        "push-toast": "ការតភ្ជាប់ម៉ូឌុល L&D នឹងសកម្ម · ការផ្ញើទៅ L&D នឹងដំណើរការនៅពេល L&D ត្រូវបានបង្កើត",
        "bulk": "អនុម័តជាក្រុម",
        "bulk-toast": "លំហូរអនុម័តជាក្រុម (សាកល្បង)",
        "approve-toast": "ផែនការ {id} បានអនុម័ត (សាកល្បង)",
        "lnd-toast": "បានផ្ញើទៅម៉ូឌុល L&D (សាកល្បង · L&D មិនទាន់បានបង្កើត)",
        "col": {
          "id": "លេខផែនការ",
          "employee": "បុគ្គលិក",
          "dept": "ផ្នែក",
          "area": "ផ្នែកអភិវឌ្ឍ",
          "action": "សកម្មភាពអនុសាសន៍",
          "status": "ស្ថានភាព",
          "owner": "ម្ចាស់",
          "actions": "សកម្មភាព"
        },
        "action": {
          "view": "មើល",
          "approve": "អនុម័ត",
          "lnd": "L&D"
        },
        "status": {
          "Active": "សកម្ម",
          "In review": "កំពុងពិនិត្យ",
          "Approved": "បានអនុម័ត",
          "Pending": "កំពុងរង់ចាំ"
        },
        "drawer": {
          "title": "{id} — {emp}",
          "sub": "{dept} · ម្ចាស់ផែនការ៖ {owner} · ស្ថានភាព៖ {status}",
          "close-label": "បិទប្រអប់",
          "employee": "បុគ្គលិក",
          "department": "ផ្នែក",
          "area": "ផ្នែកអភិវឌ្ឍ",
          "action": "សកម្មភាពអនុសាសន៍",
          "owner": "ម្ចាស់ (អ្នកគ្រប់គ្រងផ្ទាល់)",
          "status": "ស្ថានភាព",
          "milestones": "ចំណុចសំខាន់ (សាកល្បង)",
          "milestone-1": "ត្រីមាសទី២ ឆ្នាំ២០២៦ · បញ្ចប់វគ្គបណ្ដុះបណ្ដាលគ្រឹះ (៤សប្ដាហ៍)",
          "milestone-2": "ត្រីមាសទី៣ ឆ្នាំ២០២៦ · ការពិនិត្យលើកដំបូងជាមួយនាយក HR · វាយតម្លៃសញ្ញានៃការប្រសើរឡើង",
          "milestone-3": "ត្រីមាសទី៤ ឆ្នាំ២០២៦ · ការវាយតម្លៃពាក់កណ្ដាលឆ្នាំជាថ្មី · កែតម្រូវផែនការបើចាំបាច់",
          "lnd-linkage": "ការតភ្ជាប់ជាមួយ L&D",
          "lnd-body": "នៅពេលផែនការនេះត្រូវបានអនុម័ត និងផ្ញើទៅ L&D វគ្គណែនាំទាំងនោះនឹងក្លាយជាធាតុចុះឈ្មោះសម្រាប់បុគ្គលិកក្នុងម៉ូឌុល L&D។ ទិន្នន័យនៃការបញ្ចប់នឹងហូរត្រឡប់មកវិញចូលក្នុងមូលដ្ឋានភស្ដុតាងរបស់ Performance សម្រាប់វដ្តបន្ទាប់។",
          "close-cta": "បិទ",
          "send-cta": "ផ្ញើទៅ L&D",
          "send-toast": "បានផ្ញើទៅ L&D (សាកល្បង)",
          "approve-cta": "អនុម័តផែនការ",
          "approve-toast": "ផែនការបានអនុម័ត (សាកល្បង)"
        }
      },
      "reports": {
        "title": "របាយការណ៍ និងវិភាគ",
        "subtitle": "{count} របាយការណ៍ស្ដង់ដារ · ចុចលើកាតណាមួយដើម្បីមើលជាមុន",
        "custom": "របាយការណ៍ផ្ទាល់ខ្លួន",
        "custom-toast": "កម្មវិធីបង្កើតរបាយការណ៍ផ្ទាល់ខ្លួន — សមត្ថភាពកម្រិត Enterprise",
        "export": "នាំចេញទាំងអស់",
        "export-toast": "នាំចេញទាំងអស់ទៅ Excel (សាកល្បង)",
        "preview": "មើលជាមុន →",
        "preview-toast": "ប្រអប់របាយការណ៍ — នឹងមកដល់ក្នុងកំណែបន្ត",
        "items": {
          "R1": {
            "title": "របាយការណ៍សង្ខេបការអនុវត្តន៍",
            "desc": "ការចែកចាយការវាយតម្លៃទូទាំងស្ថាប័ន · ការវិវត្តវដ្ត · អត្រាបញ្ចប់ · ពិន្ទុមធ្យមតាមគំរូ",
            "period": "ផ្ទុកស្វ័យប្រវត្តិពីវដ្តបច្ចុប្បន្ន"
          },
          "R2": {
            "title": "របាយការណ៍ការចែកចាយការវាយតម្លៃ",
            "desc": "ខ្សែ Bell តាមផ្នែក · អ្នកគ្រប់គ្រង · ថ្នាក់ · ការផ្លាស់ប្ដូរឆ្នាំទៅឆ្នាំ",
            "period": "វដ្តបិទចុងក្រោយ"
          },
          "R3": {
            "title": "របាយការណ៍ការអនុវត្តន៍តាមផ្នែក",
            "desc": "តម្រៀបផ្នែកតាមការវាយតម្លៃមធ្យម · KPI · ការសម្រេចគោលដៅ · ពិន្ទុវត្តមាន",
            "period": "វដ្តបច្ចុប្បន្ន"
          },
          "R4": {
            "title": "សង្ខេបការសម្របសម្រួល",
            "desc": "ការផ្លាស់ប្ដូរមុន vs ក្រោយ · ការកែសម្រួលដោយ HR · ផ្នែកដែលមាន variance ច្រើនបំផុត",
            "period": "ក្រោយការសម្របសម្រួលបិទ"
          },
          "R5": {
            "title": "របាយការណ៍កំពូលនៃទេពកោសល្យ",
            "desc": "បុគ្គលិកដែលត្រូវវាយតម្លៃ Outstanding ២+ វដ្តជាប់គ្នា · បេក្ខជនការតម្លើងតួនាទី",
            "period": "៣ វដ្តមួយប្រែប្រួល"
          },
          "R6": {
            "title": "តាមដានអ្នកអនុវត្តន៍ខ្សោយ",
            "desc": "បុគ្គលិកអនុវត្តន៍ខ្សោយ · ហេតុ root · ស្ថានភាពផែនការអភិវឌ្ឍ · ហានិភ័យចាកចេញ",
            "period": "២ វដ្តមួយប្រែប្រួល"
          },
          "R7": {
            "title": "តាមដានផែនការអភិវឌ្ឍ",
            "desc": "ផែនការសកម្មទាំងអស់ · % បញ្ចប់ · ការបណ្ដុះបណ្ដាល · ថ្ងៃតាមដាន · មតិអ្នកគ្រប់គ្រង",
            "period": "ពីដើមវដ្តដល់ឥឡូវ"
          }
        }
      },
      "settings": {
        "title": "ការកំណត់ម៉ូឌុលការអនុវត្តន៍",
        "subtitle": "កំណត់រចនាសម្ព័ន្ធមាត្រដ្ឋានវាយតម្លៃ · លំហូរ · ការរំលឹក · ការអនុម័ត · ការតភ្ជាប់",
        "edit": "កែ",
        "restore": "ស្ដារទៅលំនាំដើម",
        "save": "រក្សាទុកទាំងអស់",
        "restore-toast": "ស្ដារទៅលំនាំដើម (សាកល្បង)",
        "save-toast": "ការកំណត់ត្រូវបានរក្សាទុក (សាកល្បង)",
        "edit-toast": "ប្រអប់កែ — នឹងមកដល់ក្នុងកំណែបន្ត",
        "toggle-toast": "បានប្ដូរ (សាកល្បង) — ការរក្សាទុកនឹងមកដល់ក្នុងកំណែបន្ត",
        "groups": {
          "workflow": "ការវាយតម្លៃ និងលំហូរ",
          "calibration": "ការសម្របសម្រួល",
          "reminders": "ការរំលឹក និងការជូនដំណឹង",
          "integrations": "ការតភ្ជាប់"
        },
        "items": {
          "rating-scale": {
            "title": "មាត្រដ្ឋានវាយតម្លៃ",
            "desc": "កម្រិតដែលប្រើនៅគ្រប់ទម្រង់វាយតម្លៃ",
            "value": "៥ កម្រិត (Outstanding → Unsatisfactory)"
          },
          "cycle-cadence": {
            "title": "ល្បឿនវដ្តលំនាំដើម",
            "desc": "ភាពញឹកញាប់ដែលវដ្តថ្មីបើក",
            "value": "ពាក់កណ្ដាលឆ្នាំ (H1 / H2)"
          },
          "self-review": {
            "title": "តម្រូវការវាយតម្លៃខ្លួនឯង",
            "desc": "បុគ្គលិកត្រូវដាក់ស្នើមុនអ្នកគ្រប់គ្រងបើក",
            "value": "បើក"
          },
          "peer-360": {
            "title": "បើកមតិកែ ៣៦០",
            "desc": "មតិពីមិត្ត / អ្នកក្រោម (ជម្រើស)",
            "value": "បិទ"
          },
          "calib-required": {
            "title": "តម្រូវការសម្របសម្រួល",
            "desc": "ការសម្របសម្រួលរបស់ HR មុនការវាយតម្លៃចុងក្រោយត្រូវចាក់សោ",
            "value": "បើក"
          },
          "forced-dist": {
            "title": "ការចែកចាយដោយបង្ខំ",
            "desc": "កំណត់ % នៃ Outstanding/Exceeds តាមផ្នែក",
            "value": "បិទ (ណែនាំ)"
          },
          "calib-quorum": {
            "title": "សន្តិបាតការសម្របសម្រួល",
            "desc": "អ្នកចូលរួមតិចបំផុតសម្រាប់ផ្នែកដើម្បីសម្របសម្រួល",
            "value": "៥ បុគ្គលិក"
          },
          "reminder-self": {
            "title": "ការរំលឹកការវាយតម្លៃខ្លួនឯង",
            "desc": "ការរំលឹកអ៊ីមែល/ក្នុងកម្មវិធីមុនថ្ងៃកំណត់",
            "value": "៧ ថ្ងៃ · ២ ថ្ងៃ · ថ្ងៃនោះ"
          },
          "reminder-mgr": {
            "title": "ការរំលឹកការវាយតម្លៃរបស់អ្នកគ្រប់គ្រង",
            "desc": "ផ្ញើទៅ LM ដែលមានការវាយតម្លៃកំពុងរង់ចាំ",
            "value": "៥ ថ្ងៃ · ១ ថ្ងៃ · ប្រចាំថ្ងៃក្រោយផុតកំណត់"
          },
          "escalate-overdue": {
            "title": "រាយការណ៍ការវាយតម្លៃហួសកំណត់",
            "desc": "ជូនដំណឹងអ្នកគ្រប់គ្រងបន្ទាប់ក្រោយផុតកំណត់",
            "value": "+៣ ថ្ងៃ"
          },
          "pull-wm": {
            "title": "ទាញពី Work Mgmt",
            "desc": "ភ្ជាប់ភស្តុតាងប្រតិបត្តិការទៅទម្រង់ស្វ័យប្រវត្តិ",
            "value": "បើក"
          },
          "pull-hrops": {
            "title": "ទាញពី HR Ops",
            "desc": "បរិបទវត្តមាន ឈប់សម្រាក OT ក្នុងទម្រង់",
            "value": "បើក"
          },
          "push-payroll": {
            "title": "ផ្ញើរង្វាន់ទៅ Payroll",
            "desc": "ផ្ញើប្រាក់រង្វាន់/កើនប្រាក់ខែដែលបានអនុម័តទៅ Payroll",
            "value": "បើក (ការណែនាំ; Payroll Admin បញ្ជាក់)"
          },
          "push-lnd": {
            "title": "ផ្ញើទៅ L&D",
            "desc": "ផ្ញើផែនការអភិវឌ្ឍ/ការបណ្ដុះបណ្ដាលដែលបានអនុម័តទៅ L&D",
            "value": "បិទ (ម៉ូឌុល L&D មិនទាន់សកម្ម)"
          }
        }
      },
      "subtitle-suffix": "ការអនុវត្តការងារ"
    },
    "billing": {
      "title": "វិក្កយបត្រ",
      "subtitle": "Optimal P · ការគិតប្រាក់សេវាបន្ត",
      "period-label": "រយៈពេលវិក្កយបត្រ",
      "no-access": "អ្នកមិនមានសិទ្ធិចូលប្រើវិក្កយបត្រទេ។",
      "not-recharged": "មិនត្រូវបានគិតប្រាក់ឡើងវិញ",
      "reconciled": "បានផ្ទៀងផ្ទាត់",
      "direct-notice": "បុគ្គលិកផ្ទាល់គឺជាថ្លៃដើមផ្ទៃក្នុងរបស់ក្រុមហ៊ុន ហើយ{strong}។ ប្តូរទៅវិសាលភាពអតិថិជន ឬគម្រោង ដើម្បីមើលការគិតប្រាក់សេវា។",
      "dashboard-empty": "មិនមានដំណើរការគិតប្រាក់សេវាសម្រាប់វិសាលភាព + រយៈពេលនេះនៅឡើយទេ។",
      "runs-direct-notice": "បុគ្គលិកផ្ទាល់គឺជាថ្លៃដើមផ្ទៃក្នុងរបស់ក្រុមហ៊ុន ហើយ{strong}។",
      "runs-empty": "មិនមានដំណើរការគិតប្រាក់សេវាសម្រាប់វិសាលភាព + រយៈពេលនេះទេ។",
      "recon-direct-notice": "បុគ្គលិកផ្ទាល់មិនត្រូវបានគិតប្រាក់សេវាឡើងវិញ — គ្មានអ្វីត្រូវផ្ទៀងផ្ទាត់ទេ។",
      "tabs": {
        "dashboard": "ផ្ទាំងគ្រប់គ្រង",
        "runs": "ដំណើរការគិតប្រាក់សេវា",
        "recon": "ការផ្ទៀងផ្ទាត់"
      },
      "kpi": {
        "total-recharge": "ការគិតប្រាក់សេវាសរុប",
        "cost-base": "មូលដ្ឋានថ្លៃដើម",
        "margin-fee": "កម្រៃ / ថ្លៃសេវា",
        "runs": "ដំណើរការគិតប្រាក់សេវា",
        "employees-billed": "បុគ្គលិកដែលបានគិតប្រាក់",
        "reconciled": "បានផ្ទៀងផ្ទាត់",
        "with-variance": "មានភាពខុសគ្នា",
        "period": "រយៈពេល"
      },
      "runs": {
        "col-run-id": "លេខដំណើរការ",
        "col-client-project": "អតិថិជន › គម្រោង",
        "col-method": "វិធីសាស្ត្រ",
        "col-emp": "បុគ្គលិក",
        "col-cost-base": "មូលដ្ឋានថ្លៃដើម",
        "col-margin": "កម្រៃ",
        "col-total": "ការគិតប្រាក់សេវាសរុប",
        "col-recon": "ការផ្ទៀងផ្ទាត់"
      },
      "recon": {
        "runs-reconciled": "ដំណើរការដែលបានផ្ទៀងផ្ទាត់",
        "total-variance": "ភាពខុសគ្នាសរុប",
        "col-run": "ដំណើរការ",
        "col-project": "គម្រោង",
        "col-payroll-cost": "ថ្លៃដើមបើកប្រាក់ខែ",
        "col-billed-base": "មូលដ្ឋានគិតប្រាក់",
        "col-variance": "ភាពខុសគ្នា",
        "col-status": "ស្ថានភាព"
      },
      "detail": {
        "back": "ត្រឡប់",
        "back-to-runs": "ត្រឡប់ទៅដំណើរការ",
        "not-found": "រកមិនឃើញដំណើរការទេ។",
        "service-fee": "ថ្លៃសេវា",
        "pass-through": "ឆ្លងកាត់",
        "margin": "កម្រៃ",
        "lines-heading": "បន្ទាត់គិតប្រាក់សេវា",
        "no-lines": "មិនមានបន្ទាត់គិតប្រាក់សេវាទេ។",
        "col-employee": "បុគ្គលិក",
        "col-cost": "ថ្លៃដើម",
        "col-fee": "ថ្លៃសេវា",
        "col-pass-through": "ឆ្លងកាត់",
        "col-line-total": "សរុបបន្ទាត់",
        "recon-heading": "ការផ្ទៀងផ្ទាត់",
        "payroll-employer-cost": "ថ្លៃដើមនិយោជកបើកប្រាក់ខែ",
        "billed-cost-base": "មូលដ្ឋានថ្លៃដើមដែលបានគិតប្រាក់",
        "variance": "ភាពខុសគ្នា",
        "sources-heading": "ប្រភពបើកប្រាក់ខែ",
        "sources-note": "ការគិតប្រាក់សេវាមានប្រភពពីការបើកប្រាក់ខែ · ADV មិនរាប់បញ្ចូលក្នុងថ្លៃដើម · FIN = ថ្លៃដើមពេញមួយខែ។",
        "advance-excluded": "បុរេប្រទាន (មិនរាប់បញ្ចូលក្នុងថ្លៃដើម)",
        "cost-amount": "ថ្លៃដើម {amount}"
      }
    },
    "insights": {
      "title": "ការវិភាគ",
      "subtitle": "របាយការណ៍ និងវិភាគ · គ្រប់ម៉ូឌុលទាំងអស់",
      "toast-open": "បើក {name}",
      "tiles": {
        "headcount": {
          "title": "ចំនួនបុគ្គលិក",
          "desc": "ផ្ទាល់ · ក្រៅ · ខាងក្រៅ"
        },
        "turnover": {
          "title": "អត្រាបុគ្គលិកចូលចេញ",
          "desc": "ស្ម័គ្រចិត្ត គ្មានស្ម័គ្រចិត្ត តាមគម្រោង"
        },
        "attendance": {
          "title": "វត្តមាន",
          "desc": "មានវត្តមាន យឺត អវត្តមាន OT"
        },
        "payroll-cost": {
          "title": "តម្លៃប្រាក់ខែ",
          "desc": "ច្រាស សុទ្ធ ពន្ធ ប្រាក់ឧបត្ថម្ភ"
        },
        "project-profitability": {
          "title": "ផលចំណេញគម្រោង",
          "desc": "តម្លៃវិក្កយបត្រធៀបនឹងតម្លៃ ប្រាក់ចំណេញ"
        },
        "compliance": {
          "title": "ការអនុលោម",
          "desc": "កិច្ចសន្យាជិតផុតកំណត់ NSSF TOS"
        }
      }
    },
    "moreapps": {
      "title": "កម្មវិធីបន្ថែម",
      "subtitle": "កន្លែងបើកដំណើរការប្រព័ន្ធអេកូ · ការពង្រីកវេទិកាកម្លាំងពលកម្ម",
      "section-live": "មានឥឡូវនេះ",
      "section-future": "នឹងមកដល់វេទិកា",
      "tag-live": "Live",
      "tag-soon": "ឆាប់ៗ",
      "title-open": "បើក {name}",
      "toasts": {
        "coming-soon": "{name} — ឆាប់ៗនេះ"
      },
      "live": {
        "stock": {
          "label": "ការគ្រប់គ្រងស្តុក",
          "desc": "ស្តុក FMCG · ឃ្លាំងច្រើន · បាច់/ផុតកំណត់ · ការផ្គត់ផ្គង់"
        },
        "lnd": {
          "label": "L&D",
          "desc": "ការសិក្សា និងអភិវឌ្ឍន៍ · វគ្គសិក្សា · ម៉ាទ្រីសសមត្ថភាព · វិញ្ញាបនបត្រ"
        },
        "admin": {
          "label": "Admin",
          "desc": "ការកំណត់រចនាសម្ព័ន្ធអ្នកជួល · អ្នកប្រើ · តួនាទី · ទិន្នន័យមេ · គោលនយោបាយ · វេទិកា"
        }
      },
      "future": {
        "recruitment": "ការជ្រើសរើស",
        "benefits": "អត្ថប្រយោជន៍",
        "ai-assistant": "AI ជំនួយ",
        "survey": "ការស្ទង់មតិ",
        "asset-mgmt": "ការគ្រប់គ្រងទ្រព្យសកម្ម",
        "compliance-center": "មជ្ឈមណ្ឌលការអនុលោម"
      }
    },
    "fieldops": {
      "title": "Field Ops",
      "subtitle": "FMCG · ឧស្សាហកម្មលក់រាយ · ការចែកចាយ — អាចមើលឃើញតែនៅពេលដែលអ្នកជួលមានអតិថិជន FMCG",
      "tabs": {
        "stock": "ការគ្រប់គ្រងស្តុក",
        "fieldforce": "កម្លាំងវាល"
      },
      "stub": {
        "title": "Field Ops — ម៉ូឌុលដែលស្នើ",
        "lede": "ឧបករណ៍សម្រាប់អ្នកជួលដែលមានអតិថិជនម៉ាករបស់អ្នកប្រើប្រាស់ (Unilever, Heineken, BAT, Samsung, AIA)៖ ការគ្រប់គ្រងស្តុក (កាតាឡុក SKU, ឃ្លាំងច្រើន, លេខបញ្ជា+ការផុតកំណត់, ការផ្គត់ផ្គង់), ការគ្រប់គ្រងកម្លាំងវាល (ការរៀបចំផ្លូវ, ការចូល GPS, ការចាប់ការបញ្ជា, ការវិភាគ — ផ្នែកបន្ថែម React Native សម្រាប់ ESS បច្ចុប្បន្ន)។"
      }
    },
    "admin-settings": {
      "title": "Admin",
      "subtitle": "ការកំណត់រចនាសម្ព័ន្ធអ្នកជួល · ទិន្នន័យមេ · គោលនយោបាយ · វេទិកា",
      "toast-open": "បើក {name}",
      "title-open": "បើក {name}",
      "groups": {
        "company": {
          "label": "ក្រុមហ៊ុន",
          "tiles": {
            "profile": {
              "title": "ប្រវត្តិក្រុមហ៊ុន",
              "desc": "ទិដ្ឋភាពអ្នកជួល · ទីតាំង · គោលនយោបាយ"
            },
            "users-roles": {
              "title": "អ្នកប្រើ និងតួនាទី",
              "desc": "ម៉ាទ្រីសសិទ្ធិ"
            },
            "modules": {
              "title": "ម៉ូឌុល",
              "desc": "បើក/បិទ តាមអ្នកជួល"
            }
          }
        },
        "setup": {
          "label": "ការរៀបចំ · ទិន្នន័យមេ",
          "tiles": {
            "employment-types": {
              "title": "ប្រភេទការងារ",
              "desc": "ពេញម៉ោង, ខ្លះៗ, ហាត់ការ, បណ្ដោះអាសន្ន"
            },
            "contract-types": {
              "title": "ប្រភេទកិច្ចសន្យា",
              "desc": "UDC, FDC, អ្នកប្រឹក្សា, ការសាកល្បង"
            },
            "cost-centers": {
              "title": "មជ្ឈមណ្ឌលថ្លៃដើម",
              "desc": "ការបែងចែកហិរញ្ញវត្ថុគ្រប់ម៉ូឌុល"
            },
            "approval-workflows": {
              "title": "លំហូរការអនុម័ត",
              "desc": "ច្បាប់ការណែនាំឆ្លងម៉ូឌុល"
            }
          }
        },
        "policies": {
          "label": "គោលនយោបាយ"
        },
        "platform": {
          "label": "វេទិកា",
          "tiles": {
            "localization": {
              "title": "ការធ្វើមូលដ្ឋាន",
              "desc": "ភាសាអង់គ្លេស + ខ្មែរ · ទម្រង់កាលបរិច្ឆេទ · តំបន់ម៉ោង"
            },
            "audit-log": {
              "title": "កំណត់ហេតុ Audit",
              "desc": "ការផ្លាស់ប្ដូរទាំងអស់ត្រូវបានកត់ត្រា"
            },
            "data-privacy": {
              "title": "ទិន្នន័យ និងភាពឯកជន",
              "desc": "ការរក្សា PDPA នាំចេញ លុប"
            }
          }
        }
      },
      "workspace": {
        "title": "ការកំណត់កន្លែងធ្វើការ និងអ្នកជួល",
        "desc": "ប្រភេទអាជីវកម្ម · វិក្កយបត្រ · អាសយដ្ឋាន · ការជាវ · ទំនាក់ទំនង"
      }
    },
    "admin-policies": {
      "title": "គោលការណ៍",
      "subtitle": "ពិនិត្យ និងកែសម្រួលគោលការណ៍ និងការកំណត់ម៉ូឌុលធនធានមនុស្សរបស់ក្រុមហ៊ុននេះ។ ការផ្លាស់ប្តូរនឹងមានប្រសិទ្ធភាពលើដំណើរការពាក់ព័ន្ធ។",
      "back": "ត្រឡប់ទៅ Admin",
      "back-to-cards": "ត្រឡប់ទៅគោលការណ៍",
      "areas": {
        "attendance": {
          "title": "វត្តមាន",
          "desc": "ច្បាប់ចុះម៉ោង រយៈពេលអនុគ្រោះ ការសម្រាក និងការអនុវត្តទីតាំង"
        },
        "employment": {
          "title": "ការងារ",
          "desc": "រយៈពេលជូនដំណឹង FDC និង UDC និងការរំលឹកកិច្ចសន្យា"
        },
        "leave": {
          "title": "ការឈប់សម្រាក",
          "desc": "ការប្រមូលផ្ដុំ ការ​ផ្ដល់​សិទ្ធិ និងច្បាប់ស្នើសុំការឈប់សម្រាក"
        },
        "schedule": {
          "title": "កាលវិភាគ",
          "desc": "ម៉ោងធ្វើការ វេន និងការកំណត់ច្បាប់ការងារ"
        },
        "localization": {
          "title": "ការធ្វើមូលដ្ឋានីយកម្ម",
          "desc": "ភាសា រូបិយប័ណ្ណ និងទ្រង់ទ្រាយតំបន់"
        }
      },
      "groups": {
        "attendance": {
          "clock-settings": "ការកំណត់ការចុះម៉ោង",
          "overtime-grace": "ម៉ោងបន្ថែម និងរយៈពេលអនុគ្រោះ",
          "breaks-reminders": "ការសម្រាក និងការរំលឹក",
          "location-enforcement": "ការអនុវត្តទីតាំង"
        },
        "employment": {
          "fdc": "កិច្ចសន្យាមានកំណត់ (FDC)",
          "udc": "កិច្ចសន្យាគ្មានកំណត់ (UDC)"
        },
        "other": "ផ្សេងៗ"
      },
      "row": {
        "value": "តម្លៃ៖",
        "edit-value": "កែសម្រួល {name}",
        "errors": {
          "min": "តម្លៃត្រូវតែយ៉ាងតិច {min}។",
          "max": "តម្លៃត្រូវតែយ៉ាងច្រើន {max}។",
          "required": "តម្រូវឱ្យមានតម្លៃ។"
        }
      },
      "error": {
        "title": "មិនអាចផ្ទុកគោលការណ៍បានទេ",
        "desc": "មានបញ្ហាក្នុងការផ្ទុកគោលការណ៍របស់ក្រុមហ៊ុននេះ។ សូមព្យាយាមម្ដងទៀត។"
      },
      "no-company": {
        "title": "គ្មានក្រុមហ៊ុនសកម្ម",
        "desc": "សូមជ្រើសរើសក្រុមហ៊ុនពីកន្លែងប្ដូរ ដើម្បីគ្រប់គ្រងគោលការណ៍របស់វា។"
      },
      "empty": {
        "title": "គ្មានការកំណត់ដែលអាចកំណត់បាន",
        "desc": "ផ្នែកនេះមិនទាន់មានគោលការណ៍ ឬការកំណត់ដែលអាចកំណត់បានឡើយ។"
      },
      "unknown": {
        "title": "ផ្នែកគោលការណ៍មិនស្គាល់",
        "desc": "ផ្នែកគោលការណ៍នោះមិនមានទេ។ សូមជ្រើសរើសផ្នែកមួយក្នុងចំណោមផ្នែកដែលមាន។"
      }
    },
    "pay": {
      "configurations": {
        "title": "ការកំណត់",
        "subtitle": "កាតាឡុកប្រាក់ខែថ្នាក់អ្នកជួល · ច្បាប់គណនា · អត្រាច្បាប់",
        "banner-lead": "ការរួមបញ្ចូល Backend កំពុងដំណើរការ។",
        "banner-body": "ផ្ទាំងនីមួយៗខាងក្រោមបើកកន្លែងដាក់រហូតដល់ Endpoint ការកំណត់ដែលត្រូវគ្នាមកដល់។ ការដំណើរការប្រាក់ខែដែលមានស្រាប់នៅតែប្រើតម្លៃដែលបានកំណត់រួចហើយនៅ server។",
        "toast-coming-soon": "{name} — ការរួមបញ្ចូល Backend នឹងមកដល់ក្នុងស្រាប់ៗ",
        "groups": {
          "catalog": {
            "label": "កាតាឡុក"
          },
          "rules": {
            "label": "ច្បាប់ និងអត្រា"
          }
        },
        "tiles": {
          "pay-components": {
            "title": "សមាសភាគប្រាក់ខែ",
            "desc": "និយមន័យបន្ថែម / កាត់កង · ប្រាក់ចំណូល vs ការកាត់កង · ផ្នែក​​ពន្ធ និង NSSF"
          },
          "pay-groups": {
            "title": "ក្រុមប្រាក់ខែ",
            "desc": "សំណុំសមាសភាគបណ្ដុំដែលអនុវត្តចំពោះប្រជាជន (HQ, ក្រុមនៅទីតាំង, បុគ្គលិកក្រៅ)"
          },
          "pay-cycles": {
            "title": "វដ្ដប្រាក់ខែ",
            "desc": "ប្រចាំខែ · ប្រចាំ​២​សប្ដាហ៍​ម្ដង · ប្រចាំសប្ដាហ៍ · កំណត់ខ្លួនឯង · កាលបរិច្ឆេទកំណត់ និង offset ថ្ងៃបង់ប្រាក់"
          },
          "calc-rules": {
            "title": "ច្បាប់គណនា",
            "desc": "មេគុណ OT, រូបមន្តប្រាក់ប្រចាំថ្ងៃ, ការវឹក, សប្ដាហ៍ការងារ, រូបិយប័ណ្ណលំនាំដើម, offset ប្រាក់ខែទីមួយ"
          },
          "nssf-rates": {
            "title": "អត្រា NSSF",
            "desc": "៤ គម្រោង (សោធននិវត្តន៍ · វិជ្ជាជីវៈ · សុខភាព · ស្ម័គ្រចិត្ត) ជាមួយតម្បន់អត្រាមានកាលបរិច្ឆេទ"
          },
          "tax-brackets": {
            "title": "តម្បន់ពន្ធ",
            "desc": "តម្បន់ TOS (ពន្ធលើប្រាក់ខែ) ជាបន្តបន្ទាប់ + ការលើកលែងសម្រាប់អ្នកស្នាក់នៅ / មិនស្នាក់នៅ"
          }
        }
      },
      "center": {
        "title": "មជ្ឈមណ្ឌលប្រាក់ខែ",
        "subtitle-upcoming": "រៀបចំការដំណើរការប្រាក់ខែខាងមុខ មុនកាលបរិច្ឆេទកំណត់ និងបង់ប្រាក់",
        "subtitle-in-progress": "បន្តដំណើរការប្រាក់ខែ (កំពុងធ្វើ)",
        "subtitle-completed": "ពិនិត្យលទ្ធផលប្រាក់ខែដែលបានអនុម័ត និងចាក់សោ",
        "subtitle-error": "មិនអាចផ្ទុកកាលវិភាគប្រាក់ខែបានទេ",
        "error": "មិនអាចផ្ទុកកាលវិភាគប្រាក់ខែ — {message}",
        "untitled": "ប្រាក់ខែគ្មានចំណងជើង",
        "selected-placeholder": "ទិដ្ឋភាពលម្អិតសម្រាប់ប្រាក់ខែដែលបានជ្រើសរើស នឹងមកដល់ក្នុងដំណាក់កាលបន្ទាប់។",
        "off-cycle": {
          "button": "ប្រាក់ខែក្រៅវាគ្គ",
          "toast": "ការដាក់ឱ្យដំណើរការប្រាក់ខែក្រៅវាគ្គ មកដល់ក្នុង Wave 2.9 — បានជ្រើស: {type}",
          "types": {
            "bonus": "ប្រាក់រង្វាន់",
            "incentive": "ប្រាក់លើកទឹកចិត្ត",
            "adjustment": "ការកែតម្រូវ",
            "final-pay": "ប្រាក់ខែចុងក្រោយ",
            "special": "ប្រាក់ខែពិសេស"
          }
        },
        "filters": {
          "all": "ទាំងអស់",
          "upcoming": "ខាងមុខ",
          "in-progress": "កំពុងដំណើរការ",
          "off-cycle": "ក្រៅវាគ្គ",
          "completed": "បានបញ្ចប់"
        },
        "schedule": {
          "title": "កាលវិភាគ",
          "subtitle": "មើលការដំណើរការប្រាក់ខែតាមស្ថានភាព",
          "scroll-left": "រំកិលកាលវិភាគទៅឆ្វេង",
          "scroll-right": "រំកិលកាលវិភាគទៅស្ដាំ"
        },
        "status": {
          "upcoming": "ខាងមុខ",
          "in-progress": "កំពុងដំណើរការ",
          "off-cycle": "ក្រៅវាគ្គ",
          "completed": "បានបញ្ចប់"
        },
        "card": {
          "period": "កំឡុងពេល: {start} – {end}"
        },
        "empty": {
          "title": "មិនមានការដំណើរការប្រាក់ខែផ្គូផ្គងនឹងតម្រងនេះទេ",
          "description": "កែតម្រូវតម្រងខាងលើ ឬបង្កើតកាលវិភាគប្រាក់ខែថ្មី។"
        }
      },
      "detail": {
        "back": "ត្រឡប់ទៅមជ្ឈមណ្ឌលប្រាក់ខែ",
        "meta": "កំឡុងពេលប្រាក់ខែ {start} – {end} · វដ្ត {cycle} · លេខសម្គាល់ {runId} · បង្កើតនៅ {generatedAt}",
        "badges": {
          "locked": "បានអនុម័ត និងចាក់សោ",
          "approved": "បានអនុម័តនៅ {date} ដោយ {actor}",
          "paid": "បានបង់នៅ {date}",
          "employees": "បុគ្គលិក {count} នាក់",
          "off-cycle": "ក្រៅវដ្ត: {type}"
        },
        "totals": {
          "title": "សរុបការដំណើរការ",
          "headcount-paid": {
            "label": "ចំនួនបុគ្គលិកដែលបានទទួលប្រាក់",
            "help": "ចំនួនបុគ្គលិកដែលបានទទួលការបង់ប្រាក់"
          },
          "gross": {
            "label": "ប្រាក់ខែសរុបដុល",
            "help": "មូលដ្ឋាន + ម៉ោងបន្ថែម + រង្វាន់ + ការលើកទឹកចិត្ត + ច្បាប់មានប្រាក់"
          },
          "deductions": {
            "label": "ការកាត់សរុប",
            "help": "ពន្ធ (TOS) + NSSF + ច្បាប់គ្មានប្រាក់ + ប្រាក់សងរំលឹក + ផ្សេងៗ"
          },
          "net": {
            "label": "ប្រាក់ខែសុទ្ធសរុប",
            "help": "ការបង់ប្រាក់ចុងក្រោយដល់បុគ្គលិក {count} នាក់"
          }
        },
        "earnings": {
          "title": "ប្រាក់ចំណូល",
          "total": "សរុបដុល"
        },
        "deductions": {
          "title": "ការកាត់",
          "total": "សរុបការកាត់"
        },
        "employees": {
          "title": "ព័ត៌មានបុគ្គលិក (បុគ្គលិក {count} នាក់)",
          "columns": {
            "employee": "បុគ្គលិក",
            "dept": "ផ្នែក",
            "pay-method": "វិធីបង់",
            "bank": "ធនាគារ",
            "gross": "ដុល",
            "tax": "ពន្ធ",
            "nssf": "NSSF",
            "other": "ផ្សេងៗ",
            "net": "សុទ្ធ"
          }
        },
        "compliance": {
          "title": "ការអនុលោម"
        },
        "audit": {
          "title": "ប្រវត្តិសវនកម្ម"
        }
      },
      "run": {
        "untitled": "ការដំណើរការប្រាក់ខែ",
        "save-exit": "រក្សាទុក & ចេញ",
        "save-exit-hint": "ការដំណើរការនៅតែស្ថិតក្នុងដំណាក់កាល · បន្តពេលណាក៏បាន",
        "identity": {
          "run-id": "លេខសម្គាល់",
          "pay-date": "ថ្ងៃបង់ប្រាក់:",
          "pay-period": "កំឡុងពេលប្រាក់ខែ:",
          "period": "{start} – {end}"
        },
        "step-title": "ជំហានទី {n} — {label}",
        "steps": {
          "eligibility": "សិទ្ធិបុគ្គលិក",
          "pay-inputs": "ពិនិត្យធាតុចូលប្រាក់ខែ",
          "calculation": "ការគណនា និងពិនិត្យ",
          "approval": "ការពិនិត្យ និងអនុម័ត",
          "payment-distribution": "ការបង់ប្រាក់ និងចែកចាយ"
        },
        "summary-strip": {
          "in-this-run": "ក្នុងការដំណើរការនេះ",
          "eligible": "មានសិទ្ធិ",
          "excluded": "មិនរាប់បញ្ចូល",
          "warnings": "ការព្រមាន"
        },
        "stepper": {
          "locked-tooltip": "សូមបញ្ចប់ជំហានមុនសិន"
        },
        "warning-banner": {
          "title": "ការព្រមានទម្រង់បុគ្គលិក {count} — មិនរារាំង",
          "subtitle": "សូមដោះស្រាយមុនជំហានទី 5 (ការបង់ប្រាក់) ដើម្បីឱ្យឯកសារធនាគារ និងរបាយការណ៍ NSSF មានភាពត្រឹមត្រូវ។",
          "show": "បង្ហាញព័ត៌មានលម្អិត",
          "hide": "លាក់ព័ត៌មានលម្អិត"
        },
        "placeholder": {
          "loading": "កំពុងផ្ទុកសង្ខេបការដំណើរការ…",
          "error": "មិនអាចផ្ទុកសង្ខេបការដំណើរការបានទេ — {message}",
          "step-coming": "មាតិកាជំហាននឹងមកដល់ក្នុង Wave 2.3+ (ទិដ្ឋភាពនីមួយៗ)។"
        },
        "step1": {
          "loading": "កំពុងផ្ទុកសង្ខេបសិទ្ធិ…",
          "error": "មិនអាចផ្ទុកសង្ខេបសិទ្ធិបានទេ — {message}",
          "kpi": {
            "total": {
              "label": "បុគ្គលិកសរុប",
              "help": "បានពិនិត្យក្នុងការដំណើរការនេះ"
            },
            "ready": {
              "label": "មានសិទ្ធិ និងត្រៀមរួចរាល់",
              "help": "នឹងត្រូវបង់ប្រាក់ក្នុងការដំណើរការនេះ"
            },
            "action": {
              "label": "ត្រូវការសកម្មភាព",
              "help": "ឧបសគ្គដែលត្រូវដោះស្រាយមុនជំហានទី 2"
            },
            "excluded": {
              "label": "គ្មានសិទ្ធិ / មិនរាប់បញ្ចូល",
              "help": "មិនរាប់បញ្ចូលក្នុងការដំណើរការនេះ"
            }
          },
          "blockers": {
            "title": "ធាតុដែលត្រូវការសកម្មភាព ({count})"
          },
          "list": {
            "title": {
              "total": "បុគ្គលិកទាំងអស់ក្នុងការដំណើរការនេះ",
              "ready": "បុគ្គលិកដែលមានសិទ្ធិ",
              "action": "បុគ្គលិកដែលត្រូវការសកម្មភាព",
              "excluded": "បុគ្គលិកដែលមិនរាប់បញ្ចូល"
            },
            "count": "{count} នៅក្នុងបញ្ជី",
            "loading": "កំពុងផ្ទុកបុគ្គលិក…",
            "error": "មិនអាចផ្ទុកបុគ្គលិកបានទេ — សូមព្យាយាមម្ដងទៀត",
            "empty": "មិនមានបុគ្គលិកផ្គូផ្គងនឹងតម្រងនេះទេ",
            "columns": {
              "code": "លេខកូដ",
              "name": "ឈ្មោះ",
              "dept": "ផ្នែក",
              "reason": "មូលហេតុ / ឧបសគ្គ",
              "actions": "សកម្មភាព"
            },
            "actions": {
              "move": "ផ្លាស់ទី"
            }
          },
          "gate-banner": {
            "text": "ធាតុដែលត្រូវការសកម្មភាពត្រូវតែដោះស្រាយមុនពេលជំហានទី ២ ដោះសោ។"
          },
          "confirm": {
            "error": "ការបញ្ជាក់បរាជ័យ — {message}"
          },
          "actions": {
            "back": "ត្រឡប់ទៅមជ្ឈមណ្ឌលប្រាក់ខែ",
            "confirm": "បញ្ជាក់ និងបន្ត"
          },
          "move-modal": {
            "title": "ផ្លាស់ទីបុគ្គលិក",
            "employee": "បុគ្គលិក",
            "from": "ថង់បច្ចុប្បន្ន",
            "to": "ផ្លាស់ទីទៅ",
            "select-bucket": "ជ្រើសរើសថង់…",
            "reason": "មូលហេតុ",
            "reason-placeholder": "ចាំបាច់នៅពេលផ្លាស់ទីទៅ/ពីមិនរាប់បញ្ចូល",
            "submit": "ផ្លាស់ទីបុគ្គលិក"
          }
        },
        "step2": {
          "loading": "កំពុងផ្ទុកផ្ទាំងព័ត៌មានធាតុចូលប្រាក់ខែ…",
          "error": "មិនអាចផ្ទុកផ្ទាំងព័ត៌មានបានទេ — {message}",
          "kpi": {
            "records": {
              "label": "កំណត់ត្រាបានត្រួតពិនិត្យ",
              "help": "ធាតុចូលប្រាក់ខែក្នុងការដំណើរការនេះ"
            },
            "employees": {
              "label": "បុគ្គលិកប៉ះពាល់",
              "help": "បុគ្គលិកមានសិទ្ធិក្នុងការដំណើរការនេះ"
            },
            "issues": {
              "label": "បញ្ហារកឃើញ",
              "detail": "ឧបសគ្គ {blockers} · ការព្រមាន {warnings}"
            },
            "components": {
              "label": "សមាសភាគប្រាក់ខែ",
              "help": "សកម្មក្នុងការដំណើរការនេះ"
            }
          },
          "components": {
            "title": "សមាសភាគប្រាក់ខែ",
            "empty": "មិនមានសមាសភាគប្រាក់ខែសកម្មក្នុងការដំណើរការនេះទេ។"
          },
          "component-card": {
            "records": "កំណត់ត្រា",
            "blockers": "ឧបសគ្គ",
            "warnings": "ការព្រមាន",
            "open": "បើកនៅធាតុចូលប្រាក់ខែ"
          },
          "component-status": {
            "not-started": "មិនទាន់ចាប់ផ្ដើម",
            "partial": "ខ្លះៗ",
            "complete": "បានបញ្ចប់",
            "blocked": "ត្រូវបានរារាំង"
          },
          "issues": {
            "title": "បញ្ហាដែលត្រូវដោះស្រាយ (ឧបសគ្គ {blockers} · ការព្រមាន {warnings})"
          },
          "passthrough": {
            "title": "មិនមានធាតុចូលប្រាក់ខែអនុវត្តសម្រាប់ការដំណើរការនេះ",
            "body": "ប្រាក់ខែដំបូងដំណើរការជាប្រាក់បុរេប្រទានមូលដ្ឋាន ៥០%។ សមាសភាគធាតុចូល (ម៉ោងបន្ថែម ប្រាក់ឧបត្ថម្ភ ប្រាក់រង្វាន់ ប្រាក់លើកទឹកចិត្ត អតីតភាពការងារ ការបង់ត្រឡប់ វិស្សមកាល ការកែតម្រូវ) គ្រោងទុកសម្រាប់ប្រាក់ខែទីពីរនៅចុងខែ នៅពេលដែលចំណូលពេញលេញត្រូវបានដឹង។ គ្មានអ្វីត្រូវផ្ទៀងផ្ទាត់ — ពិនិត្យសារ រួចបញ្ជាក់ដើម្បីបន្ត។",
            "hint": "ប្រសិនបើសមាសភាគជាក់លាក់ត្រូវដាក់បញ្ចូលក្នុងការដំណើរការនេះ (កម្រមាន) សូមរុញវាដោយផ្ទាល់ពីមជ្ឈមណ្ឌលធាតុចូលមុនពេលបញ្ជាក់។",
            "open-pic": "បើកធាតុចូលប្រាក់ខែ",
            "kpi": {
              "components": "សមាសភាគដែលបានរុញ",
              "components-sub": "គ្មានក្នុងការដំណើរការនេះ",
              "records": "កំណត់ត្រាបានត្រួតពិនិត្យ",
              "records-sub": "គ្មានសមាសភាគធាតុចូល",
              "issues": "បញ្ហារកឃើញ",
              "issues-sub": "គ្មានអ្វីត្រូវផ្ទៀងផ្ទាត់"
            },
            "ack": "ជំហានទី ២ គឺជា <strong>ការឆ្លងកាត់</strong> សម្រាប់ការដំណើរការនេះ — មិនចាំបាច់ពិនិត្យធាតុចូលប្រាក់ខែទេ។ ចុច <strong>បញ្ជាក់ និងបន្ត</strong> ខាងក្រោមដើម្បីទៅជំហានទី ៣ (ការគណនា)។"
          },
          "gate-banner": {
            "title": "ឧបសគ្គ {count} រារាំងការដោះសោជំហានទី ៣"
          },
          "confirm": {
            "error": "ការបញ្ជាក់បរាជ័យ — {message}"
          },
          "actions": {
            "back": "ថយក្រោយ",
            "issues-center": "ទិដ្ឋភាពឆ្លងសមាសភាគ",
            "confirm": "បញ្ជាក់ និងបន្ត"
          },
          "issues-center": {
            "supra": "ធាតុចូលប្រាក់ខែ",
            "title": "មជ្ឈមណ្ឌលបញ្ហា",
            "subtitle": "ការព្រមាន និងឧបសគ្គទាំងអស់ឆ្លងកាត់សមាសភាគ។ ឧបសគ្គត្រូវតែដោះស្រាយមុនពេលផ្ទៀងផ្ទាត់។",
            "kpi": {
              "total": "បញ្ហាសរុប",
              "blockers": "ឧបសគ្គ",
              "warnings": "ការព្រមាន"
            },
            "cols": {
              "severity": "កម្រិតធ្ងន់ធ្ងរ",
              "component": "សមាសភាគ",
              "code": "កូដ",
              "message": "សារ",
              "employees": "បុគ្គលិក"
            },
            "blocker": "ឧបសគ្គ",
            "warning": "ការព្រមាន",
            "empty": "មិនមានបញ្ហារកឃើញទេ។"
          }
        },
        "step3": {
          "loading": "កំពុងផ្ទុកការប្រៀបធៀបការគណនា…",
          "error": "មិនអាចផ្ទុកការប្រៀបធៀបការគណនាបានទេ — {message}",
          "empty": {
            "title": "ការគណនាកំពុងរង់ចាំ",
            "body": "មិនទាន់មានការគណនាប្រាក់ខែសម្រាប់កំឡុងពេលនេះទេ។ ចុចគណនាដើម្បីគណនារូបភាពហើយដោះសោការពិនិត្យ។"
          },
          "no-prior": {
            "title": "ប្រាក់ខែដំបូងសម្រាប់វដ្តនេះ",
            "body": "មិនមានកំឡុងពេលមុនសម្រាប់ប្រៀបធៀបទេ — សរុបបំរែបំរួលនឹងទទេ។ ដំណើរការការគណនា រួចបន្តទៅការពិនិត្យ។"
          },
          "compare": {
            "title": "ច្រកប្រៀបធៀប",
            "subtitle": "បំរែបំរួលបើធៀបនឹងកំឡុងពេលមុន (កម្រិត ±{threshold}% លើសរុបរាប់ពន្ធ)។ ជួរដែលលើសកម្រិតនឹងត្រូវសម្គាល់ដើម្បីពិនិត្យ។",
            "gross": "Δ សរុបរាប់ពន្ធ",
            "net": "Δ សុទ្ធ",
            "tos": "Δ ពន្ធលើប្រាក់បៀវត្ស",
            "nssf": "Δ បសស"
          },
          "variance": {
            "title": "បុគ្គលិក {count} នាក់លើសកម្រិត ±{threshold}% នៃសរុបរាប់ពន្ធ",
            "body": "ការសម្គាល់បំរែបំរួលគឺជាការព្រមាន — សូមពិនិត្យពួកវាមុនពេលដាក់ជូនការអនុម័ត។ គណនាឡើងវិញដើម្បីធ្វើឱ្យការប្រៀបធៀបស្រស់បន្ទាប់ពីកែតម្រូវធាតុចូល។"
          },
          "rows": {
            "title": "ការប្រៀបធៀបតាមបុគ្គលិក",
            "count": "បុគ្គលិក {count} នាក់",
            "columns": {
              "employee": "បុគ្គលិក",
              "gross": "Δ សរុបរាប់ពន្ធ",
              "net": "Δ សុទ្ធ",
              "tos": "Δ ពន្ធ",
              "nssf": "Δ បសស",
              "flag": "ទង់"
            },
            "flag": {
              "exceeds": "លើសកម្រិត"
            }
          },
          "actions": {
            "back": "ថយក្រោយ",
            "calculate": "គណនា",
            "recalculate": "គណនាឡើងវិញ",
            "calculating": "កំពុងគណនា…",
            "confirm": "បញ្ជាក់ និងបន្ត",
            "confirming": "កំពុងដាក់ជូន…"
          },
          "calc": {
            "error": "ការគណនាបានបរាជ័យ — {message}"
          },
          "submit": {
            "error": "មិនអាចដាក់ជូនការអនុម័តបានទេ — {message}"
          },
          "breakdown": {
            "empty": {
              "body": "ជ្រើសរើសជួរបុគ្គលិកដើម្បីមើលការបំបែក។"
            },
            "stale": {
              "title": "មិនទាន់ផ្ទុកការបំបែក",
              "body": "ការបំបែកតាមបុគ្គលិកត្រូវផ្ទុកពីការឆ្លើយតបគណនាចុងក្រោយ — ចុចគណនាឡើងវិញដើម្បីធ្វើឱ្យពួកវាស្រស់។"
            },
            "totals": {
              "gross": "សរុបរាប់ពន្ធ",
              "net": "សុទ្ធ"
            },
            "section": {
              "components": "សមាសភាគប្រាក់ចំណូល",
              "deductions": "ការកាត់",
              "overtime": "ការងារបន្ថែមម៉ោង",
              "seniority": "ការបំពេញសេវាកម្ម",
              "empty": "គ្មានបន្ទាត់ទេ។"
            },
            "overtime": {
              "hourlyRate": "អត្រាមួយម៉ោង",
              "workingDays": "ថ្ងៃធ្វើការ",
              "hoursPerDay": "ម៉ោងក្នុងមួយថ្ងៃ"
            },
            "seniority": {
              "ineligible": "មិនមានសិទ្ធិ",
              "daysAwarded": "ចំនួនថ្ងៃផ្តល់",
              "taxable": "ត្រូវរាប់ពន្ធ",
              "nonTaxable": "មិនរាប់ពន្ធ"
            }
          }
        },
        "step4": {
          "loading": "កំពុងផ្ទុកសង្ខេបការអនុម័ត…",
          "error": "មិនអាចផ្ទុកសង្ខេបការអនុម័តបានទេ — {message}",
          "kpi": {
            "pending": {
              "label": "កំពុងរង់ចាំការពិនិត្យ",
              "help": "កំពុងរង់ចាំការសម្រេចចិត្តអនុម័ត"
            },
            "approved": {
              "label": "បានអនុម័ត",
              "help": "បានឆ្លងផុតដើម្បីបន្តទៅការទូទាត់"
            },
            "needs-review": {
              "label": "ត្រូវការពិនិត្យ",
              "help": "ការសម្រេចពន្យារពេល + ករណីលើកលែង"
            },
            "returned": {
              "label": "បានបញ្ជូនត្រឡប់",
              "help": "បានបញ្ជូនត្រឡប់ដើម្បីកែតម្រូវ — ជំហានទី ២ បានបើកវិញ"
            }
          },
          "run-strip": {
            "total": "បុគ្គលិក {count} នាក់នៅក្នុងការដំណើរការនេះ",
            "exceptions": "ករណីលើកលែង {count}",
            "template": "គំរូ"
          },
          "list": {
            "title": {
              "pending": "បុគ្គលិកកំពុងរង់ចាំការសម្រេច",
              "approved": "បុគ្គលិកដែលបានអនុម័ត",
              "needsReview": "បុគ្គលិកដែលពន្យារពេល / បានសម្គាល់",
              "returned": "បានបញ្ជូនត្រឡប់ដើម្បីកែតម្រូវ"
            },
            "count": "{count} នៅក្នុងបញ្ជី",
            "empty": "មិនមានបុគ្គលិកផ្គូផ្គងនឹងតម្រងនេះទេ",
            "exception-badge": "ករណីលើកលែង",
            "columns": {
              "employee": "បុគ្គលិក",
              "gross": "សរុបដុល",
              "tos": "ពន្ធលើប្រាក់ខែ",
              "nssf": "ប.ស.ស.",
              "net": "សុទ្ធ",
              "decision": "ការសម្រេច",
              "reason": "មូលហេតុ"
            }
          },
          "decision": {
            "pending": "កំពុងរង់ចាំ",
            "approved": "បានអនុម័ត",
            "deferred": "ពន្យារពេល",
            "returned": "បានបញ្ជូនត្រឡប់"
          },
          "locked": {
            "title": "ជំហានទី ៤ ត្រូវបានចាក់សោ",
            "subtitle": "បុគ្គលិកគ្រប់រូបបានទទួលការអនុម័ត ហើយរូបភាពនៃការដំណើរការមិនអាចកែប្រែបានទេ។ ជំហានទី ៥ (ការទូទាត់) ឥឡូវនេះកំពុងសកម្ម។"
          },
          "gate-banner": {
            "text": "{pending} កំពុងរង់ចាំ · {deferred} ពន្យារពេល · {returned} បានបញ្ជូនត្រឡប់។ បុគ្គលិកគ្រប់រូបត្រូវតែបានអនុម័តមុនពេលជំហានទី ៥ អាចដោះសោ។"
          },
          "actions": {
            "back": "ថយក្រោយ",
            "decide-hint": "អនុម័ត និងបន្ត នឹងដំណើរការនៅពេលបុគ្គលិកគ្រប់រូបបានកត់ត្រាការសម្រេចចិត្ត។",
            "confirm": "អនុម័ត និងបន្ត",
            "confirming": "កំពុងបញ្ជាក់…"
          },
          "confirm": {
            "error": "មិនអាចបញ្ជាក់ការអនុម័តបានទេ — {message}"
          },
          "decide": {
            "empty": {
              "body": "ជ្រើសរើសជួរបុគ្គលិកដើម្បីកត់ត្រាការសម្រេចចិត្ត។"
            },
            "current": "បច្ចុប្បន្ន",
            "choose": "ជ្រើសរើសការសម្រេចចិត្ត",
            "actions": {
              "approve": "អនុម័ត",
              "defer": "ពន្យារពេល",
              "return": "បញ្ជូនត្រឡប់",
              "submit": "រក្សាទុកការសម្រេចចិត្ត",
              "submitting": "កំពុងរក្សាទុក…",
              "cancel": "បោះបង់"
            },
            "reason": {
              "label": "ហេតុផល",
              "placeholder": "បញ្ចូលកំណត់ត្រាខ្លីសម្រាប់ការតាមដាន…",
              "required-marker": "(ចាំបាច់)",
              "optional-marker": "(ស្រេចចិត្ត)",
              "required-error": "ត្រូវតែបញ្ចូលហេតុផលនៅពេលបញ្ជូនត្រឡប់ដើម្បីកែតម្រូវ។"
            },
            "error": "មិនអាចរក្សាទុកការសម្រេចចិត្តបានទេ — {message}",
            "rewound": {
              "title": "ដំណើរការត្រូវបានបង្វិលត្រឡប់ទៅជំហានទី ២",
              "body": "អ្នកធ្វើ (Maker) ឥឡូវនេះអាចកែតម្រូវធាតុចូលហើយដាក់ស្នើឡើងវិញ។ ជំហានទី ៤ នឹងបើកឡើងវិញនៅពេលជំហានទី ២ ត្រូវបានបញ្ជាក់ឡើងវិញ។"
            }
          }
        },
        "step5": {
          "loading": "កំពុងផ្ទុកជំហានទី ៥ (ការបង់ប្រាក់ បង្កាន់ដៃប្រាក់ខែ របាយការណ៍)…",
          "error": "មិនអាចផ្ទុកជំហានទី ៥ បានទេ — {message}",
          "kpi": {
            "employees": "បុគ្គលិកត្រូវបង់ប្រាក់",
            "total-net": "ប្រាក់សុទ្ធសរុប",
            "pending": "កំពុងរង់ចាំការទូទាត់",
            "settled": "បានទូទាត់",
            "distributed": "បង្កាន់ដៃប្រាក់ខែដែលបានចែកចាយ"
          },
          "held-banner": {
            "title": "បុគ្គលិក {count} នាក់ស្ថិតក្នុងការពន្យារការបង់ប្រាក់",
            "body": "ការពន្យារការបង់ប្រាក់ត្រូវបានរាយក្នុងកាតដោយដៃ / មិនធម្មតា។ ដោះស្រាយនៅរលក ២.៨c — បញ្ចេញ ពន្យារ ឬលុបចោល & កែតម្រូវ។"
          },
          "payment": {
            "title": "បំពង់ដំណើរការបង់ប្រាក់",
            "subtitle": "ឈុតប្រាក់តាមធនាគារដំណើរការដោយឯករាជ្យ។ ចុចបង្កើតដើម្បីបង្កើតឯកសារធនាគារ ឬចុចដោះស្រាយដើម្បីដោះស្រាយករណីលើកលែងខាងក្រោម។",
            "loading": "កំពុងផ្ទុកសង្ខេបការបង់ប្រាក់…",
            "error": "មិនអាចផ្ទុកសង្ខេបការបង់ប្រាក់បានទេ — {message}",
            "empty": "មិនទាន់មានទិន្នន័យបង់ប្រាក់ទេ — ជំហានទី ៤ ត្រូវអនុម័តដំណើរការមុនសិន។"
          },
          "bank-groups": {
            "aba": "ABA",
            "acleda": "ACLEDA",
            "wing": "Wing",
            "exception": "ដោយដៃ / មិនធម្មតា"
          },
          "bank-card": {
            "employees": "បុគ្គលិក",
            "amount": "ចំនួនទឹកប្រាក់សរុប",
            "generated": "ឯកសារបានបង្កើត",
            "manual": "ដោះស្រាយដោយដៃ",
            "excel": "គំរូ Excel",
            "generate": "បង្កើតឯកសារ",
            "regenerate": "បង្កើតឡើងវិញ",
            "generating": "កំពុងបង្កើត…",
            "error": "មិនអាចបង្កើតឯកសារ {bank} បានទេ — {message}",
            "placeholder-hint": "ដោះស្រាយដោយដៃ / ករណីលើកលែងតាមបញ្ជីខាងក្រោម។"
          },
          "exception-list": {
            "title": "ករណីលើកលែង {count} ត្រូវការដោះស្រាយដោយដៃ",
            "hint": "ចុចដោះស្រាយដើម្បីកត់ត្រាលទ្ធផល (សាច់ប្រាក់ / មូលប្បទានបត្រ / ផ្ទេរ / ប្ដូរធនាគារ / ពន្យារ / មិនទាន់សម្រេច)។",
            "resolve": "ដោះស្រាយ",
            "columns": {
              "employee": "បុគ្គលិក",
              "net": "សុទ្ធ",
              "reason": "មូលហេតុ",
              "actions": "សកម្មភាព"
            }
          },
          "manual": {
            "empty": {
              "body": "ជ្រើសរើសជួរករណីលើកលែងដើម្បីកត់ត្រាលទ្ធផលដោយដៃ។"
            },
            "headline": {
              "gross": "សរុបរាប់ពន្ធ",
              "net": "សុទ្ធ"
            },
            "reason-label": "ហេតុអ្វីត្រូវដោះស្រាយដោយដៃ",
            "reasons": {
              "missing-template": "មិនមានគំរូធនាគារសម្រាប់បុគ្គលិកនេះ។",
              "missing-account": "មិនមានលេខគណនីសកម្មនៅឯកសារ។",
              "unsupported-bank": "ត្រូវបានបញ្ជូនទៅធនាគារដែលគ្មានការតភ្ជាប់ប្រាក់ខែ។"
            },
            "choose": "ជ្រើសរើសលទ្ធផល",
            "outcomes": {
              "cash": "សាច់ប្រាក់",
              "cheque": "មូលប្បទានបត្រ",
              "transfer": "ផ្ទេរ",
              "update": "ប្ដូរធនាគារ",
              "hold": "ពន្យារ",
              "pending": "សម្គាល់មិនទាន់សម្រេច"
            },
            "reference": {
              "label": "លេខយោង",
              "placeholder": "លេខបង្កាន់ដៃ / លេខមូលប្បទានបត្រ / លេខផ្ទេរ / លេខគណនីថ្មី…",
              "required-marker": "(ចាំបាច់)",
              "optional-marker": "(ស្រេចចិត្ត)",
              "required-error": "លេខយោងគឺចាំបាច់សម្រាប់លទ្ធផលនេះ។"
            },
            "newbank": {
              "label": "បញ្ជូនទៅ",
              "placeholder": "ជ្រើសរើសធនាគារ…",
              "required-marker": "(ចាំបាច់)",
              "required-error": "សូមជ្រើសរើសធនាគារថ្មីសម្រាប់បុគ្គលិកនេះ។"
            },
            "note": {
              "label": "កំណត់ត្រា",
              "placeholder": "កំណត់ត្រាសម្រាប់តាមដាន…",
              "optional-marker": "(ស្រេចចិត្ត)"
            },
            "error": "មិនអាចរក្សាទុកលទ្ធផលដោយដៃបានទេ — {message}",
            "actions": {
              "submit": "រក្សាទុកលទ្ធផល",
              "submitting": "កំពុងរក្សាទុក…",
              "cancel": "បោះបង់"
            }
          },
          "payslips": {
            "title": "បង្កាន់ដៃប្រាក់ខែ",
            "subtitle": "បង្កើត និងចែកចាយរូបថតរបស់ជំហានទី ៣ ដែលបានចាក់សោ។",
            "loading": "កំពុងផ្ទុកសង្ខេបបង្កាន់ដៃប្រាក់ខែ…",
            "error": "មិនអាចផ្ទុកសង្ខេបបង្កាន់ដៃប្រាក់ខែបានទេ — {message}",
            "empty": "មិនទាន់មានបង្កាន់ដៃប្រាក់ខែទេ — បញ្ជាក់ការបង់ប្រាក់ដើម្បីដោះសោការបង្កើត។",
            "manage": "គ្រប់គ្រងបង្កាន់ដៃប្រាក់ខែ",
            "kpi": {
              "total": "សរុប",
              "ready": "ត្រៀមបង្កើត",
              "generated": "បានបង្កើត",
              "on-hold": "ស្ថិតក្នុងការពន្យារ",
              "distributed": "បានចែកចាយ"
            }
          },
          "reports": {
            "title": "របាយការណ៍ប្រាក់ខែចុងក្រោយ",
            "subtitle": "រូបថតដែលបានចាក់សោ — អាចនាំចេញសម្រាប់ដាក់ស្នើ និងតម្កល់ទុក។",
            "loading": "កំពុងផ្ទុក…",
            "row-ready": "ត្រៀមជាមួយ {rows} ជួរ",
            "row-error": "កំហុស — {message}",
            "row-empty": "មិនទាន់បង្កើតទេ",
            "generate": "មើល & ទាញយក",
            "placeholder-hint": "បង្កើត / ទាញយកនឹងមកដល់នៅរលក ២.៨b។",
            "summary": {
              "label": "របាយការណ៍សង្ខេប",
              "help": "សរុបតាមមជ្ឈមណ្ឌលថ្លៃដើម"
            },
            "detail": {
              "label": "របាយការណ៍លម្អិត",
              "help": "បញ្ជីបុគ្គលិកមួយជួរម្នាក់"
            },
            "tos": {
              "label": "របាយការណ៍ពន្ធ (TOS)",
              "help": "ឆ្លើយតបទៅនឹងតម្រូវការ GDT"
            },
            "nssf": {
              "label": "របាយការណ៍ NSSF",
              "help": "វិភាគទាន ៤ ប្រភេទ"
            }
          },
          "close": {
            "ready": {
              "title": "ដំណើរការត្រៀមរួចជាស្រេចសម្រាប់បិទ",
              "hint": "ការបង់ប្រាក់បានបញ្ជាក់ និងបង្កាន់ដៃប្រាក់ខែទាំងអស់បានចែកចាយរួច។ ការចាក់សោដំណើរការគឺជាជំហានចុងក្រោយ។"
            },
            "blocked": {
              "title": "មិនអាចបិទដំណើរការនៅឡើយទេ",
              "hint": "ការបង់ប្រាក់៖ {payment} · បង្កាន់ដៃប្រាក់ខែ៖ {payslips}"
            },
            "done": "ត្រៀម",
            "pending": "កំពុងដំណើរការ",
            "button": "បិទដំណើរការ",
            "closing": "កំពុងបិទ…",
            "closed": "ដំណើរការត្រូវបានបិទ",
            "success": "ដំណើរការត្រូវបានបិទ។ របាយការណ៍ និងបង្កាន់ដៃត្រូវបានចាក់សោ។",
            "success-idempotent": "ដំណើរការត្រូវបានបិទរួចហើយ។",
            "error": "មិនអាចបិទដំណើរការបានទេ — {message}"
          },
          "page": {
            "title": "ជំហានទី ៥ (ស្បែក) — ការបង់ប្រាក់ បង្កាន់ដៃ របាយការណ៍ បិទ",
            "heading": "ជំហានទី ៥ — ការបង់ប្រាក់ & បង្កាន់ដៃ",
            "back": "ត្រឡប់ទៅដំណើរការ"
          }
        }
      },
      "input-center": {
        "back": "ត្រឡប់ទៅមជ្ឈមណ្ឌលប្រាក់ខែ",
        "title": "មជ្ឈមណ្ឌលធាតុចូលប្រាក់ខែ",
        "subtitle": "ពិនិត្យ និងកែប្រែធាតុចូលប្រាក់ខែតាមកំឡុងពេល។ ការិយបរិច្ឆេទដែលបានចាក់សោអាចអានបានតែប៉ុណ្ណោះ។",
        "period-label": "កំឡុងពេលប្រាក់ខែ",
        "component-label": "សមាសភាគ",
        "no-periods": "មិនមានកំឡុងពេលអាចប្រើបាន",
        "no-components": "មិនមានសមាសភាគអាចប្រើបាន",
        "pick-prompt": "ជ្រើសរើសកំឡុងពេលប្រាក់ខែ និងសមាសភាគដើម្បីមើលធាតុ។",
        "loading": "កំពុងផ្ទុកធាតុ…",
        "error": "មិនអាចផ្ទុកធាតុបានទេ — {message}",
        "empty": "មិនទាន់មានធាតុចូលប្រាក់ខែសម្រាប់កំឡុងពេល × សមាសភាគនេះទេ។",
        "lock": {
          "unlocked": "អាចកែប្រែ",
          "locked-by-run": "ត្រូវបានចាក់សោដោយការដំណើរការ",
          "past-period": "កំឡុងពេលអតីត · អានបានតែប៉ុណ្ណោះ"
        },
        "columns": {
          "employee": "បុគ្គលិក",
          "period": "កំឡុងពេល",
          "amount": "ចំនួន",
          "status": "ស្ថានភាព",
          "reason": "មូលហេតុ",
          "actions": "សកម្មភាព"
        },
        "actions": {
          "edit": "កែប្រែ"
        },
        "drawer": {
          "title": "កែប្រែធាតុចូលប្រាក់ខែ",
          "employee": "បុគ្គលិក",
          "component": "សមាសភាគ",
          "period": "កំឡុងពេល",
          "amount": "ចំនួន",
          "reason": "មូលហេតុ",
          "save": "រក្សាទុកការផ្លាស់ប្តូរ",
          "saving": "កំពុងរក្សាទុក…",
          "delete": "លុបធាតុ",
          "save-success": "បានរក្សាទុកធាតុចូលប្រាក់ខែ",
          "delete-success": "បានលុបធាតុចូលប្រាក់ខែ"
        },
        "run-context": {
          "heading": "កំពុងកែតម្រូវសម្រាប់ {id}",
          "subtitle": "កំឡុងពេលត្រូវបានចាក់សោសម្រាប់ការដំណើរការនេះ។ ធ្វើការកែតម្រូវ រួចត្រឡប់ទៅការដំណើរការ។",
          "return": "ត្រឡប់ទៅការដំណើរការ"
        },
        "subtypes": {
          "all": "ទាំងអស់"
        },
        "issues-center": {
          "btn": "មជ្ឈមណ្ឌលបញ្ហា"
        },
        "header-actions": {
          "settings": "ការកំណត់",
          "add-entry": "បន្ថែមធាតុ",
          "verify": "បញ្ជាក់"
        },
        "workspace": {
          "group-label": "ការងារប្រព័ន្ធ · បានបញ្ជូនពីវត្តមាន",
          "title": "ម៉ោងបន្ថែម (OT)",
          "period-badge": "កំឡុងពេល: ២៦ មករា – ២៥ កុម្ភៈ ២០២៦",
          "cutoff-badge": "ថ្ងៃកំណត់: ១១ កុម្ភៈ ២០២៦"
        },
        "health": {
          "total-records": "កំណត់ត្រាសរុប",
          "validated-suffix": "បានបញ្ជាក់",
          "validated-amount": "ចំនួនបានបញ្ជាក់",
          "employees-suffix": "បុគ្គលិក",
          "warnings": "ការព្រមាន",
          "warnings-sub": "មិនរារាំង",
          "blockers": "ឧបសគ្គ",
          "blockers-sub": "ដោះស្រាយមុនការគណនា",
          "progress": "វឌ្ឍនភាពនៃការបញ្ជាក់",
          "resolve-banner": "ដោះស្រាយ {count} ឧបសគ្គក្នុង Overtime (OT) មុនពេលគណនាអាចដំណើរការបាន។",
          "resolve-cta": "បើក Overtime (OT) →"
        },
        "kpis": {
          "records": "កំណត់ត្រា",
          "total-amount": "ចំនួនសរុប",
          "employees": "បុគ្គលិក",
          "warnings": "ការព្រមាន",
          "blockers": "ឧបសគ្គ"
        },
        "sidebar": {
          "title": "សមាសភាគ",
          "count-suffix": "សរុប",
          "sort-urgency": "តម្រៀប: អាទិភាព",
          "sort-group": "តម្រៀប: ក្រុម",
          "sort-name": "តម្រៀប: ឈ្មោះ",
          "add-component": "បន្ថែមសមាសភាគ"
        },
        "filters": {
          "search-placeholder": "ស្វែងរកបុគ្គលិក កំណត់ចំណាំ ឯកសារយោង…",
          "all": "ទាំងអស់",
          "valid": "ត្រឹមត្រូវ",
          "warning": "ការព្រមាន",
          "blocker": "ឧបសគ្គ",
          "paid": "បានបង់",
          "source-all": "ប្រភពទាំងអស់",
          "source-attendance": "វត្តមាន",
          "source-import": "នាំចូល",
          "source-manual": "ដោយដៃ",
          "source-system": "ប្រព័ន្ធ / API"
        },
        "ot-columns": {
          "employee": "បុគ្គលិក",
          "ot-date": "ថ្ងៃ OT",
          "time": "ម៉ោង",
          "claimed": "បានទាមទារ (ម៉)",
          "computed": "បានគណនា (ម៉)",
          "amount": "ចំនួន",
          "ot-type": "ប្រភេទ OT",
          "source": "ប្រភព",
          "status": "ស្ថានភាព"
        },
        "ot-status": {
          "valid": "ត្រឹមត្រូវ",
          "warning": "ការព្រមាន",
          "blocker": "ឧបសគ្គ"
        },
        "toast": {
          "preview-only": "នឹងមកដល់នៅការចេញផ្សាយបន្ទាប់"
        },
        "bulk-import": {
          "btn": "នាំចូលជាបាច់",
          "title": "នាំចូលជាបាច់ — {component}",
          "description": "ផ្ទុកឡើងឯកសារ CSV ដែលមានជួរធាតុចូលប្រាក់ខែសម្រាប់សមាសភាគនេះ។",
          "file-label": "ផ្ទុកឡើងឯកសារ",
          "click-upload": "ចុចដើម្បីផ្ទុកឡើង",
          "file-hint": "CSV រហូតដល់ ១០ មេកាបៃ",
          "note-label": "កំណត់ចំណាំបាច់",
          "note-placeholder": "ឧ. បាច់ប្រាក់ឧបត្ថម្ភត្រីមាសទី៤ — ការអនុម័តយឺត",
          "no-rows": "រកមិនឃើញជួរទិន្នន័យក្នុងឯកសារដែលបានផ្ទុកឡើង។",
          "missing-columns": "CSV ត្រូវមានយ៉ាងតិចជួរកូដបុគ្គលិក និងចំនួន។",
          "rows": "ជួរ",
          "cancel": "បោះបង់",
          "confirm": "នាំចូល",
          "importing": "កំពុងនាំចូល…",
          "success": "បាននាំចូល {count} ជួរដោយជោគជ័យ។",
          "partial-success": "បាននាំចូល {accepted} ជួរ បដិសេធ {rejected} ។"
        },
        "validate": {
          "btn": "បញ្ជាក់ទាំងអស់",
          "validating": "កំពុងបញ្ជាក់…",
          "success": "ការបញ្ជាក់បានបញ្ចប់។",
          "error": "ការបញ្ជាក់បានបរាជ័យ — {message}"
        }
      },
      "reportsCenter": {
        "back": "ត្រឡប់ទៅមជ្ឈមណ្ឌលប្រាក់ខែ",
        "title": "របាយការណ៍",
        "subtitle": "របាយការណ៍ដែលបានបង្កើតសម្រាប់ការដំណើរការប្រាក់ខែដែលបានបញ្ចប់ — មើលជាមុន ទាញយក PDF ឬ នាំចេញ Excel។",
        "empty": "មិនទាន់មានការដំណើរការប្រាក់ខែដែលបញ្ចប់ទេ។ របាយការណ៍នឹងបង្ហាញនៅទីនេះពេលការដំណើរការត្រូវបានបិទ។",
        "empty-filtered": "មិនមានរបាយការណ៍ត្រូវនឹងតម្រងរបស់អ្នកទេ។ សូមសម្អាតការស្វែងរក ឬ តម្រងឆ្នាំ។",
        "error": "មិនអាចផ្ទុកវិចិត្រសាលបានទេ — {message}",
        "cycle": "វដ្ត",
        "header": {
          "year-all": "គ្រប់ឆ្នាំ",
          "export-all": "នាំចេញទាំងអស់ (ZIP)",
          "export-all-toast": "កំពុងបង្រួមរបាយការណ៍ — ឯកសារ ZIP នឹងទាញយកនៅពេលរបាយការណ៍ទាំងអស់រួចរាល់។",
          "search-placeholder": "ស្វែងរកតាមលេខការដំណើរការ រយៈពេល ឬ អ្នកអនុម័ត…"
        },
        "tabs": {
          "summary": "សង្ខេបប្រាក់ខែ",
          "detail": "ប្រាក់ខែលម្អិត",
          "tos": "របាយការណ៍ពន្ធ (TOS)",
          "nssf": "របាយការណ៍ NSSF"
        },
        "year-chips": {
          "all": "ទាំងអស់"
        },
        "group": {
          "runs-one": "{count} ដំណើរការ",
          "runs-other": "{count} ដំណើរការ",
          "totals": "សរុប: {net} លើ {hc} កំណត់ត្រាបុគ្គលិក"
        },
        "columns": {
          "run": "ដំណើរការ",
          "type": "ប្រភេទ",
          "pay-period": "រយៈពេលប្រាក់ខែ",
          "pay-date": "កាលបរិច្ឆេទប្រាក់ខែ",
          "employees": "បុគ្គលិក",
          "net-pay": "ប្រាក់សុទ្ធ",
          "status": "ស្ថានភាព",
          "approver": "អ្នកអនុម័ត",
          "actions": "សកម្មភាព"
        },
        "row": {
          "type-regular": "ធម្មតា",
          "type-off-cycle": "ក្រៅវដ្ត",
          "type-final-pay": "ប្រាក់ខែចុងក្រោយ",
          "type-bonus": "ប្រាក់រង្វាន់",
          "type-adjustment": "ការកែតម្រូវ",
          "view": "មើល {label}",
          "download-pdf": "ទាញយក PDF",
          "download-excel": "ទាញយក Excel",
          "completed": "បានបញ្ចប់"
        },
        "kpis": {
          "total": "ក្រឡាសរុប",
          "reports": "របាយការណ៍",
          "reports-sub": "ដំណើរការដែលបញ្ចប់",
          "total-hc": "បុគ្គលិកសរុបដែលបានទូទាត់",
          "total-hc-sub": "កំណត់ត្រាបុគ្គលិក",
          "total-net": "ប្រាក់សុទ្ធសរុបដែលបានទូទាត់",
          "total-net-sub": "តាមរយៈតម្រង",
          "total-gross": "ប្រាក់ដុលសរុបដែលបានទូទាត់",
          "total-gross-sub": "មុនការកាត់",
          "total-tax": "ពន្ធសរុប (TOS)",
          "total-tax-sub": "បានដាក់ស្នើក្នុងរយៈពេល",
          "avg-tax": "ពន្ធជាមធ្យម / ដំណើរការ",
          "avg-tax-sub": "ជាមធ្យមរុំទាន់",
          "total-nssf": "NSSF សរុប (បុគ្គលិក)",
          "total-nssf-sub": "សោធនិវត្តន៍ 2%",
          "avg-nssf": "NSSF ជាមធ្យម / ដំណើរការ",
          "avg-nssf-sub": "ជាមធ្យមរុំទាន់",
          "headcount-filed": "បុគ្គលិកដែលបានដាក់ស្នើ",
          "headcount-filed-sub": "កំណត់ត្រាបុគ្គលិក"
        },
        "filters": {
          "status": "ស្ថានភាព",
          "type": "ប្រភេទរបាយការណ៍",
          "cycle": "វដ្ត",
          "cyclePlaceholder": "ឧ. Cycle:abc123",
          "payroll": "ប្រាក់ខែ",
          "payrollPlaceholder": "ឧ. Payroll:abc123",
          "all": "ទាំងអស់",
          "clear": "សម្អាតតម្រង"
        },
        "statuses": {
          "idle": "ទំនេរ",
          "generating": "កំពុងបង្កើត…",
          "ready": "រួចរាល់",
          "failed": "បរាជ័យ"
        },
        "types": {
          "summary": "សង្ខេបប្រាក់ខែ",
          "detail": "ប្រាក់ខែលម្អិត",
          "tos": "របាយការណ៍ពន្ធ (TOS)",
          "nssf": "របាយការណ៍ NSSF"
        },
        "cell": {
          "generatedAt": "បង្កើតនៅ",
          "regeneratedAt": "បង្កើតឡើងវិញនៅ",
          "rowCount": "ជួរ",
          "notGenerated": "មិនទាន់បានបង្កើតទេ"
        },
        "actions": {
          "generate": "បង្កើត",
          "generating": "កំពុងបង្កើត…",
          "regenerate": "បង្កើតឡើងវិញ",
          "regenerating": "កំពុងបង្កើតឡើងវិញ…",
          "download": "ទាញយក",
          "downloading": "កំពុងបើក…",
          "error": "សកម្មភាពបានបរាជ័យ — {message}"
        },
        "locked": {
          "badge": "ដំណើរការបិទ"
        }
      },
      "offCycle": {
        "back": "ត្រឡប់ទៅមជ្ឈមណ្ឌលប្រាក់ខែ",
        "title": "ប្រាក់ខែក្រៅវដ្ត",
        "subtitle": "ដំណើរការប្រាក់ខែម្តងក្រៅពីវដ្តធម្មតា — ប្រាក់ខែចុងក្រោយ ប្រាក់រង្វាន់ ប្រាក់បំណុលជាន់ខាងក្រោយ ប្រាក់លើកទឹកចិត្ត ឬ ការកែតម្រូវ។ ការដំណើរការក្រៅវដ្តនីមួយៗត្រូវបានដឹកនាំដោយជំនួយការគ្រោងព្រាង។",
        "loading": "កំពុងផ្ទុកគ្រោងព្រាងក្រៅវដ្ត…",
        "error": "មិនអាចផ្ទុកគ្រោងព្រាងក្រៅវដ្តបានទេ — {message}",
        "empty": {
          "title": "មិនទាន់មានគ្រោងព្រាងក្រៅវដ្តទេ",
          "subtitle": "ចាប់ផ្ដើមការដំណើរការក្រៅវដ្តថ្មីដើម្បីបង្កើតគ្រោងព្រាងដំបូងរបស់អ្នក។ គ្រោងព្រាងស្នាក់នៅ៧ថ្ងៃ។"
        },
        "start-new": {
          "btn": "ចាប់ផ្ដើមការដំណើរការក្រៅវដ្តថ្មី",
          "submitting": "កំពុងបង្កើតគ្រោងព្រាង…",
          "error": "មិនអាចបង្កើតគ្រោងព្រាងបានទេ — {message}"
        },
        "filter": {
          "label": "ស្ថានភាព"
        },
        "status": {
          "all": "ទាំងអស់",
          "DRAFT": "គ្រោងព្រាង",
          "COMMITTED": "បានកំណត់",
          "ABANDONED": "បានបោះបង់"
        },
        "type": {
          "FINAL_PAY": "ប្រាក់ខែចុងក្រោយ",
          "BONUS": "ប្រាក់រង្វាន់",
          "BACK_PAY": "ប្រាក់បំណុលជាន់ខាងក្រោយ",
          "ADVANCE": "ប្រាក់បុរេប្រទាន",
          "INCENTIVE": "ប្រាក់លើកទឹកចិត្ត",
          "ADJUSTMENT": "ការកែតម្រូវ",
          "SPECIAL": "ប្រាក់ខែពិសេស",
          "unspecified": "មិនបានកំណត់ប្រភេទ"
        },
        "bucket": {
          "EXCLUDED": "បុគ្គលិកដែលត្រូវបានដកចេញ",
          "LEAVER": "បុគ្គលិកដែលបានចេញ",
          "unspecified": "ធុងលំនាំដើម"
        },
        "row": {
          "pay-date": "កាលបរិច្ឆេទបើកប្រាក់ · {date}",
          "employee-count": "បុគ្គលិក {count} នាក់",
          "updated": "ធ្វើបច្ចុប្បន្នភាព {at}",
          "open": "បើក"
        },
        "wizard": {
          "back": "ត្រឡប់ទៅបញ្ជីក្រៅវដ្ត",
          "loading": "កំពុងផ្ទុកគ្រោងព្រាង…",
          "error": "មិនអាចផ្ទុកគ្រោងព្រាងបានទេ — {message}",
          "not-found": "មិនឃើញគ្រោងព្រាង ឬ ផុតកំណត់។ គ្រោងព្រាងក្រៅវដ្តស្នាក់នៅ៧ថ្ងៃ។",
          "area": {
            "type": {
              "title": "1. ប្រភេទ",
              "type-label": "ប្រភេទក្រៅវដ្ត",
              "name-label": "ឈ្មោះការដំណើរការ"
            },
            "employees": {
              "title": "2. បុគ្គលិក",
              "count-label": "បុគ្គលិកដែលបានជ្រើសរើស",
              "bucket-label": "ធុងប្រភព"
            },
            "amounts": {
              "title": "3. ចំនួន",
              "empty": "មិនទាន់បានបន្ថែមធាតុបង់ប្រាក់ទេ។",
              "line-count": "{count} ជួរក្នុងម្នាក់ៗ"
            },
            "dates": {
              "title": "4. កាលបរិច្ឆេទ និងអត្រា",
              "cycle-label": "វដ្តមេ",
              "pay-date-label": "កាលបរិច្ឆេទបើកប្រាក់",
              "tos-rate-label": "អត្រាប្តូរប្រាក់ពន្ធ (TOS)",
              "nssf-rate-label": "អត្រាប្តូរប្រាក់សោធននិវត្តន៍ NSSF"
            },
            "review": {
              "title": "5. ត្រួតពិនិត្យ",
              "pending": "ទិន្នន័យត្រួតពិនិត្យមិនទាន់មានទេ។",
              "valid": "បានឆ្លងផ្ទៀងផ្ទាត់",
              "invalid": "មានបញ្ហាផ្ទៀងផ្ទាត់",
              "template": "គំរូដែលបានដោះស្រាយ៖ {code}",
              "totals-title": "សរុបតាមធាតុ",
              "grand-total": "សរុបធំ"
            }
          },
          "edit": {
            "action": "កែសម្រួល",
            "save": "រក្សាទុកការផ្លាស់ប្ដូរ",
            "saving": "កំពុងរក្សាទុក…",
            "cancel": "បោះបង់",
            "empty": "ជ្រើសរើសផ្នែកដើម្បីកែសម្រួល។",
            "error": "មិនអាចរក្សាទុកផ្នែកនេះបានទេ — {message}",
            "employees": {
              "placeholder": "Employee:e1\nEmployee:e2",
              "hint": "មួយលេខបុគ្គលិកក្នុងមួយជួរ (ឬញែកដោយក្បៀស)។"
            },
            "amounts": {
              "json-label": "សមាសភាគ (JSON)",
              "hint": "អារ៉េនៃសមាសភាគ ដែលនីមួយៗមាន ComponentCode និង Items[{ EmployeeId, Amount, Reason? }]។ កម្មវិធីកែសម្រួលតារាងក្នុងម្នាក់ៗនឹងមកនៅរលកការប៉ូលីសខាងក្រោយ។",
              "json-error": "JSON មិនត្រឹមត្រូវ — {message}"
            },
            "dates": {
              "cycle-placeholder": "Cycle:abc123"
            }
          },
          "commit": {
            "action": "ដាក់ស្នើគ្រោងព្រាង",
            "submitting": "កំពុងដាក់ស្នើ…",
            "error": "មិនអាចដាក់ស្នើគ្រោងព្រាងបានទេ — {message}",
            "success": "បានដាក់ស្នើគ្រោងព្រាង។ កំពុងបើកប្រាក់ខែ {payrollId}…"
          },
          "abandon": {
            "action": "បោះបង់គ្រោងព្រាង"
          }
        }
      },
      "templates": {
        "back": "ត្រឡប់ទៅមជ្ឈមណ្ឌលប្រាក់ខែ",
        "title": "គំរូ",
        "subtitle": "ការកំណត់ប្រាក់ខែដែលអាចប្រើឡើងវិញសម្រាប់វដ្តធម្មតា ការដំណើរការក្រៅវដ្ត និងប្រាក់ខែពិសេស។",
        "loading": "កំពុងផ្ទុកគំរូ…",
        "error": "មិនអាចផ្ទុកគំរូបានទេ — {message}",
        "empty": "មិនទាន់មានគំរូត្រូវបានបង្កើតសម្រាប់ស្ថាប័ននេះទេ។",
        "untitled": "គំរូគ្មានឈ្មោះ",
        "default-badge": "លំនាំដើម",
        "code": {
          "1ST_PAY": "ប្រាក់ខែលើកទីមួយ",
          "2ND_PAY": "ប្រាក់ខែលើកទីពីរ",
          "FINAL_PAY": "ប្រាក់ខែចុងក្រោយ"
        },
        "versions": {
          "btn": "ប្រវត្តិកំណែ",
          "heading": "ប្រវត្តិកំណែ",
          "loading": "កំពុងផ្ទុកកំណែ…",
          "error": "មិនអាចផ្ទុកកំណែបានទេ — {message}",
          "empty": "មិនមានប្រវត្តិកំណែទេ។",
          "version-label": "កំណែ {n}",
          "latest": "ចុងក្រោយ",
          "attributes": "{n} គុណលក្ខណៈ"
        },
        "clone": {
          "btn": "ចម្លង",
          "title": "ចម្លងគំរូ",
          "description": "បង្កើតគំរូថ្មីដោយផ្អែកលើគំរូដែលមានស្រាប់។",
          "name-label": "ឈ្មោះគំរូថ្មី",
          "default-name": "{name} (ចម្លង)",
          "name-required": "ឈ្មោះគំរូជាចាំបាច់។",
          "cancel": "បោះបង់",
          "confirm": "ចម្លង",
          "cloning": "កំពុងចម្លង…",
          "success": "គំរូ \"{name}\" បានបង្កើតដោយជោគជ័យ។"
        },
        "import": {
          "btn": "នាំចូល",
          "coming-soon": "ការនាំចូលគំរូស្ថិតក្នុងផែនការ — នឹងមកដល់ក្នុងកំណែបន្ត។"
        },
        "new": {
          "btn": "គំរូថ្មី",
          "coming-soon": "ការបង្កើតគំរូស្ថិតក្នុងផែនការ — នឹងមកដល់ក្នុងកំណែបន្ត។"
        },
        "use": {
          "btn": "ប្រើ",
          "coming-soon": "ចាប់ផ្តើមការដំណើរការប្រាក់ខែពីគំរូតាមរយៈ មជ្ឈមណ្ឌលប្រាក់ខែ → ចាប់ផ្តើមប្រាក់ខែ។ ការចាប់ផ្តើមដោយផ្ទាល់ពីប័ណ្ណគំរូស្ថិតក្នុងផែនការ។"
        },
        "computation": {
          "title": "ច្បាប់គណនា",
          "subtitle": "ការកំណត់គណនាប្រាក់ខែទូទៅ (អនុវត្តលើគ្រប់គំរូ)",
          "edit": "កែប្រែ",
          "ot-weekday-label": "មេគុណម៉ោងបន្ថែម (ថ្ងៃធ្វើការ)",
          "ot-weekday-value": "១.៥× តម្លៃម៉ោងមូលដ្ឋាន",
          "ot-weekend-label": "មេគុណម៉ោងបន្ថែម (ចុងសប្តាហ៍ / បុណ្យ)",
          "ot-weekend-value": "២.០× តម្លៃម៉ោងមូលដ្ឋាន",
          "daily-rate-label": "រូបមន្តប្រាក់ប្រចាំថ្ងៃ",
          "daily-rate-value": "មូលដ្ឋាន ÷ ២២ ថ្ងៃធ្វើការ · ប្រចាំម៉ោង៖ មូលដ្ឋាន ÷ ១៩៨ (២២ថ ​× ៩ម)",
          "workweek-label": "សប្តាហ៍ធ្វើការ",
          "workweek-value": "៥ ថ្ងៃ × ៩ ម៉ោង = ៤៥ ម៉ោង / សប្តាហ៍",
          "rounding-label": "ការបង្គត់",
          "rounding-value": "២ ខ្ទង់ទសភាគ បង្គត់ឡើង",
          "currency-label": "រូបិយប័ណ្ណលំនាំដើម",
          "currency-value": "USD (KHR សម្រាប់ការដាក់ TOS)",
          "first-payroll-offset-label": "ការផ្តាច់ប្រាក់ខែលើកដំបូង",
          "first-payroll-offset-value": "ពន្ធ និង NSSF អនុវត្តលើប្រាក់ខែលើកទីពីរប៉ុណ្ណោះ"
        }
      },
      "payslip": {
        "unnamed": "បុគ្គលិកគ្មានឈ្មោះ",
        "list": {
          "back": "ត្រឡប់ទៅការដំណើរការ",
          "title": "បាណ្ណប្រាក់ខែ",
          "subtitle": "បាណ្ណប្រាក់ខែតាមបុគ្គលិកសម្រាប់ការដំណើរការប្រាក់ខែនេះ។",
          "loading": "កំពុងផ្ទុកបាណ្ណប្រាក់ខែ…",
          "error": "មិនអាចផ្ទុកបាណ្ណប្រាក់ខែបានទេ — {message}",
          "empty": "មិនទាន់មានបាណ្ណប្រាក់ខែសម្រាប់ការដំណើរការនេះទេ។",
          "filtered-empty": "គ្មានបាណ្ណប្រាក់ខែត្រូវនឹងតម្រងបច្ចុប្បន្នទេ។"
        },
        "view": {
          "back": "ត្រឡប់ទៅបញ្ជីបាណ្ណប្រាក់ខែ",
          "title": "បាណ្ណប្រាក់ខែ",
          "subtitle": "រូបភាពនៃការគណនាជំហានទី៣ដែលបានចាក់សោ។",
          "loading": "កំពុងផ្ទុកបាណ្ណប្រាក់ខែ…",
          "error": "មិនអាចផ្ទុកបាណ្ណប្រាក់ខែបានទេ — {message}",
          "empty": "មិនមានបាណ្ណប្រាក់ខែសម្រាប់បុគ្គលិកនេះទេ។"
        },
        "kpi": {
          "total": "សរុប",
          "ready": "ត្រៀមបង្កើត",
          "generated": "បានបង្កើត",
          "on-hold": "ស្ថិតក្នុងការផ្អាក",
          "distributed": "បានចែកចាយ"
        },
        "lock": {
          "locked": "ការដំណើរការត្រូវបានចាក់សោ",
          "unlocked": "ការដំណើរការមិនទាន់ត្រូវបានចាក់សោ"
        },
        "filter": {
          "all": "ស្ថានភាពទាំងអស់",
          "search-label": "ស្វែងរកតាមឈ្មោះ ឬលេខកូដ",
          "search-placeholder": "ស្វែងរកតាមឈ្មោះ ឬលេខកូដបុគ្គលិក…"
        },
        "status": {
          "ready-to-generate": "ត្រៀមបង្កើត",
          "generated": "បានបង្កើត",
          "on-hold": "ស្ថិតក្នុងការផ្អាក",
          "distributed": "បានចែកចាយ"
        },
        "hold-reason": {
          "MISSING_DELIVERY_METHOD": "ខ្វះវិធីសាស្ត្រចែកចាយ",
          "MISSING_EMAIL": "ខ្វះអាសយដ្ឋានអ៊ីមែល",
          "PORTAL_NOT_ACTIVATED": "ច្រកបុគ្គលិកមិនទាន់ត្រូវបានធ្វើឱ្យសកម្ម"
        },
        "delivery": {
          "MANUAL_DOWNLOAD": "ទាញយកដោយដៃ",
          "EMAIL": "អ៊ីមែល",
          "PORTAL": "ច្រកបុគ្គលិក"
        },
        "cols": {
          "employee": "បុគ្គលិក",
          "status": "ស្ថានភាព",
          "gross": "សរុប",
          "net": "សុទ្ធ",
          "delivery": "ការចែកចាយ",
          "actions": "សកម្មភាព",
          "item": "មុខទែទាត់",
          "amount": "ចំនួនទឹកប្រាក់"
        },
        "actions": {
          "view": "មើល"
        },
        "doc": {
          "title": "បាណ្ណប្រាក់ខែ",
          "tagline": "លិខិតផ្លូវការនៃប្រាក់សំណងប្រចាំខែ",
          "run-id": "លេខការដំណើរការ: {id}"
        },
        "meta": {
          "employee-name": "ឈ្មោះបុគ្គលិក",
          "employee-id": "លេខសម្គាល់បុគ្គលិក",
          "template": "ប្រភេទប្រាក់ខែ",
          "pay-method": "វិធីបង់ប្រាក់",
          "delivery-contact": "ទំនាក់ទំនងចែកចាយ"
        },
        "summary": {
          "gross": "ប្រាក់ចំណូលសរុប",
          "deductions": "ការកាត់សរុប",
          "net": "ប្រាក់សុទ្ធ"
        },
        "section": {
          "earnings": "ចំណូល",
          "deductions": "ការកាត់",
          "empty-earnings": "មិនមានចំណូលត្រូវបានកត់ត្រាសម្រាប់បាណ្ណប្រាក់ខែនេះទេ។",
          "empty-deductions": "មិនមានការកាត់ត្រូវបានកត់ត្រាសម្រាប់បាណ្ណប្រាក់ខែនេះទេ។"
        },
        "totals": {
          "earnings": "ចំណូលសរុប",
          "deductions": "ការកាត់សរុប"
        },
        "hold-banner": {
          "title": "បាណ្ណប្រាក់ខែត្រូវបានផ្អាក",
          "hint": "ត្រូវដោះស្រាយការផ្អាកមុនពេលបង្កើត ឬចែកចាយបាណ្ណប្រាក់ខែនេះ។"
        },
        "note": {
          "label": "កំណត់ចំណាំសំខាន់",
          "body": "នេះជាបាណ្ណប្រាក់ខែដែលបង្កើតដោយប្រព័ន្ធ។ មិនចាំបាច់មានហត្ថលេខាទេ។ តួលេខដែលបង្ហាញគឺជារូបភាពនៃការគណនាជំហានទី៣ដែលបានចាក់សោ។",
          "generated-at": "បានបង្កើត: {date}",
          "file": "ឯកសារ: {name}"
        },
        "distribute": {
          "action": "ចែកចាយ",
          "title": "ចែកចាយបាណ្ណប្រាក់ខែ",
          "body": "ផ្ញើបាណ្ណប្រាក់ខែដែលបានបង្កើតតាមឆានែលចែកចាយមួយ។ ជួរដែលផ្អាក ឬមិនទាន់បង្កើតនឹងត្រូវរំលងដោយស្វ័យប្រវត្តិ។",
          "method-label": "ឆានែលចែកចាយ",
          "methods": {
            "manual": "ទាញយកដោយដៃ",
            "manual-hint": "សម្គាល់បាណ្ណប្រាក់ខែទាំងអស់ដែលបានបង្កើតថាបានចែកចាយ; អ្នកប្រើទាញយកឯកសារក្នុងពេលនេះ។",
            "email": "អ៊ីមែល",
            "email-hint": "ផ្ញើបាណ្ណប្រាក់ខែទៅអាសយដ្ឋានអ៊ីមែលដែលបានចុះឈ្មោះរបស់បុគ្គលិក។",
            "portal": "ច្រកសេវាខ្លួនឯង",
            "portal-hint": "ផ្សព្វផ្សាយបាណ្ណប្រាក់ខែទៅច្រកសេវាខ្លួនឯងរបស់បុគ្គលិក។"
          },
          "submit": "ចែកចាយឥឡូវនេះ",
          "submitting": "កំពុងចែកចាយ…",
          "cancel": "បោះបង់",
          "success": "បានចែកចាយបាណ្ណប្រាក់ខែ {count}។",
          "skipped": "បានរំលងជួរ {count}។",
          "error": "មិនអាចចែកចាយបាណ្ណប្រាក់ខែបានទេ — {message}"
        },
        "hold-resolve": {
          "action": "ដោះស្រាយការផ្អាក",
          "empty": "បើកបាណ្ណប្រាក់ខែដែលត្រូវផ្អាកដើម្បីដោះស្រាយ។",
          "reason-title": "មូលហេតុផ្អាក",
          "method-label": "ជ្រើសរើសវិធីចែកចាយ",
          "methods": {
            "manual": "ទាញយកដោយដៃ",
            "email": "អ៊ីមែល",
            "portal": "ច្រកសេវាខ្លួនឯង"
          },
          "email-label": "អ៊ីមែលបុគ្គលិក",
          "email-placeholder": "បញ្ចូលអាសយដ្ឋានអ៊ីមែលរបស់បុគ្គលិក",
          "email-required-error": "ត្រូវតែបញ្ចូលអាសយដ្ឋានអ៊ីមែលសម្រាប់ការផ្ញើតាមអ៊ីមែល។",
          "portal-label": "ដំណើរការច្រកសេវាខ្លួនឯងរបស់បុគ្គលិក",
          "portal-hint": "ចាំបាច់សម្រាប់ការផ្ញើតាមច្រកសេវាខ្លួនឯងដើម្បីឲ្យបុគ្គលិកអាចចូល។",
          "portal-required-error": "ត្រូវតែដំណើរការសម្រាប់ការផ្ញើតាមច្រកសេវាខ្លួនឯង។",
          "required-marker": "(ចាំបាច់)",
          "submit": "ដោះស្រាយការផ្អាក",
          "submitting": "កំពុងដោះស្រាយ…",
          "cancel": "បោះបង់",
          "error": "មិនអាចដោះស្រាយការផ្អាកបានទេ — {message}"
        }
      }
    },
    "people": {
      "title": "បុគ្គលិក",
      "subtitle": "បុគ្គលិក {total} នាក់",
      "page-subtitle": "ក្នុងស្ថាប័ន {direct} · ខាងក្រៅ {outsourced}",
      "tab-coming-soon": "នឹងមានក្នុងការអាប់ដេតបន្ទាប់",
      "tabs": {
        "directory": "បញ្ជី",
        "outsourced": "កម្លាំងពលកម្មក្រៅ",
        "clients": "អតិថិជន",
        "external": "អ្នកអនុម័តខាងក្រៅ",
        "emp-records": "កំណត់ហេតុការងារ",
        "sites": "ទីតាំង",
        "org-units": "អង្គភាព",
        "org-chart": "គំនូសតាងអង្គភាព",
        "workforce-plan": "ផែនការកម្លាំងពលកម្ម",
        "positions": "មុខតំណែង",
        "onboarding": "ការចូលបំពេញការងារ",
        "offboarding": "ការចាកចេញពីការងារ",
        "compliance": "ការអនុលោម",
        "configuration": "ការកំណត់"
      },
      "clients": {
        "subtitle": "អតិថិជនជួលកម្លាំងពលកម្ម · ដាក់ក្រុមគម្រោង · អ្នកអនុម័តខាងក្រៅ",
        "add-client": "បន្ថែមអតិថិជន",
        "search-placeholder": "ស្វែងរកអតិថិជន ទំនាក់ទំនង វិស័យ…",
        "status-unknown": "មិនស្គាល់",
        "yes": "បាទ/ចាស",
        "no": "ទេ",
        "banner": {
          "title": "អតិថិជន",
          "lead": "អតិថិជនម្នាក់ដាក់ក្រុមគម្រោងជួលកម្លាំងពលកម្មមួយ ឬច្រើន (ឧ. Unilever → APSARA · NAO)។ គម្រោងផ្ទុកបុគ្គលិក ហើយអ្នកអនុម័តខាងក្រៅជាប់នឹងអតិថិជន។"
        },
        "filters": {
          "all": "ទាំងអស់",
          "active": "សកម្ម",
          "archived": "ទុកក្នុងប័ណ្ណសារ",
          "all-platform": "គ្រប់វេទិកា",
          "on-platform": "នៅលើវេទិកា",
          "off-platform": "មិននៅលើវេទិកា",
          "label-status": "ស្ថានភាព",
          "label-platform": "វេទិកា",
          "label-search": "ស្វែងរក"
        },
        "actions": {
          "clear-filters": "សម្អាតតម្រង",
          "cancel": "បោះបង់",
          "create": "បង្កើតអតិថិជន",
          "save": "រក្សាទុកការផ្លាស់ប្តូរ"
        },
        "table": {
          "name": "អតិថិជន",
          "industry": "វិស័យ",
          "contact": "ទំនាក់ទំនងចម្បង",
          "platform": "វេទិកា",
          "status": "ស្ថានភាព",
          "on-platform-tag": "នៅលើវេទិកា",
          "showing": "បង្ហាញ {filtered} ក្នុងចំណោម {total} អតិថិជន",
          "click-hint": "ចុចជួរដេកដើម្បីបើកប្រវត្តិរូបអតិថិជន"
        },
        "empty": {
          "title": "មិនមានអតិថិជនត្រូវនឹងតម្រងបច្ចុប្បន្នទេ។"
        },
        "error": "មិនអាចផ្ទុកអតិថិជនបានទេ។",
        "error-403": "អ្នកមិនមានសិទ្ធិចូលមើលបញ្ជីអតិថិជននេះទេ។",
        "retry": "ព្យាយាមម្តងទៀត",
        "fields": {
          "name": "ឈ្មោះបង្ហាញ",
          "name-placeholder": "ឧ. Unilever",
          "legal-name": "ឈ្មោះស្របច្បាប់",
          "industry": "វិស័យ",
          "on-platform": "អតិថិជននៅលើ OptimalHR ផងដែរ (ឆ្លងភតិកៈ)",
          "counterparty": "ភតិកៈដៃគូ",
          "primary-contact": "ទំនាក់ទំនងចម្បង",
          "contact-name": "ឈ្មោះអ្នកទំនាក់ទំនង",
          "contact-email": "អ៊ីមែលអ្នកទំនាក់ទំនង",
          "contact-phone": "ទូរស័ព្ទអ្នកទំនាក់ទំនង",
          "email-invalid": "សូមបញ្ចូលអ៊ីមែលត្រឹមត្រូវ។",
          "address": "អាសយដ្ឋាន",
          "notes": "កំណត់ចំណាំ"
        },
        "engagement": {
          "provider-managed": "គ្រប់គ្រងដោយអ្នកផ្គត់ផ្គង់",
          "vendor-lite": "អ្នកលក់ស្រាល",
          "service": "សេវាកម្ម",
          "unknown": "មិនស្គាល់"
        },
        "create": {
          "title": "បន្ថែមអតិថិជន",
          "subtitle": "បង្កើតអតិថិជនជួលកម្លាំងពលកម្មថ្មី។"
        },
        "edit": {
          "title": "កែសម្រួលអតិថិជន"
        },
        "profile": {
          "back": "ត្រឡប់ទៅអតិថិជន",
          "edit": "កែសម្រួល",
          "error": "មិនអាចផ្ទុកអតិថិជននេះបានទេ។",
          "sections": {
            "profile": "ប្រវត្តិរូប",
            "projects": "គម្រោង",
            "approvers": "អ្នកអនុម័តខាងក្រៅ",
            "staff": "បុគ្គលិក"
          }
        },
        "projects": {
          "add": "បន្ថែមគម្រោង",
          "edit": "កែសម្រួល",
          "create-title": "បន្ថែមគម្រោង",
          "edit-title": "កែសម្រួលគម្រោង",
          "empty": "មិនទាន់មានគម្រោងក្រោមអតិថិជននេះទេ។",
          "error": "មិនអាចផ្ទុកគម្រោងបានទេ។",
          "contract-count": "កិច្ចសន្យា {n}",
          "fields": {
            "name": "ឈ្មោះគម្រោង",
            "engagement": "ប្រភេទការជាប់ពាក់ព័ន្ធ",
            "org-full": "ឈ្មោះពេញរបស់ស្ថាប័ន",
            "org-short": "ឈ្មោះខ្លីរបស់ស្ថាប័ន",
            "id-format": "ទម្រង់លេខសម្គាល់បុគ្គលិក",
            "id-format-hint": "លំនាំស្រេចចិត្តសម្រាប់លេខកូដបុគ្គលិកដែលបង្កើតដោយស្វ័យប្រវត្តិ។"
          }
        },
        "approvers": {
          "placeholder": "អ្នកអនុម័តខាងក្រៅសម្រាប់អតិថិជននេះត្រូវបានគ្រប់គ្រងនៅក្នុងផ្ទាំងអ្នកអនុម័តខាងក្រៅ។",
          "go-to-tab": "បើកអ្នកអនុម័តខាងក្រៅ",
          "error": "មិនអាចផ្ទុកអ្នកអនុម័ត។",
          "empty": "មិនទាន់មានអ្នកអនុម័តខាងក្រៅសម្រាប់អតិថិជននេះ។",
          "count": "អ្នកអនុម័តសកម្ម {active} · គម្រោងបានគ្របដណ្ដប់ {covered}/{total}"
        },
        "staff": {
          "placeholder": "បញ្ជីបុគ្គលិកតាមអតិថិជននឹងមកដល់នៅផ្នែកក្រោយ។ ឥឡូវនេះ សូមមើលចំនួនកិច្ចសន្យាក្រោមគម្រោងនីមួយៗ។"
        },
        "toasts": {
          "created": "បានបង្កើតអតិថិជន \"{name}\"។",
          "create-failed": "មិនអាចបង្កើតអតិថិជនបានទេ។ សូមព្យាយាមម្តងទៀត។",
          "saved": "បានរក្សាទុកអតិថិជន។",
          "save-failed": "មិនអាចរក្សាទុកអតិថិជនបានទេ។ សូមព្យាយាមម្តងទៀត។",
          "project-created": "បានបង្កើតគម្រោង \"{name}\"។",
          "project-saved": "បានរក្សាទុកគម្រោង។",
          "project-failed": "មិនអាចរក្សាទុកគម្រោងបានទេ។ សូមព្យាយាមម្តងទៀត។"
        }
      },
      "emp-records": {
        "title": "កំណត់ហេតុការងារ",
        "subtitle": "ការផ្ដល់ការងារ · កិច្ចសន្យា · សកម្មភាពការងារ · សំណង · អត្ថប្រយោជន៍ — មជ្ឈមណ្ឌលតែមួយសម្រាប់រឿងរ៉ាវការងាររបស់បុគ្គលិក",
        "actions": {
          "new-record": "កំណត់ហេតុថ្មី",
          "view": "មើល",
          "clear-filters": "សម្អាតតម្រង",
          "cancel": "បោះបង់",
          "close": "បិទ",
          "edit": "កែសម្រួល"
        },
        "sub-tabs": {
          "offers": "ការផ្ដល់ការងារ",
          "contracts": "កិច្ចសន្យា",
          "actions": "សកម្មភាពការងារ",
          "compensation": "សំណង",
          "benefits": "អត្ថប្រយោជន៍"
        },
        "dispatch": {
          "title": "បង្កើតកំណត់ហេតុការងារ",
          "lede": "សូមជ្រើសប្រភេទកំណត់ហេតុដែលអ្នកចង់បង្កើត — យើងនឹងបង្ហាញនូវជំហានបន្ទាប់។",
          "form-title": "{kind} ថ្មី",
          "form-lede": "បំពេញព័ត៌មានមូលដ្ឋាន — ក្រុមការងារនឹងទទួលបានការជូនដំណឹងពេលអ្នកបញ្ជូន។",
          "back": "ត្រឡប់",
          "cancel": "បោះបង់",
          "submit": "បង្កើត",
          "created-toast": "បានបង្កើតសេចក្ដីព្រាង {kind} សម្រាប់ {employee}",
          "fields": {
            "employee": "បុគ្គលិក ឬបេក្ខជន",
            "detail": "កំណត់ចំណាំ / ព័ត៌មានលម្អិត"
          },
          "placeholders": {
            "employee": "ស្វែងរកតាមឈ្មោះ ឬកូដបុគ្គលិក…",
            "detail": "បន្ថែមបរិបទ — កាលបរិច្ឆេទមានសុពលភាព ចំនួនទឹកប្រាក់ លក្ខខណ្ឌ ។ល។"
          },
          "errors": {
            "no-kind": "សូមជ្រើសប្រភេទកំណត់ហេតុជាមុនសិន។",
            "employee-required": "បុគ្គលិក ឬបេក្ខជន គឺត្រូវការ។"
          },
          "offer": {
            "title": "ការផ្ដល់ការងារ",
            "desc": "ព្រាងលិខិតផ្ដល់ការងារសម្រាប់បេក្ខជន។"
          },
          "contract": {
            "title": "កិច្ចសន្យា",
            "desc": "ចេញកិច្ចសន្យាការងារថ្មី។"
          },
          "action": {
            "title": "សកម្មភាពការងារ",
            "desc": "ការតម្លើងតួនាទី ការផ្ទេរ ឬការផ្លាស់ប្ដូរប្រាក់ខែ។"
          },
          "benefit": {
            "title": "អត្ថប្រយោជន៍",
            "desc": "ចុះឈ្មោះបុគ្គលិកចូលក្នុងកម្មវិធីអត្ថប្រយោជន៍។"
          },
          "compensation": {
            "title": "ព្រឹត្តិការណ៍សំណង",
            "desc": "កត់ត្រាការផ្លាស់ប្ដូរប្រាក់ខែ ប្រាក់រង្វាន់ ឬប្រាក់ឧបត្ថម្ភ។"
          }
        },
        "offers": {
          "banner": "លិខិតផ្ដល់ការងារ គឺជាសំណើការងារមុនកិច្ចសន្យា ដែលចេញជូនបេក្ខជនមុនពេលបន្ថែមបុគ្គល។ វដ្ត៖ សេចក្ដីព្រាង → បានចេញ → បានទទួលយក (ឬ បដិសេធ / ដកវិញ / ផុតកំណត់)។ បន្ទាប់ពីចេញ ប៉ុន្តែមុនពេលទទួលយក ការកែប្រែបង្កើតកំណែថ្មី (កែ & ចេញឡើងវិញ)។ ពេលទទួលយក ការបង្កើតបុគ្គល + កិច្ចសន្យា + សំណង នឹងដំណើរការនៅ CT-4។",
          "search-placeholder": "បេក្ខជន តួនាទី លេខការផ្ដល់…",
          "showing": "បង្ហាញ {filtered} ក្នុងចំណោម {total}",
          "footer-note": "បង្ហាញ {shown} ក្នុងចំណោម {total} ការផ្ដល់ · អនុញ្ញាតឱ្យកែតម្រូវតាមការផ្ដល់នីមួយៗ — កញ្ចប់ពីបណ្ណាល័យប្រាក់ឧបត្ថម្ភ & អត្ថប្រយោជន៍ ជាចំណុចចាប់ផ្ដើម មិនមែនជាការកំណត់។",
          "new-offer": "ការផ្ដល់ថ្មី",
          "filters": {
            "status": "ស្ថានភាព",
            "workforce": "ប្រភេទកម្លាំងពលកម្ម",
            "search": "ស្វែងរក"
          },
          "status-filter": {
            "open": "បើកចំហ (ព្រាង + បានចេញ)",
            "all": "ស្ថានភាពទាំងអស់"
          },
          "statuses": {
            "Draft": "សេចក្ដីព្រាង",
            "Issued": "បានចេញ",
            "Distributed": "បានផ្ញើ",
            "Accepted": "បានទទួលយក",
            "Declined": "បានបដិសេធ",
            "Withdrawn": "បានដកវិញ",
            "Expired": "ផុតកំណត់"
          },
          "workforce": {
            "all": "ទាំងអស់",
            "direct": "ផ្ទាល់",
            "outsourced": "ប្រៅ"
          },
          "kpi": {
            "all": "ទាំងអស់",
            "draft": "សេចក្ដីព្រាង",
            "issued-not-sent": "បានចេញ · មិនទាន់ផ្ញើ",
            "distributed": "បានផ្ញើ · កំពុងរង់ចាំចម្លើយ",
            "accepted": "បានទទួលយក",
            "declined": "បានបដិសេធ"
          },
          "cols": {
            "code": "លេខការផ្ដល់",
            "candidate": "បេក្ខជន",
            "position": "តួនាទី",
            "scope": "វិសាលភាព",
            "salary": "ប្រាក់ខែ",
            "type-on-accept": "ប្រភេទ → ពេលទទួលយក",
            "issued": "បានចេញ",
            "status": "ស្ថានភាព",
            "actions": "សកម្មភាព"
          },
          "scope": {
            "direct": "ផ្ទាល់",
            "outsourced": "ប្រៅ"
          },
          "drawer": {
            "candidate-email": "អ៊ីមែល",
            "candidate-phone": "ទូរស័ព្ទ",
            "scope": "វិសាលភាព",
            "position": "តួនាទី",
            "job-grade": "កម្រិតការងារ",
            "contract-type": "ប្រភេទកិច្ចសន្យាពេលទទួលយក",
            "salary": "ប្រាក់ខែសរុប (ប្រចាំខែ)",
            "start": "ការចាប់ផ្ដើមដែលស្នើ",
            "valid-until": "មានសុពលភាពដល់",
            "end": "ការបញ្ចប់ដែលស្នើ",
            "probation-end": "សាកល្បងបញ្ចប់",
            "allowances": "ប្រាក់ឧបត្ថម្ភ",
            "notes": "កំណត់ចំណាំផ្ទៃក្នុង",
            "issued": "បានចេញ",
            "distributed": "បានផ្ញើ",
            "accepted": "បានទទួលយក",
            "declined-reason": "មូលហេតុបដិសេធ"
          },
          "empty": {
            "title": "មិនមានការផ្ដល់ត្រូវនឹងលក្ខខណ្ឌ",
            "lede": "សូមព្យាយាមសម្អាតតម្រង ឬប្ដូរពាក្យស្វែងរក។"
          },
          "form": {
            "new-title": "លិខិតផ្ដល់ការងារថ្មី",
            "new-sub": "សេចក្ដីព្រាង · ជ្រើសតួនាទី កញ្ចប់នឹងបំពេញដោយស្វ័យប្រវត្តិ",
            "no-name": "(គ្មានឈ្មោះ)",
            "no-position": "(គ្មានតួនាទី)",
            "close": "បិទ",
            "view-mode": "របៀបមើល។",
            "edit": "កែសម្រួល",
            "chain": "កំណែ {version} · ខ្សែសង្វាក់ការផ្ដល់ដែលបានកែ។",
            "candidate": "បេក្ខជន",
            "latin-name": "ឈ្មោះឡាតាំង *",
            "khmer-name": "ឈ្មោះខ្មែរ",
            "email": "អ៊ីមែល",
            "phone": "ទូរស័ព្ទ",
            "position-contract": "តួនាទី និងប្រភេទកិច្ចសន្យា",
            "workforce-type": "ប្រភេទកម្លាំងពលកម្ម *",
            "job-grade": "កម្រិតការងារ *",
            "grade-hint": "(តម្រងតួនាទីខាងក្រោម)",
            "client": "អតិថិជន",
            "project": "គម្រោង",
            "select": "— ជ្រើស —",
            "any-project": "— គម្រោងណាមួយ —",
            "position": "តួនាទី *",
            "position-hint": "(ពីបញ្ជីតួនាទីទំនេរ)",
            "select-position": "— ជ្រើសតួនាទីទំនេរ{grade} —",
            "position-other": "— ផ្សេងទៀត (សរសេរសេរី គ្មានតួនាទីទំនេរ) —",
            "position-other-ph": "ចំណងជើងតួនាទីសរសេរសេរី (ឧ. សម្រាប់តួនាទីថ្មីដែលមិនទាន់មានក្នុងបញ្ជី)",
            "no-vacancies": "គ្មានតួនាទីទំនេរនៅ {grade} សម្រាប់កម្លាំងពលកម្មនេះ។ ប្ដូរកម្រិត ឬជ្រើស ផ្សេងទៀត (សរសេរសេរី)។",
            "selected": "បានជ្រើស",
            "contract-type": "ប្រភេទកិច្ចសន្យានៅពេលទទួលយក *",
            "start-date": "កាលបរិច្ឆេទចាប់ផ្ដើមដែលស្នើ *",
            "valid-until": "ការផ្ដល់មានសុពលភាពរហូតដល់ *",
            "end-date": "កាលបរិច្ឆេទបញ្ចប់ដែលស្នើ *",
            "fdc-max": "(អតិបរមា ២៤ ខែតាមច្បាប់ការងារ)",
            "prob-end": "(= ការបញ្ចប់សាកល្បង)",
            "fdc-warn": "FDC អតិបរមា ២៤ ខែតាមច្បាប់ការងារកម្ពុជា (បានបញ្ជាក់ {months} ខែ)",
            "include-probation": "រួមបញ្ចូលរយៈពេលសាកល្បង",
            "probation-end-date": "កាលបរិច្ឆេទបញ្ចប់សាកល្បង *",
            "probation": "ការសាកល្បង",
            "probation-ends": "បាទ/ចាស · បញ្ចប់ {date}",
            "no": "ទេ",
            "compensation": "កញ្ចប់សំណង",
            "override": "· ការកំណត់ឡើងវិញតាមការផ្ដល់",
            "template": "· គំរូ៖ {ref}",
            "gross-salary": "ប្រាក់ខែសរុប (ប្រចាំខែ) *",
            "gross-salary-short": "ប្រាក់ខែសរុប",
            "salary-ph": "ឧ. 1500",
            "salary-band-warn": "ក្រៅក្រុម {code} (${min}-${max})",
            "allowance-package": "កញ្ចប់ប្រាក់បំណាច់",
            "allowance-package-hint": "(ជ្រើសគំរូ ឬជ្រើស ផ្ទាល់ខ្លួន ដើម្បីកំណត់ដោយខ្លួនឯង)",
            "choose-template": "— ជ្រើសគំរូ ឬ ផ្ទាល់ខ្លួន —",
            "custom": "ផ្ទាល់ខ្លួន (កំណត់ដោយដៃ)",
            "no-allowance-template": "គ្មានគំរូត្រូវគ្នា — ជ្រើស ផ្ទាល់ខ្លួន ហើយបន្ថែមជួរខាងក្រោម។",
            "allowance": "ប្រាក់បំណាច់",
            "monthly": "ប្រចាំខែ",
            "no-allowances": "គ្មានប្រាក់បំណាច់",
            "add-one": "បន្ថែមមួយ",
            "total-allowances": "ប្រាក់បំណាច់សរុប + មូលដ្ឋាន",
            "add-allowance": "បន្ថែមជួរប្រាក់បំណាច់",
            "remove": "លុប",
            "benefits": "អត្ថប្រយោជន៍",
            "benefits-package": "កញ្ចប់អត្ថប្រយោជន៍",
            "benefits-package-hint": "(ជ្រើសគំរូ ឬជ្រើស ផ្ទាល់ខ្លួន)",
            "no-benefits-template": "គ្មានគំរូត្រូវគ្នា — ជ្រើស ផ្ទាល់ខ្លួន។",
            "pick-benefits": "ជ្រើសគំរូខាងលើ ឬប្ដូរទៅ",
            "no-benefits": "គ្មានអត្ថប្រយោជន៍ត្រូវបានកំណត់។",
            "note-optional": "ចំណាំ (ស្រេចចិត្ត)",
            "conditions-notes": "លក្ខខណ្ឌ និងចំណាំ",
            "conditions": "លក្ខខណ្ឌមុនពេលចូលធ្វើការ",
            "conditions-hint": "(មួយជួរក្នុងមួយបន្ទាត់ — អ្វីដែលបេក្ខជនត្រូវបំពេញមុនកាលបរិច្ឆេទចាប់ផ្ដើម)",
            "conditions-ll": "ច្បាប់ការងារកម្ពុជាតម្រូវ៖ វិញ្ញាបនបត្រសុខភាពពីវេជ្ជបណ្ឌិតក្រសួងការងារ។ លក្ខខណ្ឌផ្សេងទៀត (ការត្រួតពិនិត្យប្រវត្តិ ឯកសារយោង) ជាគោលនយោបាយក្រុមហ៊ុន។",
            "no-conditions": "គ្មានលក្ខខណ្ឌត្រូវបានបញ្ជាក់។",
            "internal-notes": "ចំណាំផ្ទៃក្នុង",
            "notes-hint": "(មិនបង្ហាញលើលិខិតផ្ដល់)",
            "notes-label": "ចំណាំ",
            "letter-preview": "មើលលិខិតជាមុន",
            "download-pdf": "ទាញយកជា PDF",
            "all-filled": "បានបំពេញគ្រប់វាលដែលត្រូវការ",
            "cancel": "បោះបង់",
            "cancel-edit": "បោះបង់ការកែសម្រួល",
            "save-draft": "រក្សាទុកសេចក្ដីព្រាង",
            "save-issue": "រក្សាទុក និងចេញ",
            "status": "ស្ថានភាព",
            "toast-draft": "ការផ្ដល់ {id} បានរក្សាទុកជាសេចក្ដីព្រាង",
            "toast-issued": "ការផ្ដល់ {id} បានចេញ"
          }
        },
        "contracts": {
          "banner": "កិច្ចសន្យាកាន់កាប់លក្ខខណ្ឌច្បាប់នៃការងារដែលបានព្រមព្រៀង។ ប្រភេទនីមួយៗមានវដ្តជីវិតផ្ទាល់៖ សាកល្បងប្ដូរទៅ FDC/UDC តាមរយៈកិច្ចសន្យាថ្មី · FDC ពន្យារ ឬប្ដូរទៅ UDC · ការផ្លាស់ប្ដូរ UDC ឆ្លងកាត់ការផ្លាស់ប្ដូរការងារ (កិច្ចសន្យានៅតែមាន) · កិច្ចសន្យាណាមួយអាចត្រូវបានបញ្ចប់។ ចុចជួរដើម្បីមើលប្រវត្តិខ្សែសង្វាក់ពេញលេញ។",
          "search-placeholder": "ស្វែងរកតាមកូដ បុគ្គលិក តួនាទី ឬប្រភេទ…",
          "showing": "បង្ហាញ {filtered} ក្នុងចំណោម {total}",
          "footer-note": "បង្ហាញកិច្ចសន្យា {shown} ក្នុងចំណោម {total} · សកម្មភាពវដ្តជីវិត (ប្ដូរ · ពន្យារ · ចេញការផ្លាស់ប្ដូរការងារ · បញ្ចប់) មាននៅក្នុងផ្ទាំងលម្អិត នៅពេលស្ថានភាពកិច្ចសន្យាជាសកម្ម",
          "kpi": {
            "active": "កិច្ចសន្យាសកម្ម",
            "expiring-30": "ផុតក្នុង ≤30 ថ្ងៃ",
            "expiring-31-60": "ផុតក្នុង 31-60 ថ្ងៃ",
            "probation-ending-30": "សាកល្បងបញ្ចប់ ≤30 ថ្ងៃ",
            "unsigned": "មិនទាន់ចុះហត្ថលេខា"
          },
          "filters": {
            "status": "ស្ថានភាព",
            "type": "ប្រភេទកិច្ចសន្យា",
            "workforce": "កម្លាំងពលកម្ម",
            "client": "អតិថិជន",
            "search": "ស្វែងរក"
          },
          "status-opts": {
            "active": "សកម្មតែប៉ុណ្ណោះ",
            "all": "ស្ថានភាពទាំងអស់",
            "Active": "សកម្ម",
            "history": "ប្រវត្តិ (បានជំនួស/ផុតកំណត់/បានបញ្ចប់)",
            "pending": "រង់ចាំចុះហត្ថលេខា"
          },
          "type-opts": {
            "all": "ប្រភេទទាំងអស់"
          },
          "workforce": {
            "all": "ទាំងអស់",
            "direct": "ផ្ទាល់",
            "outsourced": "ប្រៅ"
          },
          "client-opts": {
            "all": "អតិថិជនទាំងអស់"
          },
          "cols": {
            "code": "លេខកិច្ចសន្យា",
            "employee": "បុគ្គលិក",
            "type": "ប្រភេទ",
            "position": "តួនាទី",
            "scope": "វិសាលភាព",
            "start": "ចាប់ផ្ដើម",
            "end": "បញ្ចប់",
            "status": "ស្ថានភាព",
            "actions": "សកម្មភាព"
          },
          "scope": {
            "direct": "ផ្ទាល់",
            "outsourced": "ប្រៅ"
          },
          "exp-chip": {
            "le30": "≤30ថ្ងៃ",
            "le60": "≤60ថ្ងៃ",
            "expired": "ផុតកំណត់"
          },
          "empty": {
            "no-match": "មិនមានកិច្ចសន្យាត្រូវនឹងតម្រងបច្ចុប្បន្ន។",
            "title": "មិនមានកិច្ចសន្យាត្រូវនឹងលក្ខខណ្ឌ",
            "lede": "សូមព្យាយាមសម្អាតតម្រង ឬប្ដូរពាក្យស្វែងរក។"
          },
          "detail": {
            "close": "បិទ",
            "close-btn": "បិទ",
            "no-position": "គ្មានតួនាទី",
            "header": "ក្បាល",
            "employee": "បុគ្គលិក",
            "position": "តួនាទី",
            "type": "ប្រភេទ",
            "status": "ស្ថានភាព",
            "scope": "វិសាលភាព",
            "reports-to": "រាយការណ៍ទៅ",
            "start": "កាលបរិច្ឆេទចាប់ផ្ដើម",
            "end": "កាលបរិច្ឆេទបញ្ចប់",
            "indefinite": "មិនកំណត់",
            "probation-end": "បញ្ចប់សាកល្បង",
            "notice-period": "រយៈពេលជូនដំណឹង",
            "work-location": "ទីតាំងធ្វើការ",
            "working-hours": "ម៉ោងធ្វើការ",
            "remuneration": "ប្រាក់កម្រៃ",
            "remuneration-note": "(តម្លៃដំបូងពីកិច្ចសន្យា · តម្លៃបច្ចុប្បន្ននៅក្នុងសំណង)",
            "gross-salary": "ប្រាក់ខែសរុប",
            "pay-frequency": "ភាពញឹកញាប់នៃការបើកប្រាក់",
            "pay-method": "វិធីបើកប្រាក់",
            "extensions": "ការពន្យារ ({count})",
            "ext-addendum": "ឧបសម្ព័ន្ធ",
            "ext-old-end": "បញ្ចប់ចាស់",
            "ext-new-end": "បញ្ចប់ថ្មី",
            "ext-signed": "ចុះហត្ថលេខា",
            "ext-reason": "មូលហេតុ",
            "amendments": "ការកែប្រែ / ការផ្លាស់ប្ដូរការងារ ({count})",
            "amd-eff": "មានប្រសិទ្ធភាព {date}",
            "amd-reason": "មូលហេតុ៖ {reason}",
            "amd-by": "ដោយ {by}",
            "chain": "ខ្សែសង្វាក់កិច្ចសន្យា ({count})",
            "chain-viewing": "← កំពុងមើល",
            "chain-open": "បើក",
            "signed-copy": "ច្បាប់ចម្លងដែលបានចុះហត្ថលេខា",
            "signed-by": "ចុះហត្ថលេខាដោយ៖",
            "document": "ឯកសារ៖",
            "not-attached": "មិនបានភ្ជាប់",
            "not-signed": "កិច្ចសន្យាមិនទាន់ចុះហត្ថលេខា។",
            "footer-id": "កិច្ចសន្យា",
            "action-convert": "ប្ដូរទៅ UDC…",
            "action-extend": "ពន្យារ…",
            "action-amend": "ចេញការផ្លាស់ប្ដូរការងារ…",
            "action-terminate": "បញ្ចប់…",
            "action-stub": "{action} — នឹងមកដល់ឆាប់ៗ។ កិច្ចសន្យាត្រូវបានបង្កើតពីការផ្ដល់ជូនដែលបានទទួលយកក្នុងកំណែនេះ។"
          },
          "chips": {
            "all": "ទាំងអស់",
            "active": "សកម្ម",
            "probation": "សាកល្បង",
            "expiring": "ផុតក្នុង ≤30ថ្ងៃ",
            "unsigned": "មិនចុះហត្ថលេខា",
            "expired": "ផុតកំណត់"
          },
          "drawer": {
            "position": "តួនាទី",
            "employee-code": "កូដបុគ្គលិក",
            "start": "ចាប់ផ្ដើម",
            "end": "បញ្ចប់",
            "notes": "កំណត់ចំណាំ"
          }
        },
        "actions-tab": {
          "title": "សកម្មភាពការងារ",
          "subtitle": "កន្លែងធ្វើការប្រតិបត្តិការឆ្លងបុគ្គលិក · ការកត់ត្រាដំណាក់កាលទី ១ · ស្ថានភាពកំណត់តាមកាលបរិច្ឆេទមានសុពលភាព · គ្មានជួរអនុម័ត",
          "new-action": "សកម្មភាពការងារថ្មី",
          "search-placeholder": "ស្វែងរកតាមកូដ បុគ្គលិក ប្រភេទ ឬព័ត៌មានលម្អិត…",
          "showing": "បង្ហាញ {filtered} ក្នុងចំណោម {total}",
          "banner-title": "ដំណាក់កាលទី ១ · កត់ត្រាតែប៉ុណ្ណោះ។",
          "banner-lede": "ផ្នែកធនធានមនុស្សកត់ត្រា EA ដែលបានអនុម័តក្រៅប្រព័ន្ធ (កំណត់ត្រា / លិខិត / ការចុះហត្ថលេខារបស់អ្នកគ្រប់គ្រង)។ ស្ថានភាព៖ បានកំណត់ (កាលបរិច្ឆេទនាពេលអនាគត) → មានសុពលភាព (ថ្ងៃនេះ / អតីតកាល)។ លំហូរការអនុម័តនឹងមកនៅដំណាក់កាលទី ២។",
          "phase2": "ដំណាក់កាលទី ២",
          "kpi": {
            "all-eas": "EA ទាំងអស់",
            "scheduled": "បានកំណត់",
            "effective-this-week": "មានសុពលភាពសប្ដាហ៍នេះ",
            "by-detected-label": "តាមស្លាកដែលរកឃើញ",
            "cancelled": "បានបោះបង់",
            "cancelled-delta": "បានបោះបង់ {n}",
            "future-dated": "កាលបរិច្ឆេទអនាគត",
            "last-7-days": "ក្នុងរយៈពេល ៧ ថ្ងៃចុងក្រោយ",
            "retained": "រក្សាទុកសម្រាប់សវនកម្ម"
          },
          "filters": {
            "all-types": "ប្រភេទសកម្មភាពទាំងអស់",
            "all-labels": "ស្លាករកឃើញទាំងអស់",
            "all-statuses": "ស្ថានភាពទាំងអស់"
          },
          "status": {
            "scheduled": "បានកំណត់",
            "effective": "មានសុពលភាព",
            "cancelled": "បានបោះបង់"
          },
          "cols": {
            "effective": "កាលបរិច្ឆេទមានសុពលភាព",
            "employee": "បុគ្គលិក",
            "type": "ប្រភេទសកម្មភាព",
            "detail": "ព័ត៌មានលម្អិត",
            "detected-label": "ស្លាករកឃើញ",
            "status": "ស្ថានភាព",
            "comp": "សំណង",
            "actions": "សកម្មភាព",
            "code": "កូដ"
          },
          "empty": {
            "title": "មិនមានសកម្មភាពការងារត្រូវនឹងលក្ខខណ្ឌ",
            "lede": "សូមព្យាយាមសម្អាតតម្រង ឬប្ដូរពាក្យស្វែងរក។",
            "lede-none": "ចុច សកម្មភាពការងារថ្មី ដើម្បីកត់ត្រាលើកដំបូង។"
          },
          "modal": {
            "aria": "សកម្មភាពការងារ",
            "title": "សកម្មភាពការងារថ្មី",
            "step1": "ជំហានទី ១ ក្នុង ៣ · ជ្រើសរើសប្រភេទព្រឹត្តិការណ៍ការងារ",
            "step2": "ជំហានទី ២ ក្នុង ៣ · ជ្រើសរើសបុគ្គលិកដែលប្រភេទនេះអនុវត្ត",
            "step3": "ជំហានទី ៣ ក្នុង ៣ · បំពេញទម្រង់ · ការកត់ត្រាដំណាក់កាលទី ១",
            "what-change": "ការផ្លាស់ប្ដូរប្រភេទណា?",
            "what-change-lede": "ជ្រើសរើសប្រភេទអាជីវកម្មជាមុនសិន។ ប្រភេទនីមួយៗមានទម្រង់ផ្ទាល់ខ្លួន។ បន្ទាប់មកអ្នកនឹងជ្រើសរើសបុគ្គលិក រួចបំពេញទម្រង់។",
            "classification": "ប្រភេទ",
            "change-classification": "ប្ដូរប្រភេទ",
            "pick-employee": "ជ្រើសរើសបុគ្គលិក",
            "employee": "បុគ្គលិក",
            "employee-search": "ស្វែងរកតាមលេខសម្គាល់ · ឈ្មោះ · មុខតំណែង · នាយកដ្ឋាន…",
            "employee-hint": "មិនរាប់បញ្ចូលបុគ្គលិកអសកម្ម។ ចុចជួរមួយដើម្បីបន្តទៅទម្រង់ {label}។",
            "employee-empty": "មិនមានបុគ្គលិកសកម្មត្រូវនឹងការស្វែងរករបស់អ្នក។",
            "upcoming": "{label} — មុខងារនាពេលខាងមុខ · គ្រោងសម្រាប់ដំណាក់កាលក្រោយ",
            "upcoming-tag": "⏸ មុខងារនាពេលខាងមុខ",
            "detail-title": "ព័ត៌មានលម្អិត",
            "recorded": "បានកត់ត្រា {date}",
            "toast-saved": "បានកត់ត្រា {label} · ស្ថានភាព៖ {status}"
          },
          "form": {
            "effective-date": "កាលបរិច្ឆេទមានសុពលភាព",
            "effective-hint": "ចន្លោះកាលបរិច្ឆេទថយក្រោយ៖ {days} ថ្ងៃ · ថ្ងៃនេះ (សាកល្បង)៖ {today}",
            "reason": "មូលហេតុ",
            "reason-placeholder": "ហេតុអ្វីការផ្លាស់ប្ដូរនេះត្រូវបានកត់ត្រា?",
            "document": "ឯកសារយោង",
            "document-placeholder": "ឈ្មោះឯកសារ ឬឯកសារយោង (ឧ. PromotionLetter-2026-014.pdf)",
            "dropzone": "អូស និងទម្លាក់ ឬរុករកដើម្បីភ្ជាប់កំណត់ត្រា / លិខិតក្រៅប្រព័ន្ធ",
            "offline-label": "ការអនុម័តក្រៅប្រព័ន្ធបានបញ្ចប់",
            "offline-desc": "អ្នកគ្រប់គ្រង / ផ្នែកធនធានមនុស្ស / បុគ្គលិកបានព្រមព្រៀង និងចុះហត្ថលេខាក្រៅប្រព័ន្ធ (កំណត់ត្រា លិខិត ឬផ្ទាល់មាត់)។ គូសធីកនៅពេលឯកសារត្រូវបានរៀបចំ។",
            "offline-notes": "កំណត់សម្គាល់ — ឧ. បានអនុម័តដោយអ្នកគ្រប់គ្រង Sopheap កំណត់ត្រាចុះហត្ថលេខា ២០២៦-០៦-២៨",
            "companion-label": "ភ្ជាប់៖ កត់ត្រាការកែតម្រូវប្រាក់ខែផងដែរ",
            "companion-desc": "ការផ្ដល់មុខតំណែងតែងតែភ្ជាប់នឹងការផ្លាស់ប្ដូរប្រាក់ខែ។ កត់ត្រាធាតុពីរផ្សេងគ្នា (សកម្មភាពការងារមួយ + ព្រឹត្តិការណ៍សំណងមួយ) ដែលចែករំលែកកាលបរិច្ឆេទមានសុពលភាព និងមូលហេតុនេះ។",
            "base-salary": "ប្រាក់ខែមូលដ្ឋាន",
            "new-base-salary": "ប្រាក់ខែមូលដ្ឋានថ្មី",
            "routing-template": "គំរូផ្លូវ (រក្សាទុក មិនប្រតិបត្តិ)",
            "position-placeholder": "ជ្រើសរើសមុខតំណែងគោលដៅ…",
            "position-search": "ស្វែងរកមុខងារ · នាយកដ្ឋាន · ទីតាំង · ថ្នាក់…",
            "position-empty": "មិនមានមុខតំណែងដែលអាចចាត់តាំងបាន · កៅអីដែលត្រូវគ្នាសុទ្ធតែកំពុងកាន់កាប់។",
            "vacant": "ទំនេរ",
            "manager-placeholder": "ជ្រើសរើសអ្នកគ្រប់គ្រង…",
            "pick": "ជ្រើសរើស…",
            "value": "តម្លៃ",
            "detected-action": "សកម្មភាពរកឃើញ (ទាញចេញពីភាពខុសគ្នា)",
            "delta-attribute": "គុណលក្ខណៈ",
            "delta-current": "បច្ចុប្បន្ន",
            "delta-target": "គោលដៅ",
            "no-change": " (គ្មានការផ្លាស់ប្ដូរ)",
            "ready": "រួចរាល់ដើម្បីរក្សាទុក · ស្ថានភាពនឹងជា {status}",
            "missing": "{n} វាលដែលត្រូវការ បាត់ ឬមិនត្រឹមត្រូវ",
            "cancel": "បោះបង់",
            "save": "រក្សាទុកកំណត់ត្រា"
          },
          "detail": {
            "record-id": "លេខកំណត់ត្រា",
            "employee": "បុគ្គលិក",
            "effective": "កាលបរិច្ឆេទមានសុពលភាព",
            "status": "ស្ថានភាព",
            "detected": "សកម្មភាពរកឃើញ",
            "document": "ឯកសារយោង",
            "offline": "ការអនុម័តក្រៅប្រព័ន្ធ",
            "offline-yes": "បានបញ្ចប់",
            "offline-no": "មិនបានសម្គាល់ថាបញ្ចប់",
            "change-summary": "សេចក្ដីសង្ខេបការផ្លាស់ប្ដូរ",
            "position-delta": "ភាពខុសគ្នាមុខតំណែង (នៅពេលកត់ត្រា)",
            "routing": "ឯកសារយោងផ្លូវការអនុម័ត",
            "routing-template": "គំរូផ្លូវ (រក្សាទុក មិនប្រតិបត្តិ)",
            "cancel-record": "បោះបង់កំណត់ត្រា",
            "close": "បិទ"
          },
          "chips": {
            "all": "ទាំងអស់",
            "pending": "កំពុងរង់ចាំ",
            "approved": "បានអនុម័ត",
            "effective": "មានសុពលភាព"
          },
          "drawer": {
            "effective": "កាលបរិច្ឆេទមានសុពលភាព",
            "approver": "អ្នកអនុម័ត",
            "detail": "ព័ត៌មានលម្អិត"
          }
        },
        "benefits": {
          "title": "អត្ថប្រយោជន៍",
          "subtitle": "កន្លែងធ្វើការចុះឈ្មោះឆ្លងបុគ្គលិក · បុគ្គលិក {employees} នាក់ · ធាតុកាតាឡុក {entries} · ការគណនាចំណាយប្រចាំខែ",
          "new-benefit": "អត្ថប្រយោជន៍ថ្មី",
          "bulk-enroll": "ចុះឈ្មោះច្រើន",
          "edit-catalog": "កែកាតាឡុក",
          "search-placeholder": "ស្វែងរកតាមអត្ថប្រយោជន៍ អ្នកផ្ដល់ ប្រភេទ…",
          "showing": "បង្ហាញ {filtered} ក្នុងចំណោម {total}",
          "footer-note": "អត្ថប្រយោជន៍ថ្មី បន្ថែមធាតុកាតាឡុកទូទាំងក្រុមហ៊ុន · ចុះឈ្មោះច្រើន ចុះឈ្មោះបុគ្គលិកមានសិទ្ធិច្រើននាក់ក្នុងពេលតែមួយ · ចុចលើខ្មៅដៃនៅជួរណាមួយដើម្បីកែ។ សម្រាប់ការចុះឈ្មោះម្នាក់ៗ សូមទៅ ប្រវត្តិរូប → អត្ថប្រយោជន៍ របស់បុគ្គលិក។",
          "kpi": {
            "active-enrollments": "ការចុះឈ្មោះសកម្ម",
            "employees-enrolled": "បុគ្គលិកបានចុះឈ្មោះ",
            "monthly-cost-employer": "ការចំណាយប្រចាំខែ (និយោជក)",
            "renewing-90": "ត្រូវបន្ត ≤90 ថ្ងៃ",
            "across-all": "គ្រប់អត្ថប្រយោជន៍",
            "coverage": "ការគ្របដណ្ដប់ {pct}%",
            "annualized": "USD {amount} ប្រចាំឆ្នាំ",
            "action-needed": "ត្រូវការសកម្មភាព",
            "all-clear": "គ្មានបញ្ហា"
          },
          "chips": {
            "all": "ទាំងអស់",
            "active": "សកម្ម",
            "renewing": "កំពុងបន្ត",
            "ended": "បានបញ្ចប់"
          },
          "cols": {
            "benefit": "អត្ថប្រយោជន៍",
            "enrolled": "បានចុះឈ្មោះ",
            "eligible": "មានសិទ្ធិ",
            "takeup": "ការទទួលយក",
            "monthly-cost": "ចំណាយប្រចាំខែ",
            "renewal": "ការបន្ត",
            "actions": "សកម្មភាព"
          },
          "kinds": {
            "Insurance": "ធានារ៉ាប់រង",
            "Statutory": "តាមច្បាប់",
            "Wellness": "សុខភាព",
            "Allowance In-kind": "ប្រាក់ឧបត្ថម្ភជាសម្ភារ",
            "Other": "ផ្សេងៗ"
          },
          "statuses": {
            "Active": "សកម្ម",
            "Renewing": "កំពុងបន្ត",
            "Ended": "បានបញ្ចប់"
          },
          "workforce": {
            "Direct": "ផ្ទាល់",
            "Outsourced": "ខាងក្រៅ"
          },
          "eligibility-types": {
            "all": "បុគ្គលិកទាំងអស់",
            "grade": "តាមកម្រិត (អប្បបរមា)",
            "workforce_type": "ប្រភេទកម្លាំងពលកម្ម (ផ្ទាល់ / ខាងក្រៅ)",
            "tenure": "រយៈពេលធ្វើការ (ខែអប្បបរមា)",
            "department": "នាយកដ្ឋានជាក់លាក់"
          },
          "catalog": {
            "new-title": "អត្ថប្រយោជន៍ថ្មី",
            "edit-title": "កែអត្ថប្រយោជន៍",
            "subtitle": "ធាតុកាតាឡុកមេ",
            "kind": "ប្រភេទ",
            "status": "ស្ថានភាព",
            "name": "ឈ្មោះអត្ថប្រយោជន៍",
            "name-ph": "ឧ. Infinity Group Health · Plan A",
            "provider": "អ្នកផ្ដល់",
            "provider-ph": "ឧ. Infinity General Insurance",
            "scheme": "គម្រោង / កម្រិតគ្របដណ្ដប់",
            "scheme-ph": "ឧ. គ្រោះថ្នាក់ + សុខភាព",
            "coverage": "ធាតុគ្របដណ្ដប់ (បំបែកដោយក្បៀស)",
            "coverage-ph": "ឧ. សុខភាព, ការសម្រាកព្យាបាល, OPD",
            "eligibility": "សិទ្ធិ",
            "min-grade": "លេខកម្រិតអប្បបរមា",
            "workforce-type": "ប្រភេទកម្លាំងពលកម្ម",
            "min-months": "ខែអប្បបរមា",
            "department": "នាយកដ្ឋាន",
            "department-ph": "ឧ. លក់",
            "label": "ស្លាក",
            "cost-employee": "ចំណាយ / បុគ្គលិក / ខែ (USD)",
            "cost-family": "ចំណាយ / គ្រួសារ / ខែ (USD)",
            "renewal": "ការបន្តបន្ទាប់",
            "policy-pattern": "លំនាំលេខគោលការណ៍",
            "policy-pattern-opt": "(ស្រេចចិត្ត · ប្រើ {code} ជាកន្លែងដាក់)",
            "policy-pattern-ph": "ឧ. P/01/GPA/24/{code}",
            "create": "បង្កើតអត្ថប្រយោជន៍",
            "save-changes": "រក្សាទុកការផ្លាស់ប្ដូរ",
            "toast-created": "បានបង្កើត {name}",
            "toast-updated": "បានធ្វើបច្ចុប្បន្នភាព {name}"
          },
          "bulk": {
            "title": "ចុះឈ្មោះច្រើនក្នុងអត្ថប្រយោជន៍",
            "step1": "ជំហានទី 1 · ជ្រើសអត្ថប្រយោជន៍ដើម្បីចុះឈ្មោះច្រើន",
            "step1-eyebrow": "ជំហានទី 1 · ជ្រើសអត្ថប្រយោជន៍",
            "step2": "ជំហានទី 2 · ជ្រើសបុគ្គលិកដើម្បីចុះឈ្មោះ",
            "selected-benefit": "អត្ថប្រយោជន៍ដែលបានជ្រើស",
            "selected-count": "បានជ្រើស {count}",
            "currently-enrolled": "បានចុះឈ្មោះ {count} នាក់",
            "eligible-not-enrolled": "{count} មានសិទ្ធិ · មិនទាន់ចុះឈ្មោះ",
            "pick-different": "← ជ្រើសអត្ថប្រយោជន៍ផ្សេង",
            "select-all": "ជ្រើសទាំងអស់",
            "clear": "សម្អាត",
            "all-enrolled": "បុគ្គលិកមានសិទ្ធិទាំងអស់បានចុះឈ្មោះរួចហើយ។",
            "submit": "ចុះឈ្មោះ {count} នាក់",
            "toast": "បានចុះឈ្មោះបុគ្គលិក {count} នាក់ក្នុង {name}"
          },
          "drawer": {
            "provider": "អ្នកផ្ដល់",
            "eligibility": "សិទ្ធិ",
            "cost-per-employee": "តម្លៃក្នុងម្នាក់",
            "renewal": "ការបន្ត",
            "description": "ការពិពណ៌នា"
          },
          "empty": {
            "title": "មិនមានអត្ថប្រយោជន៍ត្រូវនឹងលក្ខខណ្ឌ",
            "lede": "សូមព្យាយាមសម្អាតតម្រង ឬប្ដូរពាក្យស្វែងរក។"
          }
        },
        "compensation": {
          "title": "មជ្ឈមណ្ឌលប្រាក់បំណាច់",
          "subtitle": "សមាសភាគ · កញ្ចប់ · ការផ្តល់ · ព្រឹត្តិការណ៍ · របាយការណ៍ — ទូទាំងកម្លាំងពលកម្ម · ដំណាក់កាលទី១ កត់ត្រាប៉ុណ្ណោះ",
          "tabs": {
            "overview": "ទិដ្ឋភាពទូទៅ",
            "components": "សមាសភាគ",
            "packages": "កញ្ចប់",
            "assignments": "ការផ្តល់",
            "events": "ព្រឹត្តិការណ៍",
            "reports": "របាយការណ៍"
          },
          "phase-banner": {
            "title": "ដំណាក់កាលទី១ · កត់ត្រាប៉ុណ្ណោះ។",
            "body": "ព្រឹត្តិការណ៍ប្រាក់បំណាច់ត្រូវបានរក្សាទុកដោយផ្ទាល់ទៅកាន់កាលប្បវត្តិប្រាក់បំណាច់ និងប្រវត្តិកែតម្រូវប្រាក់ខែតាមកិច្ចសន្យា។ ការអនុម័តធ្វើឡើងក្រៅប្រព័ន្ធ។ ម៉ាស៊ីនលំហូរការងារនឹងមកដល់ក្នុងដំណាក់កាលទី២។"
          },
          "kpi": {
            "active-employees": "បុគ្គលិកសកម្ម",
            "total-monthly-comp": "ប្រាក់បំណាច់សរុបប្រចាំខែ",
            "components": "សមាសភាគ",
            "packages": "កញ្ចប់",
            "salary-adj-ytd": "ការកែប្រាក់ខែ {year}",
            "bonuses-ytd": "ប្រាក់រង្វាន់ {year}",
            "in-scope": "ក្នុងវិសាលភាព",
            "recurring-wide": "កញ្ចប់ដែលកើតឡើងដដែល · ទូទាំងកម្លាំងពលកម្ម",
            "active-catalog": "សកម្មក្នុងបញ្ជី",
            "pkg-breakdown": "ប្រាក់ឧបត្ថម្ភ {allowance} · អត្ថប្រយោជន៍ {benefits}",
            "recorded": "បានកត់ត្រា",
            "total": "សរុប"
          },
          "actions": {
            "manage-components": "គ្រប់គ្រងសមាសភាគ",
            "manage-components-desc": "បន្ថែម ឬកែបញ្ជីសមាសភាគប្រាក់បំណាច់",
            "build-packages": "បង្កើតកញ្ចប់",
            "build-packages-desc": "ផ្គុំសមាសភាគតាមវិសាលភាព",
            "bulk-assign": "ផ្តល់ជាក្រុម",
            "bulk-assign-desc": "តាមនាយកដ្ឋាន + កម្រិត",
            "record-event": "កត់ត្រាព្រឹត្តិការណ៍",
            "record-event-desc": "ប្រាក់ខែ · ប្រាក់រង្វាន់ · ការប្តូរប្រាក់ឧបត្ថម្ភ"
          },
          "top-depts": {
            "title": "នាយកដ្ឋានកំពូលតាមប្រាក់បំណាច់ប្រចាំខែ",
            "view-report": "មើលរបាយការណ៍ពេញ →",
            "empty": "គ្មានទិន្នន័យ។"
          },
          "recent-events": {
            "title": "ព្រឹត្តិការណ៍ថ្មីៗ",
            "view-ledger": "បើកសៀវភៅកត់ត្រាពេញ →",
            "empty": "មិនទាន់មានព្រឹត្តិការណ៍ប្រាក់បំណាច់ត្រូវបានកត់ត្រាទេ។"
          },
          "stub": {
            "lede": "ផ្ទាំងនេះនឹងមកដល់ជាមួយប្រព័ន្ធសំណងដំណាក់កាល B (សមាសភាគ កញ្ចប់ ការផ្ដល់ឲ្យ ព្រឹត្តិការណ៍ និងរបាយការណ៍)។ ឥឡូវសូមប្រើទិដ្ឋភាពទូទៅសម្រាប់រូបភាពទូទាំងបុគ្គលិក។",
            "back": "ត្រឡប់ទៅទិដ្ឋភាពទូទៅ"
          },
          "phase2": "ដំណាក់កាលទី២",
          "filters": {
            "category": "ប្រភេទ",
            "status": "ស្ថានភាព",
            "dept": "នាយកដ្ឋាន",
            "grade": "កម្រិតការងារ",
            "contract": "កិច្ចសន្យា",
            "all": "ទាំងអស់",
            "all-depts": "នាយកដ្ឋានទាំងអស់",
            "all-grades": "កម្រិតទាំងអស់",
            "all-contracts": "កិច្ចសន្យាទាំងអស់"
          },
          "components": {
            "title": "បញ្ជីសមាសភាគប្រាក់បំណាច់",
            "subtitle": "បញ្ជីមេនៃសមាសភាគដែលប្រើនៅទូទាំងកញ្ចប់ និងការផ្តល់តាមបុគ្គលិក។ ការកែនឹងផ្សព្វផ្សាយទៅបុគ្គលិកទាំងអស់ពេលរក្សាទុកបន្ទាប់។",
            "new": "សមាសភាគថ្មី",
            "search-placeholder": "ស្វែងរកតាមកូដ ឬឈ្មោះ…",
            "empty": "គ្មានសមាសភាគត្រូវគ្នា។",
            "status-active": "សកម្ម",
            "status-inactive": "អសកម្ម",
            "cat": {
              "all": "ប្រភេទទាំងអស់",
              "base": "ប្រាក់គោល",
              "allowance": "ប្រាក់ឧបត្ថម្ភ",
              "var": "ប្រាក់អថេរ"
            },
            "status": {
              "active": "សកម្មប៉ុណ្ណោះ",
              "all": "ទាំងអស់",
              "inactive": "អសកម្មប៉ុណ្ណោះ"
            },
            "cols": {
              "code": "កូដ",
              "name": "ឈ្មោះ",
              "category": "ប្រភេទ",
              "recurring": "កើតឡើងដដែល",
              "tax": "ការគិតពន្ធ",
              "nssf": "មូលដ្ឋាន NSSF",
              "funded": "ឧបត្ថម្ភ",
              "status": "ស្ថានភាព"
            },
            "legend": {
              "none": "មិនរាប់បញ្ចូលក្នុងពន្ធ",
              "tos": "កម្រិតរីកចម្រើនតាមក្រុមប្រាក់ខែ (ច្បាប់ការងារកម្ពុជា)",
              "fringe": "ពន្ធអត្ថប្រយោជន៍បន្ថែម ២០% ថេរ"
            }
          },
          "packages": {
            "title": "កញ្ចប់ប្រាក់ឧបត្ថម្ភ និងអត្ថប្រយោជន៍",
            "subtitle": "ផ្គុំសមាសភាគជាកញ្ចប់ដែលប្រើឡើងវិញ តាមប្រភេទកម្លាំងពលកម្ម · អតិថិជន · គម្រោង · កម្រិតការងារ។ ការផ្សព្វផ្សាយ៖ គម្រោង → អតិថិជន → ទូទៅ។ ប្រើដោយលិខិតផ្តល់ការងារ និងការបំពេញមុនពេលបន្ថែមបុគ្គល។",
            "allowance-title": "កញ្ចប់ប្រាក់ឧបត្ថម្ភ",
            "benefits-title": "កញ្ចប់អត្ថប្រយោជន៍",
            "cols": {
              "name": "កញ្ចប់",
              "scope": "វិសាលភាព",
              "components": "សមាសភាគ",
              "monthly": "ប្រចាំខែ",
              "enabled": "បានបើក",
              "items": "ធាតុ",
              "contract": "កិច្ចសន្យា"
            },
            "kpi": {
              "active": "សកម្មក្នុងផ្នែក",
              "direct": "គំរូផ្ទាល់",
              "outsourced": "គំរូក្រៅ",
              "shown": "បង្ហាញក្រោយតម្រង"
            },
            "filters": {
              "workforce": "កម្លាំងពលកម្ម",
              "client": "អតិថិជន",
              "project": "គម្រោង",
              "all-clients": "អតិថិជនទាំងអស់",
              "all-projects": "គម្រោងទាំងអស់"
            },
            "workforce-direct": "ផ្ទាល់តែប៉ុណ្ណោះ",
            "workforce-outsourced": "ក្រៅតែប៉ុណ្ណោះ",
            "show-inactive": "បង្ហាញអសកម្ម",
            "empty": "គ្មានកញ្ចប់ត្រូវនឹងតម្រងបច្ចុប្បន្នទេ។",
            "footnote": "គំរូគ្រាន់តែជាមូលដ្ឋានក្នុងការចេញផ្សាយនេះ — នឹងត្រូវប្រើដោយលំហូរលិខិតស្នើ និងការបំពេញមុនពេលបន្ថែមបុគ្គលនៅក្នុងជំហានបន្ទាប់។ ការបដិសេធតាមការផ្តល់ជូននៅតែមាន។",
            "on": "បើក",
            "off": "បិទ",
            "detail": {
              "scope": "វិសាលភាព",
              "notes": "កំណត់ចំណាំ",
              "line-items": "ធាតុលម្អិត",
              "allowance": "ប្រាក់ឧបត្ថម្ភ",
              "amount": "ចំនួនប្រចាំខែ",
              "total": "សរុបក្នុងមួយខែ"
            }
          },
          "assignments": {
            "title": "ការផ្តល់ប្រាក់បំណាច់បុគ្គលិក",
            "subtitle": "នរណានៅលើកញ្ចប់ណា · សមាសភាគគោល + ប្រាក់ឧបត្ថម្ភក្នុងមួយបុគ្គលិក។ ប្រើ ផ្តល់ជាក្រុម សម្រាប់ការប្តូរជាក្រុម។",
            "bulk": "ផ្តល់ជាក្រុមតាមក្រុម",
            "search-placeholder": "ស្វែងរកឈ្មោះ កូដ ឋានៈ…",
            "showing": "បង្ហាញ {shown} នៃ {total} បុគ្គលិក",
            "empty": "គ្មានបុគ្គលិកត្រូវគ្នា។",
            "cols": {
              "employee": "បុគ្គលិក",
              "title": "ឋានៈ",
              "base": "គោល / ខែ",
              "allowances": "សមាសភាគប្រាក់ឧបត្ថម្ភ",
              "allowance-total": "ប្រាក់ឧបត្ថម្ភ / ខែ",
              "total": "សរុប / ខែ"
            },
            "open-profile": "បើកប្រវត្តិរូប {name}"
          },
          "events": {
            "title": "សៀវភៅកត់ត្រាព្រឹត្តិការណ៍ប្រាក់បំណាច់",
            "subtitle": "ការកែតម្រូវប្រាក់ខែ ប្រាក់រង្វាន់ ការប្តូរប្រាក់អថេរ និងព្រឹត្តិការណ៍ប្រាក់ឧបត្ថម្ភទាំងអស់ដែលបានកត់ត្រាទូទាំងកម្លាំងពលកម្ម។",
            "export": "នាំចេញ CSV",
            "export-soon": "ការនាំចេញឆ្លងបុគ្គលិក — នឹងមកដល់ឆាប់ៗ",
            "record": "កត់ត្រាព្រឹត្តិការណ៍",
            "search-placeholder": "ស្វែងរកបុគ្គលិក ប្រភេទព្រឹត្តិការណ៍ ឬមូលហេតុ…",
            "event-type": "ប្រភេទព្រឹត្តិការណ៍",
            "date-range": "ចន្លោះកាលបរិច្ឆេទ",
            "types": {
              "all": "ប្រភេទព្រឹត្តិការណ៍ទាំងអស់",
              "salary": "ការកែតម្រូវប្រាក់ខែ",
              "bonus": "ប្រាក់រង្វាន់ផ្តល់",
              "varpay": "សិទ្ធិទទួលប្រាក់អថេរ",
              "allowance": "ប្រាក់ឧបត្ថម្ភ (បន្ថែម / ប្តូរ / បញ្ចប់)"
            },
            "ranges": {
              "30": "៣០ ថ្ងៃចុងក្រោយ",
              "90": "៩០ ថ្ងៃចុងក្រោយ",
              "180": "៦ ខែចុងក្រោយ",
              "365": "១២ ខែចុងក្រោយ",
              "all": "គ្រប់ពេលវេលា"
            },
            "ledger-title": "សៀវភៅកត់ត្រាព្រឹត្តិការណ៍ប្រាក់បំណាច់",
            "ledger-count": "{groups} ធាតុ · {filtered} នៃ {total} ព្រឹត្តិការណ៍ (សកម្មភាពជាក្រុមបានដាក់ជាក្រុម)",
            "empty": "គ្មានព្រឹត្តិការណ៍ប្រាក់បំណាច់ត្រូវនឹងតម្រងបច្ចុប្បន្ន។",
            "cols": {
              "effective": "មានសុពលភាព",
              "employee": "បុគ្គលិក",
              "event": "ព្រឹត្តិការណ៍",
              "detail": "ព័ត៌មានលម្អិត",
              "reason": "មូលហេតុ",
              "status": "ស្ថានភាព"
            },
            "effective": "មានសុពលភាព",
            "scheduled": "បានកំណត់ពេល",
            "employees": "បុគ្គលិក",
            "bulk": "ជាក្រុម",
            "same-to": "ចំនួនដូចគ្នាទៅ {count} បុគ្គលិក",
            "show": "បង្ហាញ {count}",
            "hide": "លាក់ {count}",
            "open-profile": "បើកប្រវត្តិរូបបុគ្គលិក"
          },
          "cost-alloc": {
            "title": "ទិដ្ឋភាពទូទៅនៃការបែងចែកចំណាយ",
            "manage": "គ្រប់គ្រង (ដំណាក់កាលទី២)",
            "body": "ការកែការបែងចែកគម្រោងឆ្លងបុគ្គលិកនឹងមកដល់ក្នុងដំណាក់កាលទី២។ ទិដ្ឋភាពអានតែប៉ុណ្ណោះក្នុងមួយបុគ្គលិកមាននៅផ្ទាំងព័ត៌មាន → ប្រាក់បំណាច់។"
          },
          "reports": {
            "title": "របាយការណ៍ប្រាក់បំណាច់",
            "subtitle": "ការវិភាគស្រាលៗទូទាំងកម្លាំងពលកម្ម។",
            "by-component": "តាមសមាសភាគ",
            "by-dept": "តាមនាយកដ្ឋាន",
            "by-grade": "តាមកម្រិតការងារ",
            "top-earners": "អ្នករកចំណូលខ្ពស់",
            "dept-total": "សរុប · {count} នាយកដ្ឋាន",
            "footnote": "របាយការណ៍ដំណាក់កាលទី១ ប្រើកញ្ចប់មានសុពលភាពបច្ចុប្បន្ន។ ក្រាហ្វ ការប្រៀបធៀបតាមកំឡុងពេល និងការនាំចេញ CSV នឹងមកដល់ក្នុងដំណាក់កាលទី២។",
            "cols": {
              "component": "សមាសភាគ",
              "assignments": "ការផ្តល់",
              "monthly-total": "សរុបប្រចាំខែ",
              "distribution": "ការបែងចែក",
              "department": "នាយកដ្ឋាន",
              "headcount": "ចំនួនបុគ្គលិក",
              "base-total": "គោលសរុប",
              "allowances-total": "ប្រាក់ឧបត្ថម្ភសរុប",
              "grade": "កម្រិតការងារ",
              "avg-monthly": "មធ្យមប្រចាំខែ",
              "employee": "បុគ្គលិក",
              "title-dept": "ឋានៈ · នាយកដ្ឋាន",
              "base": "គោល",
              "allowances": "ប្រាក់ឧបត្ថម្ភ",
              "total-monthly": "សរុបប្រចាំខែ"
            }
          },
          "picker": {
            "title": "កត់ត្រាព្រឹត្តិការណ៍ប្រាក់បំណាច់",
            "sub": "ជ្រើសរើសបុគ្គលិកជាមុនសិន · បន្ទាប់មកជ្រើសប្រភេទព្រឹត្តិការណ៍",
            "search": "ស្វែងរក",
            "search-placeholder": "ឈ្មោះ កូដ ឬឋានៈ…",
            "helper": "បង្ហាញ ៣០ លទ្ធផលដំបូង។ កែតម្រូវការស្វែងរកដើម្បីបង្រួម។",
            "empty": "គ្មានបុគ្គលិកត្រូវគ្នា។",
            "toast": "កំពុងបើកប្រាក់បំណាច់សម្រាប់ {name} — ដំណាក់កាលទី២ កត់ត្រាព្រឹត្តិការណ៍។"
          },
          "bulk": {
            "title": "ផ្តល់សមាសភាគប្រាក់បំណាច់ជាក្រុម",
            "sub": "ដំណាក់កាលទី១ កត់ត្រាប៉ុណ្ណោះ · បង្កើតព្រឹត្តិការណ៍ប្រាក់បំណាច់មួយក្នុងមួយបុគ្គលិកត្រូវគ្នា",
            "info-title": "ផ្តល់ជាក្រុមតាមក្រុម។",
            "info-body": "ជ្រើសរើសការផ្សំ នាយកដ្ឋាន + កម្រិត បន្ទាប់មកសមាសភាគ និងចំនួន។ ព្រឹត្តិការណ៍ប្រាក់បំណាច់មួយត្រូវបានកត់ត្រាក្នុងមួយបុគ្គលិកត្រូវគ្នា។ ប្រាក់ខែគោលតាមកិច្ចសន្យាមិនត្រូវបានសរសេរជាន់លើទេ។",
            "matched": "បុគ្គលិកត្រូវគ្នា",
            "will-receive": "បុគ្គលិកនឹងទទួលការផ្តល់នេះ",
            "component": "សមាសភាគ",
            "select-component": "ជ្រើសរើសសមាសភាគប្រាក់ឧបត្ថម្ភ…",
            "component-helper": "មានតែសមាសភាគប្រាក់ឧបត្ថម្ភប៉ុណ្ណោះអាចផ្តល់ជាក្រុមក្នុងដំណាក់កាលទី១។ ការកែប្រាក់ខែត្រូវកត់ត្រាក្នុងមួយបុគ្គលិក។",
            "amount": "ចំនួន (USD)",
            "amount-helper": "ចំនួនដូចគ្នាអនុវត្តចំពោះបុគ្គលិកត្រូវគ្នាគ្រប់រូប។",
            "funded": "ឧបត្ថម្ភដោយ",
            "funded-optimal": "ឧបត្ថម្ភដោយ Optimal",
            "funded-client": "ឧបត្ថម្ភដោយអតិថិជន",
            "effective": "កាលបរិច្ឆេទមានសុពលភាព",
            "reason": "មូលហេតុ",
            "reason-placeholder": "ឧ. ការផ្សព្វផ្សាយប្រាក់ឧបត្ថម្ភទូរស័ព្ទទូទាំងនាយកដ្ឋាន",
            "submit": "កត់ត្រា {count} ព្រឹត្តិការណ៍",
            "toast": "បានកត់ត្រា {count} ព្រឹត្តិការណ៍ប្រាក់បំណាច់ · មើលសៀវភៅកត់ត្រាព្រឹត្តិការណ៍"
          },
          "component": {
            "new-title": "សមាសភាគថ្មី",
            "edit-title": "កែសមាសភាគ — {name}",
            "sub": "សមាសភាគប្រាក់បំណាច់មេ · ផ្សព្វផ្សាយទៅគ្រប់កញ្ចប់ និងការផ្តល់",
            "code": "កូដ",
            "code-helper": "កូដអក្សរធំខ្លី · មិនអាចប្តូរបានពេលក្រោយ។",
            "code-immutable": "កូដមិនអាចផ្លាស់ប្តូរបានពេលបង្កើតរួច។",
            "name-en": "ឈ្មោះ (អង់គ្លេស)",
            "name-km": "ឈ្មោះ (ខ្មែរ)",
            "tax": "ការគិតពន្ធ",
            "flags": "ទង់ផ្សេងទៀត",
            "recurring": "កើតឡើងដដែល (បង់រាល់ដំណាក់កាល)",
            "nssf": "រាប់បញ្ចូលក្នុងមូលដ្ឋាន NSSF",
            "seniority": "រាប់បញ្ចូលក្នុងមូលដ្ឋានអតីតភាព",
            "funding": "ការឧបត្ថម្ភលំនាំដើម",
            "funded-optimal": "ឧបត្ថម្ភដោយ Optimal",
            "funded-client": "ឧបត្ថម្ភដោយអតិថិជន",
            "funded-policy": "តាមគោលនយោបាយ (ក្នុងមួយការផ្តល់)",
            "save": "រក្សាទុកការផ្លាស់ប្តូរ",
            "create": "បង្កើតសមាសភាគ",
            "toast-created": "សមាសភាគ \"{name}\" ត្រូវបានបង្កើត",
            "toast-updated": "សមាសភាគ \"{name}\" ត្រូវបានកែ",
            "tax-help": {
              "none": "មិនរាប់បញ្ចូលក្នុងពន្ធលើប្រាក់បៀវត្ស (TOS) និងពន្ធលើអត្ថប្រយោជន៍បន្ថែម។ ឧ. ប្រាក់ដឹកជញ្ជូន ប្រាក់អាហារក្នុងដែនកំណត់ច្បាប់។",
              "tos": "ពន្ធលើប្រាក់បៀវត្ស · អត្រាកើនលំដាប់តាមច្បាប់ការងារកម្ពុជា។ អនុវត្តចំពោះប្រាក់សាច់ប្រាក់ដែលបង់ដោយផ្ទាល់ទៅបុគ្គលិក (គោល លំនៅឋាន តួនាទី ។ល។)។",
              "fringe": "ពន្ធលើអត្ថប្រយោជន៍បន្ថែម · អត្រាថេរ ២០% លើតម្លៃអត្ថប្រយោជន៍។ អនុវត្តចំពោះអត្ថប្រយោជន៍មិនមែនសាច់ប្រាក់ (រថយន្តក្រុមហ៊ុន លំនៅឋានផ្តល់ដោយនិយោជក ប្រាក់ឧបត្ថម្ភជាសម្ភារៈ ។ល។)។"
            }
          }
        }
      },
      "sites": {
        "subtitle": "ទីតាំងធ្វើការ · ជាកម្មសិទ្ធិក្រុមហ៊ុន និងការដាក់នៅអតិថិជន EOR · ប្រភពតែមួយសម្រាប់កន្លែងបុគ្គលិកធ្វើការ",
        "add-site": "បន្ថែមទីតាំង",
        "search-placeholder": "ឈ្មោះទីតាំង កូដ អាសយដ្ឋាន…",
        "footnote": "បង្ហាញ {shown} ក្នុងចំណោម {total} ទីតាំង · ចុចលើជួរណាមួយដើម្បីមើលព័ត៌មាន · កែ បិទ ឬលុបទីតាំងពីសកម្មភាពជួរ",
        "banner": {
          "title": "ទីតាំង",
          "lead": "— គ្រប់គ្រងទីតាំងធ្វើការដែលប្រើជា Base Location របស់បុគ្គលិក។",
          "detail": "ទីតាំងបង្រួបបង្រួមការិយាល័យក្រុមហ៊ុន និងទីតាំងដាក់នៅអតិថិជន EOR ក្នុងគំរូតែមួយ។ ការិយាល័យកណ្ដាលគឺជា Base Location មេ; ការិយាល័យសាខាបន្ថែមអាចបើក ឬបិទតាមតម្រូវការ។"
        },
        "type": {
          "main": "ការិយាល័យកណ្ដាល",
          "sub": "ការិយាល័យសាខា",
          "unknown": "មិនស្គាល់"
        },
        "filters": {
          "all": "ទាំងអស់",
          "active": "សកម្ម",
          "inactive": "មិនសកម្ម",
          "all-types": "គ្រប់ប្រភេទ",
          "label-type": "ប្រភេទ",
          "label-status": "ស្ថានភាព",
          "label-search": "ស្វែងរក"
        },
        "table": {
          "code": "កូដទីតាំង",
          "name": "ឈ្មោះទីតាំង",
          "type": "ប្រភេទ",
          "owner": "ម្ចាស់ទីតាំង",
          "status": "ស្ថានភាព",
          "enabled": "បើក",
          "actions": "សកម្មភាព",
          "always-on": "បើកជានិច្ច",
          "showing": "បង្ហាញ {filtered} ក្នុងចំណោម {total}",
          "click-hint": "ចុចលើជួរណាមួយដើម្បីបើកព័ត៌មានទីតាំង"
        },
        "actions": {
          "clear-filters": "សម្អាតតម្រង",
          "edit": "កែ {name}",
          "edit-short": "កែ",
          "delete": "លុប {name}",
          "delete-short": "លុប",
          "view-map": "មើល {name} លើផែនទី",
          "view-map-short": "មើលលើផែនទី",
          "toggle": "បើក ឬបិទ {name}"
        },
        "empty": {
          "title": "គ្មានទីតាំងណាមួយផ្គូផ្គងតម្រងបច្ចុប្បន្ន។"
        },
        "error": {
          "title": "មិនអាចផ្ទុកទីតាំងបានទេ។"
        },
        "drawer": {
          "close": "បិទព័ត៌មានទីតាំង",
          "section": {
            "address": "អាសយដ្ឋាន & GPS",
            "roster": "ព័ត៌មានលម្អិត"
          },
          "fields": {
            "gps-lat": "GPS Lat",
            "gps-lon": "GPS Lon",
            "owner": "ម្ចាស់ទីតាំង"
          },
          "no-value": "—"
        },
        "map": {
          "label": "ផែនទីទីតាំង",
          "coordinates": "កូអរដោនេទីតាំង",
          "coordinates-hint": "ចុច ឬអូសម្ជុលលើផែនទី ឬវាយ \"រយៈទទឹង, រយៈបណ្ដោយ\"។"
        },
        "modal": {
          "title": "បង្កើតទីតាំងថ្មី",
          "edit-title": "កែទីតាំង",
          "subtitle": "ទីតាំងធ្វើការដែលប្រើជា Base Location របស់បុគ្គលិក។ វាលដែលមាន * គឺត្រូវការ។",
          "cancel": "បោះបង់",
          "submit": "បង្កើតទីតាំង",
          "update": "ធ្វើបច្ចុប្បន្នភាពទីតាំង",
          "footnote": "ទីតាំងត្រូវការឈ្មោះ និងម្ជុលលើផែនទី (កូអរដោនេ)។",
          "fields": {
            "name": "ឈ្មោះទីតាំង",
            "name-placeholder": "ឧ. ការិយាល័យកណ្ដាល",
            "code": "កូដទីតាំង",
            "code-placeholder": "កូដក្រុមហ៊ុន (ស្រេចចិត្ត)",
            "type": "ប្រភេទ",
            "location": "ទីតាំងលើផែនទី",
            "address": "ព័ត៌មានអាសយដ្ឋាន",
            "address-placeholder": "ផ្លូវ សង្កាត់ ខណ្ឌ",
            "status": "ស្ថានភាព"
          }
        },
        "delete": {
          "title": "លុបទីតាំង?",
          "body": "តើអ្នកប្រាកដថាចង់លុប \"{name}\" មែនទេ? វាមិនអាចមកវិញបានទេ។",
          "confirm": "លុប"
        },
        "disable": {
          "title": "បិទទីតាំង?",
          "body": "តើអ្នកប្រាកដថាចង់បិទ \"{name}\" មែនទេ? បុគ្គលិកលែងអាចប្រើវាជា Base Location រហូតដល់បើកវិញ។",
          "confirm": "បិទ"
        },
        "toasts": {
          "created": "ទីតាំង \"{name}\" បានបង្កើត",
          "updated": "ទីតាំង \"{name}\" បានធ្វើបច្ចុប្បន្នភាព",
          "deleted": "ទីតាំង \"{name}\" បានលុប",
          "enabled": "ទីតាំង \"{name}\" បានបើក",
          "disabled": "ទីតាំង \"{name}\" បានបិទ"
        }
      },
      "workZones": {
        "title": "តំបន់ការងារ",
        "section-aria": "ទីតាំង និងតំបន់ការងារ",
        "add-zone": "បន្ថែមតំបន់",
        "convert-all": "បំប្លែងទាំងអស់",
        "search-placeholder": "ស្វែងរកតំបន់ការងារតាមឈ្មោះ លេខកូដ ឬអាសយដ្ឋាន",
        "no-match": "គ្មានតំបន់ការងារត្រូវនឹង \"{q}\" ទេ។",
        "status": {
          "active": "សកម្ម"
        },
        "table": {
          "location": "ទីតាំង",
          "address": "អាសយដ្ឋាន",
          "employees": "បុគ្គលិក",
          "radius": "កាំ",
          "status": "ស្ថានភាព",
          "actions": "សកម្មភាព",
          "no-value": "—"
        },
        "actions": {
          "edit": "កែតំបន់ការងារ {name}",
          "deactivate": "បិទតំបន់ការងារ {name}",
          "view-employees": "មើលបុគ្គលិកដែលបានកំណត់ទៅ {name}"
        },
        "empty": {
          "title": "មិនទាន់មានតំបន់ការងារ",
          "detail": "បំប្លែងទីតាំងមូលដ្ឋានដែលមានស្រាប់ទៅជាតំបន់ការងារ ដើម្បីចាប់ផ្តើមអនុវត្តព្រំដែនចូល/ចេញ។"
        },
        "error": {
          "title": "មិនអាចផ្ទុកតំបន់ការងារបានទេ។"
        },
        "form": {
          "add-title": "បន្ថែមតំបន់ការងារ",
          "edit-title": "កែតំបន់ការងារ",
          "location": "ទីតាំងការងារ",
          "center-point": "ចំណុចកណ្តាល",
          "no-coords": "ទីតាំងនេះគ្មានកូអរដោនេទេ។ កំណត់វានៅផ្ទាំងទីតាំង មុនពេលកំណត់តំបន់ការងារ។",
          "no-locations": "គ្មានទីតាំងមូលដ្ឋាន។",
          "all-converted": "ទីតាំងមូលដ្ឋានទាំងអស់គឺជាតំបន់ការងារសកម្មរួចហើយ។",
          "radius": "កាំនៃការអនុវត្ត",
          "radius-meters": "កាំនៃការអនុវត្តគិតជាម៉ែត្រ",
          "meters": "ម៉ែត្រ",
          "cancel": "បោះបង់",
          "add": "បន្ថែមតំបន់",
          "save": "រក្សាទុកការផ្លាស់ប្តូរ"
        },
        "employees": {
          "title": "បុគ្គលិកក្នុងតំបន់",
          "subtitle": "{name} · បានកំណត់ {count}",
          "name": "ឈ្មោះពេញ",
          "code": "លេខកូដ",
          "position": "មុខតំណែង",
          "orgUnit": "អង្គភាព",
          "empty": "គ្មានបុគ្គលិកត្រូវបានកំណត់ទៅតំបន់នេះទេ។",
          "close": "បិទ"
        },
        "deactivate": {
          "title": "បិទតំបន់ការងារ",
          "body": "បិទតំបន់ការងារសម្រាប់ \"{name}\"? បុគ្គលិកដែលបានកំណត់ទៅទីតាំងនេះនឹងលែងត្រូវបានដាក់កម្រិតព្រំដែននៅទីនេះទៀតហើយ។ ទីតាំងមូលដ្ឋានខ្លួនវានៅដដែល។",
          "confirm": "បិទ"
        },
        "batch": {
          "convert-all": "បំប្លែងទាំងអស់",
          "cancel": "បោះបង់",
          "dismiss": "បដិសេធ",
          "staleHint": "ការដំណើរការនេះមិនបានរាយការណ៍វឌ្ឍនភាពលើសពី ៥ នាទីទេ — កម្មករទំនងជាបរាជ័យមុនពេលចាប់ផ្តើម។ បោះបង់វាដើម្បីសម្អាតផ្ទាំង ហើយដាក់ស្នើថ្មី។",
          "processed": "{processed} នៃ {total} បានដំណើរការ",
          "succeeded": "{count} បានជោគជ័យ",
          "skipped": "{count} ទីតាំងត្រូវបានរំលងដោយសារខ្វះកូអរដោនេ។",
          "banner": {
            "title": "ការបំប្លែងជាបាច់",
            "queued": "ការបំប្លែងជាបាច់កំពុងរង់ចាំ…",
            "processing": "កំពុងបំប្លែងទីតាំងមូលដ្ឋានទៅជាតំបន់ការងារ…",
            "completed": "ការបំប្លែងជាបាច់បានបញ្ចប់",
            "failed": "ការបំប្លែងជាបាច់បានបរាជ័យ"
          },
          "error": {
            "invokeWorker": "មិនអាចចាប់ផ្តើមកម្មករផ្ទៃខាងក្រោយបានទេ។ សូមព្យាយាមម្តងទៀតក្នុងពេលបន្តិច។",
            "generic": "ប្រតិបត្តិការបានបរាជ័យមុនពេលបញ្ចប់។ សូមពិនិត្យកំណត់ហេតុ។"
          },
          "toast": {
            "completed": "{count} ទីតាំងបានបំប្លែង។",
            "conflict": "មានបាច់កំពុងដំណើរការរួចហើយ។ កំពុងបន្តប្រតិបត្តិការដែលមានស្រាប់។",
            "cancelled": "បាច់ត្រូវបានបោះបង់។ អ្នកអាចដាក់ស្នើប្រតិបត្តិការបាច់ថ្មីឥឡូវនេះ។",
            "submitFailed": "មិនអាចចាប់ផ្តើមការបំប្លែងជាបាច់បានទេ។"
          },
          "dialog": {
            "title": "បំប្លែងទីតាំងមូលដ្ឋានទៅជាតំបន់ការងារ",
            "lead": "រាល់ទីតាំងមូលដ្ឋានសកម្មដែលមានកូអរដោនេត្រឹមត្រូវ ហើយមិនទាន់ជាតំបន់ការងារ នឹងត្រូវបានធ្វើឱ្យសកម្មជាមួយកាំខាងក្រោម។ ទីតាំងដែលខ្វះកូអរដោនេនឹងត្រូវរំលងដោយស្វ័យប្រវត្តិ។",
            "willConvert": "នឹងត្រូវបំប្លែង",
            "missingCoords": "ខ្វះកូអរដោនេ",
            "excluded": "បានដកចេញ",
            "exclude": "ដកទីតាំងជាក់លាក់ចេញ (ស្រេចចិត្ត)",
            "excludeHint": "តំបន់ការងារសកម្មរួចហើយ និងទីតាំងដែលខ្វះកូអរដោនេនឹងត្រូវរំលងដោយស្វ័យប្រវត្តិ។",
            "start": "ចាប់ផ្តើមការបំប្លែង"
          }
        }
      },
      "org-units": {
        "title": "អង្គភាព",
        "subtitle": "ខ្នងរចនាសម្ព័ន្ធរបស់ក្រុមហ៊ុន · រៀបចំតាមស្រទាប់ដែលអាចកំណត់បាន",
        "add-unit": "បន្ថែមអង្គភាព",
        "search-placeholder": "ស្វែងរកតាមឈ្មោះ ឬប្រធាន…",
        "kpi": {
          "total": "អង្គភាពសរុប",
          "with-head": "មានប្រធានចាត់តាំង",
          "vacant-heads": "ប្រធានទំនេរ"
        },
        "filters": {
          "all-types": "ប្រភេទទាំងអស់",
          "all-parents": "មាតាបិតាទាំងអស់",
          "no-parent": "គ្មានមាតាបិតា (កម្រិតកំពូល)"
        },
        "view": {
          "tree": "ដើមឈើ",
          "table": "តារាង"
        },
        "actions": {
          "clear-filters": "សម្អាតតម្រង",
          "define-levels": "កំណត់ស្រទាប់",
          "edit": "កែសម្រួល",
          "delete": "លុប"
        },
        "table": {
          "name": "ឈ្មោះ",
          "parent": "មាតាបិតា",
          "layer": "ស្រទាប់",
          "type": "ប្រភេទ",
          "head": "តំណែងទទួលបន្ទុក",
          "roles": "តួនាទីភ្ជាប់",
          "vacant-head": "ទំនេរ",
          "showing": "បង្ហាញ {filtered} នៃ {total} អង្គភាព",
          "sorted-by": "តម្រៀបតាម {col} {dir}",
          "click-hint": "ចុចលើជួរណាមួយដើម្បីបើកព័ត៌មានលម្អិតអង្គភាព"
        },
        "tree": {
          "showing": "បង្ហាញ {n} អង្គភាពនៅលើ {d} ស្រទាប់",
          "expand-all": "ពង្រីកទាំងអស់",
          "collapse-all": "បង្រួមទាំងអស់",
          "click-hint": "ចុចលើថ្នាំងណាមួយដើម្បីបើកអង្គភាព · ប្រើព្រួញដើម្បីពង្រីក/បង្រួម",
          "no-children": "ស្លឹក"
        },
        "empty": {
          "title": "គ្មានលទ្ធផលដូច",
          "lede": "គ្មានអង្គភាពត្រូវនឹងតម្រងទាំងនេះទេ។ សាកល្បងសម្អាតតម្រងណាមួយដើម្បីពង្រីកការស្វែងរក។"
        },
        "error": {
          "title": "មិនអាចផ្ទុកអង្គភាពបានទេ",
          "desc": "មានបញ្ហាកើតឡើងខណៈផ្ទុកបញ្ជីអង្គភាព។ សូមព្យាយាមម្តងទៀត។"
        },
        "levels-empty": {
          "title": "មិនទាន់បានកំណត់ស្រទាប់ទេ",
          "lede": "កំណត់ស្រទាប់ឋានានុក្រមរបស់ក្រុមហ៊ុន (ឧទាហរណ៍ គ្រប់គ្រង នាយកដ្ឋាន ផ្នែក) មុននឹងបន្ថែមអង្គភាព។",
          "cta": "កំណត់ស្រទាប់"
        },
        "drawer": {
          "fields": {
            "name": "ឈ្មោះ",
            "type": "ប្រភេទ",
            "parent": "មាតាបិតា",
            "ancestor-path": "ផ្លូវដូនតា",
            "head": "តំណែងទទួលបន្ទុក",
            "created": "បានបង្កើត",
            "leadership": "ភាពជាអ្នកដឹកនាំ និងតួនាទី",
            "roles": "តួនាទីភ្ជាប់",
            "child-units": "អង្គភាពរង"
          },
          "no-value": "—",
          "no-children": "មិនទាន់មានអង្គភាពរងទេ។",
          "ancestor-root": "កំពូលក្រុមហ៊ុន"
        },
        "edit-modal": {
          "subtitle-new": "អង្គភាពគឺជាថ្នាំងរចនាសម្ព័ន្ធនៅក្នុងឋានានុក្រមក្រុមហ៊ុន។",
          "title-new": "បន្ថែមអង្គភាព",
          "title-edit": "កែសម្រួល {name}",
          "name-label": "ឈ្មោះ",
          "name-placeholder": "ឧទាហរណ៍ សេវាកម្មអតិថិជន",
          "name-required": "ត្រូវការឈ្មោះ",
          "type-label": "ប្រភេទ",
          "layer-required": "សូមជ្រើសរើសស្រទាប់",
          "parent-label": "អង្គភាពមាតាបិតា",
          "parent-note": "ជ្រើសរើសអង្គភាពស្រទាប់ {n} ជាមាតាបិតា",
          "parent-required": "ត្រូវការអង្គភាពមាតាបិតា",
          "no-levels-note": "មិនទាន់មានការកំណត់ស្រទាប់ទេ។ សូមប្រើ \"កំណត់ស្រទាប់\" សិន រួចបន្ថែមអង្គភាព។",
          "head-label": "តំណែងទទួលបន្ទុក",
          "head-placeholder": "ទំនេរ — មិនទាន់កំណត់តំណែង",
          "info-note": "អ្នកអាចចាត់តាំងតំណែងទទួលបន្ទុកឥឡូវនេះ ឬទុកឱ្យទំនេរ ហើយបំពេញនៅពេលក្រោយ។",
          "cancel": "បោះបង់",
          "create": "បង្កើត",
          "save": "រក្សាទុក",
          "error-save": "មិនអាចរក្សាទុកអង្គភាពបានទេ។ សូមព្យាយាមម្តងទៀត។",
          "error-delete": "មិនអាចលុបអង្គភាពបានទេ។ សូមព្យាយាមម្តងទៀត។",
          "delete": {
            "title": "លុបអង្គភាព",
            "warning": "សកម្មភាពនេះនឹងលុបអង្គភាពជាអចិន្ត្រៃយ៍។ វាមិនអាចត្រឡប់វិញបានទេ។",
            "cannot-children": "មិនអាចលុបបានទេ — អង្គភាពរង {n} ត្រូវផ្លាស់ទី ឬលុបជាមុនសិន។",
            "cannot-roles": "មិនអាចលុបបានទេ — តួនាទី {n} នៅតែភ្ជាប់ជាមួយអង្គភាពនេះ។",
            "reassign": "ដោះស្រាយឧបសគ្គខាងលើ រួចព្យាយាមម្តងទៀត។",
            "confirm": "លុបអង្គភាព"
          }
        },
        "define-levels-modal": {
          "title": "កំណត់ស្រទាប់",
          "subtitle": "រៀបចំស្រទាប់ឋានានុក្រមរបស់ក្រុមហ៊ុន។",
          "layers-question": "ឋានានុក្រមរបស់អ្នកមានប៉ុន្មានស្រទាប់?",
          "layers-label": "ចំនួនស្រទាប់",
          "layers-range": "ជ្រើសរើសពី 1 ដល់ 5 ស្រទាប់",
          "names-question": "កំណត់ឈ្មោះស្រទាប់នីមួយៗ (រហូតដល់ {max})",
          "layer-name-required": "ឈ្មោះស្រទាប់ {n}",
          "layer-name-optional": "ឈ្មោះស្រទាប់ {n} (ស្រេចចិត្ត)",
          "live-preview": "ការមើលជាមុនផ្ទាល់",
          "preview-note": "ការមើលជាមុននេះនឹងធ្វើបច្ចុប្បន្នភាពនៅពេលអ្នកវាយបញ្ចូល — គ្មានអ្វីត្រូវបានរក្សាទុករហូតដល់អ្នកចុចរក្សាទុកទេ។",
          "cancel": "បោះបង់",
          "save": "រក្សាទុក",
          "error-save": "មិនអាចរក្សាទុកការកំណត់ស្រទាប់បានទេ។ សូមព្យាយាមម្តងទៀត។"
        }
      },
      "org-chart": {
        "subtitle": "ការមើលឃើញរចនាសម្ព័ន្ធអង្គភាពរបស់អ្នកដែលមានបុគ្គលិកត្រូវបានចាត់តាំង",
        "export": "នាំចេញ",
        "export-toast": "នាំចេញ PDF គំនូសតាងអង្គភាព — នឹងមកដល់ក្នុងស្រាប់ៗ",
        "edit-lines": "កែបន្ទាត់របាយការណ៍",
        "info-banner": "បង្ហាញឋានានុក្រមបុគ្គលិកដែលបង្កើតពីទំនាក់ទំនងរបាយការណ៍។ ចុចលើថ្នាំងណាមួយដើម្បីផ្តោតលើដើមនោះ។ មុខតំណែងទំនេរលេចឡើងនៅក្រោមអ្នកគ្រប់គ្រងដែលបានដោះស្រាយ។",
        "canvas-title": "គំនូសតាងអង្គភាពនៃ Optimal P",
        "layer-1": "កម្រិត ១",
        "status": {
          "active": "សកម្ម",
          "pending": "កំពុងរង់ចាំ",
          "probation": "ការសាកល្បង",
          "on-leave": "ឈប់សម្រាក",
          "inactive-vacant": "អសកម្ម / ទំនេរ"
        },
        "nav": {
          "title": "ការរុករកតួនាទី",
          "hint": "បិទបើកដើម្បីពង្រីក · ចុចដើម្បីផ្តោត",
          "hide": "លាក់ការរុករក",
          "show": "បង្ហាញការរុករក",
          "short": "រុករក",
          "empty": "គ្មានការផ្គូផ្គង"
        },
        "toolbar": {
          "show-vacancies": "បង្ហាញមុខតំណែងទំនេរ",
          "default-view": "ទិដ្ឋភាពលំនាំដើម (កម្រិត ១+២ មើលឃើញ កម្រិត ៣+ បានដួល)",
          "expand-all": "ពង្រីកសាខាទាំងអស់",
          "collapse-all": "ដួលសាខាទាំងអស់",
          "zoom-out": "ពង្រីកចេញ",
          "zoom-in": "ពង្រីកចូល",
          "zoom-fit": "ដាក់ឱ្យសម ១០០%",
          "export": "នាំចេញ",
          "reset-focus": "កំណត់ការផ្តោតឡើងវិញ",
          "back-to-root": "ត្រឡប់ទៅឫស"
        },
        "search-placeholder": "ស្វែងរកឈ្មោះ ឬតួនាទី…",
        "chart": {
          "focus-reset": "បង្ហាញគំនូសតាងទាំងស្រុង",
          "showing-focused": "កំពុងផ្តោតលើ {name} — បង្ហាញតែបុព្វជន និងកូនចៅប៉ុណ្ណោះ",
          "vacancy-pill": "មុខតំណែងទំនេរ"
        },
        "drawer": {
          "title": "ប្រវត្តិរូបបុគ្គលិក",
          "section-contact": "ទំនាក់ទំនង",
          "section-reporting": "បន្ទាត់របាយការណ៍",
          "section-directs": "របាយការណ៍ផ្ទាល់",
          "section-meta": "ព័ត៌មានអង្គភាព",
          "field-code": "លេខកូដបុគ្គលិក",
          "field-title": "មុខតំណែង",
          "field-dept": "នាយកដ្ឋាន",
          "field-manager": "របាយការណ៍ទៅ",
          "field-email": "អ៊ីមែល",
          "field-phone": "ទូរស័ព្ទ",
          "field-join": "ចូលបម្រើការ",
          "field-type": "ប្រភេទការងារ",
          "field-breadcrumb": "ច្រកអង្គភាព",
          "no-directs": "គ្មានរបាយការណ៍ផ្ទាល់",
          "no-manager": "កំពូលក្រុមហ៊ុន — គ្មានអ្នកគ្រប់គ្រង",
          "directs-more": "+{count} ផ្សេងទៀត"
        },
        "edit-modal": {
          "title": "កែបន្ទាត់របាយការណ៍",
          "lede": "ផ្តល់អ្នកគ្រប់គ្រងថ្មីដល់បុគ្គលិក។ ការបញ្ជូននឹងបង្ហាញ toast — ខាងម៉ាស៊ីនមេពិតនឹងភ្ជាប់នៅក្នុងស្រាប់បន្ត។",
          "employee-label": "បុគ្គលិក",
          "manager-label": "អ្នកគ្រប់គ្រងថ្មី",
          "employee-placeholder": "ជ្រើសរើសបុគ្គលិក…",
          "manager-placeholder": "ជ្រើសរើសអ្នកគ្រប់គ្រង…",
          "submit": "រក្សាទុកបន្ទាត់របាយការណ៍",
          "cancel": "បោះបង់",
          "toast": "បន្ទាត់របាយការណ៍សម្រាប់ {employee} ត្រូវបានកែប្រែទៅរាយការណ៍ទៅ {manager}"
        },
        "empty": {
          "title": "មិនទាន់មានបុគ្គលិកនៅក្នុងគំនូសតាងអង្គភាព"
        }
      },
      "workforce-plan": {
        "title": "ផែនការកម្លាំងពលកម្ម",
        "subtitle": "មុខតំណែងបើកចំនួន {open} · ចុច Fill ដើម្បីចាប់ផ្ដើមកម្មវិធីបន្ថែមបុគ្គលិក",
        "banner": "<b>ការជ្រើសរើសផ្អែកលើមុខតំណែង។</b> មុខតំណែងនីមួយៗគឺជាកៅអីតែមួយគត់។ មុខតំណែងដែលមានចំណងជើងការងារដូចគ្នាត្រូវបានដាក់ជាក្រុម — ចុចលើក្រុមណាមួយដើម្បីពង្រីក។ ការបង្កើតក្រៅផែនការត្រូវបានកត់ត្រាសវនកម្ម។",
        "kpi": {
          "open-positions": "មុខតំណែងបើក",
          "high-priority": "អាទិភាពខ្ពស់",
          "filled-total": "បំពេញសរុប",
          "off-plan": "ការលើកលែងក្រៅផែនការ"
        },
        "budget": {
          "summary": "ថវិកាចំនួនបុគ្គលិកអង្គភាព ({count} អង្គភាព)",
          "table": {
            "org-unit": "អង្គភាព",
            "filled": "បំពេញ",
            "open": "បើក",
            "total": "សរុប",
            "hc-budget": "ថវិកា HC",
            "status": "ស្ថានភាព"
          },
          "status": {
            "over-by": "លើស {n}",
            "at-cap": "ដល់កំណត់",
            "headroom": "នៅសល់ {n}"
          }
        },
        "table": {
          "showing": "បង្ហាញក្រុមចំណងជើងការងារ <b>{groups}</b> {label} · មុខតំណែងបើកសរុប <b>{open}</b>",
          "groups-one": "ក្រុម",
          "groups-many": "ក្រុម",
          "hint": "ដាក់ជាក្រុមតាមចំណងជើងការងារ · ចុចដើម្បីពង្រីក"
        },
        "group": {
          "summary-filled": "បំពេញ {filled}",
          "summary-open": "បើក {open}",
          "summary-high": "ខ្ពស់ {high}",
          "summary-specifiers": "សញ្ញាបញ្ជាក់: {names}",
          "bulk-fill": "បំពេញច្រើន",
          "bulk-fill-title": "បើកកម្មវិធីបន្ថែមបុគ្គលិកសម្រាប់មុខតំណែងទំនេរទីមួយក្នុងក្រុមនេះ"
        },
        "row": {
          "off-plan": "ក្រៅផែនការ",
          "optimal-internal": "ផ្ទៃក្នុង Optimal",
          "days-suffix": "({days}ថ្ងៃ)",
          "fill": "បំពេញ"
        },
        "priority": {
          "low": "ទាប",
          "medium": "មធ្យម",
          "high": "ខ្ពស់",
          "urgent": "បន្ទាន់"
        },
        "empty": {
          "title": "មុខតំណែងទាំងអស់បានបំពេញ",
          "lede": "មិនមានកៅអីបើកនៅពេលនេះទេ។ ប្រើ <b>មុខតំណែងថ្មី</b> ខាងលើដើម្បីគ្រោងទុក។"
        },
        "recently-filled": {
          "summary": "បានបំពេញថ្មីៗ ({count})",
          "table": {
            "position": "មុខតំណែង",
            "job-title": "ចំណងជើងការងារ",
            "filled-by": "បំពេញដោយ",
            "filled-on": "បំពេញនៅ"
          }
        },
        "actions": {
          "new-position": "មុខតំណែងថ្មី",
          "fill-toast": "កម្មវិធីបន្ថែមបុគ្គលិកបានជ្រើសរើសសម្រាប់ {code} — នឹងមកដល់ក្នុងពេលឆាប់ៗ",
          "bulk-fill-toast": "បំពេញច្រើនសម្រាប់ {group} — នឹងមកដល់ក្នុងពេលឆាប់ៗ",
          "created-toast": "បានបង្កើតមុខតំណែង · {title}"
        },
        "drawer": {
          "title": "ព័ត៌មានលម្អិតមុខតំណែង",
          "fields": {
            "code": "កូដមុខតំណែង",
            "title": "ចំណងជើងការងារ",
            "grade": "ថ្នាក់",
            "dept": "នាយកដ្ឋាន",
            "org-unit": "អង្គភាព",
            "approver": "អ្នកអនុម័ត",
            "hiring-manager": "អ្នកគ្រប់គ្រងជ្រើសរើស",
            "created": "បានបង្កើត",
            "target-start": "ថ្ងៃចាប់ផ្ដើមគោលដៅ",
            "candidates": "បេក្ខជន",
            "timeline": "ពេលវេលាស្ថានភាព",
            "budget": "ថវិកា",
            "activity": "សកម្មភាព",
            "project": "គម្រោង",
            "filled-by": "បំពេញដោយ",
            "filled-on": "បំពេញនៅ"
          },
          "no-value": "—",
          "budget-line": "{amount} USD",
          "close": "បិទ"
        },
        "modal": {
          "title": "បង្កើតមុខតំណែង",
          "lede": "មុខតំណែងបម្រុងកៅអីដែលបានអនុម័តសម្រាប់ការជ្រើសរើសដែលបានគ្រោងទុក។",
          "fields": {
            "title": "ចំណងជើង",
            "grade": "ថ្នាក់",
            "dept": "នាយកដ្ឋាន",
            "org-unit": "អង្គភាព",
            "headcount": "ចំនួនបុគ្គលិក",
            "justification": "ហេតុផល",
            "budget": "ថវិកាប្រចាំឆ្នាំ (USD)"
          },
          "placeholders": {
            "title": "ឧ. វិស្វករផ្នែកខាងក្រោយជាន់ខ្ពស់",
            "dept": "ឧ. វិស្វកម្ម",
            "org-unit": "ឧ. OU-ENG-PLATFORM",
            "headcount": "1",
            "justification": "ហេតុអ្វីត្រូវការកៅអីនេះឥឡូវនេះ? ឯកសារយោងផែនការ…",
            "budget": "0"
          },
          "validation": {
            "title-required": "ត្រូវការចំណងជើង",
            "dept-required": "ត្រូវការនាយកដ្ឋាន",
            "org-unit-required": "ត្រូវការអង្គភាព",
            "headcount-positive": "ចំនួនបុគ្គលិកត្រូវតែជាចំនួនវិជ្ជមាន",
            "budget-non-negative": "ថវិកាមិនអាចតិចជាង 0 ទេ"
          },
          "cancel": "បោះបង់",
          "submit": "បង្កើត"
        }
      },
      "positions": {
        "title": "មុខតំណែង",
        "subtitle": "បញ្ជីមេនៃកៅអីដែលបានអនុម័តទាំងអស់ — បើក បំពេញ កក ក្រៅផែនការ",
        "add-position": "មុខតំណែងថ្មី",
        "banner": {
          "body": "{position} គឺជាកៅអីតែមួយគត់ (ឧ. P0150 = ទីតាំង Plant Operator ទី១នៅ Acme Line A)។ {jobTitle} គឺជាគំរូតួនាទីដែលអាចត្រូវបានយោងដោយ Position ច្រើន។ Job Title មួយ → Position ច្រើន; Position មួយ → បុគ្គលិកមិនលើសពីម្នាក់ទេ។",
          "position-term": "មុខតំណែង",
          "job-title-term": "ចំណងជើងការងារ"
        },
        "actions": {
          "new-position": "មុខតំណែងថ្មី",
          "clear-filters": "សម្អាតតម្រង",
          "edit-toast": "កែសម្រួលមុខតំណែង {id} — នឹងមកដល់ក្នុងស្រាប់ៗ"
        },
        "kpi": {
          "all-positions": "មុខតំណែងទាំងអស់",
          "open-vacant": "បើក (ទំនេរ)",
          "filled": "បានបំពេញ",
          "off-plan": "ក្រៅផែនការ"
        },
        "chips": {
          "all": "ទាំងអស់",
          "open": "បើក",
          "filled": "បានបំពេញ",
          "frozen": "កក",
          "offplan": "ក្រៅផែនការ",
          "cancelled": "បានបោះបង់"
        },
        "filters": {
          "all-job-titles": "ចំណងជើងការងារទាំងអស់",
          "all-org-units": "អង្គភាពទាំងអស់",
          "all-projects": "គម្រោងទាំងអស់",
          "optimal-internal": "ផ្ទៃក្នុង Optimal"
        },
        "toggles": {
          "group-by-job-title": "ដាក់ជាក្រុមតាមចំណងជើងការងារ",
          "show-cancelled": "បង្ហាញដែលបានបោះបង់"
        },
        "priority": {
          "high": "ខ្ពស់",
          "medium": "មធ្យម",
          "low": "ទាប"
        },
        "search-placeholder": "ស្វែងរកតាម P-ID ចំណងជើង បុគ្គលិក…",
        "row": {
          "off-plan": "ក្រៅផែនការ",
          "edit-action": "កែសម្រួលមុខតំណែង"
        },
        "table": {
          "showing": "បង្ហាញ {filtered} នៃ {total} មុខតំណែង",
          "click-hint": "ចុចលើជួរណាមួយដើម្បីបើកព័ត៌មានលម្អិតមុខតំណែង",
          "group-summary": "{count} មុខតំណែង · {filled} បានបំពេញ · {open} បើក",
          "position-id": "លេខសម្គាល់មុខតំណែង",
          "job-title": "ចំណងជើងការងារ",
          "org-unit": "អង្គភាព",
          "specifiers": "តម្រូវការ",
          "project": "គម្រោង",
          "grade": "ថ្នាក់",
          "status": "ស្ថានភាព",
          "filled-by": "បំពេញដោយ",
          "open-since": "បើកតាំងពី",
          "edit": "កែសម្រួល"
        },
        "empty": {
          "title": "គ្មានមុខតំណែងណាត្រូវនឹងតម្រងទាំងនេះ",
          "lede": "សាកល្បងសម្អាតតម្រងមួយឬច្រើនដើម្បីពង្រីកការស្វែងរក។"
        },
        "drawer": {
          "fields": {
            "job-title": "ចំណងជើងការងារ",
            "org-unit": "អង្គភាព",
            "project": "គម្រោង",
            "open-since": "បើកតាំងពី",
            "specifiers": "តម្រូវការ",
            "filled-by": "បំពេញដោយ"
          },
          "no-value": "—",
          "foot-note": "សកម្មភាពកែសម្រួល បំពេញ ឬកក នឹងមកដល់ក្នុងស្រាប់ៗ — តារាងនេះគឺជាការមើលត្រឹមតែប៉ុណ្ណោះសម្រាប់ពេលនេះ។"
        },
        "modal": {
          "title": "មុខតំណែងថ្មី",
          "lede": "មុខតំណែងគឺជាកៅអីតែមួយគត់ — ឈ្មោះរបស់វាមកពី Job Title + តម្រូវការ (មិនចាំបាច់សរសេរឈ្មោះដោយដៃ)។",
          "fields": {
            "job-title": "ចំណងជើងការងារ",
            "org-unit": "អង្គភាព",
            "project": "គម្រោង",
            "priority": "អាទិភាព"
          },
          "placeholders": {
            "job-title": "ជ្រើសរើស Job Title…",
            "org-unit": "ឧ. ប្រតិបត្តិការ"
          },
          "validation": {
            "job-title-required": "ត្រូវការ Job Title",
            "org-unit-required": "ត្រូវការអង្គភាព"
          },
          "cancel": "បោះបង់",
          "submit": "បង្កើតមុខតំណែង",
          "created-toast": "បានបង្កើតមុខតំណែង · {id}"
        }
      },
      "onboarding": {
        "title": "ការចូលបំពេញការងារ",
        "subtitle": "តាមដានភាពត្រៀមលក្ខណៈពីការផ្ដល់ការងារដែលបានទទួលយករហូតដល់ការបញ្ចប់សាកល្បង — សម្ភារៈ · ឯកសារ · ប្រព័ន្ធ · ប្រាក់ខែ · អ្នកគ្រប់គ្រង · សាកល្បង។",
        "add-person": "បន្ថែមបុគ្គលិក",
        "add-toast": "កម្មវិធីបន្ថែមបុគ្គលិក — នឹងមកដល់ក្នុងស្រាប់ៗ",
        "actions": {
          "start-onboarding": "ចាប់ផ្ដើមការចូលបំពេញការងារ",
          "clear-filters": "សម្អាតការត្រងទាំងអស់",
          "view": "មើល"
        },
        "banner": {
          "title": "ដំណាក់កាល ១ · កត់ត្រាតែប៉ុណ្ណោះ។",
          "body": "ការចូលបំពេញការងារតាមដានភាពត្រៀមលក្ខណៈ — ការអនុម័តកើតឡើងក្រៅប្រព័ន្ធ។ ការអនុវត្តកិច្ចការ ការជូនដំណឹង និងសមាហរណកម្ម ដំណើរការនៅក្នុងម៉ូឌុលម្ចាស់ (សូមមើលឆ្នូតភ្ជាប់)។ ដំណាក់កាល ២ បន្ថែមការងារដោយស្វ័យប្រវត្តិ។"
        },
        "kpi": {
          "new-hires": "បុគ្គលិកថ្មី (៣០ ថ្ងៃ)",
          "pending-docs": "ឯកសារកំពុងរង់ចាំ",
          "in-probation": "ស្ថិតក្នុងសាកល្បង",
          "probation-due": "ការវាយតម្លៃសាកល្បងដល់ពេល",
          "new-joiners": "បុគ្គលិកថ្មី",
          "preboarding": "មុនចូលធ្វើការ",
          "day1": "ត្រៀមថ្ងៃទី១",
          "probation-window": "ដំណាក់កាលសាកល្បង",
          "attention": "ត្រូវការការយកចិត្តទុកដាក់",
          "open-view": "បើកទិដ្ឋភាពនេះ →"
        },
        "sub-tabs": {
          "dashboard": "ផ្ទាំងព័ត៌មាន",
          "new-joiners": "បុគ្គលិកថ្មី",
          "preboarding": "មុនចូលធ្វើការ",
          "day1": "ការត្រៀមថ្ងៃទី១",
          "probation": "សាកល្បង",
          "templates": "ទំរង់គំរូ",
          "reports": "របាយការណ៍"
        },
        "dispatch": {
          "title": "ចាប់ផ្ដើមការចូលបំពេញការងារ",
          "lede": "ជ្រើសរើសបុគ្គលិកដែលអ្នកចង់ចាប់ផ្ដើមការចូលបំពេញការងារ។",
          "form-title": "ការកំណត់ការចូលបំពេញការងារ",
          "form-lede": "បញ្ជាក់ទំរង់ ម្ចាស់រឿង និងកាលបរិច្ឆេទចាប់ផ្ដើម — ការតាមដានភាពត្រៀមលក្ខណៈនឹងចាប់ផ្ដើមភ្លាមៗ។",
          "empty": "មិនមានបុគ្គលិកសមរម្យ។ សូមបង្កើតបុគ្គលិកជាមុនដោយប្រើ បន្ថែមបុគ្គលិក។",
          "fields": {
            "template": "ទំរង់គំរូ",
            "owner": "ម្ចាស់រឿងដែលបានកំណត់",
            "start-date": "កាលបរិច្ឆេទចាប់ផ្ដើម"
          },
          "placeholders": {
            "template": "ជ្រើសរើសទំរង់គំរូ…",
            "owner": "ឧ. សុគន្ធា ប៉ែន"
          },
          "errors": {
            "no-joiner": "ជ្រើសរើសបុគ្គលិកជាមុនសិន",
            "template-required": "ត្រូវការទំរង់គំរូ",
            "owner-required": "ត្រូវការម្ចាស់រឿង",
            "start-date-required": "ត្រូវការកាលបរិច្ឆេទចាប់ផ្ដើម"
          },
          "cancel": "បោះបង់",
          "back": "ត្រឡប់",
          "submit": "ចាប់ផ្ដើម",
          "created-toast": "បានចាប់ផ្ដើមការចូលបំពេញការងារ · {employee}"
        },
        "dashboard": {
          "toolbar": {
            "title": "ផ្ទាំងព័ត៌មានភាពត្រៀមលក្ខណៈ",
            "lede": "តាមដានភាពត្រៀមលក្ខណៈចាប់ពីការទទួលយកសំណើរការងាររហូតដល់ការបញ្ចប់សាកល្បង — រូបរាង · ឯកសារ · ការចូលប្រព័ន្ធ · ប្រាក់ខែ · អ្នកគ្រប់គ្រង/ក្រុម · សាកល្បង។"
          },
          "kpi": {
            "open-view": "បើកទិដ្ឋភាពនេះ →"
          },
          "stages": {
            "draft": "ការផ្ដល់ការងារទទួលយក",
            "preboarding": "មុនចូលធ្វើការ",
            "day1": "ការធ្វើឱ្យសកម្មថ្ងៃទី១",
            "active": "ការតម្រង់ទិស",
            "probation": "សាកល្បង",
            "completed": "បានបញ្ចប់"
          },
          "journey": {
            "title": "ដំណើរការការចូលបំពេញការងារ"
          },
          "current": {
            "title": "ការចូលបំពេញការងារបច្ចុប្បន្ន",
            "empty": "មិនមានការចូលបំពេញការងារសកម្ម។ បន្ថែមបុគ្គលិកពីផ្ទាំងបុគ្គលិកថ្មី។"
          },
          "card": {
            "ready": "ត្រៀម {pct}%",
            "starts-in": "ក្នុងរយៈពេល {days} ថ្ងៃ",
            "starts-today": "ថ្ងៃនេះ",
            "started-ago": "កាលពី {days} ថ្ងៃមុន"
          },
          "attention": {
            "title": "ត្រូវការការយកចិត្តទុកដាក់",
            "empty": "អ្វីៗគ្រប់យ៉ាងល្អ — មិនមានបញ្ហារាំងស្ទះភាពត្រៀមលក្ខណៈទេឥឡូវនេះ។"
          },
          "flags": {
            "contract": "កិច្ចសន្យាមិនទាន់ហត្ថលេខា",
            "bank": "ខ្វះគណនីធនាគារ",
            "laptop": "ឡែបថបមិនបានកំណត់",
            "ess": "មិនបានផ្ញើការអញ្ជើញ ESS",
            "payroll": "ការដំឡើងប្រាក់បៀវត្សរ៍កំពុងរង់ចាំ",
            "probation": "ការវាយតម្លៃសាកល្បងដល់ពេល"
          },
          "owners": {
            "title": "កម្មសិទ្ធិម៉ូឌុល — ការចូលបំពេញការងារតាមដានភាពត្រៀមលក្ខណៈ; ការអនុវត្តកើតឡើងក្នុងម៉ូឌុលម្ចាស់",
            "people": "ប្រភពនៃការពិត",
            "contract": "កំណត់ត្រាកិច្ចព្រមព្រៀងការងារ",
            "work": "ការអនុវត្តកិច្ចការ",
            "docs": "កន្លែងស្ដារទុកឯកសារ",
            "asset": "ទ្រព្យសម្បត្តិក្រុមហ៊ុនបានចេញ",
            "hrops": "ការដំឡើងកាលវិភាគ / វត្តមាន",
            "payroll": "ភាពត្រៀមនៃប្រាក់បៀវត្សរ៍",
            "perf": "ការវាយតម្លៃសាកល្បង / ការពិនិត្យ",
            "people-name": "ប្រវត្តិរូបបុគ្គលិក",
            "contract-name": "កិច្ចសន្យា",
            "work-name": "គ្រប់គ្រងការងារ",
            "docs-name": "ឯកសារ",
            "asset-name": "ទ្រព្យសម្បត្តិ",
            "hrops-name": "ប្រតិបត្តិការ HR",
            "payroll-name": "ប្រាក់បៀវត្សរ៍",
            "perf-name": "ប្រសិទ្ធភាព"
          }
        },
        "new-joiners": {
          "toolbar": {
            "title": "បុគ្គលិកថ្មី",
            "lede": "មានតែផ្ទាំងនេះប៉ុណ្ណោះដែលចាប់ផ្ដើមការចូលបំពេញការងារ។ ប្រើ <strong>+ បន្ថែមបុគ្គលិក</strong> ប្រសិនបើប្រវត្តិរូបបុគ្គលិកមិនទាន់មាន។"
          },
          "fresh": {
            "title": "បុគ្គលិកថ្មី",
            "lede": "កិច្ចសន្យាបានហត្ថលេខា · មិនទាន់ចាប់ផ្ដើមធ្វើការ · ការចូលបំពេញការងារមិនទាន់ចាប់ផ្ដើម",
            "empty": "មិនមាននរណាក្នុងក្រុមនេះទេឥឡូវនេះ។"
          },
          "catchup": {
            "title": "ការចូលបំពេញការងារចាប់តាមក្រោយ",
            "lede": "បុគ្គលិកសកម្ម ឬបានធ្វើចំណាកស្រុក · នៅក្នុងសាកល្បង · ការចូលបំពេញការងារខ្វះ",
            "empty": "មិនមាននរណាក្នុងក្រុមនេះទេឥឡូវនេះ។"
          },
          "start": "ចាប់ផ្ដើម",
          "cols": {
            "joined": "ចាប់ផ្ដើម / ចូលធ្វើការ",
            "probation-end": "ការបញ្ចប់សាកល្បង",
            "contract": "កិច្ចសន្យា",
            "reason": "មូលហេតុ"
          },
          "drawer": {
            "title": "តួនាទី",
            "dept": "នាយកដ្ឋាន",
            "joined": "កាលបរិច្ឆេទចាប់ផ្ដើម",
            "contract": "ប្រភេទកិច្ចសន្យា",
            "client": "អតិថិជន / គម្រោង",
            "reason": "មូលហេតុ"
          }
        },
        "preboarding": {
          "toolbar": {
            "title": "មុនចូលធ្វើការ",
            "lede": "អ្វីៗដែលត្រូវត្រៀម <strong>មុន</strong> ថ្ងៃទី១ — ម៉ាទ្រីសភាពត្រៀមលក្ខណៈតាមក្រុម។ ចុចលើជួរណាមួយដើម្បីបើកបញ្ជី checklist ពេញលេញ។"
          },
          "cols": {
            "employee": "បុគ្គលិក",
            "start": "ចាប់ផ្ដើម",
            "profile": "ប្រវត្តិរូប",
            "contract": "កិច្ចសន្យា",
            "physical": "រូបរាង",
            "system": "ប្រព័ន្ធ",
            "payroll": "ប្រាក់ខែ",
            "manager": "អ្នកគ្រប់គ្រង",
            "probation": "សាកល្បង",
            "overall": "សរុប"
          },
          "empty": {
            "title": "មិនមាននរណាស្ថិតក្នុងមុនចូលធ្វើការទេ។"
          },
          "drawer": {
            "role": "តួនាទី",
            "dept": "នាយកដ្ឋាន",
            "start": "កាលបរិច្ឆេទចាប់ផ្ដើម",
            "progress": "វឌ្ឍនភាព",
            "owner": "ម្ចាស់រឿងដែលបានកំណត់",
            "probation-end": "ការបញ្ចប់សាកល្បង",
            "notes": "កំណត់ចំណាំ"
          }
        },
        "day1": {
          "search-placeholder": "ស្វែងរកកំណត់ត្រាថ្ងៃទី១…",
          "chips": {
            "all": "ទាំងអស់",
            "ready": "ត្រៀម",
            "not-ready": "មិនទាន់ត្រៀម",
            "activated": "បានធ្វើឱ្យសកម្ម"
          },
          "cols": {
            "employee": "បុគ្គលិក",
            "role": "តួនាទី",
            "start": "ចាប់ផ្ដើម",
            "gates": "ច្រកផ្លូវ",
            "owner": "ម្ចាស់រឿង",
            "status": "ស្ថានភាព"
          },
          "gates": {
            "contract": "កិច្ចសន្យាបានហត្ថលេខា និងបានរក្សាទុក",
            "physical": "កន្លែងធ្វើការ · បរិក្ខារ · ប័ណ្ណចូល",
            "system": "ESS · អ៊ីមែល · វត្តមាន · កាលវិភាគ",
            "manager": "អ្នកគ្រប់គ្រង · មិត្តរួមការងារ · ផែនការថ្ងៃទី១"
          },
          "showing": "បង្ហាញ {filtered} ក្នុងចំណោម {total} កំណត់ត្រា",
          "empty": {
            "title": "គ្មាន​បេក្ខជន​ថ្ងៃ​ទី​១​នៅ​ឡើយ​ទេ — បន្ថែម​បុគ្គលិក​ថ្មី​ពី​ផ្ទាំង New Joiners។",
            "lede": "សម្អាតការត្រងសកម្ម ឬពង្រីកការស្វែងរករបស់អ្នក។"
          },
          "drawer": {
            "gates-title": "ច្រកផ្លូវថ្ងៃទី១",
            "start": "កាលបរិច្ឆេទចាប់ផ្ដើម",
            "owner": "ម្ចាស់រឿង",
            "notes": "កំណត់ចំណាំ"
          },
          "starts": "ចាប់ផ្តើម",
          "toolbar": {
            "title": "ការ​ត្រៀម​ថ្ងៃ​ទី​១",
            "lede": "បេក្ខជន​ដែល​ខិត​ជិត​ថ្ងៃ​ទី​១ — បង្ហាញ​ច្រក​ត្រៀម​លក្ខណៈ​៤​បូក​ប៊ូតុង​សកម្ម។"
          },
          "status": {
            "ready": "រួច​ហើយ",
            "not-ready": "មិន​ទាន់​រួច"
          },
          "activate": "សកម្ម · ថ្ងៃ​ទី​១​បាន​បញ្ចប់"
        },
        "probation": {
          "search-placeholder": "ស្វែងរកកំណត់ត្រាសាកល្បង…",
          "chips": {
            "all": "ទាំងអស់",
            "in-probation": "ក្នុងសាកល្បង",
            "due-soon": "ដល់ពេល ≤១៤ថ្ងៃ",
            "confirmed": "បានបញ្ជាក់"
          },
          "cols": {
            "employee": "បុគ្គលិក",
            "role": "តួនាទី",
            "start": "ចាប់ផ្ដើម",
            "probation-end": "បញ្ចប់សាកល្បង",
            "days-left": "ថ្ងៃនៅសល់",
            "owner": "ម្ចាស់រឿង",
            "status": "ស្ថានភាព",
            "role-client": "តួនាទី · អតិថិជន",
            "case": "ករណី",
            "days": "ថ្ងៃ",
            "cycle-stage": "ដំណាក់កាល",
            "lm-recommendation": "យោបល់ LM",
            "lm-recommendation-tooltip": "យោបល់របស់អ្នកគ្រប់គ្រងបន្ទាត់ពីការត្រួតពិនិត្យ — ស្ថានភាពតែប៉ុណ្ណោះ",
            "action": "សកម្មភាព"
          },
          "showing": "បង្ហាញ {filtered} ក្នុងចំណោម {total} កំណត់ត្រា",
          "empty": {
            "title": "មិនមានកំណត់ត្រាសាកល្បង",
            "lede": "សម្អាតការត្រងសកម្ម ឬពង្រីកការស្វែងរករបស់អ្នក។"
          },
          "drawer": {
            "role": "តួនាទី",
            "dept": "នាយកដ្ឋាន",
            "start": "កាលបរិច្ឆេទចាប់ផ្ដើម",
            "probation-end": "ការបញ្ចប់សាកល្បង",
            "owner": "ម្ចាស់រឿង",
            "confirmed": "បានបញ្ជាក់",
            "yes": "បាទ/ចាស",
            "no": "ទេ",
            "notes": "កំណត់ចំណាំ",
            "client": "អតិថិជន"
          },
          "toolbar": {
            "title": "ការត្រួតពិនិត្យ និងបញ្ជាក់សាកល្បង",
            "lede": "ការត្រួតពិនិត្យ LM → ការទទួលស្គាល់ពីបុគ្គលិក → ការបញ្ជាក់ HR។ ការផ្ទេរ​ដោយ​ស្វ័យ​ប្រវត្តិ​សម្រាប់​ការ​ឆ្លងផុត; HR បញ្ចប់​ព្រឹត្តិការណ៍​កិច្ច​សន្យា (ករណី A កិច្ចសន្យាថ្មី · ករណី B បញ្ជាក់ + កែប្រែ​ប្រាក់ខែ​ប្រសិន​ប្រែប្រួល)។"
          },
          "banner": {
            "title": "ច្បាប់​សាកល្បង​កម្ពុជា (ER-1)។",
            "body": "ករណី A (កិច្ចសន្យាសាកល្បងដាច់ដោយឡែក) → ឆ្លងផុត = ការផ្លាស់ប្តូរកិច្ចសន្យា (UDC/FDC ថ្មី)។ ករណី B (UDC/FDC រួមមាន​ឃ្លាសាកល្បង) → ឆ្លងផុត = ការបញ្ជាក់​សាកល្បង + កែ​ប្រាក់​ខែ​បើ​ប្តូរ។ ការបញ្ចប់​តម្រូវ​ឱ្យ​មាន​ខ្សែ​ត្រួតពិនិត្យ — មិន​ត្រឹម​តែ​កាលបរិច្ឆេទ​ទេ។"
          },
          "case-label": "ករណី {c}",
          "midway": "ពាក់​កណ្តាល",
          "days": {
            "in": "{n} ថ្ងៃ",
            "today": "ថ្ងៃ​នេះ",
            "overdue": "ហួស​ {n} ថ្ងៃ"
          },
          "stage": {
            "pending": "រង់ចាំ",
            "lm-review": "ត្រួត​ពិនិត្យ LM",
            "employee-ack": "បុគ្គលិក​ទទួល​ស្គាល់",
            "hr-confirm": "HR បញ្ជាក់",
            "confirmed": "បាន​បញ្ជាក់"
          },
          "action": {
            "confirm": "បញ្ជាក់ និងកត់ត្រា",
            "nudge": "រំលឹក LM",
            "await-employee": "រង់ចាំ​បុគ្គលិក"
          }
        },
        "templates": {
          "search-placeholder": "ស្វែងរកទំរង់គំរូ…",
          "chips": {
            "all": "ទាំងអស់",
            "active": "សកម្ម",
            "archived": "បានទុកក្នុងបណ្ណសារ"
          },
          "status": {
            "active": "សកម្ម",
            "archived": "បានទុកក្នុងបណ្ណសារ"
          },
          "cols": {
            "id": "លេខកូដ",
            "name": "ទំរង់គំរូ",
            "category": "ប្រភេទ",
            "tasks": "កិច្ចការ (ច. បាច់)",
            "duration": "រយៈពេល",
            "updated": "បានធ្វើបច្ចុប្បន្នភាព",
            "status": "ស្ថានភាព"
          },
          "showing": "បង្ហាញ {filtered} ក្នុងចំណោម {total} ទំរង់គំរូ",
          "empty": {
            "title": "មិនមានទំរង់គំរូត្រូវនឹងលក្ខខណ្ឌ",
            "lede": "សម្អាតការត្រងសកម្ម ឬពង្រីកការស្វែងរករបស់អ្នក។"
          },
          "drawer": {
            "tasks": "កិច្ចការ",
            "mandatory": "ច. បាច់",
            "duration": "រយៈពេល",
            "updated": "បានធ្វើបច្ចុប្បន្នភាពចុងក្រោយ",
            "owner": "តួនាទីម្ចាស់រឿង",
            "notes": "កំណត់ចំណាំ"
          },
          "toolbar": {
            "title": "គំរូ​បញ្ចូល​ការងារ",
            "lede": "បញ្ជី​ត្រួត​ពិនិត្យ​ត្រៀម​លក្ខណៈ​តាម​ប្រភេទ​ការងារ + តួនាទី។"
          },
          "new": "គំរូ​ថ្មី",
          "scope": {
            "direct": "ផ្ទាល់",
            "outsourced": "ខាង​ក្រៅ"
          },
          "meta": {
            "tasks": "កិច្ចការ (តម្រូវ)",
            "duration": "រយៈពេល",
            "owner": "ម្ចាស់",
            "updated": "ធ្វើបច្ចុប្បន្នភាព",
            "days": "{n} ថ្ងៃ"
          },
          "using": "{n} កំណត់ត្រា​ប្រើ​នេះ",
          "view-edit": "មើល / កែ"
        },
        "reports": {
          "search-placeholder": "ស្វែងរករបាយការណ៍…",
          "chips": {
            "all": "ទាំងអស់",
            "on-track": "តាមផ្លូវ",
            "at-risk": "ប្រឈមហានិភ័យ",
            "behind": "យឺត"
          },
          "cols": {
            "period": "កាលបរិច្ឆេទ",
            "dept": "នាយកដ្ឋាន",
            "joiners": "បុគ្គលិកថ្មី",
            "completed": "បានបញ្ចប់",
            "avg-days": "មធ្យមថ្ងៃ",
            "rate": "អត្រាបញ្ជាក់",
            "owner": "ម្ចាស់រឿង",
            "status": "ស្ថានភាព"
          },
          "showing": "បង្ហាញ {filtered} ក្នុងចំណោម {total} របាយការណ៍",
          "empty": {
            "title": "មិនមានរបាយការណ៍ត្រូវនឹងលក្ខខណ្ឌ",
            "lede": "សម្អាតការត្រងសកម្ម ឬពង្រីកការស្វែងរករបស់អ្នក។"
          },
          "drawer": {
            "joiners": "បុគ្គលិកថ្មី",
            "completed": "បានបញ្ចប់",
            "avg-days": "មធ្យមថ្ងៃដើម្បីត្រៀម",
            "rate": "អត្រាបញ្ជាក់សាកល្បង",
            "owner": "ម្ចាស់រឿង"
          },
          "view": {
            "insights": "ការ​យល់​ដឹង",
            "completion": "របាយការណ៍​លម្អិត"
          },
          "toolbar": {
            "title": "ការ​យល់​ដឹង​អំពី​ការ​បញ្ចូល​ការងារ",
            "lede": "ការ​វិភាគ​ផ្ទាល់​ឆ្លង​កាត់​កំណត់ត្រា​បញ្ចូល​ការងារ​ទាំងអស់។"
          },
          "kpi": {
            "active": "កំពុង​បញ្ចូល",
            "active-sub": "{midway} ពាក់​កណ្តាល · {cancelled} បាន​លុបចោល",
            "soon": "ចាប់​ផ្តើម ≤ ៧ ថ្ងៃ",
            "soon-sub": "ត្រូវ​ត្រៀម​រួច",
            "readiness": "ការ​ត្រៀម​លក្ខណៈ​មធ្យម",
            "readiness-sub": "{done} នៃ {total} ធាតុ",
            "ttd": "ពេល​មធ្យម​​ដាក់​ឱ្យ​ប្រើ​ប្រាស់",
            "ttd-sub": "បង្កើត → ចាប់​ផ្តើម",
            "attention": "ត្រូវ​ការ​ការ​យក​ចិត្ត​ទុក​ដាក់",
            "attention-sub": "កំណត់ត្រា​មាន​ឧបសគ្គ"
          },
          "funnel": {
            "title": "ចូល​បំពង់​បង្ហូរ",
            "preboarding": "មុន​ការ​ចូល",
            "day1": "ត្រៀម​ថ្ងៃ​ទី​១",
            "active": "សកម្ម",
            "probation": "សាកល្បង",
            "completed": "បាន​បញ្ចប់"
          },
          "groups": {
            "title": "ការ​ត្រៀម​លក្ខណៈ​តាម​ក្រុម",
            "lede": "ការ​បំពេញ​ទាប​បំផុត​បង្ហាញ​ពី​ទីតាំង​ដែល​ការ​បញ្ចូល​ការងារ​ជាប់​គាំង។",
            "contract": "កិច្ច​សន្យា",
            "physical": "ការ​សាមញ្ញ / កន្លែង​ធ្វើ​ការ",
            "system": "ការ​ចូល​ប្រព័ន្ធ",
            "payroll": "បើក​ប្រាក់​ខែ",
            "probation": "សាកល្បង"
          },
          "blockers": {
            "title": "ឧបសគ្គ​ឈាន​មុខ",
            "empty": "គ្មាន​ឧបសគ្គ​នៅ​ក្នុង​ការ​បញ្ចូល​ការងារ​សកម្ម​ទេ។"
          },
          "dim": {
            "workforce": "ប្រភេទ​កម្លាំងពលកម្ម",
            "client": "អតិថិជន",
            "dept": "នាយកដ្ឋាន",
            "category": "ប្រភេទ",
            "midway-cohort": "ពាក់​កណ្តាល",
            "fresh-cohort": "ថ្មី"
          },
          "breakdown": {
            "title": "ការ​ចែក​ចាយ​តាម {dim}"
          },
          "cycle": {
            "title": "វដ្ត​ត្រួត​ពិនិត្យ​សាកល្បង",
            "lm": "ត្រួត​ពិនិត្យ LM",
            "ack": "បុគ្គលិក​ទទួល​ស្គាល់",
            "confirm": "HR បញ្ជាក់",
            "overdue": "{n} ហួស​ការ​បញ្ចប់​សាកល្បង — ហួស​កាល​ត្រួត​ពិនិត្យ",
            "no-overdue": "គ្មាន​ការ​ត្រួត​ពិនិត្យ​សាកល្បង​ហួស​ពេល​ទេ"
          },
          "outcomes": {
            "title": "លទ្ធផល",
            "completed": "បាន​បញ្ចប់ (សាកល្បង​បាន​បញ្ជាក់)",
            "pass-rate": "អត្រា​ឆ្លងផុត​សាកល្បង",
            "midway": "ការ​បញ្ចូល​ការងារ​ពាក់​កណ្តាល",
            "cancelled": "បាន​លុបចោល (រួម​ទាំង​ការ​ធ្លាក់​ចុះ​ការ​សាកល្បង)",
            "avg-ttd": "ពេល​មធ្យម​​ដាក់​ឱ្យ​ប្រើ​ប្រាស់",
            "days": "{n} ថ្ងៃ"
          },
          "completion": {
            "title": "របាយការណ៍​លម្អិត",
            "lede": "ការ​បំបែក​ក្រុម​តាម​ដំណាក់​កាល​បំពង់​បង្ហូរ — បន្ត​ពី​កាល​បរិច្ឆេទ​ចាប់​ផ្តើម។"
          },
          "flags": {
            "contract": "កិច្ច​សន្យា​មិន​ទាន់​ចុះ",
            "bank": "ធនាគារ​មិន​ទាន់​រៀប​ចំ",
            "laptop": "ឡែបថប​មិន​ទាន់​ផ្តល់",
            "ess": "ESS មិន​ទាន់​អញ្ជើញ",
            "payroll": "បើក​ប្រាក់​ខែ​មិន​ទាន់​រួច"
          }
        },
        "stub": {
          "title": "ការចូលបំពេញការងារ",
          "lede": "ផ្ទាំងព័ត៌មានច្រើនទិដ្ឋភាព (Dashboard / New Hires / Probation) ជាមួយវឌ្ឍនភាព checklist ការសម្គាល់ឯកសារកំពុងរង់ចាំ និងការរំលឹកការវាយតម្លៃសាកល្បង។ Phase B ភ្ជាប់ទៅ `recruitment/`។"
        }
      },
      "offboarding": {
        "title": "ការចាកចេញពីការងារ",
        "subtitle": "លាលែង → លក្ខខណ្ឌ → ប្រាក់ខែចុងក្រោយ → បទសម្ភាស — ការគ្រប់គ្រងតែមួយសម្រាប់រាល់ការចាកចេញ។",
        "actions": {
          "start": "ចាប់ផ្តើមការចាកចេញ",
          "clear-filters": "សម្អាតតម្រង",
          "view": "មើល"
        },
        "banner": {
          "title": "មជ្ឈមណ្ឌលចាកចេញ គឺជាប៉ម​​ត្រួតពិនិត្យ។",
          "body": "រាល់ការចាកចេញ — ពីប្រភពណាមួយ — ចូលមកទីនេះមុនគេ ហើយឆ្លងកាត់ផ្លូវស្ថានភាពមួយ៖ ថ្មី → កំពុងពិនិត្យ → មានសិទ្ធិ → កំពុងដំណើរការ → បានបញ្ចប់។"
        },
        "kpi": {
          "leaving-30d": "ចាកចេញក្នុង 30 ថ្ងៃ",
          "asset-recovery": "ការប្រគល់ទ្រព្យសម្បត្តិ",
          "exit-pending": "បទសម្ភាសចេញរង់ចាំ",
          "final-pay-queue": "ការទូទាត់ចុងក្រោយរង់ចាំ",
          "turnover": "% ការផ្លាស់ប្ដូរស្ម័គ្រចិត្ត",
          "in-progress": "កំពុងដំណើរការ",
          "final-pay": "ប្រាក់ខែចុងក្រោយកំពុងរង់ចាំ",
          "exit-interviews": "បទសម្ភាសចេញ",
          "completed": "បានបញ្ចប់ (ឆ្នាំនេះ)"
        },
        "sub-tabs": {
          "overview": "ទិដ្ឋភាពទូទៅ",
          "center": "មជ្ឈមណ្ឌលចាកចេញ",
          "eligible": "សិទ្ធិចាកចេញ",
          "process": "ដំណើរការចាកចេញ",
          "templates": "គំរូ",
          "reports": "របាយការណ៍"
        },
        "dispatch": {
          "title": "ចាប់ផ្តើមការចាកចេញ",
          "lede": "បំពេញព័ត៌មានការចាកចេញ — វាចូលទៅមជ្ឈមណ្ឌលចាកចេញសម្រាប់ការពិនិត្យ។",
          "fields": {
            "employee": "បុគ្គលិក",
            "reason": "មូលហេតុ",
            "last-day": "ថ្ងៃធ្វើការចុងក្រោយ",
            "notice": "ការគ្រប់គ្រងការជូនដំណឹង",
            "source": "ប្រភព"
          },
          "placeholders": {
            "employee": "ជ្រើសរើសបុគ្គលិក…",
            "reason": "ឧ. ផ្លាស់ទីលំនៅ, ការផ្តល់ជូនល្អជាង, កិច្ចសន្យាបញ្ចប់…",
            "source": "ជ្រើសរើសប្រភព…"
          },
          "notice-options": {
            "served": "បម្រើដំណឹងពេញលេញ",
            "garden": "ឈប់សំរាកមានប្រាក់ខែ",
            "buyout": "ទិញដំណឹង",
            "waived": "លើកលែងដំណឹង"
          },
          "errors": {
            "employee-required": "សូមជ្រើសរើសបុគ្គលិក",
            "reason-required": "តម្រូវឱ្យមានមូលហេតុ",
            "last-day-required": "តម្រូវឱ្យមានថ្ងៃធ្វើការចុងក្រោយ",
            "source-required": "តម្រូវឱ្យមានប្រភព"
          },
          "cancel": "បោះបង់",
          "submit": "បង្កើតព្រឹត្តិការណ៍",
          "created-toast": "បានបង្កើតព្រឹត្តិការណ៍ចាកចេញ · {employee} — បានចូលមជ្ឈមណ្ឌលចាកចេញ"
        },
        "overview": {
          "toolbar-btn": "មជ្ឈមណ្ឌលចាកចេញ",
          "kpi": {
            "intake": "ថ្មី និងកំពុងពិនិត្យ",
            "intake-sub": "ការទទួលត្រូវវាយតម្លៃ",
            "eligible": "មានសិទ្ធិចាប់ផ្តើម",
            "eligible-sub": "រួចរាល់ចេញពីការងារ",
            "in-progress": "ចេញពីការងារកំពុងដំណើរការ",
            "in-progress-sub": "កំពុងអនុវត្ត",
            "overdue": "សកម្មភាពហួសកាល",
            "overdue-sub": "ករណីត្រូវការការចាប់អារម្មណ៍"
          },
          "upcoming": {
            "title": "ថ្ងៃធ្វើការចុងក្រោយខាងមុខ",
            "empty": "គ្មានកាលវិភាគ។",
            "cols": {
              "employee": "បុគ្គលិក",
              "leaving-reason": "មូលហេតុចាកចេញ",
              "last-working-day": "ថ្ងៃធ្វើការចុងក្រោយ",
              "current-stage": "ដំណាក់កាលបច្ចុប្បន្ន",
              "attention-required": "ត្រូវការការចាប់អារម្មណ៍"
            }
          },
          "recent": {
            "title": "សកម្មភាពថ្មីៗ",
            "empty": "គ្មានសកម្មភាពថ្មីៗ។"
          }
        },
        "center": {
          "search-placeholder": "ស្វែងរកអ្នកចាកចេញ…",
          "chips": {
            "all": "ទាំងអស់",
            "new": "ថ្មី",
            "under_review": "កំពុងពិនិត្យ",
            "eligible": "មានសិទ្ធិ",
            "in_progress": "កំពុងដំណើរការ",
            "completed": "បានបញ្ចប់",
            "cancelled": "បានបោះបង់"
          },
          "cols": {
            "employee": "បុគ្គលិក",
            "source": "ប្រភព",
            "reason": "មូលហេតុ",
            "last-day": "ថ្ងៃចុងក្រោយ",
            "progress": "វឌ្ឍនភាព",
            "owner": "ម្ចាស់",
            "status": "ស្ថានភាព",
            "action": "សកម្មភាព"
          },
          "actions": {
            "review": "ពិនិត្យ",
            "eligible": "សម្គាល់មានសិទ្ធិ",
            "start": "ចាប់ផ្តើម",
            "open": "បើក",
            "view": "មើល"
          },
          "action-toasts": {
            "review": "បានផ្លាស់ប្តូរ {employee} ទៅកំពុងពិនិត្យ",
            "eligible": "បានសម្គាល់ {employee} ថាមានសិទ្ធិ",
            "start": "បានចាប់ផ្តើមការចេញពីការងារ · {employee}",
            "open": "កំពុងបើកករណីរបស់ {employee}",
            "view": "កំពុងមើលករណីរបស់ {employee}"
          },
          "showing": "បង្ហាញ {filtered} ក្នុងចំណោម {total} ព្រឹត្តិការណ៍",
          "empty": {
            "title": "មិនមានព្រឹត្តិការណ៍ត្រូវនឹងតម្រង",
            "lede": "សម្អាតតម្រង ឬពង្រីកការស្វែងរក។"
          },
          "drawer": {
            "role": "តួនាទី",
            "dept": "នាយកដ្ឋាន",
            "client": "អតិថិជន",
            "source": "ប្រភព",
            "reason": "មូលហេតុ",
            "notice-date": "ថ្ងៃជូនដំណឹង",
            "last-day": "ថ្ងៃធ្វើការចុងក្រោយ",
            "owner": "ម្ចាស់",
            "progress": "វឌ្ឍនភាព",
            "status": "ស្ថានភាព",
            "notes": "កំណត់ចំណាំ",
            "attention": "ត្រូវការចាប់អារម្មណ៍"
          }
        },
        "eligible": {
          "search-placeholder": "ស្វែងរក…",
          "chips": {
            "all": "ទាំងអស់",
            "voluntary": "ស្ម័គ្រចិត្ត",
            "involuntary": "មិនស្ម័គ្រចិត្ត",
            "due-soon": "ថ្ងៃចុងក្រោយ ≤ 14 ថ្ងៃ"
          },
          "cols": {
            "employee": "បុគ្គលិក",
            "source": "ប្រភព",
            "reason": "មូលហេតុ",
            "last-day": "ថ្ងៃធ្វើការចុងក្រោយ",
            "eligible-since": "មានសិទ្ធិតាំងពី",
            "action": "សកម្មភាព"
          },
          "showing": "បង្ហាញ {filtered} ក្នុងចំណោម {total}",
          "empty": {
            "title": "មិនមាននរណាមានសិទ្ធិ",
            "lede": "ព្រឹត្តិការណ៍ក្លាយជាមានសិទ្ធិបន្ទាប់ពីការពិនិត្យ។"
          },
          "drawer": {
            "role": "តួនាទី",
            "dept": "នាយកដ្ឋាន",
            "client": "អតិថិជន",
            "reason": "មូលហេតុ",
            "last-day": "ថ្ងៃធ្វើការចុងក្រោយ",
            "eligible-since": "មានសិទ្ធិតាំងពី",
            "owner": "ម្ចាស់",
            "notes": "កំណត់ចំណាំ"
          },
          "start-button": "ចាប់ផ្តើម",
          "started-toast": "បានចាប់ផ្តើមការចេញពីការងារ · {employee} — បានផ្លាស់ប្តូរទៅកំពុងដំណើរការ",
          "in-days": "ក្នុង {n} ថ្ងៃ",
          "today": "ថ្ងៃនេះ",
          "days-ago": "{n} ថ្ងៃមុន"
        },
        "process": {
          "search-placeholder": "ស្វែងរកករណី…",
          "chips": {
            "all": "ទាំងអស់",
            "active": "កំពុងដំណើរការ",
            "completed": "បានបញ្ចប់",
            "needs-attention": "ត្រូវការចាប់អារម្មណ៍"
          },
          "cols": {
            "employee": "បុគ្គលិក",
            "source": "ប្រភព",
            "last-day": "ថ្ងៃចុងក្រោយ",
            "progress": "វឌ្ឍនភាព",
            "owner": "ម្ចាស់",
            "attention": "ការចាប់អារម្មណ៍",
            "status": "ស្ថានភាព"
          },
          "showing": "បង្ហាញ {filtered} ក្នុងចំណោម {total} ករណី",
          "empty": {
            "title": "មិនមានករណី",
            "lede": "ចាប់ផ្តើមមួយពីសិទ្ធិចាកចេញ។"
          },
          "drawer": {
            "role": "តួនាទី",
            "dept": "នាយកដ្ឋាន",
            "client": "អតិថិជន",
            "source": "ប្រភព",
            "reason": "មូលហេតុ",
            "last-day": "ថ្ងៃធ្វើការចុងក្រោយ",
            "owner": "ម្ចាស់",
            "progress": "វឌ្ឍនភាព",
            "status": "ស្ថានភាព",
            "attention": "ការចាប់អារម្មណ៍",
            "notes": "កំណត់ចំណាំ"
          }
        },
        "templates": {
          "search-placeholder": "ស្វែងរកគំរូ…",
          "chips": {
            "all": "ទាំងអស់",
            "active": "សកម្ម",
            "inactive": "មិនសកម្ម",
            "direct": "ផ្ទាល់",
            "outsourced": "ការខ្ចីក្រៅ"
          },
          "cols": {
            "name": "គំរូ",
            "workforce": "កម្លាំងពលកម្ម",
            "role-type": "ប្រភេទតួនាទី",
            "handover": "ប្រគល់",
            "clearance": "ការអនុញ្ញាត",
            "lastday": "ថ្ងៃចុងក្រោយ",
            "exit": "បទសម្ភាស",
            "last-used": "ប្រើចុងក្រោយ",
            "usage": "ការប្រើប្រាស់",
            "status": "ស្ថានភាព"
          },
          "showing": "បង្ហាញ {filtered} ក្នុងចំណោម {total} គំរូ",
          "empty": {
            "title": "មិនមានគំរូ",
            "lede": "សម្អាតតម្រង។"
          },
          "exit-required": "តម្រូវ",
          "exit-optional": "ស្រេចចិត្ត",
          "drawer": {
            "name": "ឈ្មោះគំរូ",
            "workforce": "កម្លាំងពលកម្ម",
            "role-type": "ប្រភេទតួនាទី",
            "handover": "ធាតុប្រគល់",
            "clearance": "ធាតុការអនុញ្ញាត",
            "lastday": "ធាតុថ្ងៃចុងក្រោយ",
            "exit": "បទសម្ភាសចេញ",
            "last-used": "ប្រើចុងក្រោយ",
            "usage": "ចំនួនប្រើ",
            "status": "ស្ថានភាព"
          }
        },
        "assets": {
          "search-placeholder": "ស្វែងរកទ្រព្យ…",
          "title": "ការប្រគល់ទ្រព្យសម្បត្តិ",
          "lede": "តាមដានកុំព្យូទ័រយួរដៃ ទូរស័ព្ទ កាតចូល និងឯកសណ្ឋាន ដែលត្រូវប្រគល់មកវិញ។",
          "chips": {
            "all": "ទាំងអស់",
            "pending": "រង់ចាំ",
            "received": "បានទទួល",
            "damaged": "ខូច",
            "lost": "បាត់"
          },
          "cols": {
            "employee": "បុគ្គលិក",
            "item": "របស់",
            "serial": "លេខស៊េរី",
            "condition": "ស្ថានភាព",
            "status": "ស្ថានភាព",
            "due": "ថ្ងៃកំណត់",
            "received-by": "ទទួលដោយ"
          },
          "showing": "បង្ហាញ {filtered} ក្នុងចំណោម {total} ទ្រព្យ",
          "empty": {
            "title": "មិនមានទ្រព្យ",
            "lede": "សម្អាតតម្រង។"
          },
          "drawer": {
            "employee": "បុគ្គលិក",
            "item": "របស់",
            "serial": "លេខស៊េរី",
            "condition": "ស្ថានភាព",
            "status": "ស្ថានភាព",
            "due": "ថ្ងៃកំណត់",
            "received-by": "ទទួលដោយ",
            "notes": "កំណត់ចំណាំ"
          },
          "condition": {
            "new": "ថ្មី",
            "good": "ល្អ",
            "fair": "ធម្មតា",
            "damaged": "ខូច",
            "unknown": "មិនច្បាស់"
          }
        },
        "settlement": {
          "search-placeholder": "ស្វែងរក…",
          "title": "ការទូទាត់ចុងក្រោយ",
          "lede": "ការគណនាប្រាក់ខែចុងក្រោយ — មូលដ្ឋាន ឈប់សំរាកគួរ ថ្ងៃមិនបង់ ប្រាក់សំណង កាត់កង។",
          "chips": {
            "all": "ទាំងអស់",
            "not_created": "មិនបានបង្កើត",
            "created": "ព្រាង",
            "processing": "កំពុងដំណើរការ",
            "paid": "បានបង់",
            "disputed": "ជម្លោះ"
          },
          "cols": {
            "employee": "បុគ្គលិក",
            "last-day": "ថ្ងៃចុងក្រោយ",
            "base": "ប្រាក់ខែមូលដ្ឋាន",
            "accrued": "ឈប់សំរាកគួរ",
            "unpaid": "ថ្ងៃមិនបង់",
            "severance": "ប្រាក់សំណង",
            "deductions": "កាត់កង",
            "total": "សរុប",
            "status": "ស្ថានភាព"
          },
          "showing": "បង្ហាញ {filtered} ក្នុងចំណោម {total}",
          "empty": {
            "title": "មិនមាន",
            "lede": "សម្អាតតម្រង។"
          },
          "drawer": {
            "employee": "បុគ្គលិក",
            "last-day": "ថ្ងៃធ្វើការចុងក្រោយ",
            "base": "ប្រាក់ខែមូលដ្ឋាន",
            "accrued": "ឈប់សំរាកគួរ",
            "unpaid": "ថ្ងៃមិនបង់",
            "severance": "ប្រាក់សំណង",
            "deductions": "កាត់កង",
            "total": "សរុប",
            "currency": "រូបិយប័ណ្ណ",
            "prepared-by": "រៀបចំដោយ",
            "status": "ស្ថានភាព",
            "notes": "កំណត់ចំណាំ"
          }
        },
        "source": {
          "ess_resignation": "លាលែងតាម ESS",
          "contract_end": "កិច្ចសន្យាបញ្ចប់",
          "probation_fail": "សាកល្បងបរាជ័យ",
          "retirement": "ចូលនិវត្តន៍",
          "termination": "បញ្ឈប់",
          "death": "ស្លាប់ក្នុងពេលធ្វើការ"
        },
        "status": {
          "new": "ថ្មី",
          "under_review": "កំពុងពិនិត្យ",
          "eligible": "មានសិទ្ធិ",
          "in_progress": "កំពុងដំណើរការ",
          "completed": "បានបញ្ចប់",
          "cancelled": "បានបោះបង់"
        },
        "final-pay": {
          "not_created": "មិនបានបង្កើត",
          "created": "ព្រាង",
          "processing": "កំពុងដំណើរការ",
          "paid": "បានបង់",
          "disputed": "ជម្លោះ"
        },
        "reports": {
          "title": "របាយការណ៍",
          "lede": "ការវិភាគការផ្លាស់ប្ដូរ — តាមមូលហេតុ ប្រភព រយៈពេលធ្វើការ នាយកដ្ឋាន ស្ម័គ្រចិត្ត vs មិនស្ម័គ្រចិត្ត។",
          "kpi": {
            "total": "ព្រឹត្តិការណ៍សរុប",
            "voluntary": "ស្ម័គ្រចិត្ត",
            "involuntary": "មិនស្ម័គ្រចិត្ត",
            "turnover": "% ផ្លាស់ប្តូរ",
            "rehire": "មានសិទ្ធិជួលឡើងវិញ",
            "clearance-sla": "SLA ការអនុញ្ញាត",
            "final-pay-sla": "SLA ប្រាក់ខែចុងក្រោយ"
          },
          "by-source": "តាមប្រភព",
          "by-reason": "តាមមូលហេតុ",
          "by-tenure": "តាមរយៈពេលធ្វើការ",
          "by-dept": "តាមនាយកដ្ឋាន",
          "voluntary-split": "ស្ម័គ្រចិត្ត vs មិនស្ម័គ្រចិត្ត"
        },
        "stub": {
          "title": "ការចាកចេញពីការងារ",
          "lede": "ការអនុវត្តលាលែងប្រតិបត្តិការជាមួយការតាមដាន workstream (លាលែង · លក្ខខណ្ឌ · ប្រាក់ខែចុងក្រោយ · បទសម្ភាស)។"
        }
      },
      "compliance": {
        "title": "ការអនុលោម",
        "subtitle": "ការអនុលោមតាមច្បាប់និងប្រតិបត្តិការកម្ពុជា · ថ្នាក់ទី១ កាលកំណត់រឹង (MOL, បសស, ពន្ធ) និងថ្នាក់ទី២ ការដាក់ស្នើប្រតិបត្តិការ ជាមួយផ្លូវដានសវនកម្មក្នុងប្រភេទនីមួយៗ។",
        "info-banner": {
          "title": "វិសាលភាពនៃការអនុលោម",
          "body": "តាមដាន​កាតព្វកិច្ច​និយោជក​គ្រប់​យ៉ាង​ដែល​ច្បាប់​កម្ពុជា​បង្គាប់ — ការប្រកាស MOL, វិភាគទាន បសស និងពន្ធលើប្រាក់ខែ, លិខិតការងារ និងទិដ្ឋាការបុគ្គលិកបរទេស, កូតាបុគ្គលិកបរទេស, ការត្រួតពិនិត្យសុខភាព, បទបញ្ជាការងារផ្ទៃក្នុង, សៀវភៅពលកម្ម, សុវត្ថិភាពអគ្គីភ័យ និងសំណងបុគ្គលិក។ កាលកំណត់អាចកំណត់រចនាសម្ព័ន្ធបានដោយអ្នកជួលនៅក្នុង Compliance Settings។"
        },
        "scores": {
          "healthy": "ល្អ",
          "attention": "ត្រូវការការយកចិត្តទុកដាក់",
          "critical": "សំខាន់"
        },
        "kpi": {
          "score": "ពិន្ទុការអនុលោម",
          "score-sub": "នៅទូទាំង {cats} ប្រភេទ · {items} ធាតុដែលត្រូវបានតាមដាន",
          "overdue-expiring": "ហួសកាលកំណត់ / ជិតផុតកំណត់",
          "overdue-expiring-sub": "{overdue} ហួសកាលកំណត់ · {expiring} ជិតផុតកំណត់",
          "pending-action": "សកម្មភាពរង់ចាំ",
          "pending-action-clear": "ល្អប្រសើរទាំងអស់",
          "pending-action-open": "ការប្រកាស និងការដាក់ស្នើដែលបើក"
        },
        "sidebar": {
          "overview": "ទិដ្ឋភាពទូទៅ",
          "tier1": "ថ្នាក់ទី១ — កាលកំណត់រឹង",
          "tier2": "ថ្នាក់ទី២ — ប្រតិបត្តិការ",
          "settings": "ការកំណត់"
        },
        "categories": {
          "mol-decl": {
            "label": "ការប្រកាស MOL",
            "description": "ការប្រកាសបុគ្គលិកថ្មី និងការបញ្ឈប់ទៅក្រសួងការងារ។ កាលកំណត់លំនាំដើម ១៥ ថ្ងៃធ្វើការ។"
          },
          "nssf": {
            "label": "វិភាគទាន បសស",
            "description": "វិភាគទានសន្តិសុខសង្គមប្រចាំខែ។ លំនាំដើមត្រូវដាក់ស្នើនៅថ្ងៃទី ១៥ នៃខែបន្ទាប់។"
          },
          "tax": {
            "label": "ពន្ធលើប្រាក់ខែ (TOS)",
            "description": "ការប្រកាសពន្ធលើប្រាក់ខែប្រចាំខែទៅអគ្គនាយកដ្ឋានពន្ធដារ។ លំនាំដើមត្រូវដាក់ស្នើនៅថ្ងៃទី ២០។"
          },
          "work-permit": {
            "label": "លិខិតការងារ",
            "description": "លិខិតការងារប្រចាំឆ្នាំសម្រាប់បុគ្គលិកបរទេស។ ការព្រមានបន្តលិខិត ៦០ ថ្ងៃមុនពេលផុតកំណត់។"
          },
          "visa": {
            "label": "ការបន្តទិដ្ឋាការ (Business E)",
            "description": "ការបន្តទិដ្ឋាការ Business E ប្រចាំឆ្នាំសម្រាប់បុគ្គលិកបរទេស។"
          },
          "quota": {
            "label": "កូតាបុគ្គលិកបរទេស",
            "description": "ការដាក់ពាក្យកូតាប្រចាំឆ្នាំសម្រាប់បុគ្គលិកបរទេស។ កម្រិត៖ បរទេស ≤ ១០% នៃសរុប (អាចកំណត់រចនាសម្ព័ន្ធបាន)។"
          },
          "health": {
            "label": "ការត្រួតពិនិត្យសុខភាព",
            "description": "ការត្រួតពិនិត្យសុខភាពជាកាតព្វកិច្ចប្រចាំឆ្នាំ។ តាមដានតាមបុគ្គលិក។"
          },
          "iwr": {
            "label": "បទបញ្ជាការងារផ្ទៃក្នុង",
            "description": "ត្រូវការសម្រាប់ក្រុមហ៊ុនដែលមានបុគ្គលិក ≥ ៨ នាក់។ ដាក់ស្នើទៅ MOL នៅពេលផ្លាស់ប្តូរគោលនយោបាយ។"
          },
          "labour-book": {
            "label": "សៀវភៅពលកម្ម",
            "description": "បញ្ជីបុគ្គលិក និងកំណត់ហេតុម៉ោងធ្វើការ។ មាននាំចេញប្រចាំខែសម្រាប់ការត្រួតពិនិត្យរបស់ MOL។"
          },
          "fire-safety": {
            "label": "វិញ្ញាបនបត្រសុវត្ថិភាពអគ្គីភ័យ",
            "description": "ការត្រួតពិនិត្យ និងវិញ្ញាបនបត្រសុវត្ថិភាពអគ្គីភ័យកន្លែងធ្វើការ។ បន្តប្រចាំឆ្នាំ។"
          },
          "workmen-comp": {
            "label": "សំណងបុគ្គលិក",
            "description": "ការចុះឈ្មោះធានារ៉ាប់រងហានិភ័យការងារតាមរយៈ បសស។"
          }
        },
        "filters": {
          "all": "ទាំងអស់",
          "ok": "ល្អ",
          "pending": "កំពុងរង់ចាំ",
          "submitted": "បានដាក់ស្នើ",
          "approved": "បានអនុម័ត",
          "overdue": "ហួសកាលកំណត់",
          "expiring-soon": "ជិតផុតកំណត់"
        },
        "status": {
          "OK": "ល្អ",
          "Pending": "កំពុងរង់ចាំ",
          "Submitted": "បានដាក់ស្នើ",
          "Approved": "បានអនុម័ត",
          "Overdue": "ហួសកាលកំណត់",
          "Expiring Soon": "ជិតផុតកំណត់",
          "N/A": "មិនពាក់ព័ន្ធ"
        },
        "actions": {
          "clear-filters": "សម្អាតការច្រោះ",
          "view": "មើល",
          "action": "សកម្មភាព →",
          "new-item": "ធាតុថ្មី"
        },
        "search-placeholder": "ស្វែងរក​លេខ​សម្គាល់ ប្រធានបទ រយៈពេល ព័ត៌មាន​លម្អិត…",
        "days": {
          "overdue": "ហួសកាលកំណត់ {n} ថ្ងៃ",
          "today": "ថ្ងៃនេះ",
          "in": "ក្នុង {n} ថ្ងៃ"
        },
        "action-items": {
          "title": "ធាតុ​សកម្មភាព",
          "lede": "តម្រៀបតាមភាពបន្ទាន់។ ចុចលើជួរណាមួយដើម្បីបើកប្រភេទរបស់វា។",
          "count": "{n} ធាតុ​ត្រូវការ​សកម្មភាព",
          "empty": "គ្មាន​ធាតុ​បន្ទាន់ — អ្នក​ល្អ​ប្រសើរ​ហើយ ✓"
        },
        "grid": {
          "all-categories": "ប្រភេទ​ទាំងអស់",
          "click-hint": "ចុចលើ​កាត​ណាមួយ​ដើម្បី​ស្វែងយល់​បន្ថែម",
          "healthy": "{n}% ល្អ",
          "items": "{n} ធាតុ",
          "overdue": "{n} ហួស​កាល​កំណត់"
        },
        "detail": {
          "authority": "អាជ្ញាធរ",
          "cadence": "ការ​កើត​ឡើង",
          "tier": "ថ្នាក់",
          "tier-1": "១ (កាល​កំណត់​រឹង)",
          "tier-2": "២ (ប្រតិបត្តិការ)",
          "score": "ពិន្ទុ",
          "settings": "ការ​កំណត់",
          "config-footnote": "តម្លៃ​លំនាំ​ដើម​ខាង​លើ​អាច​កំណត់​រចនា​សម្ព័ន្ធ​បាន​ដោយ​អ្នក​ជួល​នៅ Compliance Settings — ឧ. កាល​កំណត់​ប្រកាស MOL {mol} ថ្ងៃ​ធ្វើ​ការ (ការ​ជួល), បសស ថ្ងៃ​ទី {nssf}, TOS ថ្ងៃ​ទី {tax}។"
        },
        "table": {
          "tracked": "ធាតុ​ដែល​ត្រូវ​បាន​តាមដាន ({n})",
          "overdue": "{n} ហួស​កាល​កំណត់",
          "pending": "{n} កំពុង​រង់ចាំ",
          "expiring": "{n} ជិត​ផុត​កំណត់",
          "col": {
            "id": "លេខ​សម្គាល់",
            "subject": "ប្រធានបទ / ព័ត៌មាន​លម្អិត",
            "due": "កំណត់",
            "days": "ថ្ងៃ",
            "status": "ស្ថានភាព",
            "action": "សកម្មភាព"
          }
        },
        "quota": {
          "title": "សមាមាត្រ​បុគ្គលិក​បរទេស​បច្ចុប្បន្ន",
          "within": "ស្ថិត​ក្នុង​កម្រិត MOL {cap}%",
          "over": "លើស​កម្រិត MOL {cap}%"
        },
        "foreign": {
          "title": "បុគ្គលិក​បរទេស​មាន​នៅ​ក្នុង​បញ្ជី ({n})",
          "col": {
            "code": "លេខ​សម្គាល់",
            "name": "ឈ្មោះ",
            "nationality": "សញ្ជាតិ",
            "position": "មុខ​តំណែង",
            "joined": "ចូល​ធ្វើ​ការ"
          }
        },
        "empty": {
          "title": "គ្មាន​លទ្ធផល",
          "lede": "គ្មាន​ធាតុ​ត្រូវ​នឹង​តម្រង​ទាំង​នេះ​ទេ។ សាកល្បង​សម្អាត​មួយ​ដើម្បី​ពង្រីក​ការ​ស្វែងរក។"
        },
        "drawer": {
          "fields": {
            "due": "កំណត់",
            "days": "ថ្ងៃ​នៅ​សល់",
            "employee": "បុគ្គលិក",
            "details": "ព័ត៌មាន​លម្អិត",
            "audit": "ផ្លូវ​ដាន​សវនកម្ម"
          },
          "no-audit": "មិនទាន់​មាន​ព្រឹត្តិការណ៍​សវនកម្ម​ត្រូវ​បាន​កត់ត្រា​ទេ។"
        },
        "settings-placeholder": "Compliance Settings — កន្លែង​បម្រុង · តម្លៃ​លំនាំ​ដើម​អាច​កែ​បាន​នឹង​មក​ដល់​ជាមួយ​នឹង​ការ​សាងសង់ Settings"
      },
      "directory": {
        "subtitle": "មិនមានបុគ្គលិក | {n} នាក់ | {n} នាក់",
        "subtitle-empty": "រកមិនឃើញបុគ្គលិក",
        "add-person-cta": "បន្ថែមបុគ្គល",
        "add-person": {
          "wizard": {
            "title": {
              "employee": "បន្ថែមបុគ្គលិកផ្ទាល់",
              "outsourced": "បន្ថែមបុគ្គលិកជ្រើសរើសខាងក្រៅ",
              "vendor-lite": "បន្ថែមកំណត់ត្រា Vendor-lite",
              "external": "អញ្ជើញអ្នកអនុម័តពីខាងក្រៅ"
            },
            "subtitle": {
              "employee": "ជួលចូលប្រាក់ខែផ្ទាល់របស់អ្នក — កំណត់ត្រា HR ពេញលេញ + កិច្ចសន្យា។",
              "outsourced": "បុគ្គលិកដែលអ្នកជួលដាក់ឱ្យធ្វើការនៅគម្រោងអតិថិជន — ប្រាក់ខែ + ច្បាប់រដ្ឋពេញលេញ។",
              "vendor-lite": "តាមដានបុគ្គលិកដែលផ្គត់ផ្គង់ដោយក្រុមហ៊ុនផ្តល់សេវា — គ្មានប្រាក់ខែនៅខាងយើង។",
              "external": "សិទ្ធិមានកំណត់ — អនុម័តសំណើតែសម្រាប់បុគ្គលិកក្នុងគម្រោងមួយប៉ុណ្ណោះ។"
            },
            "kind": {
              "label": "ប្រភេទបុគ្គល",
              "employee": "បុគ្គលិកផ្ទាល់",
              "outsourced": "ជ្រើសរើសខាងក្រៅ (យើងគ្រប់គ្រងប្រាក់ខែ)",
              "vendor-lite": "Vendor-lite (ក្រុមហ៊ុនផ្តល់សេវាគ្រប់គ្រងប្រាក់ខែ)",
              "external": "អ្នកអនុម័តពីខាងក្រៅ"
            },
            "offer": {
              "title": "ចាប់ផ្តើមពីលិខិតផ្តល់ការងារ",
              "body": "ទាញទិន្នន័យពីលិខិតផ្តល់ការងារដែលចុះហត្ថលេខា — កាត់បន្ថយកំហុស និងការសរសេរម្តងទៀត។ ផ្ទាំងលិខិតផ្តល់ការងារនឹងមកជាមួយម៉ូឌុលជ្រើសរើស។",
              "cta": "មើលលិខិតផ្តល់",
              "coming-soon": "ឧបករណ៍ជ្រើសលិខិតផ្តល់ការងារ — នឹងមកជាមួយម៉ូឌុលជ្រើសរើស។"
            },
            "stepper": {
              "aria": "ដំណើរការនៃជំនួយការបន្ថែមបុគ្គល"
            },
            "steps": {
              "person": "បុគ្គល",
              "schedule": "កាលវិភាគ",
              "contract": "កិច្ចសន្យា",
              "leave": "ច្បាប់ឈប់សម្រាក",
              "project-access": "សិទ្ធិគម្រោង",
              "vendor": "ក្រុមហ៊ុនផ្តល់សេវា",
              "review": "ពិនិត្យឡើងវិញ"
            },
            "person": {
              "heading": "ព័ត៌មានបុគ្គល",
              "code": "លេខកូដបុគ្គលិក",
              "code-hint": "បង្កើតដោយស្វ័យប្រវត្តិ។ អ្នកអាចកែប្រែបានមុនពេលរក្សាទុក។",
              "code-hint-external": "លេខកូដបុគ្គលិកអតិថិជន — បង្កើតស្វ័យប្រវត្តិសម្រាប់ការយោងឆ្លងភាគី។",
              "name-latin": "ឈ្មោះពេញ (ឡាតាំង)",
              "name-latin-placeholder": "ឧ. Sok Pisey",
              "name-khmer": "ឈ្មោះពេញ (ខ្មែរ)",
              "gender": {
                "label": "ភេទ",
                "female": "ស្រី",
                "male": "ប្រុស",
                "other": "ផ្សេងទៀត"
              },
              "dob": "ថ្ងៃខែឆ្នាំកំណើត",
              "nid": "អត្តសញ្ញាណប័ណ្ណ / លិខិតឆ្លងដែន",
              "nid-placeholder": "ឧ. 012345678",
              "title-at-client": "តួនាទីនៅអតិថិជន",
              "title-placeholder": "ឧ. អ្នកត្រួតពិនិត្យតំបន់",
              "email": "អ៊ីមែលការងារ",
              "email-placeholder": "you\\@company.com",
              "email-client": "អ៊ីមែលអតិថិជន",
              "email-client-placeholder": "approver\\@client.com",
              "phone": "លេខទូរស័ព្ទការងារ",
              "vendor-lite-badge": "ការគ្រប់គ្រង Vendor-lite",
              "vendor-lite-help": "យើងនឹងមិនរក្សាទុកលេខអត្តសញ្ញាណច្បាប់ ឬប្រាក់ខែសម្រាប់បុគ្គលនេះទេ — ក្រុមហ៊ុនផ្តល់សេវាជាអ្នកគ្រប់គ្រងកំណត់ត្រាទាំងនោះ។",
              "help-employee": "បុគ្គលិកផ្ទាល់លេចឡើងគ្រប់ទីកន្លែង — បញ្ជី ប្រាក់ខែ ច្បាប់ឈប់សម្រាក ពេលវេលា និងវត្តមាន។",
              "help-outsourced": "បុគ្គលិកជ្រើសរើសខាងក្រៅលេចឡើងនៅក្នុងបញ្ជី និងផ្ទាំងជ្រើសរើសខាងក្រៅ។ ប្រាក់ខែ និងសិទ្ធិច្បាប់រដ្ឋដំណើរការដូចបុគ្គលិកផ្ទាល់។",
              "help-external": "អ្នកអនុម័តពីខាងក្រៅអាចមើល និងអនុម័តសំណើបានតែសម្រាប់បុគ្គលិកនៅគម្រោងដែលអ្នកកំណត់នៅជំហានបន្ទាប់ប៉ុណ្ណោះ។"
            },
            "schedule": {
              "heading": "គំរូកាលវិភាគ",
              "template": "គំរូ",
              "template-hint": "កំណត់ពេលវេលាចូលធ្វើការ ម៉ោងប្រចាំសប្តាហ៍ និងសិទ្ធិធ្វើការបន្ថែមម៉ោង។",
              "placeholder": "ជ្រើសរើសគំរូកាលវិភាគ",
              "details": "ព័ត៌មានកាលវិភាគ",
              "type": "ប្រភេទ",
              "loading": "កំពុងផ្ទុកកាលវិភាគ…",
              "error": "មិនអាចផ្ទុកកាលវិភាគបានទេ។",
              "retry": "ព្យាយាមម្ដងទៀត",
              "empty": "មិនទាន់មានកាលវិភាគការងារសម្រាប់ក្រុមហ៊ុននេះទេ។"
            },
            "contract": {
              "heading": "កិច្ចសន្យា",
              "type": "ប្រភេទកិច្ចសន្យា",
              "vacancy": "មុខតំណែងទំនេរ",
              "vacancy-hint": "ការជួលផ្អែកលើមុខតំណែង — ជ្រើសរើសពីបញ្ជីសំណើរបើកចំហ។ មុខតំណែងថ្មីត្រូវបើកតាមរយៈផែនការកម្លាំងការងារ។",
              "vacancy-placeholder": "ជ្រើសរើសមុខតំណែងទំនេរ",
              "start-date": "ថ្ងៃចាប់ផ្តើម",
              "end-date": "ថ្ងៃបញ្ចប់",
              "with-probation": "រួមបញ្ចូលរយៈពេលសាកល្បង",
              "probation-end-date": "ថ្ងៃបញ្ចប់សាកល្បង",
              "vacancy-loading": "កំពុងផ្ទុកមុខតំណែងទំនេរ…",
              "vacancy-error": "មិនអាចផ្ទុកមុខតំណែងទំនេរបានទេ។",
              "vacancy-retry": "ព្យាយាមម្ដងទៀត",
              "vacancy-empty": "គ្មានមុខតំណែងទំនេរសម្រាប់ក្រុមហ៊ុននេះទេ។ សូមបើកមុខតំណែងនៅក្នុងផែនការកម្លាំងពលកម្មជាមុនសិន។"
            },
            "leave": {
              "heading": "ច្បាប់ឈប់សម្រាក",
              "policy": "ច្បាប់ឈប់សម្រាក",
              "policy-hint": "កំណត់សិទ្ធិឈប់សម្រាកប្រចាំឆ្នាំ + ឈឺ និងវដ្តគណនា។",
              "placeholder": "ជ្រើសរើសច្បាប់ឈប់សម្រាក",
              "vendor-title": "ក្រុមហ៊ុនផ្តល់សេវាជាអ្នកគ្រប់គ្រងសិទ្ធិឈប់សម្រាក",
              "vendor-body": "ច្បាប់ឈប់សម្រាកសម្រាប់កំណត់ត្រា Vendor-lite ត្រូវបានគ្រប់គ្រងដោយ {vendor}។ យើងគ្រាន់តែបង្ហាញសំណើឈប់សម្រាកប្រតិបត្តិការសម្រាប់ភាពច្បាស់លាស់នៅទីតាំង។",
              "vendor-fallback": "ក្រុមហ៊ុនផ្តល់សេវា",
              "company-title": "គោលការណ៍ឈប់សម្រាករបស់ក្រុមហ៊ុនត្រូវបានអនុវត្ត",
              "company-body": "បុគ្គលិកថ្មីនេះទទួលបានសិទ្ធិឈប់សម្រាក និងល្បឿនបង្គរតាមស្តង់ដាររបស់ក្រុមហ៊ុន។ ប្រើការកំណត់ខាងក្រោមតែសម្រាប់សិទ្ធិដែលបានចរចាជាលក្ខណៈបុគ្គលប៉ុណ្ណោះ។",
              "override-toggle": "កំណត់សិទ្ធិស្តង់ដារឡើងវិញសម្រាប់បុគ្គលិកនេះ",
              "override-annual": "ការឈប់សម្រាកប្រចាំឆ្នាំ (ថ្ងៃ/ឆ្នាំ)",
              "override-sick": "ការឈប់សម្រាកឈឺ (ថ្ងៃ/ឆ្នាំ)",
              "override-justification": "ហេតុផល",
              "override-justification-placeholder": "ហេតុអ្វីបានជាបុគ្គលិកនេះទទួលបានសិទ្ធិមិនស្តង់ដារ"
            },
            "project": {
              "heading": "សិទ្ធិគម្រោង",
              "project": "គម្រោង",
              "project-hint": "អ្នកអនុម័តពីខាងក្រៅអាចមើលសំណើបានតែសម្រាប់បុគ្គលិកដែលដាក់ឱ្យធ្វើការនៅគម្រោងនេះប៉ុណ្ណោះ។",
              "placeholder": "ជ្រើសរើសគម្រោង",
              "their-project": "គម្រោងរបស់ពួកគេ",
              "can-do-title": "អាចធ្វើបាន",
              "can-do-1": "អនុម័ត / បដិសេធសំណើច្បាប់ឈប់សម្រាក និងចំណាយសម្រាប់បុគ្គលិកនៅ {project}",
              "can-do-2": "មើលសេចក្តីសង្ខេបវត្តមានសម្រាប់គម្រោង",
              "can-do-3": "ទទួលបានការជូនដំណឹងសម្រាប់ការអនុម័តដែលរង់ចាំ",
              "cannot-do-title": "មិនអាចធ្វើបាន",
              "cannot-do-1": "មើលទិន្នន័យប្រាក់ខែ ប្រាក់បៀវត្ស ឬច្បាប់រដ្ឋ",
              "cannot-do-2": "កែសម្រួលកំណត់ត្រាបុគ្គលិក",
              "cannot-do-3": "ចូលប្រើគម្រោងផ្សេងទៀត ឬបញ្ជី"
            },
            "vendor": {
              "heading": "ក្រុមហ៊ុនផ្តល់សេវា",
              "name": "ឈ្មោះក្រុមហ៊ុនផ្តល់សេវា",
              "name-hint": "ប្រើនៅលើរបាយការណ៍វត្តមាន វិក្កយបត្រអ្នកផ្គត់ផ្គង់ និងផ្ទាំងជ្រើសរើសខាងក្រៅ។",
              "placeholder": "ឧ. ManpowerKH Co. Ltd.",
              "governance-title": "ការគ្រប់គ្រង Vendor-lite",
              "governance-body": "ក្រុមហ៊ុនផ្តល់សេវាទទួលខុសត្រូវចំពោះប្រាក់ខែ វិភាគទានច្បាប់រដ្ឋ និងសិទ្ធិឈប់សម្រាក។ យើងតាមដានបុគ្គលនេះតែខាងប្រតិបត្តិការប៉ុណ្ណោះ — គ្មានការគណនាប្រាក់ខែទាក់ទងនឹងពួកគេទេ។"
            },
            "review": {
              "heading": "ពិនិត្យ និងបង្កើត",
              "heading-external": "ពិនិត្យ និងអញ្ជើញ",
              "section-person": "បុគ្គល",
              "section-schedule": "កាលវិភាគ",
              "section-contract": "កិច្ចសន្យា",
              "section-leave": "ច្បាប់ឈប់សម្រាក",
              "section-vendor": "ក្រុមហ៊ុនផ្តល់សេវា",
              "section-project": "សិទ្ធិគម្រោង",
              "code": "លេខកូដ",
              "name": "ឈ្មោះ",
              "gender": "ភេទ",
              "dob": "ថ្ងៃខែឆ្នាំកំណើត",
              "nid": "អត្តសញ្ញាណប័ណ្ណ",
              "email": "អ៊ីមែល",
              "phone": "ទូរស័ព្ទ",
              "schedule": "កាលវិភាគ",
              "contract-type": "ប្រភេទកិច្ចសន្យា",
              "vacancy": "មុខតំណែងទំនេរ",
              "start-date": "ថ្ងៃចាប់ផ្តើម",
              "end-date": "ថ្ងៃបញ្ចប់",
              "leave-policy": "ច្បាប់ឈប់សម្រាក",
              "vendor": "ក្រុមហ៊ុនផ្តល់សេវា",
              "project": "គម្រោង",
              "edit": "កែសម្រួល",
              "footer": "ការចុចបង្កើតនឹងបញ្ចូលបុគ្គលនេះទៅក្នុងបញ្ជី និងបង្កើតភារកិច្ចបណ្តុះបណ្តាល។ អ្នកអាចកែសម្រួលព័ត៌មានពីទម្រង់ប្រវត្តិរូបក្រោយមកបាន។",
              "footer-external": "ការចុចអញ្ជើញនឹងផ្ញើតំណចូលដល់អ្នកអនុម័តតាមរយៈអ៊ីមែល។ ពួកគេមិនមើលឃើញប្រាក់ខែ ឬគម្រោងផ្សេងទៀតទេ។",
              "leave-company-default": "គោលការណ៍លំនាំដើមរបស់ក្រុមហ៊ុន",
              "leave-annual": "ការកំណត់ប្រចាំឆ្នាំ (ថ្ងៃ)",
              "leave-sick": "ការកំណត់ការឈឺ (ថ្ងៃ)"
            },
            "footer": {
              "cancel": "បោះបង់",
              "back": "ត្រឡប់ក្រោយ",
              "next": "រក្សាទុក និងបន្ត",
              "create-employee": "បង្កើតបុគ្គលិក",
              "create-vendor": "បង្កើតកំណត់ត្រា",
              "create-external": "ផ្ញើអញ្ជើញ",
              "step-of": "ជំហានទី {n} នៃ {total}"
            },
            "toast": {
              "created": "បានបង្កើតបុគ្គល។ បញ្ជីនឹងធ្វើបច្ចុប្បន្នភាពក្នុងពេលឆាប់ៗ។",
              "endpoint-pending": "ចំណុចបញ្ចប់បង្កើតបុគ្គលនៅកំពុងតភ្ជាប់នៅខាងក្រោយ។ ការបញ្ចូលរបស់អ្នកត្រូវបានរក្សាទុក — សូមព្យាយាមម្តងទៀតពេលក្រោយ។"
            }
          }
        },
        "filters": {
          "all": "ទាំងអស់",
          "active": "សកម្ម",
          "direct": "ផ្ទាល់",
          "outsourced": "បុគ្គលិកខាងក្រៅ",
          "onboarding": "ចូលបំពេញការងារ",
          "probation": "កំពុងសាកល្បង",
          "pending": "រង់ចាំ",
          "on_leave": "ឈប់សម្រាក",
          "resigning": "លាលែង",
          "leaving": "ចាកចេញ",
          "inactive": "អសកម្ម",
          "client_staff": "បុគ្គលិកខាងក្រៅ"
        },
        "emp-type": {
          "label": "ប្រភេទ: ទាំងអស់",
          "all": "ប្រភេទ: ទាំងអស់",
          "Full-time": "ពេញម៉ោង",
          "Part-time": "ក្រៅម៉ោង"
        },
        "contract": {
          "label": "កិច្ចសន្យា: ទាំងអស់",
          "all": "កិច្ចសន្យា: ទាំងអស់",
          "UDC": "UDC (រយៈពេលមិនកំណត់)",
          "FDC": "FDC (រយៈពេលកំណត់)"
        },
        "search-placeholder": "ស្វែងរកឈ្មោះ លេខ អ៊ីមែល…",
        "columns": "ជួរឈរ",
        "export": "នាំចេញ",
        "import": "នាំចូល",
        "sort-by": "តម្រៀបតាម {column}",
        "table": {
          "employee": "បុគ្គលិក",
          "empCode": "លេខកូដបុគ្គលិក",
          "nameLatin": "ឈ្មោះពេញ (ឡាតាំង)",
          "nameKhmer": "ឈ្មោះពេញ (ខ្មែរ)",
          "gender": "ភេទ",
          "dob": "ថ្ងៃខែឆ្នាំកំណើត",
          "nid": "អត្តសញ្ញាណប័ណ្ណ / លិខិតឆ្លងដែន",
          "familyNameLatin": "ត្រកូល (ឡាតាំង)",
          "middleNameLatin": "ឈ្មោះកណ្តាល (ឡាតាំង)",
          "givenNameLatin": "នាមខ្លួន (ឡាតាំង)",
          "nicknameLatin": "ឈ្មោះហៅក្រៅ (ឡាតាំង)",
          "familyNameNative": "ត្រកូល (ខ្មែរ)",
          "middleNameNative": "ឈ្មោះកណ្តាល (ខ្មែរ)",
          "givenNameNative": "នាមខ្លួន (ខ្មែរ)",
          "nicknameNative": "ឈ្មោះហៅក្រៅ (ខ្មែរ)",
          "countryOfBirth": "ប្រទេសកំណើត",
          "cityProvinceOfBirth": "ទីក្រុង/ខេត្តកំណើត",
          "maritalStatus": "ស្ថានភាពគ្រួសារ",
          "nationality": "សញ្ជាតិ",
          "spouseName": "ឈ្មោះប្តី/ប្រពន្ធ",
          "numChildren": "ចំនួនកូន",
          "personalPhone": "លេខទូរស័ព្ទផ្ទាល់ខ្លួន",
          "personalEmail": "អ៊ីមែលផ្ទាល់ខ្លួន",
          "homeAddress": "អាសយដ្ឋានផ្ទះ",
          "email": "អ៊ីមែលការងារ",
          "phone": "លេខទូរស័ព្ទការងារ",
          "status": "ស្ថានភាពការងារ",
          "type": "ប្រភេទកម្លាំងពលកម្ម",
          "position": "តំណែង / ចំណងជើង",
          "department": "នាយកដ្ឋាន",
          "empType": "ប្រភេទការងារ",
          "joined": "កាលបរិច្ឆេទចូលបំរើការ",
          "contract": "ប្រភេទកិច្ចសន្យា",
          "contractStartDate": "កាលបរិច្ឆេទចាប់ផ្តើមកិច្ចសន្យា",
          "contractEndDate": "កាលបរិច្ឆេទបញ្ចប់កិច្ចសន្យា",
          "onProbation": "កំពុងសាកល្បង",
          "probationEndDate": "កាលបរិច្ឆេទបញ្ចប់ការសាកល្បង",
          "schedule": "កាលវិភាគការងារ",
          "weeklyHours": "ម៉ោងធ្វើការក្នុងមួយសប្តាហ៍",
          "availableAl": "ថ្ងៃឈប់សម្រាកប្រចាំឆ្នាំដែលនៅសល់",
          "project": "គម្រោង / អតិថិជន",
          "salary": "ប្រាក់ខែមូលដ្ឋាន",
          "costCenters": "មជ្ឈមណ្ឌលចំណាយ",
          "bank": "ធនាគារ",
          "account": "លេខគណនី",
          "bankAccountName": "ឈ្មោះគណនីធនាគារ",
          "nssfId": "លេខសម្គាល់ NSSF",
          "nssfScheme": "គម្រោង NSSF",
          "nssfEmployerType": "ប្រភេទនិយោជក NSSF",
          "nssfStatus": "ស្ថានភាព NSSF",
          "privateInsuranceProvider": "អ្នកផ្តល់ធានារ៉ាប់រងឯកជន",
          "privateInsurancePolicyId": "លេខសម្គាល់ធានារ៉ាប់រងឯកជន",
          "privateInsuranceScheme": "គម្រោងធានារ៉ាប់រងឯកជន",
          "lifecycle": "វដ្តជីវិត",
          "jobTitle": "ងារការងារ",
          "jobGrade": "កម្រិតការងារ",
          "seniorityLevel": "កម្រិតជាន់ខ្ពស់",
          "reportsToRole": "តួនាទីរបាយការណ៍ទៅ",
          "reportsToPerson": "រាយការណ៍ទៅបុគ្គល",
          "orgUnitType": "ប្រភេទអង្គភាព",
          "orgUnitLayer": "ស្រទាប់អង្គភាព",
          "locationName": "ឈ្មោះទីតាំង",
          "locationCode": "កូដទីតាំង",
          "locationLatLong": "កូអរដោនេទីតាំង (រយៈទទឹង/បណ្តោយ)",
          "locationAddress": "អាសយដ្ឋានទីតាំង",
          "resignationSubmittedDate": "កាលបរិច្ឆេទដាក់ពាក្យលាលែង",
          "resignationStatus": "ស្ថានភាពលាលែង",
          "requestedLastDay": "ថ្ងៃចុងក្រោយដែលបានស្នើសុំ",
          "resignationReason": "មូលហេតុលាលែង",
          "agreedLastDay": "ថ្ងៃចុងក្រោយដែលបានព្រមព្រៀង",
          "resignationDiscussedDate": "កាលបរិច្ឆេទពិភាក្សាការលាលែង",
          "discussReason": "មូលហេតុពិភាក្សា",
          "forwardToHrDate": "កាលបរិច្ឆេទបញ្ជូនទៅផ្នែកធនធានមនុស្ស",
          "leavingLastDate": "ថ្ងៃចុងក្រោយនៃការចាកចេញ",
          "leavingType": "ប្រភេទការចាកចេញ",
          "leavingReason": "មូលហេតុនៃការចាកចេញ",
          "client": "អតិថិជន",
          "externalManager": "អ្នកគ្រប់គ្រងខាងក្រៅ",
          "workforceSource": "ប្រភពកម្លាំងពលកម្ម",
          "vendor": "អ្នកផ្គត់ផ្គង់ / អ្នកផ្តល់សេវា",
          "providerEmpId": "លេខសម្គាល់និយោជិតរបស់អ្នកផ្តល់សេវា"
        },
        "col-panel": {
          "title": "កំណត់ជួរឈរតារាង",
          "subtitle": "ជ្រើសរើសប្រភេទព័ត៌មានបុគ្គលិកដើម្បីបង្ហាញក្នុងតារាង។ ជួរឈរដែលតម្រូវការមិនអាចលាក់បាន។",
          "hint": "{count} ជួរឈរត្រូវបានជ្រើស · អូសដើម្បីរៀបចំ · ចុចដើម្បីបើក/បិទ",
          "close": "បិទ",
          "reset": "កំណត់ឡើងវិញ",
          "apply": "អនុវត្ត",
          "required": "ចាំបាច់",
          "locked": "ចាក់សោ",
          "group": {
            "employee": "បុគ្គលិក",
            "basic-info": "ព័ត៌មានបុគ្គលិកមូលដ្ឋាន",
            "contact-info": "ព័ត៌មានទំនាក់ទំនង",
            "employment": "ការងារ និងតួនាទី",
            "contract": "ព័ត៌មានកិច្ចសន្យា",
            "schedule-leave": "កាលវិភាគ និងការឈប់សម្រាក",
            "payroll": "បើកប្រាក់ និងហិរញ្ញវត្ថុ",
            "insurance": "ការធានារ៉ាប់រង",
            "offboarding": "ការបញ្ចប់ការងារ",
            "other": "ផ្សេងៗ",
            "assignment": "ការចាត់តាំង",
            "provider": "ព័ត៌មានអ្នកផ្តល់សេវា"
          },
          "no-render": "មិនទាន់មានជាជួរឈរតារាង"
        },
        "loading": "កំពុងផ្ទុកជួរឈរ…",
        "showing": "បង្ហាញ {shown} នៃ {total} នាក់",
        "sorted-by": "តម្រៀបតាម {column} {dir}",
        "sort-dir-asc": "↑",
        "sort-dir-desc": "↓",
        "info-banner": {
          "title": "បញ្ជីបុគ្គលិក",
          "body": "ប្រភពទិន្នន័យតែមួយសម្រាប់បុគ្គលិកទាំងអស់ដែលធ្វើការនៅក្រុមហ៊ុនរបស់អ្នក — បុគ្គលិកផ្ទាល់ បុគ្គលិកខាងក្រៅ និងបុគ្គលិកក្រៅជាដៃគូ។ ប្រើផ្នែកស្ថានភាពដើម្បីត្រង ជួរឈរដើម្បីកំណត់ការបង្ហាញ ហើយចុចលើជួរណាមួយដើម្បីបើកប្រវត្តិរូបបុគ្គលិក។",
          "dismiss": "បិទ",
          "dismiss-aria": "បិទផ្ទាំងព័ត៌មាន Directory"
        },
        "filter-active": "ត្រង: {filter}",
        "type-active": "ប្រភេទ: {type}",
        "contract-active": "កិច្ចសន្យា: {contract}",
        "search-active": "ស្វែងរក: \"{q}\"",
        "clear-all": "លុបការត្រង",
        "empty": {
          "title": "រកមិនឃើញ",
          "with-search": "រកមិនឃើញបុគ្គលិក \"{q}\" នៅក្នុងការត្រង {filter}។",
          "no-search": "មិនមានបុគ្គលិកក្នុងការត្រង {filter}។",
          "clear": "លុបការត្រង",
          "first-title": "បន្ថែមបុគ្គលិកដំបូងរបស់អ្នក",
          "first-body": "កន្លែងធ្វើការនេះមិនទាន់មានបុគ្គលិកទេ។ បន្ថែមម្នាក់ដើម្បីចាប់ផ្តើមបង្កើតបញ្ជី ឬនាំចូលជាបាច់ពី Excel/CSV។",
          "first-cta-add": "បន្ថែមបុគ្គលិក",
          "first-cta-import": "នាំចូលពីឯកសារ"
        },
        "internal": "Optimal Internal",
        "error": "បរាជ័យក្នុងការផ្ទុកបុគ្គលិក។ សូមព្យាយាមឡើងវិញ។",
        "error-403": "អ្នកគ្មានសិទ្ធិមើលបុគ្គលិកទេ។",
        "error-500": "មានបញ្ហាខាងម្ខាងរបស់យើង។ សូមព្យាយាមឡើងវិញ។",
        "retry": "ព្យាយាមឡើងវិញ",
        "filter-remove": "លុបតម្រង {filter}",
        "sort-employee": "តម្រៀបតាមឈ្មោះបុគ្គលិក",
        "sort-position": "តម្រៀបតាមតួនាទី",
        "sort-department": "តម្រៀបតាមនាយកដ្ឋាន",
        "sort-project": "តម្រៀបតាមគម្រោង/អតិថិជន",
        "sort-type": "តម្រៀបតាមប្រភេទ",
        "sort-contract": "តម្រៀបតាមកិច្ចសន្យា",
        "sort-status": "តម្រៀបតាមស្ថានភាព",
        "delete": {
          "selected": "លុប {count} ដែលបានជ្រើស",
          "modal-title": "លុបបុគ្គលិក?",
          "modal-body": "{name} ({code}) នឹងត្រូវលុបចោលជាអចិន្ត្រៃយ៍។ សកម្មភាពនេះមិនអាចត្រឡប់វិញបានទេ។",
          "modal-body-many": "បុគ្គលិក {count} នាក់នឹងត្រូវលុបចោលជាអចិន្ត្រៃយ៍។ សកម្មភាពនេះមិនអាចត្រឡប់វិញបានទេ។",
          "confirm": "លុប",
          "cancel": "បោះបង់",
          "success": "{name} ត្រូវបានលុបរួចហើយ។",
          "success-many": "បុគ្គលិក {count} នាក់ត្រូវបានលុបរួចហើយ។",
          "error": "បរាជ័យក្នុងការលុបបុគ្គលិក។ សូមព្យាយាមឡើងវិញ។",
          "error-partial": "បានលុប {deleted} បរាជ័យ {failed} មិនអាចលុបបាន។ សូមព្យាយាម​ម្ដង​ទៀត។"
        },
        "bulkbar": {
          "count": "បានជ្រើស {n}",
          "in-view-all": "ទាំងអស់ក្នុងទិដ្ឋភាពបច្ចុប្បន្ន",
          "in-view-mixed": "{inView} ក្នុងទិដ្ឋភាពបច្ចុប្បន្ន · {offView} ក្រៅទិដ្ឋភាព",
          "export-selected": "នាំចេញដែលបានជ្រើស",
          "clear": "សម្អាត"
        },
        "coming-soon": "មកដល់ឆាប់ៗ",
        "download-excel": "ទាញយក Excel",
        "export-loading": "កំពុងនាំចេញ…",
        "export-success": "នាំចេញ {count} នាក់",
        "export-sheet": "បុគ្គលិក",
        "export-empty": "មិនមានបុគ្គលិកដើម្បីនាំចេញ",
        "export-error": "នាំចេញបរាជ័យ — សូមព្យាយាមម្ដងទៀត",
        "export-modal": {
          "title": "នាំចេញបុគ្គលិក",
          "description": "ជ្រើសរើសវិសាល ទ្រង់ទ្រាយ និងព័ត៌មានដែលត្រូវបញ្ចូល",
          "scope": {
            "label": "វិសាល — តើនាំចេញបុគ្គលិកណា",
            "filtered": "បញ្ជីដែលបានត្រង",
            "filtered-hint": "បុគ្គលិក {count} នាក់ដែលត្រូវនឹងតម្រង",
            "selected": "តែអ្នកដែលបានជ្រើស",
            "selected-hint": "បានជ្រើស {count} នាក់",
            "selected-empty": "អ្នកត្រូវជ្រើសជួរដេកនៅលើតារាងជាមុន",
            "full": "ឯកសារបុគ្គលិកទាំងមូល",
            "full-hint": "បុគ្គលិក {count} នាក់ — មិនអើពើតម្រង"
          },
          "format": {
            "label": "ទ្រង់ទ្រាយ",
            "xlsx": "Excel (.xlsx)",
            "xlsx-hint": "ណែនាំសម្រាប់ HR — បើកក្នុង Excel & Google Sheets ភ្លាម",
            "csv": "CSV (.csv)",
            "csv-hint": "អក្សរធម្មតា — ល្អបំផុតសម្រាប់ការនាំចូលឡើងវិញ"
          },
          "fields": {
            "label": "ជួរឈរបន្ថែម (លើសពីតារាងរបស់អ្នក)"
          },
          "sensitive-warning": "បុគ្គលិក {count} នាក់នឹងត្រូវនាំចេញ។ ព័ត៌មានប្រាក់ខែត្រូវបានបញ្ចូល — ប្រើប្រាស់ដោយប្រុងប្រយ័ត្ន។",
          "count": "បុគ្គលិក {count} នាក់នឹងត្រូវនាំចេញ",
          "cancel": "បោះបង់",
          "submit": "នាំចេញ {count} នាក់"
        },
        "workforce": {
          "label": "កម្លាំងពលកម្ម៖ ទាំងអស់",
          "all": "កម្លាំងពលកម្ម៖ ទាំងអស់",
          "Direct": "ផ្ទាល់",
          "Outsourced": "បុគ្គលិកខាងក្រៅ"
        },
        "workforce-active": "កម្លាំងពលកម្ម៖ {workforce}",
        "colfilter-active": "តម្រងជួរ {count}"
      },
      "outsourced": {
        "title": "កម្លាំងការងារជ្រើសរើសពីខាងក្រៅ",
        "subtitle": "បុគ្គលិកគ្រប់គ្រងដោយស្ថាប័ននេះ និងបានចាត់ឱ្យធ្វើការនៅគម្រោងអតិថិជន។ អ្នកអនុម័តរបស់អតិថិជនត្រូវបានអញ្ជើញតាមរយៈអ៊ីមែល និងទទួលបានការចូលដោយតំណមន្ត្រី — ពួកគេពុំមានគណនី Optimal HR ឡើយ។",
        "banner": {
          "title": "កម្លាំងការងារជ្រើសរើសពីខាងក្រៅ",
          "all": "បុគ្គលិកមិនមែនផ្ទាល់ទាំងអស់ដែលធ្វើការនៅទីតាំងរបស់យើង — ទាំងបុគ្គលិកដែលយើងជួល (UDC/FDC/Casual) និងបុគ្គលិកដែលអ្នកផ្ដល់សេវាបញ្ជូនមក។",
          "provider": "បុគ្គលិករបស់ Optimal P ដែលដាក់ឱ្យធ្វើការនៅទីតាំងអតិថិជន · យើងបង់ប្រាក់ខែ · LM អតិថិជនអនុម័តប្រចាំថ្ងៃ។",
          "service": "បុគ្គលិកដែលអ្នកផ្ដល់សេវាបញ្ជូនមក · ពួកគេគ្រប់គ្រងប្រាក់ខែ អត្ថប្រយោជន៍ និងបញ្ហាច្បាប់ · យើងគ្រាន់តែអនុម័តវត្តមាននិងការឈប់សម្រាក។",
          "detail-all": "នេះគឺជាការសិក្សាស៊ីជម្រៅប្រតិបត្តិការសម្រាប់ការចូលរួម EOR។ បញ្ជី Directory បង្ហាញបុគ្គលិកដូចគ្នាជាមួយបុគ្គលិកផ្ទាល់ · នៅទីនេះយើងបង្ហាញជួរឈរជាក់លាក់ EOR។",
          "detail-provider": "នេះគឺជាការសិក្សាស៊ីជម្រៅប្រតិបត្តិការសម្រាប់ការចូលរួម EOR។ បញ្ជី Directory បង្ហាញបុគ្គលិកដូចគ្នាជាមួយបុគ្គលិកផ្ទាល់ · នៅទីនេះយើងបង្ហាញជួរឈរជាក់លាក់ EOR។",
          "detail-service": "មិនបានកត់ត្រាប្រាក់ខែ — អ្នកលក់គ្រប់គ្រងការងារ។ យើងគ្រាន់តែឃើញអ្នកដែលគ្រប់គ្រងប្រតិបត្តិការ។"
        },
        "actions": {
          "invite-approver": "អញ្ជើញអ្នកអនុម័តរបស់អតិថិជន",
          "invite-toast": "លំហូរការអញ្ជើញ — នឹងមកដល់ក្នុងស្រាប់ៗ",
          "add-employee": "បន្ថែមបុគ្គលិកជ្រើសរើស",
          "add-toast": "លំហូរបន្ថែមបុគ្គលិក — នឹងមកដល់ក្នុងស្រាប់ៗ",
          "columns": "ជួរឈរ",
          "export": "នាំចេញ",
          "export-toast": "នាំចេញទៅ Excel · {count} ជួរ",
          "clear-filters": "សម្អាតតម្រង",
          "add-vendor-lite": "បន្ថែមកំណត់ត្រាអ្នកផ្គត់ផ្គង់ (Lite)"
        },
        "col-groups": {
          "identification": "អត្តសញ្ញាណ",
          "job-details": "ព័ត៌មានការងារ",
          "assignment": "ការចាត់តាំង",
          "contract": "កិច្ចសន្យា",
          "status": "ស្ថានភាព"
        },
        "view-mode": {
          "label": "ទិដ្ឋភាព",
          "all": "ទាំងអស់",
          "provider": "បុគ្គលិកអ្នកផ្ដល់",
          "provider-hint": "បុគ្គលិកដែលយើងជួល — UDC / FDC / Casual",
          "service": "កំណត់ត្រា Vendor Lite",
          "service-hint": "បុគ្គលិកដែលអ្នកលក់បញ្ជូនមក — មិនមានប្រាក់ខែខាងយើង",
          "assigned": "ចាត់តាំងដោយអ្នកផ្គត់ផ្គង់",
          "assigned-hint": "កម្មករដែលត្រូវបានចាត់តាំងទៅគម្រោងរបស់អ្នកដោយអ្នកផ្គត់ផ្គង់នៅលើ Optimal HR — អានតែប៉ុណ្ណោះ កម្មសិទ្ធិដោយអ្នកផ្គត់ផ្គង់"
        },
        "kpi": {
          "total-outsourced": "សរុបជ្រើសរើស",
          "total-provider": "សរុបបុគ្គលិកអ្នកផ្ដល់",
          "total-service": "សរុបបុគ្គលិកសេវាកម្ម",
          "active": "សកម្ម",
          "probation": "កំពុងសាកល្បង",
          "onboarding": "ការទទួល",
          "vendors": "អ្នកលក់",
          "expiring-fdc": "FDC ផុតកំណត់ ≤ ៣០ ថ្ងៃ",
          "expiring-service": "ការចូលរួមផុតកំណត់ ≤ ៣០ ថ្ងៃ"
        },
        "filters": {
          "all": "ទាំងអស់",
          "active": "សកម្ម",
          "probation": "កំពុងសាកល្បង",
          "onboarding": "ការទទួល",
          "onleave": "កំពុងឈប់សម្រាក",
          "resigning": "កំពុងលាឈប់",
          "leaving": "កំពុងចាកចេញ",
          "expiring": "ផុតកំណត់ ≤៣០ ថ្ងៃ",
          "all-projects": "គម្រោងទាំងអស់ · {count}",
          "all-managers": "LM អតិថិជនទាំងអស់"
        },
        "search-placeholder": "ស្វែងរកឈ្មោះ លេខ មុខងារ…",
        "table": {
          "showing": "បង្ហាញ {filtered} ក្នុងចំណោម {total} បុគ្គលិកជ្រើសរើស",
          "sorted-by": "តម្រៀបតាម {col} {dir}",
          "click-hint": "ចុចជួរណាមួយដើម្បីបើកប្រវត្តិរូប",
          "code": "លេខកូដ",
          "person": "បុគ្គល",
          "kh-name": "ឈ្មោះខ្មែរ",
          "position": "មុខតំណែង",
          "dept": "ផ្នែក",
          "project": "គម្រោង / អតិថិជន",
          "ext-mgr": "អ្នកគ្រប់គ្រងខាងក្រៅ (LM)",
          "contract": "កិច្ចសន្យា",
          "contract-end": "ផុតកំណត់កិច្ចសន្យា",
          "vendor": "អ្នកលក់",
          "joined": "កាលបរិច្ឆេទចូលរួម",
          "status": "ស្ថានភាព",
          "actions": "សកម្មភាព",
          "row-actions": "សកម្មភាពជួរ",
          "open-profile": "បើកប្រវត្តិរូប",
          "open-profile-toast": "ប្រវត្តិរូប — កំពុងបើក {code}",
          "no-end": "—"
        },
        "drawer": {
          "tabs": {
            "overview": "ទិដ្ឋភាពទូទៅ",
            "contract": "កិច្ចសន្យា"
          },
          "fields": {
            "code": "លេខកូដបុគ្គលិក",
            "kh-name": "ឈ្មោះខ្មែរ",
            "position": "មុខតំណែង",
            "dept": "ផ្នែក",
            "project": "គម្រោង",
            "client": "អតិថិជន",
            "external-manager": "អ្នកគ្រប់គ្រងខាងក្រៅ (LM)",
            "contract": "ប្រភេទកិច្ចសន្យា",
            "contract-end": "ផុតកំណត់កិច្ចសន្យា",
            "joined": "ចូលរួម",
            "base-location": "ទីតាំងគោល",
            "phone": "ទូរស័ព្ទ",
            "email": "អ៊ីមែល",
            "vendor": "អ្នកលក់"
          },
          "no-value": "—"
        },
        "empty": {
          "title": "គ្មានលទ្ធផល",
          "lede": "គ្មានបុគ្គលិកជ្រើសរើសណាមួយដែលត្រូវនឹងតម្រងទាំងនេះ។"
        },
        "mode-subtitle": {
          "provider-off": "បុគ្គលិកជាកម្មសិទ្ធិរបស់អង្គភាពនេះ ហើយត្រូវបានចាត់តាំងទៅគម្រោងអតិថិជន។ អ្នកអនុម័តខាងអតិថិជនត្រូវបានអញ្ជើញតាមអ៊ីមែល និងទទួលការចូលតាមតំណ magic-link — ពួកគេមិនមានគណនី Optimal HR ទេ។",
          "provider-on": "បុគ្គលិកជាកម្មសិទ្ធិរបស់អង្គភាពនេះ ហើយត្រូវបានចាត់តាំងទៅគម្រោងអតិថិជន។ ពេលអញ្ជើញអ្នកអនុម័តអតិថិជន ប្រព័ន្ធភ្ជាប់ទៅគណនី Optimal HR ដែលមានស្រាប់របស់ពួកគេ — គ្មាន ESS ស្ទួនទេ។",
          "client-on": "បុគ្គលិកក្រៅផ្ទះដែលត្រូវបានចាត់តាំងទៅគម្រោងរបស់អ្នកដោយអ្នកផ្គត់ផ្គង់នៅលើវេទិកា។ អ្នកផ្គត់ផ្គង់គ្រប់គ្រងប្រវត្តិរូប HR របស់កម្មករនីមួយៗ — អ្នកឃើញតែស្រមោលនៃការចាត់តាំង និងអាចអនុម័តសំណើប្រតិបត្តិការ។",
          "client-off": "កំណត់ត្រា Lite សម្រាប់កម្មករដែលផ្គត់ផ្គង់ដោយអ្នកផ្គត់ផ្គង់ដែលមិននៅលើ Optimal HR។ តាមដានប្រតិបត្តិការតែប៉ុណ្ណោះ — គ្មានបើកប្រាក់ខែដោយអង្គភាពនេះទេ។",
          "none": "ការដាក់បុគ្គលិកក្រៅផ្ទះត្រូវបានបិទសម្រាប់អង្គភាពនេះ។"
        },
        "mode": {
          "label": "របៀបដាក់បុគ្គលិកក្រៅផ្ទះរបស់អង្គភាព",
          "demo-tools": "ឧបករណ៍សាកល្បង",
          "dev-only": "សម្រាប់គំរូប៉ុណ្ណោះ — មិនមែននៅក្នុងផលិតកម្ម",
          "prod-note": "ផលិតកម្ម៖ កំណត់នៅ Admin → Modules",
          "close": "បិទ",
          "option": {
            "provider-off": "១ · អ្នកផ្គត់ផ្គង់បុគ្គលិក · អតិថិជនមិននៅលើ Optimal HR",
            "provider-on": "២ · អ្នកផ្គត់ផ្គង់បុគ្គលិក · អតិថិជននៅលើ Optimal HR ដែរ",
            "client-on": "៣ · អតិថិជនក្រៅផ្ទះ · អ្នកផ្គត់ផ្គង់នៅលើ Optimal HR",
            "client-off": "៤ · អតិថិជនក្រៅផ្ទះ · អ្នកផ្គត់ផ្គង់មិននៅលើ Optimal HR",
            "none": "៥ · សហគ្រាសតូចមធ្យមទូទៅ (គ្មានការដាក់ក្រៅផ្ទះ)"
          },
          "pill": {
            "role-provider": "តួនាទីអ្នកផ្គត់ផ្គង់",
            "role-client": "តួនាទីអតិថិជន",
            "role-none": "គ្មានការដាក់ក្រៅផ្ទះ",
            "client-on": "អតិថិជននៅលើ OHR",
            "client-off": "អតិថិជនក្រៅវេទិកា",
            "provider-on": "អ្នកផ្គត់ផ្គង់នៅលើ OHR",
            "provider-off": "អ្នកផ្គត់ផ្គង់ក្រៅវេទិកា",
            "disabled": "បានបិទ"
          }
        },
        "assigned": {
          "banner-title": "ចាត់តាំងដោយអ្នកផ្គត់ផ្គង់",
          "banner-lead": "កម្មករក្រៅផ្ទះដែលមិនមែនជាកម្មសិទ្ធិរបស់អង្គភាពនេះ។ អង្គភាពអ្នកផ្គត់ផ្គង់នៅលើ Optimal HR គ្រប់គ្រងប្រវត្តិរូប HR ពេញលេញ (បើកប្រាក់ខែ កិច្ចសន្យា ESS សិទ្ធិឈប់សម្រាក)។ អង្គភាពនេះទទួលតែស្រមោលនៃការចាត់តាំង និងអាចអនុម័តសំណើប្រតិបត្តិការសម្រាប់អ្នកអនុម័តដែលបានកំណត់។",
          "banner-detail": "ទិន្នន័យកម្មករអានតែប៉ុណ្ណោះនៅទីនេះ — ដើម្បីផ្លាស់ប្ដូរព័ត៌មានផ្ទាល់ខ្លួន លក្ខខណ្ឌកិច្ចសន្យា ឬប្រាក់ខែ សូមទាក់ទងអង្គភាពអ្នកផ្គត់ផ្គង់។ (ទិន្នន័យគំរូ — ការធ្វើសមកាលកម្មឆ្លងអង្គភាពនឹងមកដល់ពេលក្រោយ។)",
          "empty-title": "គ្មានការចាត់តាំងចូលមក",
          "empty-lede": "គ្មានអ្នកផ្គត់ផ្គង់នៅលើវេទិកាបញ្ជូនកម្មករទៅអង្គភាពនេះក្នុងសេណារីយ៉ូនេះទេ។ ប្ដូរទៅកំណត់ត្រា Lite ដើម្បីបន្ថែមកំណត់ត្រាដោយដៃសម្រាប់អ្នកផ្គត់ផ្គង់ក្រៅវេទិកា។",
          "empty-cta": "ទៅកាន់កំណត់ត្រា Lite",
          "showing": "កំពុងបង្ហាញការចាត់តាំងចូលមក {count} · កម្មសិទ្ធិដោយអង្គភាពអ្នកផ្គត់ផ្គង់",
          "click-hint": "ប្រវត្តិរូបកម្មករស្ថិតនៅក្នុងអង្គភាពអ្នកផ្គត់ផ្គង់",
          "accept": "ទទួលយកការចាត់តាំង",
          "decline": "បដិសេធការចាត់តាំង",
          "view": "មើលវិសាលភាព (អានតែប៉ុណ្ណោះ)",
          "accept-toast": "ការទទួលយក — អ្នកផ្គត់ផ្គង់នឹងត្រូវបានជូនដំណឹង; ស្រមោលនៃការចាត់តាំងក្លាយជា សកម្ម",
          "decline-toast": "ការបដិសេធ — អ្នកផ្គត់ផ្គង់នឹងត្រូវបានជូនដំណឹង; ការចាត់តាំងផុតកំណត់",
          "view-toast": "អានតែប៉ុណ្ណោះ · ប្រវត្តិរូបកម្មករស្ថិតនៅក្នុងអង្គភាពអ្នកផ្គត់ផ្គង់ ({tenant})",
          "kpi": {
            "total": "ចូលមកសរុប",
            "active": "សកម្ម",
            "pending": "កំពុងរង់ចាំការទទួលយក",
            "ended": "បានបញ្ចប់ (បណ្ណសារ)"
          },
          "col": {
            "worker": "កម្មករ",
            "provider": "អ្នកផ្គត់ផ្គង់",
            "project": "គម្រោង",
            "approver": "អ្នកអនុម័ត",
            "scope": "វិសាលភាព",
            "dates": "ចាប់ផ្ដើម–បញ្ចប់",
            "status": "ស្ថានភាព",
            "actions": "សកម្មភាព"
          }
        }
      },
      "configuration": {
        "sub-nav": {
          "grades": "ថ្នាក់ការងារ",
          "job-titles": "ងារតួនាទី",
          "job-profiles": "កម្រងការងារ",
          "benefits": "អត្ថប្រយោជន៍"
        },
        "banner": {
          "lead": "ទិន្នន័យយោង។",
          "rest": "ថ្នាក់ការងារ ងារតួនាទី កម្រងការងារ និងបញ្ជីអត្ថប្រយោជន៍ គឺជាគ្រឹះរួមដែលរាល់មុខតំណែង លិខិតផ្តល់ការងារ និងកំណត់ត្រាបុគ្គលនីមួយៗយោងទៅរក។ ការកែប្រែនៅទីនេះនឹងផ្សព្វផ្សាយដល់អ្នកប្រើទាំងអស់ — សូមកែប្រែដោយចេតនា។"
        },
        "benefits": {
          "title": "បញ្ជីអត្ថប្រយោជន៍",
          "subtitle": "បញ្ជីមេទូទាំងក្រុមហ៊ុនសម្រាប់ការធានារ៉ាប់រង · កាតព្វកិច្ច · សុខភាព · អត្ថប្រយោជន៍ជាសម្ភារៈ។ កំណត់ម្តង · យោងដោយការចុះឈ្មោះបុគ្គលិកគ្រប់រូប។",
          "add": "អត្ថប្រយោជន៍ថ្មី",
          "add-toast": "អត្ថប្រយោជន៍ថ្មី · ផ្ទាំងបង្កើតនឹងមកដល់នៅផ្នែកបន្ទាប់ ពេលដែល API បញ្ជីត្រូវបានដាក់ឱ្យដំណើរការ។",
          "search-placeholder": "ស្វែងរកតាមឈ្មោះ អ្នកផ្តល់សេវា គម្រោង…",
          "clear-filters": "សម្អាតតម្រង",
          "showing": "បង្ហាញ {filtered} ក្នុងចំណោម {total}",
          "renewal-soon": "ឆាប់ៗ",
          "cost-family": "គ្រួសារ USD {amt}",
          "auto-enroll": "ចុះឈ្មោះស្វ័យប្រវត្តិពេលជួល",
          "footnote": "ដើម្បីចុះឈ្មោះបុគ្គលិកជាក់លាក់ សូមបើកប្រវត្តិរូបរបស់គាត់ → អត្ថប្រយោជន៍។ សម្រាប់ការចុះឈ្មោះច្រើនរូប សូមប្រើកំណត់ត្រាការងារ → អត្ថប្រយោជន៍។",
          "kpi": {
            "active": "អត្ថប្រយោជន៍សកម្ម",
            "enrollments": "ការចុះឈ្មោះសកម្ម",
            "monthly-cost": "ថ្លៃប្រចាំខែ (និយោជក)",
            "renewing": "ត្រូវបន្តក្នុង ≤៩០ ថ្ងៃ"
          },
          "chips": {
            "all": "ទាំងអស់",
            "statutory": "កាតព្វកិច្ច",
            "insurance": "ការធានារ៉ាប់រង",
            "wellness": "សុខភាព",
            "allowance": "ប្រាក់ឧបត្ថម្ភជាសម្ភារៈ",
            "other": "ផ្សេងៗ"
          },
          "cols": {
            "benefit": "អត្ថប្រយោជន៍",
            "kind": "ប្រភេទ",
            "eligibility": "លក្ខណៈសម្បត្តិ",
            "cost": "ថ្លៃ / ខែ",
            "enrolled": "បានចុះឈ្មោះ",
            "renewal": "ការបន្ត",
            "status": "ស្ថានភាព"
          },
          "status": {
            "Active": "សកម្ម",
            "Renewing": "កំពុងបន្ត",
            "Ended": "បានបញ្ចប់"
          },
          "empty": {
            "title": "គ្មានអត្ថប្រយោជន៍ត្រូវនឹងតម្រងបច្ចុប្បន្ន",
            "lede": "សូមសម្អាតតម្រង ឬស្វែងរកដោយពាក្យគន្លឹះផ្សេង។"
          },
          "drawer": {
            "scheme": "គម្រោង",
            "policy-pattern": "លំនាំលេខគោលនយោបាយ",
            "coverage": "ការគ្របដណ្តប់",
            "eligibility": "លក្ខណៈសម្បត្តិ",
            "cost-emp": "ថ្លៃ / បុគ្គលិក / ខែ",
            "cost-fam": "ថ្លៃ / គ្រួសារ / ខែ",
            "cost-note": "កំណត់ចំណាំថ្លៃ",
            "renewal": "ការបន្តបន្ទាប់",
            "enrolled": "ការចុះឈ្មោះសកម្ម"
          }
        },
        "job-titles": {
          "banner-lead": "ងារតួនាទី",
          "banner-rest": " គឺជាគំរូតួនាទីដែលត្រូវបានយោងដោយមុខតំណែងជាច្រើន។ ងារនីមួយៗកំណត់ក្រុមការងារ ថ្នាក់លំនាំដើម និងលក្ខណៈបញ្ជាក់ ០–២ (ហាង បន្ទាត់ វេន ។ល។) ដែលបែងចែកកៅអីនីមួយៗដែលប្រើងារដូចគ្នា។ ឧ. ងារ \"អ្នកប្រតិបត្តិការរោងចក្រ\" មួយអាចត្រូវបានយោងដោយមុខតំណែងជាច្រើននៅលើបន្ទាត់ផលិតកម្មផ្សេងៗ។",
          "kpi": {
            "active": "ងារសកម្ម",
            "with-specifiers": "មានលក្ខណៈបញ្ជាក់",
            "orphan-main": "ងារគ្មានមុខតំណែង",
            "orphan-sub": "(មុខតំណែង ០)",
            "broken-grade": "តំណថ្នាក់ខូច"
          },
          "families-label": "ក្រុមការងារ៖",
          "toolbar-summary": "សកម្ម {active} · អសកម្ម {inactive}",
          "show-inactive": "បង្ហាញអសកម្ម",
          "add": "បន្ថែមងារតួនាទី",
          "error": "មិនអាចផ្ទុកងារតួនាទីបានទេ — {message}",
          "retry": "ព្យាយាមម្តងទៀត",
          "footnote": "ចុចជួរណាមួយដើម្បីកែ។ ដើម្បីមើលមុខតំណែងរបស់ងារ សូមប្រើទំព័រមុខតំណែងជាមួយតម្រងងារតួនាទី។",
          "cols": {
            "id": "លេខសម្គាល់",
            "title": "ងារ",
            "family": "ក្រុមការងារ",
            "grade": "ថ្នាក់លំនាំដើម",
            "specifiers": "លក្ខណៈបញ្ជាក់",
            "positions": "មុខតំណែង",
            "filled": "បានបំពេញ",
            "open": "ទំនេរ",
            "status": "ស្ថានភាព"
          },
          "status": {
            "active": "សកម្ម",
            "inactive": "អសកម្ម"
          },
          "errors": {
            "conflict": "ងារតួនាទីដែលមានឈ្មោះនេះមានរួចហើយ។ សូមប្រើងារផ្សេង ឬបន្ថែមលក្ខណៈបញ្ជាក់។",
            "forbidden": "អ្នកគ្មានសិទ្ធិគ្រប់គ្រងងារតួនាទីសម្រាប់ក្រុមហ៊ុននេះទេ។",
            "generic": "មិនអាចរក្សាទុកងារតួនាទីបានទេ។ សូមព្យាយាមម្តងទៀត។"
          },
          "empty": {
            "title": "មិនទាន់មានងារតួនាទីទេ",
            "subtitle": "បង្កើតគំរូតួនាទីដំបូងរបស់អ្នកដើម្បីចាប់ផ្តើមបង្កើតបញ្ជីមុខតំណែង។"
          },
          "modal": {
            "title": "ងារតួនាទីថ្មី",
            "subtitle": "បង្កើតគំរូតួនាទីសម្រាប់មុខតំណែងយោង",
            "sections": {
              "identity": "អត្តសញ្ញាណ",
              "classification": "ការចាត់ថ្នាក់",
              "specifiers": "លក្ខណៈបញ្ជាក់",
              "description": "ការពិពណ៌នា"
            },
            "fields": {
              "id": {
                "label": "លេខសម្គាល់",
                "hint": "នឹងត្រូវកំណត់ជាលេខកូដ JT-0XX នៅពេលបង្កើត។",
                "auto": "(ស្វ័យប្រវត្តិ)"
              },
              "title": {
                "label": "ងារ",
                "placeholder": "ឧ. វិស្វករជាន់ខ្ពស់"
              },
              "family": {
                "label": "ក្រុមការងារ",
                "placeholder": "ជ្រើសរើសក្រុមការងារ…"
              },
              "grade": {
                "label": "ថ្នាក់លំនាំដើម",
                "placeholder": "— ជ្រើសរើសថ្នាក់ —"
              },
              "specifiers": {
                "placeholder": "បន្ថែមលក្ខណៈបញ្ជាក់…"
              },
              "description": {
                "placeholder": "សង្ខេបតួនាទីខ្លី។ KSA លម្អិតគួរនៅលើកម្រងការងារវិញ។"
              }
            },
            "specifier-add": "បន្ថែម",
            "specifier-remove": "លុបលក្ខណៈបញ្ជាក់",
            "specifier-section-hint": "(អតិបរមា ២ — ប្រើដើម្បីបែងចែកមុខតំណែងដែលមានងារដូចគ្នា)",
            "specifier-empty": "គ្មានលក្ខណៈបញ្ជាក់។ មុខតំណែងនីមួយៗត្រូវបានកំណត់ដោយលេខសម្គាល់មុខតំណែងតែម្នាក់ឯង។ បន្ថែមមួយ (ឧ. ហាង បន្ទាត់ វេន) នៅពេលមុខតំណែងជាច្រើនប្រើងារដូចគ្នា។",
            "specifier-fields": {
              "name": "ឈ្មោះ",
              "name-placeholder": "ហាង / បន្ទាត់ / វេន",
              "source": "ប្រភព",
              "location-type": "ប្រភេទទីតាំង",
              "location-type-placeholder": "— ជ្រើសរើសប្រភេទ —",
              "free-text-hint": "វាយបញ្ចូលដោយ HR ពេលបំពេញមុខតំណែងនីមួយៗ",
              "projects-hint": "ប្រើបញ្ជីគម្រោងក្រៅ"
            },
            "note-before": "ងារថ្មីចាប់ផ្តើមជា ",
            "note-active": "សកម្ម",
            "note-after": " ហើយមានជាបន្ទាន់នៅក្នុងកម្មវិធីជ្រើសរើសមុខតំណែងថ្មី។ បិទ / បើកឡើងវិញ / ប្រវត្តិ នឹងមាននៅទីនេះបន្ទាប់ពីបង្កើតងាររួច។",
            "errors": {
              "employer-missing": "គ្មាននិយោជកសកម្ម — សូមបើកទំព័រនេះឡើងវិញ ហើយព្យាយាមម្តងទៀត។",
              "title-required": "ងារត្រូវបានទាមទារ។",
              "family-required": "ក្រុមការងារត្រូវបានទាមទារ។",
              "grade-required": "ថ្នាក់លំនាំដើមត្រូវបានទាមទារ។"
            },
            "cancel": "បោះបង់",
            "create": "បង្កើតងារ",
            "creating": "កំពុងបង្កើត…",
            "success": "ងារតួនាទី \"{title}\" ត្រូវបានបង្កើត។",
            "specifier-empty-1": "គ្មានលក្ខណៈបញ្ជាក់។ មុខតំណែងនីមួយៗត្រូវបានកំណត់អត្តសញ្ញាណដោយ Position ID តែម្នាក់ឯង។",
            "specifier-empty-2": "បន្ថែមលក្ខណៈបញ្ជាក់ (ឧ. Outlet, Line, Shift) នៅពេលមុខតំណែងជាច្រើនប្រើងារដូចគ្នា។"
          },
          "edit": {
            "title": "កែងារតួនាទី · {code}",
            "success": "ងារតួនាទី \"{title}\" ត្រូវបានធ្វើបច្ចុប្បន្នភាព។",
            "history": "ប្រវត្តិ",
            "history-soon": "ប្រវត្តិ — នឹងមានឆាប់ៗ",
            "id-locked": "ចាក់សោបន្ទាប់ពីបង្កើត។",
            "usage-positions": "មុខតំណែងយោងតាមងារនេះ",
            "inactive-notice-lead": "ងារតួនាទីនេះគឺអសកម្ម",
            "inactive-notice-rest": "។ វាត្រូវបានលាក់ពីកម្មវិធីជ្រើសរើសមុខតំណែងថ្មី ប៉ុន្តែត្រូវបានរក្សាទុកសម្រាប់សវនកម្ម។ ប្រើប៊ូតុងបើកឡើងវិញខាងក្រោមដើម្បីនាំវាមកវិញ។",
            "inactive-notice-rest-dated": " (បានបិទ {date})។ វាត្រូវបានលាក់ពីកម្មវិធីជ្រើសរើសមុខតំណែងថ្មី ប៉ុន្តែត្រូវបានរក្សាទុកសម្រាប់សវនកម្ម។ ប្រើប៊ូតុងបើកឡើងវិញខាងក្រោមដើម្បីនាំវាមកវិញ។",
            "cancel": "បោះបង់",
            "save-changes": "រក្សាទុកការផ្លាស់ប្តូរ",
            "saving": "កំពុងរក្សាទុក…",
            "deactivate": {
              "heading": "បិទងារតួនាទី",
              "explanation": "ងារដែលបានបិទត្រូវបានលាក់ពីកម្មវិធីជ្រើសរើសមុខតំណែងថ្មី ប៉ុន្តែត្រូវបានរក្សាទុកសម្រាប់សវនកម្ម។ ការលុបជាអចិន្ត្រៃយ៍មិនត្រូវបានអនុញ្ញាតទេ — នៅពេលកំណត់រួច ងារតួនាទីតែងតែនៅ។",
              "cannot": "មិនអាចបិទបានទេ — ងារនេះនៅតែប្រើដោយមុខតំណែង {count} ({filled} បានបំពេញ {open} ទំនេរ)។",
              "reassign-note": "បោះបង់ ឬផ្ដល់ឱ្យឡើងវិញនូវមុខតំណែងទាំងនោះជាមុនសិន។ មុខតំណែងទំនេរអាចបោះបង់បាន; មុខតំណែងដែលបានបំពេញត្រូវប្ដូរងារតួនាទីរបស់វា (ឬងារត្រូវរក្សាដំណើរការ)។",
              "action": "បិទងារនេះ",
              "cannot-lead": "មិនអាចបិទដំណើរការ",
              "cannot-rest": " — ងារនេះនៅតែប្រើដោយ៖",
              "usage-count": "{count} មុខតំណែង",
              "usage-breakdown": " ({filled} បានបំពេញ, {open} ទំនេរ)"
            },
            "reactivate": {
              "heading": "បើកងារតួនាទីឡើងវិញ",
              "explanation": "ការបើកឡើងវិញនាំងារនេះត្រឡប់ទៅសកម្ម។ វានឹងបង្ហាញនៅក្នុងកម្មវិធីជ្រើសរើសមុខតំណែងថ្មីម្តងទៀត។",
              "action": "បើកងារនេះឡើងវិញ"
            }
          },
          "banner-line1": "<strong>ងារតួនាទី</strong> គឺជាគំរូតួនាទីដែលត្រូវបានយោងដោយមុខតំណែងជាច្រើន។ ងារនីមួយៗប្រកាសក្រុមការងារ ថ្នាក់លំនាំដើម និងលក្ខណៈបញ្ជាក់ ០–២ (Outlet, Line, Shift ។ល។) ដែលបែងចែកកៅអីនីមួយៗដែលប្រើងារដូចគ្នា។",
          "banner-line2": "ឧ. ងារ «Plant Operator» មួយត្រូវបានយោងដោយ ៥ មុខតំណែងនៅលើខ្សែរោងចក្រផ្សេងៗ។",
          "specifier": {
            "none": "គ្មាន",
            "free-text": "អត្ថបទសេរី",
            "locations": "ទីតាំង",
            "projects": "គម្រោង"
          },
          "footnote-pre": "ចុចជួរណាមួយដើម្បីកែ។ ដើម្បីមើលមុខតំណែងនៃងារ ប្រើទំព័រ ",
          "footnote-bold": "មុខតំណែង",
          "footnote-post": " ជាមួយតម្រងងារតួនាទី។"
        },
        "job-profiles": {
          "banner-lead": "កម្រងការងារ",
          "banner-rest": " គឺជាស្រទាប់ជ្រៅជាជម្រើសដែលភ្ជាប់ទៅងារតួនាទី — KSA (ចំណេះដឹង ជំនាញ សមត្ថភាព) វិញ្ញាបនបត្រដែលត្រូវការ កំណត់ចំណាំផែនការបន្តវេន ផ្លូវសិក្សា និងទង់តួនាទីសំខាន់។ ក្រុមហ៊ុនភាគច្រើនបំពេញទាំងនេះសម្រាប់តួនាទីជាន់ខ្ពស់ ឬសំខាន់ប៉ុណ្ណោះ។ កម្រងគឺជាមាតិកា (មិនមែនរចនាសម្ព័ន្ធ) ដូច្នេះសកម្មភាពគឺធ្វើបច្ចុប្បន្នភាពជាជាងកែ។ ការដកចេញអាចត្រឡប់វិញបាន — មាតិកានៅតែក្នុងមូលដ្ឋានទិន្នន័យសម្រាប់សវនកម្ម។",
          "kpi": {
            "active-titles": "ងារសកម្ម",
            "attached": "កម្រងបានភ្ជាប់",
            "critical": "តួនាទីសំខាន់",
            "without-succession": "គ្មានការបន្តវេន",
            "succession-unit": "តួនាទីសំខាន់"
          },
          "filters": {
            "label": "តម្រងកម្រង",
            "all": "ងារទាំងអស់",
            "with": "មានកម្រង",
            "no": "គ្មានកម្រង",
            "critical": "សំខាន់តែប៉ុណ្ណោះ"
          },
          "show-removed": "បង្ហាញកម្រងដែលបានដក ({count})",
          "error": "មិនអាចផ្ទុកកម្រងការងារបានទេ — {message}",
          "retry": "ព្យាយាមម្តងទៀត",
          "empty": {
            "title": "មិនទាន់មានងារតួនាទីទេ",
            "subtitle": "បង្កើតងារតួនាទីជាមុនសិន — កម្រងភ្ជាប់ទៅពួកវា។"
          },
          "cols": {
            "title": "ងារតួនាទី",
            "family": "ក្រុមការងារ",
            "grade": "ថ្នាក់លំនាំដើម",
            "profile": "កម្រង",
            "updated": "ធ្វើបច្ចុប្បន្នភាពចុងក្រោយ",
            "action": "សកម្មភាព"
          },
          "profile-attached": "កម្រង",
          "profile-critical": "សំខាន់",
          "profile-none": "គ្មានកម្រង",
          "action-add": "បន្ថែមកម្រង",
          "action-update": "ធ្វើបច្ចុប្បន្នភាព",
          "action-restore": "ស្តារ",
          "removed-heading": "កម្រងដែលបានដក ({count})",
          "removed-subtitle": "មាតិកាត្រូវបានរក្សាទុកសម្រាប់សវនកម្ម។ ការស្តារនាំកម្រងត្រឡប់ទៅសកម្មដោយគ្មានការបាត់បង់ទិន្នន័យ។",
          "removed-cols": {
            "id": "លេខសម្គាល់កម្រង",
            "title": "ងារតួនាទី",
            "removed-on": "បានដកនៅ",
            "removed-by": "បានដកដោយ",
            "action": "សកម្មភាព"
          },
          "removed-toast": "កម្រងការងារត្រូវបានដក។ អ្នកអាចស្តារវាពីបញ្ជីដែលបានដក។",
          "status": {
            "removed": "បានដក"
          },
          "errors": {
            "conflict": "កម្រងមានរួចហើយសម្រាប់ងារតួនាទីនេះ។",
            "forbidden": "អ្នកគ្មានសិទ្ធិគ្រប់គ្រងកម្រងការងារសម្រាប់ក្រុមហ៊ុននេះទេ។",
            "generic": "មិនអាចរក្សាទុកកម្រងការងារបានទេ។ សូមព្យាយាមម្តងទៀត។"
          },
          "modal": {
            "add-title": "បន្ថែមកម្រងការងារ",
            "update-title": "ធ្វើបច្ចុប្បន្នភាពកម្រងការងារ",
            "add-note": "កំពុងបន្ថែមកម្រងថ្មី។ គ្រប់ផ្នែកជាជម្រើស — បំពេញអ្វីដែលមានប្រយោជន៍។ ក្រុមហ៊ុនភាគច្រើនចាប់ផ្តើមជាមួយតួនាទីជាន់ខ្ពស់/សំខាន់ ហើយពង្រីកតាមពេលវេលា។",
            "success": "កម្រងការងារត្រូវបានបង្កើត។",
            "sections": {
              "content": "មាតិកា",
              "certifications": "វិញ្ញាបនបត្រដែលត្រូវការ",
              "strategic": "ទង់យុទ្ធសាស្ត្រ"
            },
            "fields": {
              "knowledge": {
                "label": "ចំណេះដឹង",
                "hint": "អ្វីដែលត្រូវដឹង",
                "placeholder": "ឧ. ច្បាប់ការងារកម្ពុជា; នីតិវិធីដាក់ NSSF; គណនេយ្យចូលពីរ…"
              },
              "skills": {
                "label": "ជំនាញ",
                "hint": "អ្វីដែលត្រូវធ្វើ",
                "placeholder": "ឧ. ពិនិត្យកូដ; ការណែនាំ; សរសេរអាជីវកម្មខ្មែរ + អង់គ្លេស…"
              },
              "abilities": {
                "label": "សមត្ថភាព",
                "hint": "សមត្ថភាព",
                "placeholder": "ឧ. លើក ២៥ គីឡូ; ធ្វើការវេនយប់; វិភាគនិន្នាការពីទិន្នន័យលេខ…"
              },
              "certification": {
                "placeholder": "ឧ. SHRM-SCP ឬសមមូល"
              },
              "critical": {
                "label": "តួនាទីសំខាន់",
                "hint": "ផលប៉ះពាល់ខ្ពស់ប្រសិនបើមិនបានបំពេញ; ត្រូវការផែនការបន្តវេន + យុទ្ធសាស្ត្របន្ត"
              },
              "succession": {
                "label": "កំណត់ចំណាំការបន្តវេន",
                "placeholder": "តើនរណាជាអ្នកបន្តវេន? ពេលវេលា? គម្លាតការអភិវឌ្ឍន៍?",
                "hint": "ណែនាំសម្រាប់តួនាទីសំខាន់"
              },
              "learning": {
                "label": "ផ្លូវសិក្សា",
                "placeholder": "ការណែនាំផ្ទៃក្នុង; វគ្គសិក្សាខាងក្រៅ; ការបង្វិល…"
              },
              "performance": {
                "label": "វិមាត្រការអនុវត្ត",
                "placeholder": "តើម៉ែត្រិកណាវាស់ភាពជោគជ័យក្នុងតួនាទីនេះ?"
              }
            },
            "cert-add": "បន្ថែម",
            "cert-empty": "មិនត្រូវការវិញ្ញាបនបត្រ។",
            "cert-remove": "លុបវិញ្ញាបនបត្រ",
            "succession-warning": "តួនាទីសំខាន់ដែលគ្មានកំណត់ចំណាំការបន្តវេន — បន្ថែមអ្នកបន្តវេន ឬផែនការអភិវឌ្ឍន៍។",
            "cancel": "បោះបង់",
            "create": "បង្កើតកម្រង",
            "creating": "កំពុងបង្កើត…",
            "errors": {
              "employer-missing": "គ្មាននិយោជកសកម្ម — សូមបើកទំព័រនេះឡើងវិញ ហើយព្យាយាមម្តងទៀត។",
              "no-title": "មិនបានជ្រើសរើសងារតួនាទីទេ — សូមបើកឡើងវិញ ហើយព្យាយាមម្តងទៀត។"
            },
            "add-note-lead": "កំពុងបន្ថែមកម្រងថ្មី។",
            "add-note-rest": " គ្រប់ផ្នែកជាជម្រើស — បំពេញអ្វីដែលមានប្រយោជន៍។ ក្រុមហ៊ុនភាគច្រើនចាប់ផ្តើមជាមួយតួនាទីជាន់ខ្ពស់/សំខាន់ ហើយពង្រីកតាមពេលវេលា។",
            "confirm-critical": "ទង់តួនាទីសំខាន់ត្រូវបានកំណត់ ប៉ុន្តែកំណត់ចំណាំការបន្តវេនទទេ។\n\nវាត្រូវបានណែនាំយ៉ាងមុតមាំឱ្យកត់ត្រាអ្នកស្នងតំណែងសម្រាប់តួនាទីសំខាន់។ បន្តដែរឬទេ?"
          },
          "update": {
            "success": "កម្រងការងារត្រូវបានធ្វើបច្ចុប្បន្នភាព។",
            "history": "ប្រវត្តិ",
            "history-soon": "ប្រវត្តិ — នឹងមានឆាប់ៗ",
            "removed-notice": " នៅ {date} ដោយ {by}។ មាតិកាត្រូវបានរក្សាទុកសម្រាប់សវនកម្ម។ ប្រើប៊ូតុងស្តារនៅខាងក្រោមដើម្បីនាំវាត្រឡប់មកវិញ។",
            "save-changes": "ធ្វើបច្ចុប្បន្នភាពកម្រង",
            "saving": "កំពុងរក្សាទុក…",
            "remove": {
              "heading": "ដកកម្រង",
              "explanation": "ដកកម្រងនេះចេញពីងារតួនាទី។ មាតិកាត្រូវបានរក្សាទុកសម្រាប់សវនកម្ម — នេះមិនមែនជាការលុបជាអចិន្ត្រៃយ៍ទេ។ អ្នកអាចស្តារវាពេលក្រោយពីបញ្ជីដែលបានដក។",
              "action": "ដកកម្រងនេះ",
              "explanation-pre": "ការដកចេញផ្តាច់កម្រងចេញពីងារតួនាទីរបស់វា។ ",
              "explanation-bold": "មាតិកាត្រូវបានរក្សាទុក",
              "explanation-post": " សម្រាប់សវនកម្ម — នេះមិនមែនជាការលុបទេ។ អ្នកអាចស្តារពី «បង្ហាញកម្រងដែលបានដក» នៅពេលក្រោយ។",
              "confirm": "ដកកម្រងការងារសម្រាប់ «{title}» ឬ?\n\nមាតិកាកម្រងត្រូវបានរក្សាទុកក្នុងមូលដ្ឋានទិន្នន័យសម្រាប់សវនកម្ម។ ងារតួនាទីនឹងបង្ហាញជា «គ្មានកម្រង» ប៉ុន្តែអ្នកអាចស្តារវានៅពេលក្រោយ។"
            },
            "restore": {
              "heading": "ស្តារកម្រង",
              "explanation": "ការស្តារនាំកម្រងនេះត្រឡប់ទៅសកម្មវិញ។ មាតិកាត្រូវបានរក្សាទុកអំឡុងពេលដកចេញ — គ្មានការបាត់បង់។",
              "action": "ស្តារកម្រងនេះ"
            },
            "removed-notice-lead": "កម្រងនេះត្រូវបានដក"
          },
          "banner-line1": "<strong>កម្រងការងារ</strong> គឺជាស្រទាប់ជ្រៅ<em>ជាជម្រើស</em>ដែលភ្ជាប់ទៅងារតួនាទី — KSA (ចំណេះដឹង ជំនាញ សមត្ថភាព) វិញ្ញាបនបត្រដែលត្រូវការ កំណត់ចំណាំផែនការបន្តវេន ផ្លូវសិក្សា និងទង់តួនាទីសំខាន់។ ក្រុមហ៊ុនភាគច្រើនបំពេញទាំងនេះសម្រាប់តួនាទីជាន់ខ្ពស់ ឬសំខាន់ប៉ុណ្ណោះ។",
          "banner-line2": "កម្រងគឺជា<strong>មាតិកា</strong> (មិនមែនរចនាសម្ព័ន្ធ) ដូច្នេះសកម្មភាពគឺ<strong>ធ្វើបច្ចុប្បន្នភាព</strong>ជាជាងកែ។ ការដកចេញអាចត្រឡប់វិញបាន — មាតិកានៅតែក្នុងមូលដ្ឋានទិន្នន័យសម្រាប់សវនកម្ម។",
          "counts-active": "សកម្ម",
          "counts-removed": "បានដក",
          "show-removed-label": "បង្ហាញកម្រងដែលបានដក",
          "guide": {
            "title": "អ្វីដែលកម្រងការងារមាន",
            "k": {
              "head": "K · ចំណេះដឹង",
              "desc": "អ្វីដែលតួនាទីត្រូវដឹង។ ឧ.",
              "eg": "«ច្បាប់ការងារកម្ពុជា» «នីតិវិធីដាក់ NSSF» «គណនេយ្យពីរផ្នែក»"
            },
            "s": {
              "head": "S · ជំនាញ",
              "desc": "អ្វីដែលតួនាទីត្រូវធ្វើ។ ឧ.",
              "eg": "«តារាង Pivot ក្នុង Excel» «ផ្សារដែក TIG តាមស្តង់ដារ ASME» «សរសេរអាជីវកម្មខ្មែរ + អង់គ្លេស»"
            },
            "a": {
              "head": "A · សមត្ថភាព",
              "desc": "សមត្ថភាព។ ឧ.",
              "eg": "«លើកទម្ងន់ ២៥គក ដដែលៗ» «ធ្វើការវេនយប់» «វិភាគនិន្នាការពីទិន្នន័យលេខ»"
            },
            "other": {
              "head": "ផ្សេងៗ",
              "desc": "វិញ្ញាបនបត្រដែលត្រូវការ · ផ្លូវសិក្សា · ទង់តួនាទីសំខាន់ · បេក្ខជនបន្តវេន · វិមាត្រការអនុវត្ត។"
            }
          },
          "table-caption-lead": "ងារតួនាទី",
          "table-caption-rest": " ជាមួយស្ថានភាពកម្រងរបស់វា — ចុច «ធ្វើបច្ចុប្បន្នភាព» ដើម្បីកែលម្អ «បន្ថែម» ដើម្បីចាប់ផ្តើមកម្រងថ្មី",
          "table-count": "{shown} ក្នុងចំណោម {total} ងារ",
          "profile-active": "សកម្ម",
          "action-review-restore": "ពិនិត្យ និងស្តារ",
          "action-review": "ពិនិត្យ",
          "removed-caption-rest": " — មាតិកាត្រូវបានរក្សាទុកសម្រាប់សវនកម្ម។ ស្តារពីតារាងខាងលើ (ជួរបង្ហាញស្ថានភាព «បានដក») ឬចុចខាងក្រោម។",
          "profile-no-succession": "គ្មានការបន្តវេន"
        },
        "grades": {
          "banner-lead": "ថ្នាក់ការងារ",
          "banner-mid": " កំណត់ក្រុមប្រាក់ខែ និងឋានានុក្រមអតីតភាព។ ងារតួនាទីនីមួយៗប្រកាស",
          "banner-emphasis": "ថ្នាក់លំនាំដើម",
          "banner-rest": " ហើយមុខតំណែងនីមួយៗទទួលថ្នាក់ពីងារតួនាទីរបស់ខ្លួន។ ប្រាក់ខែក្រៅក្រុមនៅពេលបន្ថែមបុគ្គលិក នឹងបង្ហាញការព្រមានស្រាល។",
          "kpi": {
            "active": "ថ្នាក់សកម្ម",
            "lowest-min": "ប្រាក់ខែអប្បបរមាទាបបំផុត",
            "highest-max": "ប្រាក់ខែអតិបរមាខ្ពស់បំផុត",
            "orphan-main": "ថ្នាក់គ្មានងារ",
            "orphan-sub": "(គ្មានងារតួនាទី)",
            "primary-currency-caption": "({currency} · ថ្នាក់ច្រើនបំផុត)"
          },
          "currency-filter-label": "រូបិយប័ណ្ណ",
          "currency-all": "ទាំងអស់",
          "toolbar-summary-head": "សកម្ម {active} · អសកម្ម {inactive}",
          "toolbar-summary-overlaps": "ក្រុមត្រួតគ្នា {overlaps}",
          "show-inactive": "បង្ហាញអសកម្ម",
          "add": "បន្ថែមថ្នាក់ការងារ",
          "cols": {
            "code": "កូដ",
            "grade": "ទម្ងន់ថ្នាក់",
            "title": "ងារ",
            "min": "ប្រាក់ខែអប្បបរមា",
            "max": "ប្រាក់ខែអតិបរមា",
            "currency": "រូបិយប័ណ្ណ",
            "titles": "ងារតួនាទី",
            "positions": "មុខតំណែងបានបំពេញ",
            "description": "ការពិពណ៌នា",
            "status": "ស្ថានភាព"
          },
          "status": {
            "active": "សកម្ម",
            "inactive": "អសកម្ម"
          },
          "loading": "កំពុងផ្ទុកថ្នាក់ការងារ…",
          "error": "មិនអាចផ្ទុកថ្នាក់ការងារបានទេ — {message}",
          "retry": "ព្យាយាមឡើងវិញ",
          "errors": {
            "conflict": "មានថ្នាក់ការងារដែលប្រើកូដ ឬទម្ងន់ថ្នាក់នេះរួចហើយ។ សូមប្រើកូដ ឬទម្ងន់ផ្សេង។",
            "forbidden": "អ្នកមិនមានសិទ្ធិគ្រប់គ្រងថ្នាក់ការងារសម្រាប់ក្រុមហ៊ុននេះទេ។",
            "generic": "មិនអាចរក្សាទុកថ្នាក់ការងារបានទេ។ សូមព្យាយាមម្តងទៀត។"
          },
          "empty": {
            "title": "មិនទាន់មានថ្នាក់ការងារ",
            "subtitle": "បង្កើតក្រុមអតីតភាពដំបូងរបស់អ្នក ដើម្បីចាប់ផ្តើមបង្កើតកាំជណ្តើរថ្នាក់។"
          },
          "modal": {
            "title": "ថ្នាក់ការងារថ្មី",
            "subtitle": "កំណត់ក្រុមអតីតភាពថ្មី",
            "sections": {
              "identity": "អត្តសញ្ញាណ",
              "salary": "ក្រុមប្រាក់ខែ (សរុប ប្រចាំខែ)",
              "description": "ការពិពណ៌នា"
            },
            "fields": {
              "code": {
                "label": "កូដ",
                "placeholder": "ឧ. L5",
                "hint": "កូដបង្ហាញខ្លី (ឧ. L5)"
              },
              "grade": {
                "label": "ថ្នាក់",
                "placeholder": "ឧ. 5",
                "hint": "ទម្ងន់ជាលេខសម្រាប់តម្រៀប — ខ្ពស់ជាង = ថ្នាក់ខ្ពស់ជាង"
              },
              "title": {
                "label": "ងារ",
                "placeholder": "ឧ. អ្នកគ្រប់គ្រងជាន់ខ្ពស់"
              },
              "min": {
                "label": "អប្បបរមា",
                "placeholder": "ឧ. 5000"
              },
              "max": {
                "label": "អតិបរមា",
                "placeholder": "ឧ. 8000"
              },
              "currency": {
                "label": "រូបិយប័ណ្ណ"
              },
              "description": {
                "placeholder": "អ្នកណាសមនឹងថ្នាក់នេះ? ឆ្នាំបទពិសោធន៍ វិសាលភាព កម្រិតសិទ្ធិអំណាច…"
              }
            },
            "note-before": "ថ្នាក់ថ្មីចាប់ផ្តើមជា",
            "note-active": "សកម្ម",
            "note-after": " ហើយបង្ហាញក្នុងបញ្ជីជ្រើសរើសថ្នាក់ភ្លាមៗ។ បិទ / បើកឡើងវិញ / ប្រវត្តិ នឹងមាននៅទីនេះបន្ទាប់ពីបង្កើតថ្នាក់រួច។",
            "errors": {
              "grade-required": "តម្រូវឱ្យមានថ្នាក់។",
              "grade-numeric": "ថ្នាក់ត្រូវតែជាលេខត្រឹមត្រូវ។",
              "grade-taken": "ថ្នាក់នេះត្រូវបានប្រើរួចហើយ។",
              "code-taken": "កូដនេះត្រូវបានប្រើរួចហើយ។",
              "code-required": "តម្រូវឱ្យមានកូដ។",
              "title-required": "តម្រូវឱ្យមានងារ។",
              "salary-required": "តម្រូវឱ្យមានប្រាក់ខែអប្បបរមា និងអតិបរមា។",
              "numeric": "អប្បបរមា និងអតិបរមា ត្រូវតែជាលេខត្រឹមត្រូវ។",
              "max-below-min": "ប្រាក់ខែអតិបរមាត្រូវតែធំជាង ឬស្មើនឹងប្រាក់ខែអប្បបរមា។",
              "employer-missing": "មិនមាននិយោជកសកម្មទេ — សូមបើកទំព័រនេះឡើងវិញ ហើយព្យាយាមម្ដងទៀត។"
            },
            "cancel": "បោះបង់",
            "create": "បង្កើតថ្នាក់",
            "creating": "កំពុងបង្កើត…",
            "success": "បានបង្កើតថ្នាក់ការងារ {code}។"
          },
          "edit": {
            "title": "កែថ្នាក់ការងារ · {code}",
            "history": "ប្រវត្តិ",
            "history-soon": "ប្រវត្តិ — នឹងមានឆាប់ៗ",
            "save-changes": "រក្សាទុកការផ្លាស់ប្តូរ",
            "saving": "កំពុងរក្សាទុក…",
            "cancel": "បោះបង់",
            "success": "បានកែថ្នាក់ការងារ {code}។",
            "code-locked": "កូដត្រូវបានចាក់សោបន្ទាប់ពីបង្កើត (យោងដោយងារតួនាទី)។",
            "code-editable": "មិនទាន់មានកូដ — បន្ថែមមួយ (យោងដោយងារតួនាទី រួចចាក់សោ)។",
            "inactive-notice-lead": "ថ្នាក់ការងារនេះអសកម្ម",
            "inactive-notice-rest": "។ ប្រវត្តិកែប្រែត្រូវបានរក្សាទុក។ ប្រើប៊ូតុងបើកឡើងវិញខាងក្រោម ដើម្បីនាំវាត្រឡប់មកវិញ។",
            "inactive-notice-rest-dated": " (បានបិទនៅ {date})។ ប្រវត្តិកែប្រែត្រូវបានរក្សាទុក។ ប្រើប៊ូតុងបើកឡើងវិញខាងក្រោម ដើម្បីនាំវាត្រឡប់មកវិញ។",
            "overlap-lead": "ក្រុមត្រួតគ្នា",
            "overlap-detail": "ជាមួយ៖ {code} ({min}–{max})។ វាត្រូវបានអនុញ្ញាត (ការព្រមានស្រាល) ប៉ុន្តែជាទូទៅថ្នាក់មិនគួរត្រួតគ្នាទេ។",
            "usage": {
              "titles-suffix": "ងារតួនាទី យោងលើថ្នាក់នេះ",
              "positions-suffix": "មុខតំណែងបានបំពេញ នៅថ្នាក់នេះ"
            },
            "deactivate": {
              "heading": "បិទថ្នាក់ការងារ",
              "explanation": "ថ្នាក់ដែលបានបិទនឹងលាក់ពីបញ្ជីជ្រើសរើស ប៉ុន្តែរក្សាទុកសម្រាប់ការត្រួតពិនិត្យ។ ការលុបជាអចិន្ត្រៃយ៍មិនត្រូវបានអនុញ្ញាតទេ — បន្ទាប់ពីបានកំណត់ ថ្នាក់ការងារតែងតែនៅក្នុងមូលដ្ឋានទិន្នន័យ។",
              "cannot": "មិនអាចបិទបានទេ — ថ្នាក់នេះកំពុងត្រូវបានប្រើ៖",
              "reason-titles": "ងារតួនាទី {count} យោងវាជាថ្នាក់លំនាំដើម",
              "reason-positions": "មុខតំណែងបានបំពេញ {count} នៅថ្នាក់នេះ",
              "reassign-note": "សូមផ្ដល់ឱ្យពួកវាទៅថ្នាក់ផ្សេងជាមុនសិន រួចត្រឡប់មកទីនេះ។",
              "action": "បិទថ្នាក់នេះ",
              "cannot-lead": "មិនអាចបិទបានទេ",
              "cannot-rest": " — ថ្នាក់នេះកំពុងត្រូវបានប្រើ៖",
              "reason-titles-count": "ងារតួនាទី {count}",
              "reason-titles-rest": " យោងវាជាថ្នាក់លំនាំដើម",
              "reason-positions-count": "មុខតំណែងបានបំពេញ {count}",
              "reason-positions-rest": " នៅថ្នាក់នេះ"
            },
            "reactivate": {
              "heading": "បើកថ្នាក់ការងារឡើងវិញ",
              "explanation": "ការបើកឡើងវិញ ស្ដារថ្នាក់នេះទៅជាសកម្ម។ វានឹងបង្ហាញក្នុងបញ្ជីជ្រើសរើសថ្នាក់ម្តងទៀត។ ប្រវត្តិកែប្រែបន្តដោយមិនផ្លាស់ប្តូរ។",
              "action": "បើកថ្នាក់នេះឡើងវិញ"
            }
          }
        }
      },
      "salaryBatch": {
        "button": "បង្វិលប្រាក់ខែជាបាច់",
        "modal": {
          "title": "ការកែប្រាក់ខែជាបាច់",
          "subtitle": "ធ្វើបច្ចុប្បន្នភាពប្រាក់ខែបុគ្គលិកជាច្រើននាក់ពី Excel ជាមួយការផ្ទៀងផ្ទាត់ភ្លាមៗ។"
        },
        "steps": {
          "upload": "ផ្ទុកឯកសារ",
          "validation": "ការផ្ទៀងផ្ទាត់",
          "confirm": "ការបញ្ជាក់"
        },
        "tabs": {
          "batch": "បាច់ថ្មី",
          "history": "ប្រវត្តិបាច់"
        },
        "footer": {
          "cancel": "បោះបង់",
          "validate": "ផ្ទៀងផ្ទាត់",
          "confirmApply": "បញ្ជាក់ & អនុវត្ត",
          "nextValidation": "បន្ទាប់: ការផ្ទៀងផ្ទាត់",
          "nextConfirm": "បន្ទាប់: ការបញ្ជាក់",
          "back": "ថយក្រោយ"
        },
        "confirm": {
          "summaryTitle": "សង្ខេបការអនុវត្ត",
          "rowsToApply": "ជួរដែលត្រូវអនុវត្ត",
          "warningsOverridden": "ការព្រមានដែលបានជ្រួស",
          "noRowsToApply": "មិនមានជួរត្រឹមត្រូវសម្រាប់អនុវត្ត។ សូមត្រឡប់ក្រោយ ហើយពិនិត្យលទ្ធផលផ្ទៀងផ្ទាត់។",
          "note": "ការផ្លាស់ប្តូរប្រាក់ខែគឺជារៀងរហូត ហើយមិនអាចត្រឡប់វិញបាន។ សូមពិនិត្យលទ្ធផលផ្ទៀងផ្ទាត់មុនពេលបញ្ជាក់។"
        },
        "instructions": {
          "title": "ការណែនាំ & តម្រូវការ",
          "step1Title": "ជំហានទី ១ — បង្កើតពុម្ព",
          "step1Bullet1": "ជ្រើសតម្រងវិសាលភាព (នាយកដ្ឋាន, ទីតាំង) ប្រសិនចង់ ហើយចុចបង្កើតពុម្ព។",
          "step1Bullet2": "ដោយគ្មានតម្រង ពុម្ពរួមមានបុគ្គលិកសកម្មទាំងអស់។ មានតម្រង មានតែបុគ្គលិកដែលត្រូវគ្នាប៉ុណ្ណោះ។",
          "step1Bullet3": "ទាញយកឯកសារ ហើយបំពេញ: ប្រាក់ខែមូលដ្ឋានថ្មី (លេខវិជ្ជមាន), កាលបរិច្ឆេទចូលជាធរមាន (YYYY-MM-DD), ហេតុផល (ចាំបាច់)។",
          "step1Bullet4": "ជួរឈរដែលអានបាន — លេខកូដបុគ្គលិក ឈ្មោះពេញ ប្រាក់ខែបច្ចុប្បន្ន — កុំកែទាំងនេះ។",
          "step2Title": "ជំហានទី ២ — ផ្ទុកឡើង & ផ្ទៀងផ្ទាត់",
          "step2Bullet1": "ទទួលឯកសារ .xlsx ប៉ុណ្ណោះ។ ទំហំអតិបរមា: 5 MB។",
          "step2Bullet2": "កុំកែសន្លឹកទិន្នន័យលាក់ — វាត្រូវបានប្រើដើម្បីផ្ទៀងផ្ទាត់ភាពត្រឹមត្រូវនៃពុម្ព។",
          "step2Bullet3": "ការចុចផ្ទៀងផ្ទាត់គឺជាការសាកល្បង — គ្មានកំណត់ត្រាប្រាក់ខែត្រូវបានបង្កើត។",
          "step2Bullet4": "ជួរដែលមានកំហុសមិនអាចអនុវត្ត។ ជួរដែលមានការព្រមានអាចត្រូវបានជ្រួស។"
        },
        "scopeFilters": {
          "title": "វិសាលភាព & ពុម្ព",
          "optional": "(ស្រេចចិត្ត)",
          "orgUnit": "អង្គភាពស្ថាប័ន",
          "orgUnitPlaceholder": "អង្គភាពទាំងអស់",
          "baseLocation": "ទីតាំងមូលដ្ឋាន",
          "baseLocationPlaceholder": "ទីតាំងទាំងអស់",
          "downloadBtn": "ទាញយកពុម្ព",
          "downloading": "កំពុងទាញយក…",
          "descriptionAll": "និយោជិតសកម្មទាំងអស់",
          "descriptionFiltered": "និយោជិតដែលត្រូវបានត្រងតែប៉ុណ្ណោះ"
        },
        "upload": {
          "title": "ផ្ទុកឡើងពុម្ពដែលបានបំពេញ",
          "dropHint": "ទម្លាក់ឯកសារ ឬចុចដើម្បីរុករក",
          "fileTypeHint": "ឯកសារ .xlsx ប៉ុណ្ណោះ",
          "fileSizeLimit": "អតិបរមា {size} MB",
          "removeFile": "លុបឯកសារ"
        },
        "preview": {
          "title": "មើលជាមុនក្រោយផ្ទៀងផ្ទាត់",
          "statTotal": "សរុប:",
          "statValid": "ត្រឹមត្រូវ:",
          "statInvalid": "កំហុស:",
          "statWarnings": "ការព្រមាន:",
          "statPending": "រង់ចាំការផ្ទៀងផ្ទាត់",
          "colNum": "#",
          "colStatus": "ស្ថានភាព",
          "colEmployeeCode": "លេខកូដបុគ្គលិក",
          "colFullName": "ឈ្មោះពេញ",
          "colCurrentSalary": "ប្រាក់ខែបច្ចុប្បន្ន",
          "colNewSalary": "ប្រាក់ខែថ្មី",
          "colEffectiveDate": "កាលបរិច្ឆេទចូលជាធរមាន",
          "colReason": "ហេតុផល",
          "colRemark": "ចំណាំ",
          "colOverride": "ជ្រួស",
          "statusValid": "ត្រឹមត្រូវ",
          "statusError": "កំហុស",
          "statusWarning": "ការព្រមាន",
          "statusPending": "កំពុងរង់ចាំ",
          "statusUnknown": "មិនស្គាល់",
          "exportErrors": "នាំចេញកំហុស",
          "warningOverrideBanner": "ជួរខ្លះ​មានការ​ព្រមាន។ ធីក​ប្រអប់​ជ្រួស​ ដើម្បី​រួម​បញ្ចូល​ក្នុង​ការ​អនុវត្ត។",
          "csvColRow": "ជួរ",
          "csvColErrors": "កំហុស / ការព្រមាន"
        },
        "result": {
          "successTitle": "បានអនុវត្តការកែប្រាក់ខែ",
          "successSub": "{succeeded} កំណត់ត្រា​ត្រូវ​បាន​ធ្វើ​បច្ចុប្បន្ន​ភាព​ដោយ​ជោគ​ជ័យ។",
          "successSubFailed": " {failed} បរាជ័យ។",
          "downloadResult": "ទាញយកឯកសារលទ្ធផល",
          "downloadOriginal": "ទាញយកឯកសារដើម"
        },
        "history": {
          "description": "ការ​កែ​ប្រាក់​ខែ​ជា​បាច់​ពី​មុន​សម្រាប់​និយោជ​ករ​រូប​នេះ។",
          "loading": "កំពុងបង្ហាញប្រវត្តិ…",
          "empty": "មិន​ទាន់​មាន​ប្រវត្តិ​បាច់​នៅ​ឡើយ។",
          "unknown": "មិនស្គាល់",
          "batchId": "លេខ​បាច់",
          "validated": "បាន​ផ្ទៀង​ផ្ទាត់",
          "applied": "បាន​អនុវត្ត",
          "validateSummaryValue": "{valid} ត្រឹមត្រូវ / {total} សរុប",
          "applySummaryValue": "{succeeded} ជោគជ័យ, {failed} បរាជ័យ / {total} សរុប",
          "importedOf": "{succeeded} / {total} បាន​អនុវត្ត",
          "rowsCount": "{count} ជួរ",
          "downloadResult": "ទាញ​យក​លទ្ធ​ផល",
          "downloadOriginal": "ទាញ​យក​ប្រភព"
        },
        "errors": {
          "filterLoadFailed": "មិន​អាច​ផ្ទុក​ជម្រើស​ត្រង​បាន​ទេ។ សូម​ព្យា​យាម​ម្ដង​ទៀត។",
          "generateFailed": "មិន​អាច​បង្កើត​ពុម្ព​បាន​ទេ។ សូម​ព្យា​យាម​ម្ដង​ទៀត។",
          "invalidTemplateResponse": "ការ​ឆ្លើយ​តប​ពុម្ព​មិន​ត្រឹម​ត្រូវ​ពី​ម៉ាស៊ីន​បម្រើ។",
          "onlyXlsx": "ទទួល​យក​ឯក​សារ .xlsx ប៉ុណ្ណោះ។",
          "fileTooLarge": "ឯក​សារ​លើស {size} MB ។",
          "noDataRows": "ឯក​សារ​គ្មាន​ជួរ​ទិន្នន័យ​ទេ។",
          "parseError": "មិន​អាច​អាន​ឯក​សារ​បាន​ទេ។ សូម​ប្រាកដ​ថា​វា​ជា​ឯក​សារ .xlsx ត្រឹម​ត្រូវ។",
          "readError": "មិន​អាច​អាន​ឯក​សារ​ពី​ថា​ស​ក្បាល​បាន​ទេ។",
          "validateFailed": "ការ​ផ្ទៀង​ផ្ទាត់​បរាជ័យ។ សូម​ព្យា​យាម​ម្ដង​ទៀត។",
          "applyFailed": "ការ​អនុវត្ត​បរាជ័យ។ សូម​ព្យា​យាម​ម្ដង​ទៀត។",
          "historyLoadFailed": "មិន​អាច​ផ្ទុក​ប្រវត្តិ​បាច់​បាន​ទេ។",
          "resultDownloadFailed": "មិន​អាច​ទាញ​យក​ឯក​សារ​លទ្ធ​ផល​បាន​ទេ។",
          "originalDownloadFailed": "មិន​អាច​ទាញ​យក​ឯក​សារ​ដើម​បាន​ទេ។"
        }
      },
      "profile": {
        "joined": "ចូលបម្រើការ",
        "message": "ទំនាក់ទំនង",
        "edit": "កែប្រែ",
        "coming-soon": "នឹងមានក្នុងការអាប់ដេតបន្ទាប់",
        "photo": {
          "upload-tooltip": "ផ្លាស់ប្ដូររូបថតប្រវត្តិ",
          "upload-success": "រូបថតប្រវត្តិត្រូវបានធ្វើបច្ចុប្បន្នភាព។",
          "upload-error": "ការធ្វើបច្ចុប្បន្នភាពរូបថតប្រវត្តិបរាជ័យ។ សូមព្យាយាមម្ដងទៀត។",
          "remove": "លុបរូបថត"
        },
        "error": "បរាជ័យក្នុងការផ្ទុកប្រវត្តិបុគ្គលិក។",
        "retry": "ព្យាយាមម្ដងទៀត",
        "nav-label": "ផ្នែកប្រវត្តិ",
        "tabs": {
          "overview": "ទិដ្ឋភាពទូទៅ",
          "job": "ការងារ និងអង្គភាព",
          "contract": "កិច្ចសន្យា",
          "employment-actions": "សកម្មភាពការងារ",
          "compensation": "សំណង",
          "benefits": "អត្ថប្រយោជន៍",
          "payroll": "បើកប្រាក់ខែ",
          "attendance": "វត្តមាន",
          "documents": "ឯកសារ",
          "personal": "ព័ត៌មានផ្ទាល់ខ្លួន",
          "journey": "ដំណើរការការងារ"
        },
        "contract": {
          "current-contract": "កិច្ចសន្យាបច្ចុប្បន្ន",
          "readonly-label": "អានបានតែ",
          "readonly-structural": "ការផ្លាស់ប្ដូររចនាសម្ព័ន្ធគឺជា ព្រឹត្តិការណ៍កិច្ចសន្យា",
          "readonly-pay": "ការផ្លាស់ប្ដូរប្រាក់ខែគឺជា ការកែប្រែប្រាក់ខែ",
          "contract-type": "ប្រភេទកិច្ចសន្យា",
          "status": "ស្ថានភាព",
          "start-date": "កាលបរិច្ឆេទចាប់ផ្ដើម",
          "end-date": "កាលបរិច្ឆេទបញ្ចប់",
          "ongoing": "កំពុងដំណើរការ",
          "end-date-ongoing": "— កំពុងដំណើរការ",
          "probation-end": "ថ្ងៃបញ្ចប់ការសាកល្បង",
          "base-salary-monthly": "ប្រាក់បៀវត្សមូលដ្ឋានកិច្ចសន្យា",
          "base-salary-hint": "/ ខែ — នៅពេលចុះហត្ថលេខា",
          "base-salary-no-adj": "គ្មានការកែប្រែប្រាក់ខែចាប់តាំងពីការចុះហត្ថលេខា — ប្រាក់ខែមូលដ្ឋានកិច្ចសន្យា = ប្រាក់ខែដែលមានប្រសិទ្ធភាពបច្ចុប្បន្ន។",
          "all-contracts": "កិច្ចសន្យាទាំងអស់",
          "all-contracts-desc": "រាល់ជួរគឺជាកិច្ចសន្យាដែលបានចុះហត្ថលេខាដាច់ដោយឡែក។ កិច្ចសន្យាថ្មីមកពី ព្រឹត្តិការណ៍កិច្ចសន្យា (ការបន្ត · ការពន្យារ · ការបម្លែង · ការកែប្រែ)។ ការកែប្រែប្រាក់ខែមិនបង្កើតជួរកិច្ចសន្យាថ្មីទេ។",
          "col-start": "ចាប់ផ្ដើម",
          "col-end": "បញ្ចប់",
          "col-type": "ប្រភេទ",
          "col-base-salary": "ប្រាក់ខែមូលដ្ឋាន",
          "col-status": "ស្ថានភាព",
          "col-actions": "សកម្មភាព",
          "no-contracts": "មិនមានកិច្ចសន្យា",
          "add": "កិច្ចសន្យាថ្មី",
          "edit": "កែប្រែកិច្ចសន្យា",
          "delete": "លុបកិច្ចសន្យា",
          "confirm-delete": "លុបកិច្ចសន្យានេះ? វាមិនអាចត្រឡប់វិញបានទេ។",
          "confirm-delete-yes": "បាទ/ចាស លុប",
          "confirm-delete-no": "បោះបង់",
          "events-title": "ព្រឹត្តិការណ៍កិច្ចសន្យា",
          "events-subtitle": "កត់ត្រាការផ្លាស់ប្ដូរវដ្ដជីវិតកិច្ចសន្យា: បន្ត · ពន្យារ · បម្លែង · កែប្រែ · ការជ្រើសរើស · បញ្ចប់។ ដំណាក់កាល ១ — ការកត់ត្រាតែប៉ុណ្ណោះ។",
          "events-add": "បន្ថែមព្រឹត្តិការណ៍កិច្ចសន្យា",
          "events-empty-title": "មិនទាន់មានព្រឹត្តិការណ៍កិច្ចសន្យា",
          "events-empty-hint": "ប្រើផ្ទៃនេះ នៅពេល HR ទទួលបានកិច្ចសន្យា / ការបន្ត / ការកែប្រែ / ការជ្រើសរើស ក្រៅបណ្ដាញ ហើយត្រូវការកត់ត្រា។",
          "events-col-effective": "ចូលជាធរមាន",
          "events-col-event": "ព្រឹត្តិការណ៍",
          "events-col-detail": "ព័ត៌មានលម្អិត",
          "events-col-status": "ស្ថានភាព",
          "salary-adj-title": "ប្រវត្តិការកែប្រែប្រាក់ខែ",
          "salary-adj-subtitle": "ព្រឹត្តិការណ៍ប្រាក់ចំណូលដែលផ្លាស់ប្ដូរប្រាក់ខែជាប់ពន្ធ ដោយមិនកែប្រែកិច្ចសន្យដែលបានចុះហត្ថលេខា។",
          "salary-adj-count": "ការកែប្រែ {n}",
          "salary-adj-col-effective-date": "កាលបរិច្ឆេទចូលជាធរមាន",
          "salary-adj-col-from": "ពី",
          "salary-adj-col-to": "ទៅ",
          "salary-adj-col-reason": "មូលហេតុ",
          "salary-adj-col-status": "ស្ថានភាព",
          "salary-adj-note": "ប្រាក់ខែមូលដ្ឋានកិច្ចសន្យាដែលបានចុះហត្ថលេខាខាងលើគឺចាក់ស្ថិតិ។ ការកែប្រែកិច្ចសន្យាផ្ទាល់ ទាមទារ ព្រឹត្តិការណ៍កិច្ចសន្យា (ការកែប្រែ / ការបន្ត / ការបម្លែង)។ ការកែប្រែប្រាក់ខែ ត្រូវបានកត់ត្រាតាម ផ្ទាំងប្រាក់ចំណូល → កំណត់ព្រឹត្តិការណ៍ប្រាក់ចំណូល → ការកែប្រែប្រាក់ខែ។"
        },
        "more-menu": {
          "label": "សកម្មភាពបន្ថែម",
          "section-contract": "សកម្មភាពកិច្ចសន្យា",
          "section-other": "ផ្សេងទៀត",
          "new-contract": "កិច្ចសន្យាថ្មី",
          "new-contract-sub": "បង្កើតកិច្ចសន្យាថ្មីសម្រាប់បុគ្គលិកនេះ",
          "renew-contract": "បន្តកិច្ចសន្យា",
          "renew-contract-sub": "ពន្យាររយៈពេលកិច្ចសន្យាបច្ចុប្បន្ន",
          "rehire": "ជ្រើសរើសមកវិញ",
          "rehire-sub": "ជួលបុគ្គលិកដែលធ្លាប់ចាកចេញឡើងវិញ",
          "download-pdf": "ទាញយកកិច្ចសន្យា PDF",
          "download-pdf-unavailable": "ការនាំចេញ PDF កិច្ចសន្យានៅមិនទាន់អាចធ្វើបានទេ។",
          "delete-employee": "លុបប្រវត្តិបុគ្គលិក",
          "delete-employee-confirm-title": "លុបប្រវត្តិបុគ្គលិក",
          "delete-employee-confirm-body": "សកម្មភាពនេះជាអចិន្ត្រៃយ៍ ហើយមិនអាចដកហូតវិញបាន។ តើអ្នកប្រាកដថាចង់លុបជាអចិន្ត្រៃយ៍",
          "delete-employee-confirm-yes": "បាទ/ចាស លុប",
          "delete-employee-confirm-no": "បោះបង់",
          "delete-employee-error": "ការលុបបុគ្គលិកបរាជ័យ។ សូមព្យាយាមម្ដងទៀត។"
        },
        "contract-drawer": {
          "title": {
            "new": "កិច្ចសន្យាថ្មី",
            "renew": "បន្តកិច្ចសន្យា",
            "rehire": "ជ្រើសរើសបុគ្គលិកឡើងវិញ"
          },
          "subtitle": {
            "new": "បង្កើតកិច្ចសន្យាការងារថ្មី",
            "renew": "ពន្យារកិច្ចសន្យាបច្ចុប្បន្នជាមួយរយៈពេលថ្មី",
            "rehire": "ជ្រើសរើសបុគ្គលិកនេះឡើងវិញក្រោមកិច្ចសន្យាថ្មី"
          },
          "rehire-note": "វានឹងបង្កើតកិច្ចសន្យាថ្មី និងសម្គាល់បុគ្គលិកថាជ្រើសរើសឡើងវិញ។ ត្រូវប្រាកដថាឯកសារចាំបាច់ទាំងអស់ត្រូវបានបំពេញ មុនពេលបន្ត។",
          "field-type": "ប្រភេទកិច្ចសន្យា",
          "field-type-placeholder": "ជ្រើសប្រភេទកិច្ចសន្យា",
          "field-employment-type": "ប្រភេទការងារ",
          "field-start-date": "ថ្ងៃចាប់ផ្ដើម",
          "field-end-date": "ថ្ងៃបញ្ចប់",
          "field-salary": "ប្រាក់ខែមូលដ្ឋាន",
          "field-salary-placeholder": "ឧ. 1200",
          "field-position": "មុខតំណែង (តារាងស្ថាប័ន)",
          "field-position-placeholder": "ជ្រើសរើសមុខតំណែងទំនេរ",
          "field-position-hint": "ស្រេចចិត្ត — ភ្ជាប់កិច្ចសន្យានេះទៅនឹងមុខតំណែងទំនេរក្នុងតារាងស្ថាប័ន។",
          "position-loading": "កំពុងផ្ទុកមុខតំណែង…",
          "position-empty": "មិនមានមុខតំណែងទំនេរ។",
          "field-reason": "មូលហេតុ",
          "field-reason-placeholder": "មូលហេតុសម្រាប់សកម្មភាពកិច្ចសន្យានេះ",
          "error-start-required": "ថ្ងៃចាប់ផ្ដើមត្រូវការ។",
          "error-end-required": "ថ្ងៃបញ្ចប់ត្រូវការសម្រាប់ប្រភេទកិច្ចសន្យានេះ។",
          "error-end-after-start": "ថ្ងៃបញ្ចប់ត្រូវនៅក្រោយថ្ងៃចាប់ផ្ដើម។",
          "error-reason-required": "មូលហេតុត្រូវការ។",
          "error-save-failed": "បរាជ័យក្នុងការរក្សាទុក។ សូមព្យាយាមម្ដងទៀត។",
          "cancel": "បោះបង់",
          "save": "រក្សាទុककិច្ចសន្យា",
          "saving": "កំពុងរក្សាទុក…"
        },
        "employment-actions": {
          "title": "សកម្មភាពការងារ",
          "subtitle": "កំណត់ EA ស្របតួនាទី · កាតាឡុក v1 ៣ សកម្មភាព · §9.6 រក្សាទុក · ស្លាកដែលទាញចេញត្រូវបានរក្សា",
          "frozen-chip": "CI Rev 3.2.1 · ជំហានដែលបានតម្កល់",
          "new-action": "+ សកម្មភាពការងារថ្មី",
          "error": "បរាជ័យក្នុងការផ្ទុកសកម្មភាពការងារ។",
          "retry": "ព្យាយាមម្ដងទៀត",
          "phase1-bold": "ដំណាក់កាល ១ · ការកត់ត្រាតែប៉ុណ្ណោះ។",
          "phase1-notice": "HR កត់ត្រានូវអ្វីដែលបានយល់ព្រមក្រៅបណ្ដាញ (អំផ្លិត / លិខិត / ការអនុម័ត LM)។ ស្ថានភាពត្រូវបានទាញចេញពីថ្ងៃចូលជាធរមាន — កំណត (ពេលអនាគត) ឬ ជាធរមាន (ថ្ងៃនេះ/ពីមុន)។",
          "empty-title": "មិនទាន់មានសកម្មភាពការងារសម្រាប់ {name}",
          "empty-hint": "ចុច សកម្មភាពការងារថ្មី ខាងលើ ដើម្បីបង្កើតអំបូរដំបូង។",
          "confirm-cancel": "បោះបង់សកម្មភាពការងារនេះ? វាមិនអាចត្រឡប់វិញបានទេ។",
          "confirm-cancel-yes": "បាទ/ចាស បោះបង់",
          "confirm-cancel-no": "រក្សាទុក",
          "cancel-action": "បោះបង់",
          "view-detail": "មើលព័ត៌មានលម្អិត",
          "kpi": {
            "current-position": "តួនាទីបច្ចុប្បន្ន",
            "reports-to": "រាយការណ៍ទៅ",
            "eas-employee": "EA (បុគ្គលិកនេះ)",
            "eas-tenant": "EA (រួមទាំងអស់)",
            "scheduled": "កំណត",
            "effective": "ជាធរមាន",
            "cancelled": "បានបោះបង់",
            "scheduled-future": "កំណត (ពេលអនាគត)"
          },
          "col": {
            "date": "កាលបរិច្ឆេទ",
            "type": "ប្រភេទ",
            "detail": "ព័ត៌មានលម្អិត",
            "label": "ស្លាកដែលរកឃើញ",
            "status": "ស្ថានភាព"
          },
          "info": {
            "current-position": "តួនាទីបច្ចុប្បន្ន",
            "reports-to": "រាយការណ៍ទៅ",
            "eas-employee": "EA (បុគ្គលិកនេះ)",
            "eas-tenant": "EA (រួមទាំងអស់)",
            "scheduled": "កំណត",
            "effective": "ជាធរមាន",
            "cancelled": "បានបោះបង់"
          },
          "status": {
            "scheduled": "កំណត",
            "effective": "ជាធរមាន",
            "cancelled": "បានបោះបង់",
            "unknown": "មិនស្គាល់"
          },
          "field": {
            "effective-date": "ថ្ងៃចូលជាធរមាន",
            "created-by": "បង្កើតដោយ",
            "reason": "មូលហេតុ"
          },
          "detail": {
            "col-from": "ពី",
            "col-to": "ទៅ",
            "job-profile": "តួនាទីការងារ",
            "job-grade": "ចំណាត់ថ្នាក់ការងារ",
            "org-unit": "អង្គភាព",
            "basic-salary": "ប្រាក់ខែមូលដ្ឋាន",
            "employment-type": "ប្រភេទការងារ",
            "no-changes": "មិនមានទិន្នន័យលម្អិតសម្រាប់ការផ្លាស់ប្ដូរនេះទេ។"
          },
          "change-type": {
            "PROMOTE": "ការបដិភូ",
            "TRANSFER": "ការផ្ទេរ",
            "REDESIGNATION": "ការប្តូរតួនាទី",
            "INVOLUNTARY_TERMINATION": "ការបញ្ចប់ការងារដោយបង្ខំ",
            "VOLUNTARY_TERMINATION": "ការបញ្ចប់ការងារដោយស្ម័គ្រ",
            "SALARY_CHANGE": "ការផ្លាស់ប្ដូរប្រាក់ខែ",
            "SALARY_INCREASE": "ការបង្កើនប្រាក់ខែ",
            "CHANGE_EMPLOYMENT_TYPE": "ការប្តូរប្រភេទការងារ",
            "RENEW": "ការបន្តកិច្ចសន្យា",
            "SUSPEND": "ការផ្អាក",
            "DEMOTE": "ការបន្ថយតួនាទី",
            "Unknown": "មិនស្គាល់"
          },
          "modal": {
            "title-step1": "សកម្មភាពការងារថ្មី · {name}",
            "title-step2": "សកម្មភាពការងារថ្មី · {name}",
            "step1-desc": "ជំហានទី ១ ក្នុង ២ – ជ្រើសរើសប្រភេទព្រឹត្តិការណ៍ការងារ",
            "step2-desc": "ជំហានទី ២ ក្នុង ២ – ព័ត៌មានលម្អិត {type}",
            "for-label": "សម្រាប់:",
            "locked-from-profile": "ចាក់សោពីប្រវត្តិ (ឃ្លាំងស្តុក)",
            "incoming-feature": "មុខងារបន្ទាប់",
            "upcoming-feature": "⏸ មុខងារបន្ទាប់",
            "not-actionable-banner": "ស្ថានភាពបុគ្គលិកនេះគឺ រង់ចាំ ឬ អសកម្ម — សកម្មភាពការងារត្រូវការកិច្ចសន្យាសកម្ម។ ប្រើ ជួលឡើងវិញ (កិច្ចសន្យា → ព្រឹត្តិការណ៍កិច្ចសន្យាថ្មី) ប្រសិនបើពួកគេត្រូវការវិលត្រឡប់មកវិញ។",
            "not-actionable-badge": "បុគ្គលិកមិនសកម្ម",
            "field-effective-date": "ថ្ងៃចូលជាធរមាន",
            "field-reason": "មូលហេតុ",
            "field-reason-placeholder": "ផ្ដល់មូលហេតុសម្រាប់ការផ្លាស់ប្ដូរនេះ",
            "field-org-unit": "អង្គភាព / នាយកដ្ឋានគោលដៅ",
            "field-org-unit-placeholder": "ឧ. Sales, Finance",
            "field-salary": "ប្រាក់បៀវត្សមូលដ្ឋានថ្មី",
            "field-salary-placeholder": "ឧ. 1200",
            "field-doc-ref": "ឯកសារយោង",
            "field-doc-ref-placeholder": "ឧ. MEMO-2026-001, ឯកសារយោង",
            "file-upload-phase2": "ភ្ជាប់ឯកសារ — មកក្នុងដំណាក់កាល ២",
            "field-offline-approval": "ការអនុម័តក្រៅបណ្ដាញ",
            "offline-approval-label": "ការអនុម័តក្រៅបណ្ដាញបានបញ្ចប់ (អំផ្លិត / លិខិត / ការអនុម័ត LM បានទទួល)",
            "field-offline-notes": "កំណត់ហេតុការអនុម័តក្រៅបណ្ដាញ",
            "field-offline-notes-placeholder": "កំណត់ហេតុអំពីដំណើរការការអនុម័តក្រៅបណ្ដាញ",
            "cancel": "បោះបង់",
            "back": "← ត្រឡប់",
            "submit": "រក្សាទុក",
            "saving": "កំពុងរក្សាទុក…",
            "error-type-required": "សូមជ្រើសរើសប្រភេទសកម្មភាព។",
            "error-date-required": "ថ្ងៃចូលជាធរមានត្រូវបានទាមទារ។",
            "error-reason-required": "មូលហេតុត្រូវបានទាមទារ។",
            "error-no-contract": "រកមិនឃើញកិច្ចសន្យាដែលមានសម្រាប់បុគ្គលិកនេះ។",
            "error-salary-numeric": "ប្រាក់ខែត្រូវតែជាលេខត្រឹមត្រូវ។",
            "error-save-failed": "បរាជ័យក្នុងការរក្សាទុក។ សូមព្យាយាមម្ដងទៀត។",
            "field-effective-date-hint": "ថ្ងៃអនាគត → កំណត · ថ្ងៃនេះ ឬ ពីមុន → ជាធរមាន",
            "promotion": {
              "info-banner": "ការបដិភូ = ការរីកចម្រើនក្នុងអាជីព ២ របៀប។ ប្រសិនបើផ្លាស់ប្ដូរតែប្រាក់ខែ (គ្មានថ្នាក់ · គ្មានតួនាទី · គ្មានចំណងជើង) ប្រើផ្ទាំងសំណង → ការកែប្រែប្រាក់ខែ។ ប្រសិនបើផ្លាស់ប្ដូរតែចំណងជើងដោយគ្មានការបង្កើនថ្នាក់/ប្រាក់ខែ ប្រើ ការប្ដូរតួនាទី។",
              "mode-a-label": "របៀប A",
              "mode-a-sub": "កៅអីថ្មីក្នុងតារាងអង្គភាព",
              "mode-a-desc": "ផ្លាស់ទៅតួនាទីផ្សេងដែលមានក្នុងប្រចាំ",
              "mode-b-label": "របៀប B",
              "mode-b-sub": "កៅអីដដែល · ថ្នាក់ ឬ កម្រិតប្រសើរ",
              "mode-b-desc": "មិនផ្លាស់ទីតួនាទី · ថ្នាក់ត្រូវខ្ពស់ជាង · ការប្ដូរចំណងជើងអាច",
              "mode-b-hint": "របៀប B: មិនចាំបាច់ផ្លាស់ទីតួនាទី។ ត្រូវប្រាកដថាថ្នាក់ថ្មីខ្ពស់ជាថ្នាក់បច្ចុប្បន្ន មុននឹងរក្សាទុក។",
              "target-position": "តួនាទីគោលដៅ",
              "target-position-placeholder": "ជ្រើសតួនាទីគោលដៅ…",
              "target-position-hint": "លុបតួនាទីបច្ចុប្បន្នរបស់បុគ្គលិកចេញ។ បង្ហាញតែកៅអីអាចចាត់តាំងបាន។",
              "companion-label": "រួមបញ្ចូលការកែប្រែប្រាក់ខែក្នុងប្រតិបត្តិការតែមួយ",
              "companion-desc": "ដកធីក ដើម្បីកត់ត្រាការបដិភូដោយគ្មានការផ្លាស់ប្ដូរប្រាក់ខែ។",
              "base-salary-label": "ប្រាក់បៀវត្សមូលដ្ឋាន",
              "base-salary-source-of-truth": "ប្រភពពិត",
              "new-base-salary-label": "ប្រាក់បៀវត្សមូលដ្ឋានថ្មី",
              "delta": "ការផ្លាស់ប្ដូរ: USD {from} → USD {to} · {sign}USD {delta} · {sign}{pct}%",
              "error-target-required": "តួនាទីគោលដៅត្រូវបានទាមទារសម្រាប់របៀប A។",
              "loading-positions": "កំពុងផ្ទុកតួនាទី…",
              "no-positions-promote": "គ្មានតួនាទីទំនេរដែលអាចប្រើបានក្នុងថ្នាក់នេះ។",
              "no-positions-transfer": "គ្មានតួនាទីអាចប្រើបានក្នុងថ្នាក់ដូចគ្នា។"
            },
            "classification": {
              "PROMOTE": {
                "title": "ការបដិភូ",
                "desc": "ការរីកចម្រើនក្នុងអាជីព · របៀប A: កៅអីថ្មី · របៀប B: ថ្នាក់ប្រសើរ"
              },
              "TRANSFER": {
                "title": "ការផ្ទេរ",
                "desc": "ចលនាប្រតិបត្តិការ · នាយកដ្ឋាន / ទីតាំង / សាខា · ជាទូទៅគ្មានការផ្លាស់ប្ដូរថ្នាក់"
              },
              "REDESIGNATION": {
                "title": "ការប្ដូរតួនាទី",
                "desc": "ការប្ដូរចំណងជើងដោយគ្មានការរីកចម្រើន · គ្មានការបង្កើនប្រាក់ខែ ឬ ថ្នាក់"
              },
              "SALARY_CHANGE": {
                "title": "ការផ្លាស់ប្ដូរប្រាក់ខែ",
                "desc": "កែតម្រូវប្រាក់ខែមូលដ្ឋាន ឬ ប្រាក់ឧបត្ថម្ភ · មានប្រសិទ្ធភាពពីកាលបរិច្ឆេទ"
              },
              "INVOLUNTARY_TERMINATION": {
                "title": "ការបញ្ចប់ការងារដោយមិនស្ម័គ្រចិត្ត",
                "desc": "ការបណ្តេញ ការចូលនិវត្តន៍ ឬ អំពើខុសក្រម · បញ្ចប់ការងារជាអចិន្ត្រៃយ៍"
              },
              "VOLUNTARY_TERMINATION": {
                "title": "ការបញ្ចប់ការងារដោយស្ម័គ្រចិត្ត",
                "desc": "ការលាឈប់របស់បុគ្គលិក · បញ្ចប់ការងារជាអចិន្ត្រៃយ៍"
              }
            },
            "salary-change": {
              "info-banner": "ការផ្លាស់ប្ដូរប្រាក់ខែធ្វើបច្ចុប្បន្នភាពប្រាក់ខែមូលដ្ឋានរបស់បុគ្គលិក។ ការកត់ត្រាទាំងស្រុងត្រូវបានរក្សាទុកជាមួយកាលបរិច្ឆេទមានប្រសិទ្ធភាព។",
              "current-label": "ប្រាក់ខែមូលដ្ឋានបច្ចុប្បន្ន",
              "new-label": "ប្រាក់ខែមូលដ្ឋានថ្មី"
            },
            "termination": {
              "warning-title": "សកម្មភាពនេះបញ្ចប់ការងារជាអចិន្ត្រៃយ៍",
              "warning-desc": "ត្រូវប្រាកដថាការងារបញ្ចប់ការងារទាំងអស់ត្រូវបានបំពេញរួចរាល់មុននឹងរក្សាទុក។ វាមិនអាចត្រូវបានដកហូតពីអេក្រង់នេះទេ។",
              "voluntary-note": "ការបញ្ចប់ការងារដោយស្ម័គ្រចិត្ត — ការលាឈប់ដោយបុគ្គលិកផ្ទាល់។",
              "involuntary-note": "ការបញ្ចប់ការងារដោយមិនស្ម័គ្រចិត្ត — ការបណ្តេញ ការចូលនិវត្តន៍ ឬ អំពើខុសក្រម។",
              "confirm-label": "ខ្ញុំបញ្ជាក់សកម្មភាពនេះ ហើយយល់ថាវាបញ្ចប់ការងារជាអចិន្ត្រៃយ៍។"
            }
          }
        },
        "personal": {
          "not-set": "—",
          "edit": "កែប្រែ",
          "history": {
            "title": "ប្រវត្តិការផ្លាស់ប្តូរ",
            "empty": "មិនទាន់មានការផ្លាស់ប្តូរត្រូវបានកត់ត្រា។"
          },
          "identity": {
            "title": "អត្តសញ្ញាណ",
            "first-name": "នាម",
            "last-name": "គោត្តនាម",
            "preferred-name": "នាមដែលចូលចិត្ត",
            "gender": "ភេទ",
            "dob": "ថ្ងៃខែឆ្នាំកំណើត",
            "nationality": "សញ្ជាតិ",
            "marital-status": "ស្ថានភាពអាពាហ៍ពិពាហ៍",
            "national-id": "អត្តសញ្ញាណប័ណ្ណ",
            "blood-type": "ក្រុមឈាម"
          },
          "gov-ids": {
            "title": "អត្តសញ្ញាណប័ណ្ណរដ្ឋាភិបាល",
            "national-id": "អត្តសញ្ញាណប័ណ្ណ",
            "nssf": "NSSF",
            "tax-id": "លេខសម្គាល់ពន្ធ",
            "number": "លេខ",
            "issued": "ថ្ងៃចេញ",
            "expires": "ថ្ងៃផុតកំណត់",
            "authority": "អាជ្ញាធរ",
            "never": "មិនផុតកំណត់"
          },
          "contact": {
            "title": "ទំនាក់ទំនង & អាសយដ្ឋាន",
            "section-contact": "ទំនាក់ទំនង",
            "section-address": "អាសយដ្ឋាន",
            "email": "អ៊ីម៉ែលផ្ទាល់ខ្លួន",
            "mobile": "ទូរស័ព្ទដៃ",
            "alt-phone": "ទូរស័ព្ទបន្ទាប់",
            "telegram": "Telegram",
            "whatsapp": "WhatsApp",
            "linkedin": "LinkedIn",
            "current-address": "អាសយដ្ឋានបច្ចុប្បន្ន",
            "modal": {
              "title": "កែសម្រួលទំនាក់ទំនង & អាសយដ្ឋាន",
              "subtitle": "ការផ្លាស់ប្តូរត្រូវបានអនុវត្តភ្លាមៗ",
              "cancel": "បោះបង់",
              "save": "រក្សាទុក",
              "saving": "កំពុងរក្សាទុក…",
              "error-save-failed": "បានបរាជ័យក្នុងការរក្សាទុកព័ត៌មានទំនាក់ទំនង។ សូមព្យាយាមម្តងទៀត។"
            }
          },
          "family": {
            "title": "គ្រួសារ & អ្នកដែលពឹងផ្អែក",
            "col-name": "ឈ្មោះ",
            "col-relationship": "ទំនាក់ទំនង",
            "col-dob": "ថ្ងៃខែឆ្នាំកំណើត",
            "col-national-id": "អត្តសញ្ញាណប័ណ្ណ",
            "col-tax-dependent": "អ្នកពឹងផ្អែកពន្ធ",
            "col-status": "ស្ថានភាព",
            "col-actions": "សកម្មភាព",
            "tax-note": "អ្នកពឹងផ្អែកពន្ធជំរុញការគណនាការបន្ថយពន្ធ ToS នៅក្នុងប្រព័ន្ធប្រាក់ខែ។",
            "yes": "បាទ/ចាស",
            "no": "ទេ",
            "empty": "មិនទាន់មានការកត់ត្រាសមាជិកគ្រួសារ។",
            "btn-add": "បន្ថែមសមាជិក",
            "delete-confirm": "លុបសមាជិកគ្រួសារនេះ?",
            "modal": {
              "add-title": "បន្ថែមសមាជិកគ្រួសារ",
              "edit-title": "កែប្រែសមាជិកគ្រួសារ",
              "subtitle": "ការផ្លាស់ប្តូរត្រូវបានកត់ត្រាភ្លាម · មិនចាំបាច់ការអនុម័ត",
              "field-fullname": "ឈ្មោះពេញ",
              "field-relationship": "ទំនាក់ទំនង",
              "field-dob": "ថ្ងៃខែឆ្នាំកំណើត",
              "field-phone": "ទូរស័ព្ទ",
              "field-email": "អ៊ីម៉ែល",
              "field-dependent": "អ្នកពឹងផ្អែក (ការលើកលែងពន្ធ)",
              "field-emergency": "ទំនាក់ទំនងអាសន្ន",
              "field-occupation": "មុខរបរ",
              "field-note": "កំណត់ចំណាំ",
              "cancel": "បោះបង់",
              "save": "រក្សាទុក",
              "saving": "កំពុងរក្សាទុក…",
              "error-name-required": "ឈ្មោះពេញត្រូវការ។",
              "error-save-failed": "រក្សាទុកបានបរាជ័យ។ សូមព្យាយាមម្តងទៀត។"
            }
          },
          "emergency": {
            "title": "ទំនាក់ទំនងអាសន្ន",
            "primary": "ចម្បង",
            "relationship": "ទំនាក់ទំនង",
            "phone": "ទូរស័ព្ទ",
            "empty": "មិនទាន់មានទំនាក់ទំនងអាសន្ន។",
            "btn-add": "បន្ថែមទំនាក់ទំនង",
            "delete-confirm": "លុបទំនាក់ទំនងអាសន្ននេះ?"
          },
          "bank": {
            "title": "ព័ត៌មានគណនីធនាគារ",
            "managed-note": "គ្រប់គ្រងដោយការដំឡើងប្រាក់ខែ — មើលបានតែប៉ុណ្ណោះ។",
            "bank": "ធនាគារ",
            "account-name": "ឈ្មោះគណនី",
            "account-number": "លេខគណនី",
            "status": "ស្ថានភាព",
            "empty": "មិនទាន់មានគណនីធនាគារ។",
            "cash-no-bank": "សាច់ប្រាក់ (គ្មានធនាគារ)"
          },
          "btn-history": "ប្រវត្តិ",
          "active": "សកម្ម"
        },
        "benefits": {
          "banner-intro": "ធានារ៉ាប់រង សិទ្ធិ និងកម្មវិធីបុគ្គលិកក្រៅសាច់ប្រាក់។",
          "banner": "ប្រាក់ខែ និងប្រាក់ឧបត្ថម្ភត្រូវបានគ្រប់គ្រងក្រោម",
          "banner-link": "ប្រាក់ខែ",
          "insurance-title": "ធានារ៉ាប់រង និងអត្ថប្រយោជន៍ច្បាប់",
          "add": "បន្ថែម",
          "no-benefits": "មិនមានធានារ៉ាប់រង ឬអត្ថប្រយោជន៍ច្បាប់ទេ។",
          "policy-id": "លេខកូដបណ្ណសន្យា",
          "scheme": "គម្រោង",
          "type": "ប្រភេទ",
          "enrolled": "ចុះឈ្មោះ",
          "status-active": "សកម្ម",
          "status-enrolled": "បានចុះឈ្មោះ",
          "nssf-title": "NSSF (មូលនិធិសន្តិសុខសង្គមជាតិ)",
          "nssf-subtitle": "កាតព្វកិច្ច · សុខភាព + សោធននិវត្តន៍",
          "nssf-id": "លេខ NSSF",
          "nssf-employment-type": "ប្រភេទការងារ",
          "nssf-employment-status": "ស្ថានភាពការងារ",
          "nssf-in-scheme": "ក្នុងគម្រោង",
          "dependents-title": "អ្នកពឹងផ្អែក",
          "no-dependents": "មិនមានអ្នកពឹងផ្អែកចុះឈ្មោះ។",
          "add-dependent": "បន្ថែមអ្នកពឹងផ្អែក",
          "delete-insurance": "លុបធានារ៉ាប់រង"
        },
        "documents": {
          "title": "ឯកសារ",
          "upload": "បញ្ចូលឯកសារ",
          "empty": "មិនទាន់មានឯកសារ។",
          "options": "ជម្រើសឯកសារ",
          "delete": "លុបឯកសារ",
          "confirm-delete": "លុប",
          "confirm-delete-warning": "វាមិនអាចត្រឡប់វិញបានទេ។",
          "confirm-delete-yes": "បាទ/ចាស លុប",
          "confirm-delete-no": "បោះបង់"
        },
        "attendance": {
          "days-worked": "ថ្ងៃធ្វើការ (មេសា)",
          "overtime": "ម៉ោងបន្ថែម",
          "late-missed": "យឺត / អវត្តមាន",
          "on-leave": "ឈប់សម្រាក",
          "leave-balances": "សមតុល្យការឈប់សម្រាក",
          "annual-leave": "ការឈប់សម្រាកប្រចាំឆ្នាំ",
          "sick-leave": "ការឈប់សម្រាកជំងឺ",
          "special-leave": "ការឈប់សម្រាកពិសេស",
          "maternity": "ការឈប់សម្រាកសម្រាលកូន",
          "days": "ថ្ងៃ",
          "recent-attendance": "វត្តមានថ្មីៗ",
          "col-day": "ថ្ងៃ",
          "col-in": "ចូល",
          "col-out": "ចេញ",
          "col-hours": "ម៉ោង",
          "col-notes": "កំណត់ចំណាំ"
        },
        "job": {
          "current-job": "ការងារបច្ចុប្បន្ន",
          "modify": "បើក​សកម្មភាពការងារ",
          "position": "មុខតំណែង",
          "department": "នាយកដ្ឋាន",
          "employment-type": "ប្រភេទការងារ",
          "contract-type": "ប្រភេទកិច្ចសន្យា",
          "reports-to": "ស្ថិតក្រោម",
          "org-unit": "អង្គភាព",
          "project-client": "គម្រោង / អតិថិជន",
          "hire-date": "កាលបរិច្ឆេទចូលធ្វើការ",
          "subordinates": "អ្នកក្រោមបង្គាប់",
          "work-location": "ទីតាំងធ្វើការ",
          "working-hours": "ម៉ោងធ្វើការ",
          "employment-change-note": "ការផ្លាស់ប្ដូរមុខតំណែង នាយកដ្ឋាន និងកិច្ចសន្យា គ្រប់គ្រងដោយ {term} — ការកែប្រែគ្រប់យ៉ាងបង្កើតការកត់ត្រាដែលអាចត្រួតពិនិត្យបាន ជាមួយកាលបរិច្ឆេទ មូលហេតុ និងការអនុម័ត។",
          "employment-change-term": "Employment Change",
          "start-one": "ចាប់ផ្ដើម →",
          "gov-menu-title": "ជ្រើសប្រភេទ Employment Change",
          "gov-transfer": "ផ្ទេរ",
          "gov-transfer-sub": "ផ្លាស់ប្ដូរនាយកដ្ឋាន / ប្រធានផ្ទាល់ / ទីតាំង",
          "gov-promotion": "ឡើងលំដាប់",
          "gov-promotion-sub": "ផ្លាស់ប្ដូរទៅមុខតំណែង / ថ្នាក់ខ្ពស់ជាង",
          "gov-change-type": "ផ្លាស់ប្ដូរប្រភេទការងារ",
          "gov-change-type-sub": "ឧ. ពេញម៉ោង ↔ កន្លះម៉ោង / ខ្ចីប្រើ",
          "gov-salary": "ផ្លាស់ប្ដូរប្រាក់ខែ",
          "gov-salary-sub": "កែតម្រូវប្រាក់ខែមូលដ្ឋាន ឬប្រាក់ឧបត្ថម្ភ",
          "gov-renew": "បន្តកិច្ចសន្យា",
          "gov-renew-sub": "ពន្យារកាលបរិច្ឆេទបញ្ចប់កិច្ចសន្យាបច្ចុប្បន្ន",
          "gov-menu-title-danger": "ការបញ្ចប់ការងារ",
          "gov-suspend": "ព្យួរការងារ",
          "gov-suspend-sub": "ព្យួរការងារបណ្ដោះអាសន្ន",
          "gov-terminate-involuntary": "បញ្ចប់ការងារដោយបង្ខំ",
          "gov-terminate-involuntary-sub": "បណ្ដេញ ការបន្ថយ ឬការប្រព្រឹត្តខុស",
          "gov-terminate-voluntary": "លាឈប់ពីការងារ",
          "gov-terminate-voluntary-sub": "ការឈប់ស្ម័គ្រចិត្តរបស់និយោជិត",
          "emp-change-drawer": {
            "title": "ការផ្លាស់ប្ដូរការងារ",
            "subtitle": "កត់ត្រាការផ្លាស់ប្ដូរការងារផ្លូវការសម្រាប់និយោជិតនេះ",
            "field-type": "ប្រភេទការផ្លាស់ប្ដូរ",
            "field-type-placeholder": "ជ្រើសប្រភេទ",
            "field-effective-date": "កាលបរិច្ឆេទដែលមានប្រសិទ្ធភាព",
            "field-reason": "មូលហេតុ",
            "field-reason-placeholder": "ពណ៌នាមូលហេតុនៃការផ្លាស់ប្ដូរ",
            "field-to-org-unit": "នាយកដ្ឋាន / មុខតំណែងថ្មី",
            "field-to-org-unit-placeholder": "ឧ. ហិរញ្ញវត្ថុ – គណនេយ្យករជាន់ខ្ពស់",
            "field-to-salary": "ប្រាក់ខែមូលដ្ឋានថ្មី",
            "field-to-salary-placeholder": "ឧ. 1200",
            "field-new-employment-type": "ប្រភេទការងារថ្មី",
            "field-new-employment-type-placeholder": "ជ្រើសប្រភេទ",
            "field-suspend-until": "ព្យួរការងាររហូតដល់",
            "field-new-contract-end-date": "កាលបរិច្ឆេទបញ្ចប់កិច្ចសន្យាថ្មី",
            "warning-destructive-title": "សកម្មភាពនេះប៉ះពាល់ដល់ស្ថានភាពការងារ",
            "warning-destructive-body": "សូមពិនិត្យឡើងវិញដោយប្រុងប្រយ័ត្នមុនពេលរក្សាទុក។ ការផ្លាស់ប្ដូរនេះនឹងត្រូវបានកត់ត្រានៅក្នុងប្រវត្តិការងារ។",
            "confirm-destructive": "ខ្ញុំបញ្ជាក់ថាសកម្មភាពនេះត្រូវបានអនុម័ត និងកត់ត្រាត្រឹមត្រូវ",
            "error-type-required": "សូមជ្រើសប្រភេទការផ្លាស់ប្ដូរ",
            "error-date-required": "ត្រូវការកាលបរិច្ឆេទដែលមានប្រសិទ្ធភាព",
            "error-reason-required": "សូមផ្តល់មូលហេតុ",
            "error-confirm-required": "សូមបញ្ជាក់សកម្មភាពនេះមុនពេលរក្សាទុក",
            "error-no-contract": "រកមិនឃើញកិច្ចសន្យាសកម្ម — សូមបង្កើតកិច្ចសន្យាជាមុន",
            "error-salary-numeric": "ប្រាក់ខែត្រូវតែជាលេខត្រឹមត្រូវ",
            "error-save-failed": "រក្សាទុកបរាជ័យ។ សូមព្យាយាមម្ដងទៀត។",
            "cancel": "បោះបង់",
            "save": "រក្សាទុកការផ្លាស់ប្ដូរ",
            "saving": "កំពុងរក្សាទុក…",
            "type": {
              "TRANSFER": "ផ្ទេរ",
              "PROMOTE": "ឡើងលំដាប់",
              "SALARY_CHANGE": "ផ្លាស់ប្ដូរប្រាក់ខែ",
              "SALARY_INCREASE": "បង្កើនប្រាក់ខែ",
              "CHANGE_EMPLOYMENT_TYPE": "ផ្លាស់ប្ដូរប្រភេទការងារ",
              "INVOLUNTARY_TERMINATION": "បញ្ចប់ការងារដោយបង្ខំ",
              "VOLUNTARY_TERMINATION": "លាឈប់ពីការងារ",
              "DEMOTE": "បញ្ចុះលំដាប់",
              "REDESIGNATION": "ប្ដូរអត្តសញ្ញាណ",
              "SUSPEND": "ព្យួរការងារ",
              "RENEW": "បន្តកិច្ចសន្យា",
              "Unknown": "ការផ្លាស់ប្ដូរមិនស្គាល់"
            }
          }
        },
        "overview": {
          "tenure": "អាយុការ",
          "status": "ស្ថានភាព",
          "current-package": "កញ្ចប់បច្ចុប្បន្ន",
          "recurring-month": "ប្រចាំខែ",
          "reports-to": "របាយការណ៍ទៅ",
          "no-manager": "មិនទាន់មានប្រធានផ្ទាល់",
          "compliance": "ការអនុលោម",
          "nssf-enrolled": "បានចុះឈ្មោះ NSSF",
          "not-enrolled": "មិនបានចុះឈ្មោះ",
          "tax-declaration": "បានប្រកាសពន្ធ (ToSI)",
          "contract-signed": "បានចុះហត្ថលេខាលើកិច្ចសន្យា",
          "health-check-due": "ការពិនិត្យសុខភាពប្រចាំឆ្នាំ",
          "quick-facts": "ព័ត៌មានសង្ខេប",
          "working-hours": "ម៉ោងធ្វើការ",
          "workspace": "កន្លែងធ្វើការ",
          "time-zone": "តំបន់ម៉ោង",
          "language": "ភាសា",
          "personal-info": "ព័ត៌មានផ្ទាល់ខ្លួន",
          "view-full-personal": "មើលព័ត៌មានផ្ទាល់ខ្លួនពេញ →",
          "nationality": "សញ្ជាតិ",
          "personal-phone": "ទូរស័ព្ទផ្ទាល់ខ្លួន",
          "personal-email": "អ៊ីម៉ែលផ្ទាល់ខ្លួន",
          "emergency-contact": "ទំនាក់ទំនងអាសន្ន"
        },
        "external": {
          "chip": "បុគ្គលិកខាងក្រៅ",
          "personal-info": "ព័ត៌មានផ្ទាល់ខ្លួន",
          "latin-name": "ឈ្មោះឡាតាំង",
          "native-name": "ឈ្មោះខ្មែរ",
          "gender": "ភេទ",
          "status": "ស្ថានភាព",
          "reporting-structure": "រចនាសម្ព័ន្ធរបាយការណ៍ និងក្រុម",
          "org-unit": "អង្គភាព",
          "role": "តួនាទី",
          "report-to-role": "រាយការណ៍ទៅតួនាទី",
          "subordinates": "អ្នកក្រោមបង្គាប់",
          "line-manager": "ប្រធានផ្ទាល់",
          "no-manager": "មិនទាន់មានប្រធានផ្ទាល់",
          "view-subordinates": "មើល"
        },
        "subordinates-modal": {
          "title": "អ្នកក្រោមបង្គាប់",
          "search-placeholder": "ស្វែងរកតាមពាក្យគន្លឹះ…",
          "col-name": "ឈ្មោះពេញ",
          "col-code": "លេខសម្គាល់បុគ្គលិក",
          "col-status": "ស្ថានភាព",
          "col-org-unit": "អង្គភាព",
          "col-position": "តំណែង",
          "empty": "រកមិនឃើញអ្នកក្រោមបង្គាប់ទេ។",
          "no-match": "រកមិនឃើញអ្នកក្រោមបង្គាប់ដែលត្រូវនឹង \"{query}\" ទេ។",
          "loading": "កំពុងផ្ទុកអ្នកក្រោមបង្គាប់…",
          "error": "បរាជ័យក្នុងការផ្ទុកអ្នកក្រោមបង្គាប់។",
          "retry": "ព្យាយាមម្ដងទៀត",
          "showing-range": "បង្ហាញ {from}–{to} នៃ {total}",
          "rows-per-page": "ជួរដេកក្នុងមួយទំព័រ",
          "prev": "ទំព័រមុន",
          "next": "ទំព័របន្ទាប់"
        },
        "journey": {
          "title": "ដំណើរការការងារ",
          "subtitle": "ប្រវត្តិវិជ្ជមាននៃព្រឹត្តិការណ៍ការផ្លាស់ប្ដូរការងារ · ប្រព័ន្ធកត់ត្រាសម្រាប់ការត្រួតពិនិត្យ",
          "empty": "មិនមានព្រឹត្តិការណ៍ផ្លាស់ប្ដូរការងារ។",
          "reason-label": "មូលហេតុ",
          "doc-label": {
            "promote": "មើលលិខិតបដិភូ",
            "transfer": "មើលលិខិតផ្ទេរ",
            "salary": "មើលលិខិតកែប្រែប្រាក់ខែ",
            "change-employment-type": "មើលលិខិតកែប្រែប្រភេទការងារ",
            "termination": "មើលលិខិតបញ្ចប់ការងារ",
            "joined": "មើលកិច្ចសន្យាការងារ",
            "probation-passed": "មើលការបញ្ជាក់ការសាកល្បង",
            "default": "មើលលិខិតគាំទ្រ"
          },
          "kpi": {
            "total": "ព្រឹត្តិការណ៍ទាំងអស់",
            "years": "ឆ្នាំ",
            "pending": "កំពុងរង់ចាំ"
          },
          "state": {
            "applied": "បានអនុវត្ត",
            "pending": "កំពុងរង់ចាំ"
          },
          "event-type": {
            "joined": "ចូលក្រុមហ៊ុន",
            "probation-passed": "ឆ្លងកាត់ការសាកល្បង"
          },
          "event": {
            "hired-summary": "ការចូលធ្វើការដំបូង",
            "hired-reason": "ការជ្រើសរើសដំបូង",
            "probation-summary": "ការសាកល្បងបានបញ្ចប់ · បញ្ជាក់ក្នុងតួនាទី",
            "probation-reason": "ការត្រួតពិនិត្យការសាកល្បងជោគជ័យ"
          }
        },
        "identity-modal": {
          "title": "កែប្រែអត្តសញ្ញាណ",
          "subtitle": "ធ្វើបច្ចុប្បន្នភាពឈ្មោះ ភេទ និងព័ត៌មានទំនាក់ទំនងការងារ",
          "section-latin": "ឈ្មោះឡាតាំង",
          "section-native": "ឈ្មោះខ្មែរ",
          "section-work-contacts": "ទំនាក់ទំនងការងារ",
          "field-latin-first": "នាមដំបូង",
          "field-latin-last": "នាមត្រកូល",
          "field-nickname": "ឈ្មោះហៅ",
          "field-gender": "ភេទ",
          "field-native-first": "នាមដំបូង (ខ្មែរ)",
          "field-native-last": "នាមត្រកូល (ខ្មែរ)",
          "field-work-email": "អ៊ីមែលការងារ",
          "field-work-phone": "លេខទូរស័ព្ទការងារ",
          "section-personal": "ព័ត៌មានផ្ទាល់ខ្លួន",
          "field-dob": "ថ្ងៃខែឆ្នាំកំណើត",
          "field-nationality": "សញ្ជាតិ",
          "field-marital-status": "ស្ថានភាពអាពាហ៍ពិពាហ៍",
          "field-national-id": "អត្តសញ្ញាណប័ណ្ណ",
          "field-national-id-placeholder": "ឧ. 012345678",
          "field-blood-type": "ក្រុមឈាម",
          "loading": "កំពុងផ្ទុក…",
          "no-results": "មិនមានលទ្ធផល",
          "pim-note": "",
          "audit-note": "ការផ្លាស់ប្ដូរត្រូវបានកត់ត្រាសម្រាប់ការត្រួតពិនិត្យ។",
          "save": "រក្សាទុក",
          "cancel": "បោះបង់",
          "saving": "កំពុងរក្សាទុក…",
          "error-name-required": "ត្រូវការនាមដំបូង និងនាមត្រកូល។",
          "error-save-failed": "បរាជ័យក្នុងការរក្សាទុក។ សូមព្យាយាមម្តងទៀត។"
        },
        "document-modal": {
          "title": "បញ្ចូលឯកសារ",
          "drop-zone-label": "ចុច ឬទាញ-ទម្លាក់ឯកសារ",
          "drop-zone-cta": "ទាញ-ទម្លាក់ឯកសារ",
          "drop-zone-hint": "ឬចុចដើម្បីរកមើល · PDF, DOC, JPG, PNG",
          "field-name": "ឈ្មោះឯកសារ",
          "field-name-placeholder": "ឧ. ការវាយតម្លៃការងារ 2026.pdf",
          "field-group": "ក្រុមឯកសារ",
          "field-group-placeholder": "ជ្រើសរើសក្រុម",
          "group-personal": "ផ្ទាល់ខ្លួន",
          "group-spouse": "ប្តី/ប្រពន្ធ",
          "group-children": "កូន",
          "field-description": "ការពិពណ៌នា",
          "field-description-placeholder": "កំណត់ចំណាំខ្លីអំពីឯកសារនេះ",
          "info-banner": "ត្រូវការឈ្មោះឯកសារ និងក្រុម ដើម្បីឱ្យ HR អាចរកឃើញ និងចាត់ថ្នាក់ក្រោយ។",
          "upload": "បញ្ចូល",
          "cancel": "បោះបង់",
          "uploading": "កំពុងបញ្ចូល…",
          "field-type": "ប្រភេទឯកសារ",
          "field-type-placeholder": "ជ្រើសរើសប្រភេទ",
          "field-fam-member": "សមាជិកគ្រួសារ",
          "field-fam-member-placeholder": "ជ្រើសរើសកូន",
          "no-spouse": "មិនមានប្តី/ប្រពន្ធចុះឈ្មោះសម្រាប់បុគ្គលិកនេះ។",
          "no-children": "មិនមានកូនចុះឈ្មោះសម្រាប់បុគ្គលិកនេះ។",
          "error-file-required": "សូមជ្រើសរើសឯកសារ។",
          "error-name-required": "ត្រូវការឈ្មោះឯកសារ។",
          "error-group-required": "សូមជ្រើសរើសក្រុមឯកសារ។",
          "error-type-required": "សូមជ្រើសរើសប្រភេទឯកសារ។",
          "error-fam-required": "សូមជ្រើសរើសសមាជិកគ្រួសារ។",
          "error-upload-failed": "បរាជ័យក្នុងការបញ្ចូល។ សូមព្យាយាមម្តងទៀត។"
        },
        "contract-modal": {
          "title-create": "កិច្ចសន្យាថ្មី",
          "title-edit": "កែប្រែកិច្ចសន្យា",
          "subtitle": "កំណត់ប្រភេទកិច្ចសន្យា កាលបរិច្ឆេទ និងប្រាក់ខែ",
          "section-type": "ប្រភេទកិច្ចសន្យា",
          "section-dates": "កាលបរិច្ឆេទ",
          "section-compensation": "ប្រាក់ខែ",
          "field-type": "ប្រភេទកិច្ចសន្យា",
          "field-type-placeholder": "ជ្រើសរើសប្រភេទ",
          "field-employment-type": "ប្រភេទការងារ",
          "field-employment-type-placeholder": "ជ្រើសរើសប្រភេទការងារ",
          "field-start": "កាលបរិច្ឆេទចាប់ផ្ដើម",
          "field-end": "កាលបរិច្ឆេទបញ្ចប់ (ទុកចោលប្រសិនបើគ្មានកំណត់)",
          "field-probation-start": "ចាប់ផ្ដើមការសាកល្បង",
          "field-probation-end": "បញ្ចប់ការសាកល្បង",
          "field-salary": "ប្រាក់បៀវត្សមូលដ្ឋាន",
          "field-salary-placeholder": "ចំនួនប្រចាំខែ",
          "save": "រក្សាទុក",
          "cancel": "បោះបង់",
          "saving": "កំពុងរក្សាទុក…",
          "error-type-required": "ត្រូវការប្រភេទកិច្ចសន្យា។",
          "error-start-required": "ត្រូវការកាលបរិច្ឆេទចាប់ផ្ដើម។",
          "error-salary-numeric": "ប្រាក់ខែត្រូវតែជាលេខ។",
          "error-save-failed": "បរាជ័យក្នុងការរក្សាទុក។ សូមព្យាយាមម្តងទៀត។"
        },
        "insurance-modal": {
          "title-add": "បន្ថែមធានារ៉ាប់រង",
          "title-edit": "កែប្រែធានារ៉ាប់រង",
          "subtitle": "ផែនការធានារ៉ាប់រងសុខភាព ជីវិត និងបន្ថែម",
          "field-type": "ប្រភេទធានារ៉ាប់រង",
          "field-type-placeholder": "ជ្រើសប្រភេទ",
          "field-policy-id": "លេខគោលនយោបាយ",
          "field-policy-id-placeholder": "លេខយោងគោលនយោបាយ",
          "field-insurer": "ឈ្មោះក្រុមហ៊ុនធានារ៉ាប់រង",
          "field-insurer-placeholder": "ឧ. Prudential",
          "field-scheme": "គ្រោងការណ៍",
          "field-scheme-placeholder": "ឧ. ផែនការបុព្វលាភ",
          "loading": "កំពុងផ្ទុក…",
          "no-results": "មិនមានលទ្ធផល",
          "field-employment-type": "ប្រភេទការងារ",
          "field-employment-type-placeholder": "ជ្រើសប្រភេទការងារ",
          "field-employment-type-formal": "ក្នុងប្រព័ន្ធ (Formal)",
          "field-employment-type-informal": "ក្រៅប្រព័ន្ធ (Informal)",
          "field-employment-status": "ស្ថានភាពការងារ",
          "field-employment-status-placeholder": "ជ្រើសស្ថានភាពការងារ",
          "field-employment-status-active": "កំពុងធ្វើការ (Active)",
          "field-employment-status-maternity": "លំហែរមាតុភាព (Maternity Leave)",
          "field-employment-status-sickness": "កំពុងព្យាបាលជំងឺ (Sickness Treatment)",
          "save": "រក្សាទុក",
          "cancel": "បោះបង់",
          "saving": "កំពុងរក្សាទុក…",
          "confirm-delete": "លុបកំណត់ត្រាធានារ៉ាប់រងនេះ? វាមិនអាចត្រឡប់វិញបានទេ។",
          "confirm-delete-yes": "បាទ/ចាស លុប",
          "confirm-delete-no": "បោះបង់",
          "error-type-required": "ត្រូវការប្រភេទធានារ៉ាប់រង។",
          "error-policy-required": "ត្រូវការលេខគោលនយោបាយ។",
          "error-save-failed": "បរាជ័យក្នុងការរក្សាទុក។ សូមព្យាយាមម្តងទៀត។"
        },
        "employment-action-modal": {
          "title": "ការផ្លាស់ប្ដូរការងារ",
          "subtitle": "ការផ្លាស់ប្ដូរទាំងអស់បង្កើតព្រឹត្តិការណ៍ដែលអាចត្រួតពិនិត្យបានក្នុងដំណើរការការងារ",
          "field-type": "ប្រភេទការផ្លាស់ប្ដូរ",
          "field-type-placeholder": "ជ្រើសរើសប្រភេទ",
          "field-effective-date": "កាលបរិច្ឆេទអនុវត្ត",
          "field-reason": "មូលហេតុ",
          "field-reason-placeholder": "ពណ៌នាអំពីមូលហេតុ",
          "field-to-salary": "ប្រាក់បៀវត្សមូលដ្ឋានថ្មី",
          "field-to-salary-placeholder": "ចំនួនប្រចាំខែ",
          "field-to-org-unit": "ទៅ អង្គភាព / នាយកដ្ឋាន",
          "field-to-org-unit-placeholder": "ឧ. វិស្វកម្ម",
          "field-new-employment-type": "ប្រភេទការងារថ្មី",
          "type": {
            "PROMOTE": "ការដំឡើងតំណែង",
            "TRANSFER": "ការផ្ទេរ",
            "SALARY_CHANGE": "ការផ្លាស់ប្ដូរប្រាក់ខែ",
            "CHANGE_EMPLOYMENT_TYPE": "ការផ្លាស់ប្ដូរប្រភេទការងារ",
            "INVOLUNTARY_TERMINATION": "ការបញ្ចប់ការងារដោយមិនស្ម័គ្រចិត្ត",
            "VOLUNTARY_TERMINATION": "ការបញ្ចប់ការងារដោយស្ម័គ្រចិត្ត"
          },
          "save": "ដាក់ស្នើ",
          "cancel": "បោះបង់",
          "saving": "កំពុងដាក់ស្នើ…",
          "warning-destructive-title": "សកម្មភាពនេះប៉ះពាល់ដល់ស្ថានភាពការងារ",
          "confirm-destructive": "ខ្ញុំបញ្ជាក់ថាសកម្មភាពនេះត្រូវបានអនុម័ត និងកត់ត្រាឱ្យបានត្រឹមត្រូវ",
          "error-type-required": "សូមជ្រើសរើសប្រភេទការផ្លាស់ប្ដូរ។",
          "error-date-required": "ត្រូវការកាលបរិច្ឆេទអនុវត្ត។",
          "error-reason-required": "ត្រូវការមូលហេតុ។",
          "error-confirm-required": "សូមបញ្ជាក់សកម្មភាពនេះមុនពេលរក្សាទុក។",
          "error-no-contract": "រកមិនឃើញកិច្ចសន្យាសកម្មសម្រាប់បុគ្គលិកនេះ។",
          "error-salary-numeric": "ប្រាក់ខែត្រូវតែជាលេខ។",
          "error-save-failed": "បរាជ័យក្នុងការដាក់ស្នើ។ សូមព្យាយាមម្តងទៀត។"
        },
        "renew-contract-modal": {
          "title": "បន្តកិច្ចសន្យា",
          "subtitle": "{name} · កិច្ចសន្យាបច្ចុប្បន្ន: {type}",
          "banner": "វានឹងបង្កើតកំណត់ត្រាកិច្ចសន្យាថ្មី។ កិច្ចសន្យាមុននឹងនៅក្នុងប្រវត្តិ All Contracts។",
          "field-type": "ប្រភេទកិច្ចសន្យាថ្មី",
          "field-type-placeholder": "ជ្រើសរើសប្រភេទកិច្ចសន្យា",
          "field-employment-type": "ប្រភេទការងារ",
          "field-start-date": "ថ្ងៃចាប់ផ្ដើម",
          "field-start-date-hint": "កំណត់ដោយស្វ័យប្រវត្តិទៅជាថ្ងៃបន្ទាប់បន្ទាប់ពីកិច្ចសន្យាបច្ចុប្បន្នផុតកំណត់។",
          "field-end-date": "ថ្ងៃបញ្ចប់",
          "field-salary": "ប្រាក់ខែមូលដ្ឋាន",
          "field-salary-placeholder": "ឧ. 1200",
          "field-position": "មុខតំណែង (តារាងស្ថាប័ន)",
          "field-position-placeholder": "ជ្រើសរើសមុខតំណែងទំនេរ",
          "field-position-hint": "ស្រេចចិត្ត — ភ្ជាប់កិច្ចសន្យានេះទៅនឹងមុខតំណែងទំនេរ។",
          "position-loading": "កំពុងផ្ទុកមុខតំណែង…",
          "position-empty": "មិនមានមុខតំណែងទំនេរ។",
          "field-reason": "មូលហេតុ",
          "field-reason-placeholder": "មូលហេតុនៃការបន្ត",
          "error-start-required": "ថ្ងៃចាប់ផ្ដើមត្រូវការ។",
          "error-end-required": "ថ្ងៃបញ្ចប់ត្រូវការសម្រាប់ប្រភេទកិច្ចសន្យានេះ។",
          "error-end-after-start": "ថ្ងៃបញ្ចប់ត្រូវនៅក្រោយថ្ងៃចាប់ផ្ដើម។",
          "error-reason-required": "មូលហេតុត្រូវការ។",
          "error-save-failed": "បរាជ័យក្នុងការរក្សាទុក។ សូមព្យាយាមម្ដងទៀត។",
          "cancel": "បោះបង់",
          "back": "ត្រឡប់",
          "next": "បន្ទាប់",
          "confirm": "បញ្ជាក់ & បន្ត",
          "confirming": "កំពុងបន្ត…",
          "save": "បន្តកិច្ចសន្យា",
          "saving": "កំពុងរក្សាទុក…",
          "step-1": "កិច្ចសន្យា",
          "step-2": "ឈប់សម្រាក",
          "step-3": "ពិនិត្យ",
          "al-heading": "ការតំឡើងការឈប់សម្រាកប្រចាំឆ្នាំ",
          "al-description": "បញ្ជាក់ពីវិធីគ្រប់គ្រងសមតុល្យការឈប់សម្រាកដែលនៅសល់ពីកិច្ចសន្យាមុន។",
          "al-current-balance": "សមតុល្យការឈប់សម្រាកបច្ចុប្បន្ន",
          "al-current-taken": "ការឈប់សម្រាកដែលបានយក",
          "al-entitlement-preview-heading": "ការមើលជាមុននូវសិទ្ធិឈប់សម្រាកប្រចាំឆ្នាំ",
          "al-entitled-this-contract": "ថ្ងៃឈប់សម្រាកមានសិទ្ធិក្រោមកិច្ចសន្យានេះ",
          "al-seniority-bonus": "ប្រាក់រង្វាន់អតីតភាព",
          "al-entitlement-as-of": "គិតត្រឹមថ្ងៃទី {date} ដោយផ្អែកលើគោលការណ៍ឈប់សម្រាករបស់ក្រុមហ៊ុន",
          "al-days": "ថ្ងៃ",
          "al-carry-forward-label": "យកសមតុល្យការឈប់សម្រាកទៅបន្ត?",
          "al-carry-forward-yes": "បាទ/ចាស, យកទៅបន្ត",
          "al-carry-forward-no": "ទេ, កំណត់ជាសូន្យ",
          "al-prev-amount": "សមតុល្យការឈប់សម្រាកដែលត្រូវយកទៅបន្ត",
          "al-prev-amount-hint": "ចំនួនថ្ងៃឈប់សម្រាកដែលត្រូវបន្តទៅកិច្ចសន្យាថ្មី។",
          "al-taken": "ការឈប់សម្រាកដែលបានយករំដោះ",
          "al-taken-hint": "ចំនួនថ្ងៃឈប់សម្រាកដែលបានយករំដោះក្នុងអំឡុងពេលកិច្ចសន្យាបច្ចុប្បន្ន។",
          "review-heading": "ពិនិត្យ & បញ្ជាក់",
          "review-description": "សូមពិនិត្យព័ត៌មានលម្អិតការបន្តមុនពេលបញ្ជាក់។",
          "review-contract": "ព័ត៌មានលម្អិតកិច្ចសន្យា",
          "review-al": "ការតំឡើងការឈប់សម្រាកប្រចាំឆ្នាំ",
          "review-type": "ប្រភេទកិច្ចសន្យា",
          "review-employment-type": "ប្រភេទការងារ",
          "review-start-date": "ថ្ងៃចាប់ផ្ដើម",
          "review-end-date": "ថ្ងៃបញ្ចប់",
          "review-salary": "ប្រាក់ខែមូលដ្ឋាន",
          "review-position": "មុខតំណែង",
          "review-position-none": "មិនបានបញ្ជាក់",
          "review-reason": "មូលហេតុ",
          "review-carry-forward": "យកការឈប់សម្រាកទៅបន្ត",
          "review-carry-amount": "ចំនួនទៅបន្ត",
          "review-al-taken": "ការឈប់សម្រាកដែលបានយក",
          "error-al-setup-failed": "កិច្ចសន្យាត្រូវបានបង្កើត។ ការដំឡើងការឈប់សម្រាកប្រចាំឆ្នាំមិនអាចបញ្ចប់បានទេ — សូមកំណត់រចនាសម្ព័ន្ធវាដោយដៃក្នុងផ្ទាំងការទូទាត់ប្រាក់ខែ។"
        },
        "new-contract-modal": {
          "title": "កិច្ចសន្យាថ្មី",
          "subtitle": "{name} · ការបង្កើតកិច្ចសន្យាដំបូង",
          "confirm": "បញ្ជាក់ និងបង្កើត"
        },
        "rehire-contract-modal": {
          "title": "ជួលបុគ្គលិកចាស់ឡើងវិញ",
          "subtitle": "{name} · កិច្ចសន្យាមុន: {type}",
          "banner": "នេះនឹងបង្កើតកិច្ចសន្យាថ្មីសម្រាប់បុគ្គលិកដែលវិលត្រឡប់មកវិញ។ កិច្ចសន្យាមុននឹងនៅតែមាននៅក្នុងប្រវត្តិកិច្ចសន្យាទាំងអស់។",
          "error-start-overlaps": "កាលបរិច្ឆេទចាប់ផ្ដើមត្រូវតែក្រោយកាលបរិច្ឆេទបញ្ចប់នៃកិច្ចសន្យាមុនរបស់បុគ្គលិក។",
          "error-start-no-gap": "កាលបរិច្ឆេទចាប់ផ្ដើមនេះបន្តបន្ទាប់ពីកាលបរិច្ឆេទបញ្ចប់នៃកិច្ចសន្យាមុនភ្លាមៗ — នេះជា ការបន្តកិច្ចសន្យា មិនមែន ការជួលឡើងវិញ ទេ។ សូមប្រើ ការបន្តកិច្ចសន្យា ឬជ្រើសរើសកាលបរិច្ឆេទចាប់ផ្ដើមក្រោយបន្ថែមទៀត ប្រសិនបើមានគម្លាតការងារពិតប្រាកដ។",
          "confirm": "បញ្ជាក់ និងជួលឡើងវិញ"
        },
        "contract-event-modal": {
          "title": "ព្រឹត្តិការណ៍កិច្ចសន្យាថ្មី",
          "subtitle": "{name} · កិច្ចសន្យាបច្ចុប្បន្ន: {type} · ដំណាក់កាល ១ · ការកត់ត្រាតែប៉ុណ្ណោះ",
          "policy-banner-prefix": "កំពុងប្រើ",
          "policy-banner-suffix": "កិច្ចសន្យា។",
          "badge-not-terminated": "អាចប្រើបានបន្ទាប់ពីបញ្ចប់ការងារ",
          "badge-pending-contract": "មានកិច្ចសន្យារង់ចាំរួចហើយ",
          "cancel": "បោះបង់",
          "back": "ត្រឡប់ក្រោយ",
          "save": "រក្សាទុក",
          "saving": "កំពុងរក្សាទុក…",
          "policy-note": {
            "UDC": "UDC គ្មានកំណត់ · មិនអាចបន្ត ឬ ពង្រីកបាន។ ការកែប្រែសម្រាប់ការផ្លាស់ប្ដូរក្នុងពេលសន្យា; ការបញ្ចប់ដើម្បីបិទសន្យា។",
            "FDC": "FDC មានកំណត់ · អាចបន្ត ពង្រីក បំប្លែង កែប្រែ ឬ បញ្ចប់។ ច្បាប់ការងារកម្ពុជាកំណត់រយៈពេលសរុបFDCអតិបរមា ២ ឆ្នាំ។",
            "Probation": "ក្នុងអំឡុងពេលសាកល្បង · បញ្ជាក់ (ឆ្លងកាត់), ពន្យឺត (ត្រូវការពេលបន្ថែម), បំប្លែងទៅ FDC/UDC, ឬ បញ្ចប់។",
            "Internship": "កម្មសិក្សា · បំប្លែងទៅ FDC/UDC ប្រសិនបើជ្រើសរើស ឬ បញ្ចប់នៅចុងគ្រាកម្មសិក្សា។",
            "Outsourcing Service": "កិច្ចសន្យាម៉ៅការ · កែប្រែវិសាលភាព ឬ បញ្ចប់ការប្រាក់ការ។ ការបន្តគ្រប់គ្រងដោយ SOW ។",
            "none": "មិនមានកិច្ចសន្យា · តែ កិច្ចសន្យាថ្មី ប៉ុណ្ណោះ។ ប្រើសម្រាប់កិច្ចសន្យាដំបូងនៅពេលជ្រើសរើស។"
          },
          "type": {
            "new_contract": {
              "label": "កិច្ចសន្យាថ្មី",
              "desc": "កិច្ចសន្យាដំបូងនៅពេលជ្រើសរើស (ឬ ការចាប់ផ្ដើមឡើងវិញបន្ទាប់ពីចន្លោះ)",
              "date-label": "កាលបរិច្ឆេទចាប់ផ្ដើមកិច្ចសន្យា"
            },
            "contract_renewal": {
              "label": "ការបន្តកិច្ចសន្យា",
              "desc": "FDC ឬ UDC ត្រូវបានបន្តសម្រាប់អាណត្តិថ្មី",
              "date-label": "កាលបរិច្ឆេទចូលជាធរមានការបន្ត"
            },
            "rehire": {
              "label": "ជួលបុគ្គលិកចាស់ឡើងវិញ",
              "desc": "នាំយកអតីតបុគ្គលិកមកវិញក្រោមកិច្ចសន្យាថ្មី",
              "date-label": "កាលបរិច្ឆេទចាប់ផ្ដើមជួលឡើងវិញ"
            },
            "contract_extension": {
              "label": "ការពង្រីកកិច្ចសន្យា",
              "desc": "កិច្ចសន្យាដែលមានស្រាប់ត្រូវបានពង្រីកក្នុងអំឡុងពេលបច្ចុប្បន្ន",
              "date-label": "កាលបរិច្ឆេទចាប់ផ្ដើមការពង្រីក"
            },
            "contract_conversion": {
              "label": "ការបំប្លែងកិច្ចសន្យា",
              "desc": "ផ្លាស់ប្ដូរប្រភេទកិច្ចសន្យា (ឧ. FDC → UDC)",
              "date-label": "កាលបរិច្ឆេទចូលជាធរមានការបំប្លែង"
            },
            "contract_amendment": {
              "label": "ការកែប្រែកិច្ចសន្យា",
              "desc": "ការកែប្រែក្នុងពេលសន្យា (ម៉ោងការងារ, ទីតាំង, លក្ខខណ្ឌ, ប្រការ)",
              "date-label": "កាលបរិច្ឆេទចូលជាធរមានការកែប្រែ"
            },
            "probation_confirmation": {
              "label": "ការបញ្ជាក់ពេលសាកល្បង",
              "desc": "ពេលសាកល្បងកន្លងផុតហើយ · បុគ្គលិកត្រូវបានបញ្ជាក់",
              "date-label": "កាលបរិច្ឆេទបញ្ជាក់"
            },
            "probation_extension": {
              "label": "ការពន្យឺតពេលសាកល្បង",
              "desc": "ពេលសាកល្បងត្រូវបានពន្យឺតសម្រាប់រយៈពេលបន្ថែម",
              "date-label": "កាលបរិច្ឆេទបញ្ចប់ពេលសាកល្បងថ្មី"
            },
            "termination_record": {
              "label": "កំណត់ត្រាការបញ្ចប់",
              "desc": "កំណត់ត្រាការបញ្ចប់ការងារតាមរដ្ឋបាល",
              "date-label": "កាលបរិច្ឆេទបញ្ចប់ការងារ"
            }
          },
          "form": {
            "subtitle": "កត់ត្រាការផ្លាស់ប្ដូរកិច្ចសន្យានេះ · ដំណាក់កាល ១",
            "phase1-label": "ដំណាក់កាល ១ · ការកត់ត្រាតែប៉ុណ្ណោះ។",
            "phase1-desc": "កត់ត្រាការផ្លាស់ប្ដូរកិច្ចសន្យាក្រៅប្រព័ន្ធ (លិខិតស្នាម / លិខិត)។ លំហូរការអនុម័តនឹងមកក្នុងដំណាក់កាល ២។",
            "field-new-contract-type": "ប្រភេទកិច្ចសន្យាថ្មី",
            "field-new-end-date": "កាលបរិច្ឆេទបញ្ចប់ថ្មី",
            "field-new-end-date-hint": "ចាំបាច់សម្រាប់កិច្ចសន្យា FDC ។",
            "field-new-probation-end-date": "កាលបរិច្ឆេទបញ្ចប់ពេលសាកល្បងថ្មី",
            "field-probation-originally-ended": "ពេលសាកល្បងបានបញ្ចប់ដើម",
            "field-reason": "មូលហេតុ / កំណត់ចំណាំ",
            "field-reason-placeholder": "មូលហេតុនៃការផ្លាស់ប្ដូរកិច្ចសន្យានេះ?",
            "field-doc-ref": "ឯកសារយោង",
            "field-doc-ref-placeholder": "ឈ្មោះឯកសារ / យោង (ឧ. ContractRenewal-2026-007.pdf)",
            "file-upload-phase2": "ភ្ជាប់ឯកសារ — ដំណាក់កាល ២",
            "field-offline-approval": "ការអនុម័តក្រៅប្រព័ន្ធ",
            "offline-approval-label": "ការអនុម័តក្រៅប្រព័ន្ធបានបញ្ចប់ — ចុះហត្ថលេខាក្រៅប្រព័ន្ធ",
            "field-offline-notes": "កំណត់ចំណាំការអនុម័តក្រៅប្រព័ន្ធ",
            "field-offline-notes-placeholder": "កំណត់ចំណាំ — ឧ. ចុះហត្ថលេខាដោយបុគ្គលិក ២០២៦-០៦-២៨",
            "error-date-required": "ចាំបាច់ត្រូវបញ្ចូលកាលបរិច្ឆេទ។",
            "error-reason-required": "ចាំបាច់ត្រូវបញ្ចូលមូលហេតុ។",
            "error-save-failed": "បរាជ័យក្នុងការរក្សាទុក។ សូមព្យាយាមម្ដងទៀត។",
            "validation-summary-invalid": "✗ ចាំបាច់ត្រូវបញ្ចូលកាលបរិច្ឆេទ និង មូលហេតុ",
            "validation-summary-ok": "✓ រួចរាល់ · ស្ថានភាពនឹងជា {status}",
            "status-scheduled": "កំណត់ពេល",
            "status-effective": "ចូលជាធរមាន"
          }
        }
      },
      "batch-import": {
        "title": "នាំចូលបុគ្គលិក",
        "subtitle": "នាំចូលបុគ្គលិកជាបាច់ពី Excel ដោយមានការផ្ទៀងផ្ទាត់ និងការរកឃើញការស្ទួន។",
        "tab": {
          "new-import": "នាំចូលថ្មី",
          "history": "ប្រវត្តិការនាំចូល"
        },
        "steps": {
          "upload": "ផ្ទុកឯកសារ",
          "validation": "ការផ្ទៀងផ្ទាត់",
          "confirm": "បញ្ជាក់"
        },
        "mode": {
          "label": "របៀបនាំចូល",
          "add-label": "បន្ថែមថ្មីតែប៉ុណ្ណោះ",
          "add-desc": "បង្កើតកំណត់ត្រាបុគ្គលិកថ្មី។ លេខកូដបុគ្គលិកជាជម្រើស (ប្រព័ន្ធបង្កើតដោយស្វ័យប្រវត្តិ ប្រសិនបើទទេ)។",
          "update-label": "ធ្វើបច្ចុប្បន្នភាពដែលមានស្រាប់",
          "update-desc": "ធ្វើបច្ចុប្បន្នភាពកំណត់ត្រាដែលមានស្រាប់ដោយប្រើលេខកូដបុគ្គលិក។ ជួរដេកដែលគ្មានលេខកូដបុគ្គលិកត្រឹមត្រូវមិនអាចធ្វើបច្ចុប្បន្នភាពបានទេ។",
          "note": "សម្រាប់ការធ្វើបច្ចុប្បន្នភាព លេខកូដបុគ្គលិកជាគន្លឹះភ្ជាប់តែមួយ។ ប្រព័ន្ធនឹងមិនផ្ទៀងផ្ទាត់តាមឈ្មោះ អ៊ីមែល ឬទូរស័ព្ទ ដើម្បីជៀសវាងការធ្វើបច្ចុប្បន្នភាពខុស។"
        },
        "upload": {
          "tip": "ថ្មីនៅទីនេះ? ទាញយកគំរូជាមុនសិន ដើម្បីមើលជួរឈរដែលត្រូវការ រួចបំពេញព័ត៌មានបុគ្គលិក ហើយទម្លាក់ឯកសារត្រឡប់មកវិញ។",
          "tip-link": "ទាញយកគំរូ",
          "download-template": "ទាញយកគំរូ",
          "export-existing": "នាំចេញបុគ្គលិកដែលមានស្រាប់",
          "drop-label": "ទម្លាក់ឯកសារនៅទីនេះ ឬចុចដើម្បីរក",
          "drop-hint": "Excel (.xlsx) · រហូតដល់ 5 MB · អតិបរមា 5,000 ជួរ · មើលជាមុន 500 ជួរដំបូង",
          "remove": "លុបឯកសារ",
          "preview-truncated": "មើលជាមុន {cap} ជួរ ចេញពី {total} — ឯកសារពេញលេញនឹងត្រូវផ្ទៀងផ្ទាត់ដោយម៉ាស៊ីនបម្រើ។"
        },
        "validation": {
          "col-errors": "កំហុសជួរឈរ",
          "total": "សរុប: {n}",
          "valid": "ត្រឹមត្រូវ: {n}",
          "invalid": "មិនត្រឹមត្រូវ: {n}",
          "warnings": "ការព្រមាន: {n}",
          "status": "ស្ថានភាព",
          "issues": "បញ្ហា",
          "export-result": "នាំចេញលទ្ធផល",
          "required": "ចាំបាច់",
          "issues-expand": "{n} បញ្ហា — ចុចដើម្បីពង្រីក",
          "show-less": "បង្ហាញតិចជាង"
        },
        "confirm": {
          "summary": "ត្រៀមខ្លួននាំចូល",
          "mode": "របៀប",
          "rows": "ជួរដេកសរុប",
          "valid": "ត្រឹមត្រូវ",
          "invalid": "មិនត្រឹមត្រូវ (នឹងត្រូវរំលង)",
          "dl-results": "លទ្ធផលការនាំចូល",
          "dl-credentials": "ព័ត៌មានសម្ងាត់អ្នកប្រើ",
          "dl-original": "ឯកសារដើម",
          "errors-label": "កំហុសការនាំចូល ({n})"
        },
        "progress": {
          "completed": "ការនាំចូលបានបញ្ចប់",
          "completed-errors": "ការនាំចូលបានបញ្ចប់ប៉ុន្តែមានកំហុស",
          "failed": "ការនាំចូលបានបរាជ័យ",
          "in-progress": "កំពុងនាំចូលបុគ្គលិក…",
          "detail": "បាននាំចូល {succeeded} ចេញពី {total} ដោយជោគជ័យ",
          "error-msg": "ការនាំចូលបានជួបបញ្ហា។",
          "processing": "កំពុងដំណើរការ {done} ចេញពី {total}…",
          "detail-failed-suffix": ", {failed} បានបរាជ័យ"
        },
        "row": {
          "pending": "រង់ចាំ",
          "valid": "ត្រឹមត្រូវ",
          "invalid": "មិនត្រឹមត្រូវ",
          "warning": "ការព្រមាន"
        },
        "history": {
          "loading": "កំពុងផ្ទុកប្រវត្តិ…",
          "empty": "មិនមានប្រវត្តិការនាំចូលទេ។",
          "completed": "បានបញ្ចប់",
          "completed-errors": "បានបញ្ចប់ប៉ុន្តែមានកំហុស",
          "failed": "បានបរាជ័យ",
          "imported": "បាននាំចូល",
          "failed-rows": "បានបរាជ័យ",
          "batch-id": "លេខបាច់",
          "results": "លទ្ធផល",
          "dl-original": "ឯកសារផ្ទុកដើម",
          "dl-results": "លទ្ធផលការនាំចូល",
          "dl-credentials": "ព័ត៌មានសម្ងាត់អ្នកប្រើ",
          "processing": "កំពុងដំណើរការ",
          "processing-note": "ការនាំចូលកំពុងដំណើរការ — ឯកសារនឹងមានបន្ទាប់ពីបញ្ចប់។",
          "results-detail": "បានជោគជ័យ {succeeded}, បានបរាជ័យ {failed} / សរុប {total}"
        },
        "btn": {
          "back": "ត្រឡប់ក្រោយ",
          "done": "រួចរាល់"
        },
        "next": {
          "validation": "បន្ទាប់: ការផ្ទៀងផ្ទាត់",
          "confirm": "បន្ទាប់: បញ្ជាក់",
          "import": "នាំចូល"
        },
        "error": {
          "invalid-format": "សូមជ្រើសរើសឯកសារ .xlsx ត្រឹមត្រូវ។",
          "file-too-large": "ឯកសារធំជាង 5 MB។ សូមជ្រើសរើសឯកសារតូចជាងនេះ។",
          "empty-file": "ឯកសារដែលផ្ទុកឡើងមានទម្រង់ត្រឹមត្រូវ ប៉ុន្តែមិនមានកំណត់ត្រាបុគ្គលិកទេ។",
          "template-mismatch": "ឯកសារដែលផ្ទុកឡើងមិនត្រូវនឹងទម្រង់គំរូដែលរំពឹង។",
          "missing-columns": "ជួរឈរខ្វះ",
          "unexpected-columns": "ជួរឈរមិនរំពឹង",
          "read-failed": "មិនអាចអានឯកសារបានទេ។ សូមពិនិត្យទម្រង់ឯកសារ។",
          "validation-failed": "ការផ្ទៀងផ្ទាត់បានបរាជ័យ។ សូមព្យាយាមម្តងទៀត។",
          "import-failed": "ការនាំចូលបានបរាជ័យ។ សូមព្យាយាមម្តងទៀត។",
          "download-failed": "មិនអាចទាញយកឯកសារបានទេ។ ឯកសារអាចមិនទាន់មានឡើយ។",
          "template-failed": "មិនអាចទាញយកគំរូបានទេ។ សូមព្យាយាមម្តងទៀត។",
          "export-failed": "មិនអាចនាំចេញបុគ្គលិកបានទេ។ សូមព្យាយាមម្តងទៀត។",
          "import-timeout": "ការនាំចូលចំណាយពេលយូរជាងការរំពឹង។ សូមពិនិត្យប្រវត្តិការនាំចូលសម្រាប់លទ្ធផលចុងក្រោយ។"
        },
        "instructions": {
          "title": "ការណែនាំ & តម្រូវការ",
          "general": "ទូទៅ",
          "no-delete-headers": "កុំលុបជួរដេកខាងលើ ឬកែប្រែចំណងជើងជួរឈរ — ប្រព័ន្ធអាចមិនយល់ទម្រង់ឯកសារដែលអ្នកផ្ទុក",
          "required-cols": "ជួរឈរដែលមានសញ្ញា (*) ចាំបាច់ត្រូវបំពេញ។ ការផ្ទៀងផ្ទាត់នឹងត្រូតពិនិត្យភាពពេញលេញ ប្រភេទទិន្នន័យ និងទម្រង់",
          "max-size": "ទំហំឯកសារអតិបរមា: 5 MB",
          "unique-note": "តម្លៃតែមួយ (ឧ. National_id) ត្រូវបានផ្ទៀងផ្ទាត់តែក្នុងឯកសារដែលផ្ទុកប៉ុណ្ណោះ មិនប្រៀបធៀបជាមួយបុគ្គលិកដែលមានស្រាប់ទេ",
          "dates": "ជួរឈរកាលបរិច្ឆេទ",
          "date-format": "បញ្ចូលកាលបរិច្ឆេទទាំងអស់ក្នុងទម្រង់ ISO: YYYY-MM-DD (ឧ. 2022-10-25)",
          "key-cols": "ចំណាំជួរឈរចំណុចសំខាន់",
          "employee-code": "Employee_code — ជាជម្រើស។ ប្រសិនបើបំពេញ ជាឯកសារយោងទៅបុគ្គលិកដែលមានស្រាប់។ ប្រសិនបើទទេ ប្រព័ន្ធបញ្ជូលលេខកូដដោយស្វ័យប្រវត្តិ",
          "contract-type": "Contract_type — បញ្ចូល FDC, UDC, ឬ PROBATION",
          "contract-end-date": "Contract_end_date — ចាំបាច់ ប្រសិនបើប្រភេទកិច្ចសន្យាមិនមែន UDC",
          "report-to": "Report_to — ត្រូវជា Employee_code របស់បុគ្គលិកដែលមានស្រាប់ ឬបុគ្គលិកថ្មីក្នុងឯកសារតែមួយ",
          "username": "Username / User_email — ការបង្កើតទម្រង់បុគ្គលិករួមមានការបង្កើតគណនីអ្នកប្រើផងដែរ",
          "repeatable": "ឈុតជួរឈរដែលអាចធ្វើម្ដងទៀត",
          "repeatable-note": "ជួរឈរខ្លះមានតួនាទីជាក្រុម។ អ្នកអាចបន្ថែមក្រុមបន្ថែមដោយចម្លងចំណងជើងជួរឈរ:",
          "repeatable-complete": "ក្រុមនីមួយៗត្រូវស្ថិតពេញលេញ — ក្រុមមិនពេញលេញនឹងបរាជ័យការផ្ទៀងផ្ទាត់"
        }
      }
    },
    "common": {
      "cancel": "បោះបង់",
      "save": "រក្សាទុក",
      "edit": "កែសម្រួល",
      "retry": "ព្យាយាមម្តងទៀត",
      "confirm": "បញ្ជាក់",
      "yes": "បាទ/ចាស",
      "no": "ទេ",
      "remove": "លុបចេញ",
      "create": "បង្កើត",
      "clear": "សម្អាត",
      "clear-all": "សម្អាតទាំងអស់",
      "previous": "មុន",
      "next": "បន្ទាប់"
    },
    "organization": {
      "title": "អង្គភាព",
      "tabs": {
        "profile": "ប្រវត្តិរូប",
        "structure": "រចនាសម្ព័ន្ធ",
        "sites": "ទីតាំង",
        "outsourcing": "ការផ្គត់ផ្គង់ខាងក្រៅ"
      },
      "kind": {
        "company": "ក្រុមហ៊ុន",
        "os_client": "អតិថិជន",
        "os_vendor": "អ្នកផ្គត់ផ្គង់",
        "os_project": "គម្រោង",
        "unknown": "មិនស្គាល់"
      },
      "structure": {
        "org-units": "អង្គភាពរង",
        "org-chart": "តារាងរចនាសម្ព័ន្ធ",
        "positions": "មុខតំណែង",
        "workforce-plan": "ផែនការកម្លាំងពលកម្ម",
        "grades": "កម្រិតការងារ",
        "job-titles": "ឈ្មោះមុខតំណែង",
        "job-profiles": "ប្រវត្តិរូបការងារ"
      },
      "profile": {
        "edit": "កែសម្រួល",
        "edit-title": "កែសម្រួលក្រុមហ៊ុន",
        "industry": "វិស័យ",
        "employee-id-format": "ទម្រង់លេខសម្គាល់បុគ្គលិក",
        "website": "គេហទំព័រ",
        "address": "អាសយដ្ឋាន",
        "primary-contact": "ទំនាក់ទំនងចម្បង"
      },
      "form": {
        "company-full-name": "ឈ្មោះពេញរបស់ក្រុមហ៊ុន",
        "company-short-name": "ឈ្មោះខ្លីរបស់ក្រុមហ៊ុន",
        "project-full-name": "ឈ្មោះពេញរបស់គម្រោង",
        "project-short-name": "ឈ្មោះខ្លីរបស់គម្រោង",
        "short-name-hint": "ប្រើជាស្លាកខ្លី និងជាបុព្វបទលេខសម្គាល់បុគ្គលិក។",
        "client": "អតិថិជន",
        "client-none": "គ្មានអតិថិជនមេ",
        "employee-id-format": "ទម្រង់លេខសម្គាល់បុគ្គលិក",
        "employee-id-format-hint": "តម្លៃលំនាំដើម <ឈ្មោះខ្លី>-000000។ អាចកែបាន។",
        "industry": "វិស័យ",
        "website": "គេហទំព័រ",
        "address": "អាសយដ្ឋាន",
        "primary-contact": "ទំនាក់ទំនងចម្បង",
        "contact-name": "ឈ្មោះ",
        "contact-email": "អ៊ីមែល",
        "contact-phone": "ទូរស័ព្ទ",
        "notes": "កំណត់ចំណាំ",
        "create": "បង្កើត",
        "errors": {
          "full-name": "តម្រូវឱ្យមានឈ្មោះ។",
          "email": "សូមបញ្ចូលអ៊ីមែលត្រឹមត្រូវ។"
        },
        "outsourcing-client-flag": "តើនេះជាអតិថិជនការផ្តល់សេវាបុគ្គលិកមែនទេ?",
        "outsourcing-client-hint": "សម្គាល់ក្រុមហ៊ុននេះជាអតិថិជនការផ្តល់សេវាបុគ្គលិក។ អ្នកគ្រប់គ្រងគម្រោង បុគ្គលិក និងអ្នកអនុម័តខាងក្រៅរបស់ពួកគេ។",
        "outsourcing-vendor-flag": "តើនេះជាអ្នកផ្គត់ផ្គង់ការផ្តល់សេវាបុគ្គលិកមែនទេ?",
        "outsourcing-vendor-hint": "សម្គាល់ក្រុមហ៊ុននេះជាអ្នកផ្គត់ផ្គង់ការផ្តល់សេវាបុគ្គលិក។ អ្នកតាមដានកម្មករប្រតិបត្តិការ ឯអ្នកផ្គត់ផ្គង់ដំណើរការប្រាក់ខែ។"
      },
      "outsourcing": {
        "shell-title": "ការផ្គត់ផ្គង់ខាងក្រៅ",
        "shell-desc": "គ្រប់គ្រងអតិថិជន ឬអ្នកផ្គត់ផ្គង់ខាងក្រៅ គម្រោងរបស់ពួកគេ និងអ្នកអនុម័តខាងក្រៅ ពីទីនេះ។",
        "shell-note": "នឹងមកដល់ឆាប់ៗ។",
        "clients-title": "អតិថិជន",
        "clients-section-desc": "អតិថិជនការផ្តល់សេវាដែលអ្នកផ្គត់ផ្គង់បុគ្គលិកឱ្យ។ បន្ថែមអតិថិជននៅពេលអ្នកទទួលយកកិច្ចការផ្តល់សេវាថ្មី។",
        "vendors-title": "អ្នកផ្គត់ផ្គង់",
        "vendors-section-desc": "អ្នកផ្គត់ផ្គង់ការផ្តល់សេវាដែលផ្គត់ផ្គង់បុគ្គលិកដល់អ្នក។ បន្ថែមអ្នកផ្គត់ផ្គង់នៅពេលអ្នកចាប់ផ្តើមទទួលបុគ្គលិកពីអ្នកផ្គត់ផ្គង់ថ្មី។",
        "add-client": "បន្ថែមអតិថិជន",
        "add-vendor": "បន្ថែមអ្នកផ្គត់ផ្គង់",
        "create-subtitle": "ព័ត៌មានលម្អិតផ្តល់ការកំណត់រចនាសម្ព័ន្ធពេញលេញដោយស្វ័យប្រវត្តិ។",
        "search-label": "ស្វែងរក",
        "search-placeholder": "ស្វែងរកតាមឈ្មោះ ទំនាក់ទំនង វិស័យ…",
        "showing-clients": "បង្ហាញ {filtered} ក្នុងចំណោម {total} អតិថិជន",
        "showing-vendors": "បង្ហាញ {filtered} ក្នុងចំណោម {total} អ្នកផ្គត់ផ្គង់",
        "empty-clients": "មិនទាន់មានអតិថិជន។ បន្ថែមអតិថិជនដំបូងរបស់អ្នក។",
        "empty-vendors": "មិនទាន់មានអ្នកផ្គត់ផ្គង់។ បន្ថែមអ្នកផ្គត់ផ្គង់ដំបូងរបស់អ្នក។",
        "empty-filtered": "គ្មានដៃគូត្រូវនឹងការស្វែងរកបច្ចុប្បន្ន។",
        "error": "បរាជ័យក្នុងការផ្ទុកបញ្ជីនេះ។",
        "error-403": "អ្នកមិនមានសិទ្ធិចូលប្រើបញ្ជីនេះទេ។",
        "back-clients": "ត្រឡប់ទៅអតិថិជន",
        "back-vendors": "ត្រឡប់ទៅអ្នកផ្គត់ផ្គង់",
        "projects-title": "គម្រោង",
        "approvers-title": "អ្នកអនុម័ត",
        "projects-empty": "មិនទាន់មានគម្រោងក្រោមដៃគូនេះទេ។",
        "projects-error": "បរាជ័យក្នុងការផ្ទុកគម្រោង។",
        "back-to-projects": "ត្រឡប់ទៅគម្រោង",
        "project-under": "ក្រោម {parent}",
        "positions-title": "មុខតំណែង",
        "positions-count": "{filled} មាន · {vacant} ទំនេរ · {total} សរុប",
        "positions-empty": "ប្លង់អង្គភាពរបស់គម្រោងនេះមិនទាន់មានមុខតំណែងទេ។",
        "positions-error-title": "មិនអាចផ្ទុកមុខតំណែង",
        "positions-error-desc": "មានបញ្ហាក្នុងការផ្ទុកប្លង់អង្គភាពរបស់គម្រោងនេះ។",
        "position-vacant": "ទំនេរ",
        "position-untitled": "មុខតំណែងគ្មានចំណងជើង",
        "add-project": "បន្ថែមគម្រោង",
        "edit-project": "កែសម្រួលគម្រោង",
        "detail-error-title": "មិនអាចផ្ទុកដៃគូនេះបានទេ",
        "detail-error-desc": "មានបញ្ហាក្នុងការទាញយកព័ត៌មានលម្អិត។ សូមព្យាយាមម្តងទៀត។",
        "toasts": {
          "created": "\"{name}\" ត្រូវបានបង្កើត។",
          "create-failed": "មិនអាចបង្កើតបានទេ។ សូមព្យាយាមម្តងទៀត។",
          "saved": "បានរក្សាទុកការផ្លាស់ប្តូរ។",
          "save-failed": "មិនអាចរក្សាទុកបានទេ។ សូមព្យាយាមម្តងទៀត។",
          "project-created": "គម្រោង \"{name}\" ត្រូវបានបង្កើត។",
          "project-saved": "បានរក្សាទុកគម្រោង។",
          "project-failed": "មិនអាចរក្សាទុកគម្រោងបានទេ។ សូមព្យាយាមម្តងទៀត។"
        },
        "oversight-title": "ការត្រួតពិនិត្យប្រតិបត្តិ"
      },
      "approvers": {
        "title": "អ្នកអនុម័តខាងក្រៅ",
        "invite": "អញ្ជើញអ្នកអនុម័ត",
        "explainer": "អ្នកអនុម័តខាងក្រៅ គឺជាប្រធានផ្នែករបស់អតិថិជន ដែលត្រូវបានដាក់ចូលក្នុងតួនាទីទំនេរនៅក្នុងតារាងអង្គភាពរបស់គម្រោងនេះ។ ពួកគេអនុម័តការច្បាប់ និងវត្តមានសម្រាប់បុគ្គលិករបស់គម្រោង។ ការអញ្ជើញពួកគេនឹងផ្ញើតំណភ្ជាប់ទទួលយកតាមអ៊ីមែល ហើយការទទួលយកនឹងបង្កើតការចូលប្រើ ESS ដែលកំណត់ត្រឹមគម្រោងនេះ។",
        "counterparty-explainer": "អ្នកអនុម័តខាងក្រៅ គឺជាប្រធានផ្នែករបស់អតិថិជន ដែលត្រូវបានដាក់ចូលក្នុងតួនាទីទំនេរនៅក្នុងតារាងអង្គភាពនៃគម្រោងរបស់អ្នក។ ពួកគេអនុម័តការច្បាប់ និងវត្តមានសម្រាប់បុគ្គលិកគម្រោង។ មនុស្សតែម្នាក់អាចគ្រប់គ្រងគម្រោងច្រើន ដោយការដាក់ចូលនីមួយៗត្រូវរៀបចំតាមគម្រោង។ ការអញ្ជើញនឹងផ្ញើតំណភ្ជាប់ទទួលយកតាមអ៊ីមែល ដែលបង្កើតការចូលប្រើ ESS កំណត់ត្រឹមគម្រោងនោះ។",
        "oversees": "គ្រប់គ្រងគម្រោង {n}",
        "edit-in-project": "កែសម្រួលការដាក់ចូលក្នុង {project}",
        "target-project": "គម្រោង",
        "target-project-placeholder": "ជ្រើសរើសគម្រោងដែលត្រូវដាក់អ្នកអនុម័តចូល",
        "empty-no-projects": "សូមបន្ថែមគម្រោងជាមុនសិន បន្ទាប់មកអញ្ជើញអ្នកអនុម័តឱ្យគ្រប់គ្រងវា។",
        "search-placeholder": "ស្វែងរកតាមឈ្មោះ លេខកូដ អ៊ីមែល លេខទូរស័ព្ទ…",
        "showing": "អ្នកអនុម័ត {n} នាក់",
        "empty": "មិនទាន់មានអ្នកអនុម័តខាងក្រៅទេ។ អញ្ជើញម្នាក់ដើម្បីអនុម័តសំណើសម្រាប់គម្រោងរបស់ដៃគូនេះ។",
        "empty-filtered": "គ្មានអ្នកអនុម័តត្រូវនឹងតម្រងរបស់អ្នកទេ។",
        "error": "មិនអាចផ្ទុកអ្នកអនុម័តបានទេ។",
        "filters": {
          "all": "ទាំងអស់"
        },
        "status": {
          "active": "សកម្ម",
          "invited": "បានអញ្ជើញ",
          "inactive": "អសកម្ម",
          "unknown": "មិនស្គាល់"
        },
        "invite-modal": {
          "title": "អញ្ជើញអ្នកអនុម័តខាងក្រៅ"
        },
        "edit": {
          "title": "កែសម្រួលអ្នកអនុម័តខាងក្រៅ",
          "status": "ស្ថានភាព"
        },
        "form": {
          "latin-name": "ឈ្មោះឡាតាំង",
          "latin-name-placeholder": "ឧ. Sok Somnang",
          "native-name": "ឈ្មោះជាតិ",
          "native-name-placeholder": "ឧ. សុខ សំណាង",
          "gender": "ភេទ",
          "gender-male": "ប្រុស",
          "gender-female": "ស្រី",
          "email": "អ៊ីមែលការងារ",
          "email-placeholder": "ឧ. name\\@client.com",
          "phone": "លេខទូរស័ព្ទ",
          "phone-placeholder": "ឧ. 012 345 678",
          "placement-heading": "ការដាក់ក្នុងតារាងអង្គភាព",
          "org-unit": "អង្គភាពរៀបចំ",
          "org-unit-placeholder": "ជ្រើសរើសអង្គភាព",
          "report-to": "តួនាទីរាយការណ៍ទៅ",
          "report-to-placeholder": "ជ្រើសរើសអ្នកដែលពួកគេរាយការណ៍ទៅ",
          "report-to-none": "(មិនរាយការណ៍ទៅអ្នកណាទេ)",
          "position": "តួនាទី",
          "position-placeholder": "ជ្រើសរើសតួនាទីទំនេរ",
          "position-hint": "ទាំងនេះជាតួនាទីទំនេរនៅក្នុងតារាងអង្គភាពរបស់គម្រោងនេះ។ បើតួនាទីមិនមាន សូមបង្កើតវាជាមុននៅអេក្រង់តារាងអង្គភាព។",
          "create": "បង្កើត"
        },
        "toasts": {
          "invite-sent": "បានបង្កើតអ្នកអនុម័តខាងក្រៅ — បានផ្ញើការអញ្ជើញតាមអ៊ីមែល។",
          "invite-failed": "មិនអាចបង្កើតអ្នកអនុម័តបានទេ។ សូមព្យាយាមម្ដងទៀត។",
          "saved": "បានរក្សាទុកការផ្លាស់ប្តូរ។",
          "save-failed": "មិនអាចរក្សាទុកបានទេ។ សូមព្យាយាមម្ដងទៀត។"
        }
      },
      "error": {
        "title": "មិនអាចផ្ទុកក្រុមហ៊ុននេះបានទេ",
        "desc": "មានបញ្ហាក្នុងការទាញយកព័ត៌មានលម្អិតរបស់ក្រុមហ៊ុន។ សូមព្យាយាមម្តងទៀត។"
      },
      "no-company": {
        "title": "មិនបានជ្រើសរើសក្រុមហ៊ុន",
        "desc": "ជ្រើសរើសក្រុមហ៊ុនពីប្រអប់ប្តូរ ដើម្បីមើលប្រវត្តិរូប គោលការណ៍ និងរចនាសម្ព័ន្ធរបស់វា។"
      },
      "company-form": {
        "drawer-title": "បង្កើតក្រុមហ៊ុនថ្មី",
        "drawer-subtitle": "បន្ថែមក្រុមហ៊ុនថ្មីក្រោមអ្នកជួល។ វានឹងបង្ហាញនៅក្នុងកម្មវិធីប្ដូរវិសាលភាពនៅពេលបង្កើតរួច។",
        "emails": "អាសយដ្ឋានអ៊ីមែល",
        "email-n": "អ៊ីមែល #{n}",
        "add-email": "បន្ថែមអ៊ីមែលមួយទៀត",
        "phones": "លេខទូរស័ព្ទ",
        "phone-n": "ទូរស័ព្ទ #{n}",
        "add-phone": "បន្ថែមលេខទូរស័ព្ទមួយទៀត",
        "representatives": "អ្នកតំណាង",
        "representative-n": "អ្នកតំណាង #{n}",
        "add-representative": "បន្ថែមអ្នកតំណាងម្នាក់ទៀត",
        "toasts": {
          "created": "\"{name}\" ត្រូវបានបង្កើត។",
          "create-failed": "មិនអាចបង្កើតក្រុមហ៊ុនបានទេ។ សូមព្យាយាមម្ដងទៀត។"
        },
        "base-location": {
          "legend": "ទីតាំងគោលចម្បង",
          "name": "ឈ្មោះទីតាំង",
          "name-placeholder": "ឧ. ការិយាល័យកណ្ដាល",
          "address": "អាសយដ្ឋាន",
          "address-placeholder": "ផ្លូវ អគារ ស្រុក…",
          "coordinates": "កូអរដោនេ (រយៈទទឹង, រយៈបណ្ដោយ)",
          "coordinates-hint": "កំណត់ដោយចុច ឬអូសម្ជុលលើផែនទី ឬវាយបញ្ចូលដោយផ្ទាល់។",
          "map-label": "ផែនទី — ចុច ឬអូសម្ជុលដើម្បីកំណត់ទីតាំង",
          "error": "ត្រូវការឈ្មោះទីតាំង និងកូអរដោនេត្រឹមត្រូវ។"
        }
      },
      "org-chart-editor": {
        "title": "ប្លង់អង្គភាព",
        "subtitle": "បង្កើត និងកែសម្រួលមុខតំណែង និងខ្សែរាយការណ៍សម្រាប់ក្រុមហ៊ុននេះ។",
        "canvas-title": "ប្លង់អង្គភាព",
        "layer-1": "ស្រទាប់ ១",
        "info-banner": "បង្ហាញគ្រប់មុខតំណែង និងខ្សែរាយការណ៍។ ប្រើម៉ឺនុយរបស់មុខតំណែងដើម្បីបន្ថែម កែ ផ្លាស់ ប្ដូរ បិទ ឬលុប។ អូសផ្ទាំងដើម្បីផ្លាស់ទី ប្រើកង់ ឬរបារឧបករណ៍ដើម្បីពង្រីក។",
        "vacant": "ទំនេរ",
        "untitled": "មុខតំណែងគ្មានឈ្មោះ",
        "actions-menu": "សកម្មភាពមុខតំណែង",
        "actions-for": "សកម្មភាពមុខតំណែង",
        "expand": "ពង្រីក",
        "collapse": "បង្រួម",
        "search-ph": "ស្វែងរកមុខតំណែង អង្គភាព ឬបុគ្គល…",
        "error-header": "ប្លង់អង្គភាព",
        "status": {
          "active": "សកម្ម",
          "pending": "រង់ចាំ",
          "probation": "សាកល្បង",
          "on-leave": "ឈប់សម្រាក",
          "inactive-vacant": "អសកម្ម / ទំនេរ"
        },
        "counter": {
          "vacant": "ទំនេរ {n}",
          "disabled": "បិទ {n}"
        },
        "nav": {
          "title": "ការរុករកមុខតំណែង",
          "hint": "ចុចដើម្បីផ្ដោតលើសាខា",
          "hide": "លាក់ការរុករក",
          "show": "បង្ហាញការរុករក",
          "short": "រុករក",
          "empty": "គ្មានមុខតំណែងត្រូវនឹងការស្វែងរករបស់អ្នក។"
        },
        "toolbar": {
          "show-vacancies": "បង្ហាញមុខតំណែងទំនេរ",
          "default-view": "ទិដ្ឋភាពលំនាំដើម",
          "expand-all": "ពង្រីកទាំងអស់",
          "collapse-all": "បង្រួមទាំងអស់",
          "zoom-out": "បន្ថយ",
          "zoom-in": "ពង្រីក",
          "zoom-100": "កំណត់ ១០០%",
          "zoom-fit": "សមនឹងអេក្រង់",
          "reset-zoom": "កំណត់ផ្លាស់ទី និងពង្រីកឡើងវិញ",
          "reset-focus": "ត្រឡប់ទៅប្លង់ពេញ"
        },
        "chart": {
          "showing-focused": "កំពុងបង្ហាញសាខាក្រោម {name}។ ប្រើ «ត្រឡប់ទៅប្លង់ពេញ» ដើម្បីចេញ។"
        },
        "action": {
          "edit": "កែមុខតំណែង",
          "add-child": "បន្ថែមមុខតំណែងក្រោម",
          "move": "ផ្លាស់មុខតំណែង",
          "delete": "លុបមុខតំណែង",
          "disable": "បិទមុខតំណែង",
          "enable": "បើកមុខតំណែង",
          "swap": "ប្ដូរតួនាទី",
          "manage-roles": "គ្រប់គ្រងតួនាទីបន្ថែម",
          "temp-oversight-on": "បើកការត្រួតពិនិត្យបណ្ដោះអាសន្ន",
          "temp-oversight-off": "បិទការត្រួតពិនិត្យបណ្ដោះអាសន្ន"
        },
        "form": {
          "add-title": "បន្ថែមមុខតំណែងក្រោម",
          "edit-title": "កែមុខតំណែង",
          "org-unit": "អង្គភាពអង្គការ",
          "org-unit-ph": "ឧ. នាយកដ្ឋានទីផ្សារ",
          "reports-to": "រាយការណ៍ទៅ",
          "top-most": "មុខតំណែងកំពូល",
          "job-title": "ងារការងារ",
          "job-title-ph": "ឧ. វិស្វករសូហ្វវែរ",
          "base-location": "ទីតាំងមូលដ្ឋាន",
          "base-location-ph": "ជ្រើសរើសទីតាំងមូលដ្ឋាន",
          "base-location-loading": "កំពុងផ្ទុកទីតាំង…",
          "base-location-empty": "មិនមានទីតាំងមូលដ្ឋានត្រូវបានកំណត់",
          "advanced": "ជម្រើសកែសម្រួលកម្រិតខ្ពស់",
          "cascade-org-unit": "អនុវត្តអង្គភាពនេះទៅគ្រប់មុខតំណែងក្រោមផងដែរ។",
          "cascade-title": "ធ្វើបច្ចុប្បន្នភាពមុខតំណែងផ្សេងដែលប្រើងារការងារដូចគ្នាផងដែរ។",
          "required": "ត្រូវការ",
          "create": "បង្កើត"
        },
        "move": {
          "title": "ផ្លាស់មុខតំណែង",
          "current": "ខ្សែរាយការណ៍បច្ចុប្បន្ន",
          "new": "ខ្សែរាយការណ៍ថ្មី",
          "new-ph": "ជ្រើសរើសប្រធានថ្មី",
          "warning": "ការផ្លាស់ខ្សែរាយការណ៍នឹងធ្វើបច្ចុប្បន្នភាពឋានានុក្រមភ្លាមៗ។"
        },
        "swap": {
          "title": "ប្ដូរតួនាទី",
          "current": "អ្នកកាន់តួនាទីបច្ចុប្បន្ន",
          "with": "ប្ដូរជាមួយ",
          "with-ph": "ជ្រើសរើសមុខតំណែង",
          "reason": "មូលហេតុ",
          "reason-ph": "ហេតុអ្វីបានជាប្ដូរតួនាទីទាំងនេះ?",
          "submit": "ប្ដូរ"
        },
        "manage-roles": {
          "title": "គ្រប់គ្រងតួនាទីបន្ថែម",
          "lede": "កំពុងគ្រប់គ្រងតួនាទីស្របគ្នាសម្រាប់ {name}។",
          "primary": "មុខតំណែងចម្បង",
          "additional": "មុខតំណែងបន្ថែម",
          "no-candidates": "គ្មានមុខតំណែងទំនេរសមរម្យដើម្បីត្រួតពិនិត្យ។",
          "vacant-only": "តែមុខតំណែងទំនេរប៉ុណ្ណោះ",
          "reason": "មូលហេតុ / ការបញ្ជាក់"
        },
        "vacant-drawer": {
          "open": "ទំនេរ",
          "title": "មុខតំណែងទំនេរ",
          "reports-to": "រាយការណ៍ទៅ"
        },
        "disabled-drawer": {
          "open": "បានបិទ",
          "title": "មុខតំណែងដែលបានបិទ"
        },
        "drawer": {
          "count": "មុខតំណែង {count}",
          "empty": "មិនទាន់មានអ្វីនៅទីនេះទេ។"
        },
        "export": "នាំចេញ",
        "toast": {
          "added": "បានបន្ថែមមុខតំណែង។",
          "updated": "បានធ្វើបច្ចុប្បន្នភាពមុខតំណែង។",
          "moved": "បានធ្វើបច្ចុប្បន្នភាពខ្សែរាយការណ៍។",
          "swapped": "បានប្ដូរតួនាទី។",
          "deleted": "បានលុបមុខតំណែង។",
          "disabled": "បានបិទមុខតំណែង។",
          "enabled": "បានបើកមុខតំណែង។",
          "oversight-disabled": "បានបិទការត្រួតពិនិត្យបណ្ដោះអាសន្ន។",
          "oversight-soon": "ការបើកការត្រួតពិនិត្យបណ្ដោះអាសន្ននឹងមកដល់ពេលក្រោយ។",
          "save-failed": "មិនអាចរក្សាទុកបានទេ។ សូមព្យាយាមម្ដងទៀត។"
        },
        "confirm": {
          "delete-title": "លុបមុខតំណែងនេះ?",
          "delete-body": "វានឹងលុបមុខតំណែងចេញពីប្លង់អង្គភាពជាអចិន្ត្រៃយ៍។ មានតែមុខតំណែងទំនេរគ្មានក្រោមប៉ុណ្ណោះអាចលុបបាន។",
          "disable-title": "បិទមុខតំណែងនេះ?",
          "disable-body": "មុខតំណែងនឹងត្រូវលាក់ពីប្លង់ និងគ្រប់បញ្ជីជ្រើស។ អ្នកអាចបើកវាឡើងវិញនៅពេលក្រោយ។",
          "enable-title": "បើកមុខតំណែងនេះ?",
          "enable-body": "មុខតំណែងនឹងបង្ហាញនៅក្នុងប្លង់ និងអាចជ្រើសរើសបានម្ដងទៀត។"
        },
        "error": {
          "title": "មិនអាចផ្ទុកប្លង់អង្គភាពបានទេ",
          "desc": "មានបញ្ហាពេលទាញយកមុខតំណែង។ សូមព្យាយាមម្ដងទៀត។"
        },
        "empty": {
          "title": "មិនទាន់មានប្លង់អង្គភាពទេ",
          "desc": "ក្រុមហ៊ុននេះគ្មានមុខតំណែង។ បន្ថែមមុខតំណែងកំពូលដើម្បីចាប់ផ្ដើម។"
        }
      },
      "oversight": {
        "showing": "បង្ហាញ {filtered} ក្នុងចំណោម {total} កិច្ចការ",
        "confirm-remove": "លុប {name} ចេញពីអ្នកត្រួតពិនិត្យ?",
        "error": "មិនអាចផ្ទុកការចាត់តាំងត្រួតពិនិត្យបានទេ។",
        "toasts": {
          "overseer-removed": "អ្នកត្រួតពិនិត្យត្រូវបានលុប។",
          "remove-failed": "មិនអាចលុបអ្នកត្រួតពិនិត្យបានទេ។ សូមព្យាយាមមើលទិត។",
          "assigned": "ការចាត់តាំងត្រួតពិនិត្យត្រូវបានរក្សាទុក។",
          "assign-failed": "មិនអាចរក្សាទុកការចាត់តាំង។ សូមព្យាយាមមើលទិត។"
        }
      }
    },
    "tenant-settings": {
      "title": "ការកំណត់កន្លែងធ្វើការ និងអ្នកជួល",
      "subtitle": "គ្រប់គ្រងប្រភេទអាជីវកម្ម វិក្កយបត្រ និងការកំណត់វេទិការបស់អង្គភាពអ្នក",
      "back": "ត្រឡប់ទៅ Admin",
      "live": "សកម្ម",
      "coming-soon": "នឹងមកដល់ឆាប់ៗ",
      "coming-soon-tag": "ឆាប់ៗ",
      "stub-toast": "{name} នឹងមកដល់ឆាប់ៗ",
      "denied": {
        "title": "ត្រូវការសិទ្ធិអ្នកគ្រប់គ្រងកំពូល",
        "body": "មានតែអ្នកគ្រប់គ្រងទូទាំងអ្នកជួលប៉ុណ្ណោះអាចគ្រប់គ្រងការកំណត់កន្លែងធ្វើការ។"
      },
      "business-type": {
        "title": "ប្រភេទអាជីវកម្ម",
        "desc": "ដំឡើងកន្លែងធ្វើការរបស់អ្នកទៅជាអ្នកផ្តល់សេវា EOR / ការផ្តល់សេវាបុគ្គលិក ឬត្រឡប់ទៅអង្គភាពធម្មតា។ អ្នកជួលជាអ្នកផ្តល់សេវាគ្រប់គ្រងអតិថិជន និងគម្រោង; អ្នកជួលធម្មតាគ្រប់គ្រងអ្នកផ្គត់ផ្គង់។",
        "provider-label": "អ្នកផ្តល់សេវាការផ្តល់សេវាបុគ្គលិក",
        "status-provider": "អ្នកផ្តល់សេវា",
        "status-standard": "ធម្មតា",
        "hint-provider": "កន្លែងធ្វើការរបស់អ្នកត្រូវបានរៀបចំសម្រាប់ការផ្តល់សេវាបុគ្គលិក — អ្នកគ្រប់គ្រងអតិថិជន គម្រោង និងអ្នកអនុម័តខាងក្រៅ។",
        "hint-standard": "អង្គភាពធម្មតា។ បើកដើម្បីដំណើរការអាជីវកម្មការផ្តល់សេវាបុគ្គលិក (គ្រប់គ្រងអតិថិជន និងគម្រោង)។",
        "toggle-aria": "បិទ/បើកអ្នកផ្តល់សេវាការផ្តល់សេវាបុគ្គលិក",
        "promoted": "កន្លែងធ្វើការត្រូវបានដំឡើងទៅជាអ្នកផ្តល់សេវាការផ្តល់សេវាបុគ្គលិក។",
        "demoted": "កន្លែងធ្វើការត្រូវបានត្រឡប់ទៅអង្គភាពធម្មតា។",
        "error": "មិនអាចធ្វើបច្ចុប្បន្នភាពប្រភេទអាជីវកម្មបានទេ។ សូមព្យាយាមម្តងទៀត។",
        "demote-confirm-title": "បិទអ្នកផ្តល់សេវាការផ្តល់សេវាបុគ្គលិក?",
        "demote-confirm-desc": "វានឹងត្រឡប់កន្លែងធ្វើការរបស់អ្នកទៅអង្គភាពធម្មតា។",
        "demote-confirm-body": "អតិថិជន គម្រោង និងបុគ្គលិករបស់ពួកគេដែលមានស្រាប់ត្រូវបានរក្សាទុក — គ្រាន់តែលែងបង្ហាញជាការផ្តល់សេវាបុគ្គលិករហូតដល់អ្នកបើកវាឡើងវិញ។ អ្នកអាចបើកវាឡើងវិញនៅពេលណាក៏បាន។",
        "demote-confirm-cta": "បិទ"
      },
      "sections": {
        "billing": {
          "title": "វិក្កយបត្រ",
          "desc": "វិធីបង់ប្រាក់ វិក្កយបត្រ និងប្រវត្តិវិក្កយបត្រ។"
        },
        "address": {
          "title": "អាសយដ្ឋាន និងព័ត៌មានក្រុមហ៊ុន",
          "desc": "អាសយដ្ឋានចុះបញ្ជី និងព័ត៌មានច្បាប់។"
        },
        "subscription": {
          "title": "ការជាវ និងគម្រោង",
          "desc": "គម្រោងបច្ចុប្បន្ន កៅអី និងការបន្ត។"
        },
        "contacts": {
          "title": "ទំនាក់ទំនង",
          "desc": "ទំនាក់ទំនងចម្បង និងវិក្កយបត្រ។"
        }
      }
    },
    "errors": {
      "dialog": {
        "close": "បិទ",
        "badRequest": {
          "header": "មិនអាចបញ្ចប់សំណើបានទេ",
          "message": "យើងមិនអាចបញ្ចប់សំណើនោះបានទេ។ សូមពិនិត្យឡើងវិញ ហើយព្យាយាមម្តងទៀត។"
        },
        "forbidden": {
          "header": "អ្នកមិនមានសិទ្ធិចូលប្រើទេ",
          "message": "គណនីរបស់អ្នកមិនត្រូវបានអនុញ្ញាតឱ្យធ្វើបែបនេះទេ។ ប្រសិនបើអ្នកគិតថានេះជាកំហុស សូមទាក់ទងអ្នកគ្រប់គ្រងរបស់អ្នក។"
        },
        "notFound": {
          "header": "រកមិនឃើញ",
          "message": "យើងរកមិនឃើញអ្វីដែលអ្នកកំពុងស្វែងរកទេ។ វាប្រហែលជាត្រូវបានផ្លាស់ទី ឬលុបចេញ។"
        },
        "server": {
          "header": "មានបញ្ហាកើតឡើងនៅខាងយើង",
          "message": "នេះជាបញ្ហារបស់យើង មិនមែនរបស់អ្នកទេ។ សូមព្យាយាមម្តងទៀតក្នុងពេលបន្តិចទៀត — ប្រសិនបើវានៅតែកើតឡើង សូមប្រាប់យើង។"
        },
        "network": {
          "header": "មិនអាចភ្ជាប់ទៅម៉ាស៊ីនមេបានទេ",
          "message": "យើងមិនអាចភ្ជាប់នៅពេលនេះបានទេ។ សូមពិនិត្យការតភ្ជាប់អ៊ីនធឺណិតរបស់អ្នក ហើយព្យាយាមម្តងទៀត។"
        }
      }
    },
    "admin": {
      "users": {
        "title": "អ្នកប្រើ និងតួនាទី",
        "subtitle": "គ្រប់គ្រងគណនីអ្នកប្រើ ការតភ្ជាប់បុគ្គលិក និងសិទ្ធិគ្រប់គ្រងក្រុមហ៊ុន។",
        "add": "បន្ថែមអ្នកប្រើ",
        "search-placeholder": "ស្វែងរកឈ្មោះអ្នកប្រើ ឈ្មោះ ឬអ៊ីមែល",
        "result-count": "អ្នកប្រើ {count} នាក់",
        "clear-filter": "សម្អាតតម្រង {name}",
        "clear-search": "សម្អាតការស្វែងរក",
        "clear-all": "សម្អាតទាំងអស់",
        "select-all": "ជ្រើសរើសអ្នកប្រើទាំងអស់",
        "select-row": "ជ្រើសរើស {name}",
        "row-actions": "សកម្មភាពសម្រាប់ {name}",
        "retry": "ព្យាយាមម្តងទៀត",
        "error": "មិនអាចផ្ទុកអ្នកប្រើបានទេ។ សូមព្យាយាមម្តងទៀត។",
        "error-403": "អ្នកមិនមានសិទ្ធិមើលអ្នកប្រើសម្រាប់ក្រុមហ៊ុននេះទេ។",
        "kpi": {
          "enabled": "បានបើក",
          "disabled": "បានបិទ",
          "admin": "អ្នកគ្រប់គ្រងក្រុមហ៊ុន",
          "temporary": "ពាក្យសម្ងាត់បណ្តោះអាសន្ន"
        },
        "cols": {
          "username": "ឈ្មោះអ្នកប្រើ",
          "employee": "បុគ្គលិក",
          "email": "អ៊ីមែល",
          "admin-companies": "ក្រុមហ៊ុនដែលគ្រប់គ្រង",
          "access": "ស្ថានភាពចូលប្រើ",
          "password": "ស្ថានភាពពាក្យសម្ងាត់",
          "actions": "សកម្មភាព"
        },
        "access": {
          "enabled": "បានបើក",
          "disabled": "បានបិទ"
        },
        "password": {
          "temporary": "បណ្តោះអាសន្ន",
          "confirmed": "បានបញ្ជាក់",
          "unknown": "មិនស្គាល់"
        },
        "actions": {
          "edit-email": "កែអ៊ីមែល",
          "admin-company": "សិទ្ធិគ្រប់គ្រងក្រុមហ៊ុន",
          "enable": "បើកការចូលប្រើ",
          "disable": "បិទការចូលប្រើ",
          "delete": "លុបអ្នកប្រើ"
        },
        "empty": {
          "title": "មិនទាន់មានអ្នកប្រើទេ",
          "subtitle": "បន្ថែមអ្នកប្រើដើម្បីតភ្ជាប់គណនីចូលប្រើទៅបុគ្គលិក។"
        },
        "empty-filtered": {
          "title": "គ្មានអ្នកប្រើដែលត្រូវគ្នា",
          "subtitle": "សូមសាកល្បងស្វែងរកផ្សេង ឬសម្អាតតម្រង។"
        },
        "form": {
          "create-title": "បង្កើតអ្នកប្រើ",
          "create-subtitle": "តភ្ជាប់គណនីចូលប្រើទៅបុគ្គលិកដែលមានស្រាប់។",
          "edit-email-title": "កែអ៊ីមែលអ្នកប្រើ",
          "edit-email-subtitle": "ផ្លាស់ប្តូរអ៊ីមែលនៅលើគណនីរបស់អ្នកប្រើនេះ។",
          "admin-company-title": "សិទ្ធិគ្រប់គ្រងក្រុមហ៊ុន",
          "admin-company-subtitle": "ជ្រើសរើសក្រុមហ៊ុនណាដែលអ្នកប្រើនេះអាចគ្រប់គ្រងបាន។",
          "employee": "បុគ្គលិក",
          "employee-placeholder": "ជ្រើសរើសបុគ្គលិកដើម្បីតភ្ជាប់ទៅអ្នកប្រើនេះ",
          "employee-required": "សូមជ្រើសរើសបុគ្គលិកដើម្បីតភ្ជាប់។",
          "loading-employees": "កំពុងផ្ទុកបុគ្គលិក…",
          "username": "ឈ្មោះអ្នកប្រើ",
          "first-name": "នាមខ្លួន",
          "last-name": "នាមត្រកូល",
          "email": "អ៊ីមែល",
          "phone": "លេខទូរស័ព្ទ",
          "invalid-email": "អាសយដ្ឋានអ៊ីមែលមិនត្រឹមត្រូវ។",
          "new-email": "អ៊ីមែលថ្មី",
          "new-email-placeholder": "បញ្ចូលអ៊ីមែលថ្មី",
          "selected-user": "ព័ត៌មានអ្នកប្រើដែលបានជ្រើស",
          "managed-companies": "ក្រុមហ៊ុនកំពុងគ្រប់គ្រង",
          "managed-companies-desc": "ទាំងនេះគឺជាក្រុមហ៊ុនដែលអ្នកប្រើនេះកំពុងគ្រប់គ្រង។ លុបសិទ្ធិដោយប្រើប៊ូតុងនៅជួរនីមួយៗ។",
          "grant-more": "ផ្តល់សិទ្ធិគ្រប់គ្រងដល់ក្រុមហ៊ុនបន្ថែម",
          "grant-more-desc": "ជ្រើសរើសក្រុមហ៊ុនមួយ ឬច្រើនដើម្បីផ្តល់សិទ្ធិគ្រប់គ្រង។ បន្ទាប់មកអ្នកប្រើអាចគ្រប់គ្រងបុគ្គលិក ការកំណត់ និងវត្តមានសម្រាប់ពួកវា។",
          "remove-company": "ដកចេញ {name}",
          "no-companies": "គ្មានក្រុមហ៊ុនបានកំណត់",
          "no-more-companies": "គ្មានក្រុមហ៊ុនបន្ថែមទេ",
          "add": "បន្ថែម",
          "new": "ថ្មី",
          "create": "បង្កើត",
          "update": "ធ្វើបច្ចុប្បន្នភាព",
          "cancel": "បោះបង់"
        },
        "confirm": {
          "enable-title": "បើកអ្នកប្រើ?",
          "enable-message": "អ្នកប្រើនេះនឹងអាចចូលប្រើម្តងទៀត។",
          "enable": "បើក",
          "disable-title": "បិទអ្នកប្រើ?",
          "disable-message": "អ្នកប្រើនេះនឹងមិនអាចចូលប្រើបានទៀតទេ។",
          "disable": "បិទ",
          "delete-title": "លុបអ្នកប្រើ?",
          "delete-message": "នេះនឹងលុបគណនីចូលប្រើរបស់អ្នកប្រើជាអចិន្ត្រៃយ៍។ វាមិនអាចត្រឡប់វិញបានទេ។",
          "delete": "លុប",
          "cancel": "បោះបង់"
        },
        "toast": {
          "created": "បានបង្កើតអ្នកប្រើ {name}។",
          "create-error": "មិនអាចបង្កើតអ្នកប្រើបានទេ។",
          "updated": "បានធ្វើបច្ចុប្បន្នភាពអ្នកប្រើ។",
          "update-error": "មិនអាចធ្វើបច្ចុប្បន្នភាពអ្នកប្រើបានទេ។",
          "enabled": "បានបើក {name}។",
          "disabled": "បានបិទ {name}។",
          "deleted": "បានលុប {name}។",
          "action-error": "សកម្មភាពបានបរាជ័យ។ សូមព្យាយាមម្តងទៀត។"
        }
      }
    },
    "scope": {
      "all-scopes": "គ្រប់វិសាលភាព",
      "all-companies": "គ្រប់ក្រុមហ៊ុន",
      "this-company": "ក្រុមហ៊ុននេះ",
      "tenant-fallback": "អង្គភាព",
      "hint": "បរិបទកម្មសិទ្ធិ",
      "breadcrumb-label": "វិសាលភាពសកម្ម",
      "kind": {
        "oversight": "គ្រប់វិសាលភាព · ត្រួតពិនិត្យ",
        "company": "ក្រុមហ៊ុន",
        "client": "អតិថិជន",
        "vendor": "អ្នកផ្គត់ផ្គង់",
        "project": "គម្រោង"
      },
      "empty-notice": "គ្មានកំណត់ត្រា {label} សម្រាប់ {company} ទេ។ ទាំងនេះត្រូវបានកត់ត្រាតាមក្រុមហ៊ុនប្រតិបត្តិការនីមួយៗ — ក្រុមហ៊ុននេះគ្មាននៅក្នុងទិន្នន័យគំរូ។ សូមប្តូរទៅក្រុមហ៊ុនប្រតិបត្តិការ ឬ គ្រប់វិសាលភាព។"
    },
    "legal": {
      "back-to-sign-in": "ត្រឡប់ទៅចូលគណនី",
      "terms": {
        "title": "លក្ខខណ្ឌប្រើប្រាស់",
        "updated": "ធ្វើបច្ចុប្បន្នភាពចុងក្រោយ៖ ថ្ងៃទី 16 ខែមិថុនា ឆ្នាំ 2026",
        "contact": "មានសំណួរអំពីលក្ខខណ្ឌទាំងនេះឬ? សូមទាក់ទងយើងតាម {email}។",
        "sections": [
          {
            "heading": "1. សេចក្ដីផ្ដើម",
            "body": "លក្ខខណ្ឌប្រើប្រាស់ទាំងនេះគ្រប់គ្រងការចូលប្រើ និងការប្រើប្រាស់វេទិកា OptimalHR ដែលជាសេវាគ្រប់គ្រងធនធានមនុស្សពហុអតិថិជន ដំណើរការដោយក្រុមហ៊ុន Optimal P HR Strategic Partner Co., Ltd។ ដោយចូលគណនី ឬប្រើប្រាស់សេវានេះ អ្នកយល់ព្រមនឹងលក្ខខណ្ឌទាំងនេះក្នុងនាមអង្គភាពរបស់អ្នក។"
          },
          {
            "heading": "2. គណនី និងការចូលប្រើ",
            "body": "ការចូលប្រើត្រូវបានផ្ដល់ដោយអ្នកគ្រប់គ្រង HR នៃអង្គភាពរបស់អ្នក។ អ្នកទទួលខុសត្រូវក្នុងការរក្សាការសម្ងាត់នៃព័ត៌មានសម្គាល់ខ្លួន និងសកម្មភាពទាំងអស់ក្រោមគណនីរបស់អ្នក។ សូមជូនដំណឹងដល់អ្នកគ្រប់គ្រងភ្លាមៗ ប្រសិនបើអ្នកសង្ស័យថាមានការចូលប្រើដោយគ្មានការអនុញ្ញាត។"
          },
          {
            "heading": "3. ការប្រើប្រាស់ដែលអាចទទួលយកបាន",
            "body": "អ្នកយល់ព្រមមិនប្រើប្រាស់សេវាខុស មិនព្យាយាមចូលប្រើទិន្នន័យរបស់អតិថិជនផ្សេង មិនរំខានដល់ដំណើរការធម្មតា ឬប្រើវេទិកាក្នុងការបំពានច្បាប់កម្ពុជា ឬបទប្បញ្ញត្តិការងារដែលគ្រប់គ្រងអង្គភាពរបស់អ្នក។"
          },
          {
            "heading": "4. ទិន្នន័យអតិថិជន",
            "body": "អង្គភាពរបស់អ្នកជាម្ចាស់ទិន្នន័យបុគ្គលិក និងបៀវត្សដែលបានបញ្ជូន។ យើងដំណើរការទិន្នន័យនោះតែដើម្បីផ្ដល់សេវា ក្រោមការគ្រប់គ្រងការបំបែកទិន្នន័យដែលបានពិពណ៌នាក្នុងគោលនយោបាយឯកជនភាពរបស់យើង។ យើងមិនលក់ទិន្នន័យអតិថិជនទេ។"
          },
          {
            "heading": "5. ភាពអាចរកបាននៃសេវា",
            "body": "យើងព្យាយាមរក្សាភាពអាចរកបានខ្ពស់ ប៉ុន្តែមិនធានាសេវាដែលគ្មានការរំខានទេ។ ការថែទាំ និងការធ្វើបច្ចុប្បន្នភាពតាមកាលវិភាគអាចប៉ះពាល់ការចូលប្រើជាបណ្ដោះអាសន្ន។ ឧប្បត្តិហេតុសំខាន់ៗត្រូវបានជូនដំណឹងដល់អ្នកគ្រប់គ្រងអតិថិជន។"
          },
          {
            "heading": "6. ការផ្លាស់ប្ដូរលក្ខខណ្ឌ",
            "body": "យើងអាចធ្វើបច្ចុប្បន្នភាពលក្ខខណ្ឌទាំងនេះពីពេលមួយទៅពេលមួយ។ ការផ្លាស់ប្ដូរសំខាន់ៗនឹងត្រូវជូនដំណឹងដល់អ្នកគ្រប់គ្រងអតិថិជនមុនពេលមានប្រសិទ្ធភាព។ ការបន្តប្រើបន្ទាប់ពីការផ្លាស់ប្ដូរ ចាត់ទុកជាការយល់ព្រម។"
          }
        ]
      },
      "privacy": {
        "title": "គោលនយោបាយឯកជនភាព",
        "updated": "ធ្វើបច្ចុប្បន្នភាពចុងក្រោយ៖ ថ្ងៃទី 16 ខែមិថុនា ឆ្នាំ 2026",
        "contact": "សម្រាប់សំណើ ឬសំណួរអំពីឯកជនភាព សូមទាក់ទងយើងតាម {email}។",
        "sections": [
          {
            "heading": "សេចក្ដីផ្ដើម",
            "body": "គោលនយោបាយឯកជនភាពនេះពន្យល់ពីរបៀបដែល OptimalHR ប្រមូល ប្រើ រក្សាទុក និងការពារព័ត៌មានផ្ទាល់ខ្លួនដែលដំណើរការតាមរយៈវេទិកា។ វាអនុវត្តចំពោះគ្រប់បរិស្ថាន (Dev, Staging, Prod) ដែលដំណើរការសម្រាប់អង្គភាពរបស់អ្នក។"
          },
          {
            "heading": "ទិន្នន័យដែលយើងប្រមូល",
            "body": "យើងដំណើរការទិន្នន័យប្រវត្តិរូបបុគ្គលិក ព័ត៌មានទំនាក់ទំនង កំណត់ត្រាការងារ និងកិច្ចសន្យា វត្តមាន ការឈប់សម្រាក ម៉ោងបន្ថែម និងព័ត៌មានបៀវត្ស ដែលអង្គភាពរបស់អ្នកបញ្ចូល ឬផ្ទុកឡើង។ ទិន្នន័យផ្ទៀងផ្ទាត់ត្រូវបានគ្រប់គ្រងដោយ Amazon Cognito។"
          },
          {
            "heading": "របៀបដែលយើងប្រើទិន្នន័យ",
            "body": "ទិន្នន័យផ្ទាល់ខ្លួនត្រូវបានប្រើតែដើម្បីផ្ដល់សេវា HR ដែលអង្គភាពរបស់អ្នកបានកំណត់ — ដំណើរការបៀវត្ស តាមដានវត្តមាន និងការឈប់សម្រាក នាំផ្លូវការអនុម័ត និងបង្កើតរបាយការណ៍។ យើងមិនប្រើវាសម្រាប់ការផ្សាយពាណិជ្ជកម្មទេ។"
          },
          {
            "heading": "ការបំបែកទិន្នន័យ និងសុវត្ថិភាព",
            "body": "OptimalHR ប្រើស្ថាបត្យកម្មពហុអតិថិជន ដោយការបំបែកត្រូវបានអនុវត្តនៅកម្រិតមូលដ្ឋានទិន្នន័យ (គោលការណ៍ IAM)។ ទិន្នន័យរបស់អតិថិជននីមួយៗត្រូវបានបែងចែក និងគ្រប់គ្រងការចូលប្រើ ដូច្នេះវាមិនអាចត្រូវបានអានដោយអតិថិជនផ្សេងទេ។ លេខសម្គាល់រសើបមិនដែលត្រូវបានសរសេរទៅក្នុងកំណត់ហេតុប្រតិបត្តិការទេ។"
          },
          {
            "heading": "ការរក្សាទុកទិន្នន័យ",
            "body": "យើងរក្សាទុកទិន្នន័យផ្ទាល់ខ្លួនរយៈពេលដែលអង្គភាពរបស់អ្នករក្សាការជាវ និងតាមតម្រូវការនៃច្បាប់ការងារ និងពន្ធកម្ពុជា។ នៅពេលបញ្ចប់ ទិន្នន័យត្រូវបានលុប ឬប្រគល់មកវិញតាមការណែនាំរបស់អង្គភាពអ្នក។"
          },
          {
            "heading": "សិទ្ធិរបស់អ្នក",
            "body": "បុគ្គលិកអាចស្នើសុំការចូលប្រើ ឬកែតម្រូវទិន្នន័យផ្ទាល់ខ្លួនរបស់ខ្លួនតាមរយៈអ្នកគ្រប់គ្រង HR។ អ្នកគ្រប់គ្រងអាចដោះស្រាយសំណើទាំងនេះក្នុងវេទិកា ឬដោយទាក់ទងក្រុមជំនួយរបស់យើង។"
          },
          {
            "heading": "ទំនាក់ទំនង",
            "body": "សំណួរអំពីឯកជនភាពត្រូវបានដោះស្រាយដោយអ្នកទំនាក់ទំនងការពារទិន្នន័យរបស់យើងខាងក្រោម។ យើងឆ្លើយតបទៅសំណើដែលបានផ្ទៀងផ្ទាត់ក្នុងរយៈពេលសមរម្យ។"
          }
        ]
      }
    }
  }
}
